import {
  philosophyImage,
  anupSharma,
  researchImage,
  visionImage,
  valuesImage,
  projectInternshipImage,
  internshipResourcesImage,
  abhishekTrained,
  sidharthaTrained,
  riyaTrained,
  rithinTrained,
  swatiTrained,
  prajnaPravahLogo,
  tanuTrained,
  akhilTrained,
  blog7,
  blog8,
  blog9,
  blog10,
  blog11,
  blog12,
  blog13,
  blog14,
  blog15,
  blog6,
  aartip,
  equationGraph,
  socialOrderCube,
  onamInner,
  E1,
  E2,
  E3,
  E4,
  O1,
  O2,
  O3,
  O4,
  O5,
  O6,
  iksProject,
  iksAwarenessProject,
  chandasProject,
  ihiProject,
  ihiPhilosophicalRoots,
  ihiMilestone1,
  ihiMilestone2,
  ihiMilestone3,
  ihiMilestone4,
  ihiMilestone5,
  ihiMilestone6,
  ihiMilestone7,
  sampadananda,
  vandana,
  neelabh,
  dipankar,
  diwakar,
  tanushree,
  chaitra,
  kavyakanth2,
  kavyakanth3,
  kavyakanth4,
  slcBanner,
  kridakautuki,
  abhyasalahari,
  ramyanatakani,
  kathaslokavinshatika,
  laghugalpalatika,
  kathamalika,
  kathabharati,
  kakahkako,
  shabdakrida,
  ramayanakathamanjari,
  avadhanakalaBanner,
  wonderAvadhanam,
  traditionOdisha,
  artAvadhana,
  jainAvadhana,
  crpProjectBanner,
  crpImpact1,
  crpImpact2,
  crpImpact3,
  iksCourse,
  chandasCourse,
  untranslatablesCourse,
  samatvamCourse,
  samvidCourse,
  paniniCourse,
  mantraYogaCourse,
  aurobindoCourse,
  icprSeriesImage,
  ekatmaDarshanImage,
  avadhanakalaImage,
  vaicarikiImage,
  omNathBimali,
  sankrantSanu,
  lakshmiBandlamudi,
  oscarPujol,
  taponidhi,
  rishiTradition,
  nupurTewari,
  nitashaSharma,
  nationalSelfhood,
  ananyaAwasthi,
  nikhilYadav,
  sonalMansingh,
  shefaliKashyap,
  ankurKakkar,
  sheTheKing,
  sonuTrivedi,
  comeCarpentier,
  brokenPromises,
  aryaaVedicWomen,
  inMediaMain,
  inMedia1,
  inMedia2,
  inMedia3,
  inMedia4,
  inMedia5,
  bhavaniPoster,
  sampadanandaWorkshop,
  sangeetaWorkshop,
  paniniWorkshop,
  translationWorkshop1,
  translationWorkshop2,
  confMain,
  confSlide1,
  confSlide2,
  confSlide3,
  confSlide4,
  confPhilosophyImage,
  nep2020Image,
  universalConfBanner,
  universalConf1,
  universalConf2,
  universalConf3,
  universalConf4,
  universalConf5,
  universalConf6,
  universalConf7,
  universalConf8,
  universalConf9,
  universalConf10,
  universalConf11,
  universalConf12,
  universalConf13,
  universalConf14,
  philosophyIntro1,
  philosophyIntro2,
  philosophyPresAddress1,
  philosophyPresAddress2,
  philosophyLecture1Img1,
  philosophyLecture1Img2,
  philosophyLecture2Img1,
  philosophyLecture2Img2,
  philosophyLecture3Img1,
  philosophyLecture3Img2,
  philosophyLecture4Img1,
  philosophyLecture4Img2,
  philosophyLecture5Img1,
  philosophyLecture5Img2,
  philosophyLecture5Img3,
  philosophyConcludingImg1,
  philosophyConcludingImg2,
  pedagogyBanner,
  pedagogyRef1,
  pedagogyRef2,
  advancingIntegralBanner,
  patronShobhit,
  convenerSampadananda,
  partner1,
  partner2,
  partner3,
  youthConfBanner,
  youthConf1,
  youthConf2,
  youthConf3,
  youthConf4,
  avadhanaSangamaBanner,
  avadhanaSangama1,
  avadhanaSangama2,
  bhashaMahotsavBanner,
  bhashaMahotsavIntro,
  bhashaImage2,
  bhashaImage10,
  bhashaImage16,
  bhashaImage35,
  bhashaImage49,
  bhashaImage51,
  bhashaImage59,
  bhashaImage63,
  bhashaImage77,
  bhashaImage104,
  bhashaImage111,
  bhashaImage13,
  bhashaImage36,
  bhashaImage70,
  bhashaImage103,
  bhashaImage107,
  bhashaImage6,
  bhashaImage17,
  bhashaImage55,
  bhashaImage71,
  bhashaImage82,
  bhashaImage87,
  bhashaImage91,
  bhashaImage101,
  bhashaImage23,
  bhashaImage73,
  bhashaImage94,
  bhashaImage106,
  bhashaImage109,
  bhashaImage112,
  bhashaImage113,
  bhashaImage14,
  bhashaImage19,
  bhashaImage21,
  bhashaImage22,
  bhashaImage25,
  bhashaImage27,
  bhashaImage30,
  bhashaImage32,
  bhashaImage34,
  bhashaImage4,
  bhashaImage45,
  bhashaImage47,
  bhashaImage52,
  bhashaImage54,
  bhashaImage72,
  bhashaImage78,
  bhashaImage8,
  bhashaImage90,
  bhashaImage95,
  bhashaImage97,
  sanskritChildrenBanner,
  aurobindoRenaissanceBanner,
  iiasLogo,
  aurovedaLogo,
  kashmirShaivismBanner,
  aurobindoLecturesMedia,
  pedagogyBook,
  ekatmvadBook,
  eventReport1,
  eventReport2,
  eventReport3,
  eventReport4,
  eventReport5,
  eventReport6,
  eventReport7,
  eventReport8,
  eventReport9,
  eventReport10,
  eventReport11,
  annualReport1,
  annualReport2,
  annualReport3,
  anusree,
  sidharth,
  vishnu,
  logo,
  integralEducation1,
  integralEducation2,
  integralEducation3,
  integralEducation4,
  universalIntegralSub1,
  universalIntegralSub2,
  universalIntegralSub3,
  universalIntegralSub4,
  universalIntegralSub5,
  universalIntegralSub6,
  universalIntegralSub7,
  universalIntegralSub8,
  universalIntegralSub9,
  universalIntegralSub10,
  universalIntegralSub11,
  universalIntegralSub12,
  universalIntegralSub13,
  universalIntegralSub14,
  universalIntegralSub15,
  universalIntegralSub16,
  shaivismBlogImage,
  spiritualityPoliticsBlogImage,
  antyodayaBlogImage,
  onamMainImage,
  onamSec1Image,
  onamSec2Image,
  roboticsBlogImage,
  upasika,
  ghantaBlogImage,
  ghantaSec1,
  ghantaSec2,
  ghantaSec3,
  kumbhakarnaBlogImage,
  avadhanaMindBlogImage,
  avadhanaTraditionImage,
  quest2MindMirrorImage,
  silenceBlogImage,
  aiRoboticsBlogImage,
  bhutadaGrantBlogImage,
  humilityLifeBlogImage,
  user,
  nurturingCuriosityBlogImage,
  socialOrderCubeBlogImage,
  tridentHumanismBlogImage,
  reconnectingNatureBlogImage,
  aurobindoSocioPoliticalBlogImage,
  damini,
  quest1MindTerrainImage,
  iksMilestone1,
  iksMilestone2,
  iksMilestone3,
  iksMilestone4,
  iksMilestone5,
  iksMilestone6,
  iksMilestone7,
  iksMilestone8,
  iksMilestone9,
  iksMilestone10,
  iksMilestone11,
  iksMilestone12,
  sangeeta,
  ranjanaSwain,
  sanjeevKumar,
  durgeshRai,
  sakshiVermani,
  shrutiSharma,
  stateWiseYogaProject,
  advancingIntegralBook,
} from "./image";

// Featured Research Projects for the homepage
export const researchProjects = [
  {
    id: 10,
    title: "IKS Awareness Program for School Children",
    description:
      "This Program introduces young minds across Bharat to India's civilizational knowledge heritage through workshops, exhibitions, and multilingual resources, reconnecting students, teachers, and parents with timeless Indian Knowledge Systems.",
    status: "ongoing",
    leader: "Prof. Sampadananda Mishra",
    slug: "iks-awareness-program",
    image: iksAwarenessProject,
  },
  {
    id: 11,
    title:
      "Effect of Sanskrit Chandas (Metres) on Children with Learning Disabilities",
    description:
      "This two-year interdisciplinary research project aims to examine how the rhythmic precision of Sanskrit Chandas can enhance focus, memory, and emotional balance in children with specific learning disabilities.",
    status: "ongoing",
    leader: "Prof. Sampadananda Mishra",
    slug: "sanskrit-chandas-learning-disabilities",
    image: chandasProject,
  },
  {
    id: 12,
    title: "Integral Humanism Initiative",
    description:
      "The Integral Humanism Initiative explores a holistic vision of humanity by synthesising the profound teachings of Sri Aurobindo, Swami Vivekananda, and Pt. Deendayal Upadhyaya.",
    status: "ongoing",
    leader: "Prof. Sampadananda Mishra",
    slug: "integral-humanism-initiative",
    image: ihiProject,
  },
  {
    id: 13,
    title: "Translation - Vashishtha Kavyakatha Ganapati Muni's Works",
    description:
      "This project aims to translate the works of Kavyakanth Vashishtha Ganapati Muni from Sanskrit into English and Hindi, opening new vistas for further research in academia.",
    status: "ongoing",
    leader: "Prof. Sampadananda Mishra",
    slug: "ganapati-muni-translation",
    image: kavyakanth3,
  },
  {
    id: 14,
    title: "Sanskrit Literature for Children",
    description:
      "This project, in collaboration with Central Sanskrit University, New Delhi, under the Ashtadashi Scheme, created ten children's books in Sanskrit aimed at developing stories, rhymes, songs, and playlets.",
    status: "completed",
    leader: "Prof. Sampadananda Mishra",
    slug: "sanskrit-literature-children",
    image: slcBanner,
  },
  {
    id: 15,
    title: "Avadhanakala and Consciousness Studies",
    description:
      "The Avadhanakala and Consciousness Studies project focused on developing cognitive faculties and included research in Avadhanakala, practical implications of Yogic shastras, and a comparative study of Indian psychology, yoga, and consciousness studies.",
    status: "completed",
    leader: "Prof. Sampadananda Mishra",
    slug: "avadhanakala-consciousness-studies",
    image: avadhanakalaBanner,
  },
  {
    id: 16,
    title: "Role of CRPs in Empowering Rural Communities",
    description:
      "Community Resource Persons (CRPs) served as grassroots change-makers, mobilising rural communities and strengthening Self-Help Groups under DAY-NRLM. This study empirically examined their selection, training, autonomy, and impact in Uttar Pradesh.",
    status: "completed",
    leader: "Prof. Sampadananda Mishra",
    slug: "crp-empowering-rural-communities",
    image: crpProjectBanner,
  },
];

// Complete list of research projects for the Research Projects page
export const allResearchProjects = [
  {
    id: 17,
    title: "State-wise Contributions to the Yoga Traditions in India",
    description:
      "The project, State-wise Contributions to the Yoga Tradition in India, aims to document and analyse the diverse regional foundations that have shaped the evolution of yoga across the Indian subcontinent.",
    status: "ongoing",
    leader: "Prof. Sampadananda Mishra",
    sponsors: ["Haryana State Higher Education Council"],
    slug: "state-wise-contributions-yoga-traditions",
    image: stateWiseYogaProject,
    detailedContent: {
      duration: "2026 - Present",
      intro:
        "This project seeks to document and analyse the diverse regional foundations that have shaped the evolution of yoga across 22 major states of India. While yoga is globally recognised, existing scholarship often presents it as a homogenous tradition. This project adopts a state-wise approach and an expert-driven methodology. A year-long lecture series (22 lectures) will complement the research. The outcomes include one edited volume with 22 chapters and a digital repository. The project aims to create a consolidated academic narrative of India’s yogic heritage.",
      about: [
        "This project seeks to document and analyse the diverse regional foundations that have shaped the evolution of yoga across 22 major states of India. While yoga is globally recognised, existing scholarship often presents it as a homogenous tradition. This project adopts a state-wise approach and an expert-driven methodology. A year-long lecture series (22 lectures) will complement the research. The outcomes include one edited volume with 22 chapters and a digital repository. The project aims to create a consolidated academic narrative of India’s yogic heritage.",
      ],
      objectives: [
        "Document Yoga Traditions across 22 states.",
        "Analyse literature and manuscripts.",
        "Study institutions.",
        "Conduct expert consultants.",
        "Publish one edited volume.",
        "Conduct 22 lectures.",
        "Create a digital repository.",
      ],
      framework: {
        description: "The Implementation Blueprint",
        blueprint: [
          {
            title: "State-wise Research & Documentation",
            description: "Develop a framework to map yoga traditions across 22 states through literature review."
          },
          {
            title: "Lecture Series",
            description: "Engage 22 Subject Matter Experts through the year-long lecture series."
          },
          {
            title: "Digital Repository",
            description: "Systematically organise research findings, lecture recordings, and archival materials into a comprehensive digital repository."
          }
        ]
      },
      futurePathway: [
        {
          title: "Research Publications",
          description: "Publication of a comprehensive scholarly volume containing 22 chapters, with each chapter dedicated to one of the 22 selected states, documenting the yoga traditions across India."
        },
        {
          title: "Educational Resources",
          description: "Establishment of a publicly accessible digital repository, containing lecture recordings and research summaries."
        }
      ],
      team: [
        {
          name: "Prof. Sampadananda Mishra",
          role: "Principal Investigator",
          title: "",
          img: sampadananda,
        },
        {
          name: "Neelabh Kumar Sharma",
          role: "Core Team",
          title: "",
          img: neelabh,
        },
        {
          name: "Sanchita Berry",
          role: "Core Team",
          title: "",
          img: user,
        },
      ],
    },
  },
  {
    id: 14,
    title: "Sanskrit Literature for Children",
    description:
      "This project, in collaboration with Central Sanskrit University, New Delhi, under the Ashtadashi Scheme, created ten children's books in Sanskrit aimed at developing stories, rhymes, songs, and playlets.",
    status: "completed",
    leader: "Prof. Sampadananda Mishra",
    sponsors: ["Central Sanskrit University, New Delhi"],
    slug: "sanskrit-literature-children",
    image: slcBanner,
    detailedContent: {
      duration: "2023 - 2026",
      intro:
        "The project Sanskrit Literature for Children was undertaken by the Centre for Human Sciences, Rishihood University, in association with Central Sanskrit University, New Delhi, under the Ashtaadashi Scheme. The project aimed to encourage the creation of high-quality Sanskrit literature for children through stories, rhymes, songs, playlets, and other creative literary forms suitable for young learners.",
      about: [
        "Recognising the need for engaging and accessible Sanskrit content for children, the project brought together writers, educators, and creative practitioners to contribute original works in simple and child-friendly Sanskrit. The initiative focused on developing literature that could nurture imagination, language learning, creativity, and cultural rootedness among children.",
        "The project encouraged innovative literary and pedagogical approaches, including stories, poems, songs, anecdotes, and classroom-based teaching methods that could make Sanskrit learning joyful, interactive, and meaningful. Special emphasis was placed on simple language, child-centric themes, and the incorporation of new Sanskrit vocabulary relevant to children's everyday lives.",
        "In addition to literary contributions, the project invited works on navÄcÄra (innovation in teaching and learning), encouraging educators to share classroom experiments, creative pedagogical practices, and innovative methods for effectively teaching Sanskrit to children.",
        "As part of the project, ten Sanskrit children's books were successfully published, contributing significantly to the growing body of contemporary Sanskrit children's literature. These publications represent an important step towards revitalising Sanskrit learning among young readers and promoting creative writing in Sanskrit for future generations.",
        "The project also helped create a broader network of Sanskrit writers, teachers, and educators interested in children's literature and innovative Sanskrit pedagogy, thereby strengthening ongoing efforts to develop Sanskrit educational resources for children.",
      ],
      books: [
        {
          title: "Krīḍākautukī",
          author: "Sampadananda Mishra",
          image: kridakautuki,
          links: {
            amazon:
              "https://www.amazon.in/Kr%C4%ABd%C4%81kautuki-%E0%A4%95%E0%A5%8D%E0%A4%B0%E0%A5%80%E0%A4%A1%E0%A4%BE%E0%A4%95%E0%A5%8C%E0%A4%A4%E0%A5%81%E0%A4%95%E0%A5%80-Sampadananda-Mishra/dp/9347691151",
            garuda:
              "https://garudalife.in/kridakautuki-%E0%A4%95%E0%A5%8D%E0%A4%B0%E0%A5%80%E0%A4%A1%E0%A4%BE%E0%A4%95%E0%A5%8C%E0%A4%A4%E0%A5%81%E0%A4%95%E0%A5%80",
            exoticIndia:
              "https://www.exoticindiaart.com/book/details/kridakautuki-hch387/",
          },
        },
        {
          title: "Abhyāsalaharī",
          author: "Asha Agrawal",
          image: abhyasalahari,
          links: {
            amazon:
              "https://www.amazon.in/Abhy%C4%81salahar%C4%AB-%E0%A4%85%E0%A4%AD%E0%A5%8D%E0%A4%AF%E0%A4%BE%E0%A4%B8%E0%A4%B2%E0%A4%B9%E0%A4%B0%E0%A5%80-Asha-Agrawal/dp/9347691771",
            garuda: "https://garudalife.in/abhyasalahari",
            exoticIndia:
              "https://www.exoticindiaart.com/book/details/abhyasalahari-hch381/",
          },
        },
        {
          title: "Ramyanāṭakāni",
          author: "Arya Chandrashekhara",
          image: ramyanatakani,
          links: {
            amazon:
              "https://www.amazon.in/Ramyan%C4%81%C8%9Bak%C4%81ni-%E0%A4%B0%E0%A4%AE%E0%A5%8D%E0%A4%AF%E0%A4%A8%E0%A4%BE%E0%A4%9F%E0%A4%95%E0%A4%BE%E0%A4%A8%E0%A4%BF-Arya-Chandrashekhara/dp/9347691437",
            exoticIndia:
              "https://www.exoticindiaart.com/book/details/ramyanatakani-hch380/",
          },
        },
        {
          title: "Kathāślokaviṃśatikā",
          author: "Sampadananda Mishra",
          image: kathaslokavinshatika,
          links: {
            amazon:
              "https://www.amazon.in/Kath%C4%81%C5%9Blokavim%5%9Batik%C4%81-%E0%A4%95%E0%A4%A5%E0%A4%BE%E0%A4%B6%E0%A5%8D%E0%A4%B2%E0%A5%8B%E0%A4%95%E0%A4%B5%E0%A4%BF%E0%A4%82%E0%A4%B6%E0%A4%A4%E0%A4%BF%E0%A4%95%E0%A4%BE-Sampadananda-Mishra/dp/9347691119",
            flipkart:
              "https://www.flipkart.com/hi/kathlokavimatik/p/itmf6510fc074142",
            exoticIndia:
              "https://www.exoticindiaart.com/book/details/kathashlokavinshatika-hch386/",
          },
        },
        {
          title: "Laghugalpalatikā",
          author: "Upasika Ghosh, Vishnu Madhusudhanan",
          image: laghugalpalatika,
          links: {
            amazon:
              "https://www.amazon.in/Laghugalpalatik%C4%81-%E0%A4%B2%E0%A4%98%E0%A5%81%E0%A4%97%E0%A4%B2%E0%A5%8D%E0%A4%AA%E0%A4%B2%E0%A4%A4%E0%A4%BF%E0%A4%95%E0%A4%BE-Upasika-Ghosh/dp/9347691755",
            garuda:
              "https://garudalife.in/laghugalpalatika-%E0%A4%B2%E0%A4%98%E0%A5%81%E0%A4%97%E0%A4%B2%E0%A5%8D%E0%A4%AA%E0%A4%B2%E0%A4%A4%E0%A4%BF%E0%A4%95%E0%A4%BE",
            exoticIndia:
              "https://www.exoticindiaart.com/book/details/laghugalpalatika-hch382/",
          },
        },
        {
          title: "Kathāmālikā",
          author: "Madhusudan Mahapatra",
          image: kathamalika,
          links: {
            amazon:
              "https://www.amazon.in/Kath%C4%81m%C4%81lik%C4%81-%E0%A4%95%E0%A4%A5%E0%A4%BE%E0%A4%AE%E0%A4%BE%E0%A4%B2%E0%A4%BF%E0%A4%95%E0%A4%BE-Madhusudan-Mahapatra/dp/B0GGZ8382K",
            exoticIndia:
              "https://www.exoticindiaart.com/book/details/kathamalika-hch385/",
          },
        },
        {
          title: "Kathā Bhāratī",
          author: "Radhika Ranjan Das",
          image: kathabharati,
          links: {
            amazon:
              "https://www.amazon.in/Katha-Bh%C4%81rat%C4%AB-Radhika-Ranjan-Das/dp/9347691275",
            exoticIndia:
              "https://www.exoticindiaart.com/book/details/katha-bharati-hch383/",
          },
        },
        {
          title: "Kākaḥ Kāko Vako Vakaḥ",
          author: "Narayana Dash",
          image: kakahkako,
          links: {
            amazon:
              "https://www.amazon.in/K%C4%81kah-K%C4%81ko-Vako-Vakah-%E0%A4%95%E0%A4%BE%E0%A4%95%E0%A4%83/dp/9347691283",
            exoticIndia:
              "https://www.exoticindiaart.com/book/details/kakah-kako-vako-vakah-children-s-story-collection-hch388/",
          },
        },
        {
          title: "Śabdakrīḍā",
          author: "Priyanka Salekar",
          image: shabdakrida,
          links: {
            amazon:
              "https://www.amazon.in/%C5%A0abdakr%C4%ABd%C4%81-%E0%A4%B6%E0%A4%AC%E0%A5%8D%E0%A4%A6%E0%A4%95%E0%A5%8D%E0%A4%B0%E0%A5%80%E0%A4%A1%E0%A4%BE-Priyanka-Salekar/dp/934769195X",
            garuda: "https://garudalife.in/sabdakrida",
            exoticIndia:
              "https://www.exoticindiaart.com/book/details/sabdakrida-hch389/",
          },
        },
        {
          title: "Rāmāyaṇakathāmañjarī",
          author: "Sangeeta Sharma",
          image: ramayanakathamanjari,
          links: {
            amazon:
              "https://www.amazon.in/R%C4%81m%C4%81ya%C5%86akath%C4%81ma%C3%B1jar%C4%AB-%E0%A4%B0%E0%A4%BE%E0%A4%AE%E0%A4%BE%E0%A4%AF%E0%A4%A3%E0%A4%95%E0%A4%A5%E0%A4%BE%E0%A4%AE%E0%A4%9E%E0%A5%8D%E0%A4%9C%E0%A4%B0%E0%A5%80-Sangeeta-Sharma/dp/9347691666",
            exoticIndia:
              "https://www.exoticindiaart.com/book/details/ramayana-kathamanjari-hch384/",
          },
        },
      ],
      team: [
        {
          name: "Prof. Sampadananda Mishra",
          role: "Principal Investigator",
          title: "Director, CHS",
          img: sampadananda,
        },
        {
          name: "Neelabh Kumar Sharma",
          role: "Project Coordinator",
          title: "",
          img: neelabh,
        },
        {
          name: "Dr. Upasika Ghosh",
          role: "Co-coordinator",
          title: "",
          img: upasika,
        },
        {
          name: "Vishnu M",
          role: "Co-coordinator",
          title: "",
          img: vishnu,
        },
        {
          name: "Dr. Sangeeta Sharma",
          role: "Data Entry Operator",
          title: "",
          img: sangeeta,
        },
        {
          name: "Ranjana Swain",
          role: "Book Designer",
          title: "",
          img: ranjanaSwain,
        },
      ],
    },
  },
  {
    id: 10,
    title: "IKS Awareness Program for School Children",
    description:
      "This Program introduces young minds across Bharat to India's civilizational knowledge heritage through workshops, exhibitions, and multilingual resources, reconnecting students, teachers, and parents with timeless Indian Knowledge Systems.",
    status: "ongoing",
    leader: "Prof. Sampadananda Mishra",
    sponsors: ["Ms Vandana Govil (NRI, USA)"],
    slug: "iks-awareness-program",
    image: iksAwarenessProject,
    detailedContent: {
      duration: "2025 - present",
      intro:
        "Bringing Bhāratīya Jñāna Paramparā to the Next Generation. A comprehensive national initiative aligning with NEP 2020 to integrate India's timeless civilizational wisdom into school ecosystems and contemporary learning frameworks.",
      about: [
        "The IKS Awareness Program for School Children Project is a structured, value-driven national model pioneered by the Centre for Human Sciences (CHS), Rishihood University.",
        "Supported by the generous patronage of Smt. Vandana Govil, a New York–“based visionary, the program's core objective is to ensure young minds encounter India's ancient knowledge heritage early in their development. By providing schools with supplementary materials and organising interactive workshops, the initiative removes the unfamiliarity of traditional knowledge before students step into higher education.",
      ],
      impacts: [
        {
          title: "Grassroots-Proven Impact",
          description:
            "Initial pilot programs in government schools across Sonipat demonstrated transformative results. Children gaining immediate cultural pride, inspiring the vision to expand the project nationwide.",
        },
        {
          title: "Alignment with NEP 2020",
          description:
            "Deeply embedded in the national framework to build character, responsibility, and civic awareness using localised, traditional pedagogical models.",
        },
      ],
      framework: {
        description:
          "To transition from a local pilot into a nationwide movement, CHS has entered into a strategic collaboration with READ India.",
        blueprint: [
          {
            title: "Strategic Reach",
            description:
              "Targeting a phased expansion beginning with 200 foundational schools.",
          },
          {
            title: "Training of Trainers (ToT) Model",
            description:
              "CHS designs specialised academic content and directly trains school teachers.",
          },
          {
            title: "Hierarchical Coordination",
            description:
              "A robust monitoring mechanism runs from School Teachers up through District Coordinators and State Coordinators.",
          },
        ],
      },
      milestones: {
        title: "Our ground milestones and workshops",
        description:
          "Our expert teams have completed intensive, interactive regional workshops featuring experiential elements such as Vedic Mathematics, storytelling, and holistic body-mind awareness for 1,500+ students in Haryana and Uttar Pradesh.",
        images: [
          iksMilestone1,
          iksMilestone2,
          iksMilestone3,
          iksMilestone4,
          iksMilestone5,
          iksMilestone6,
          iksMilestone7,
          iksMilestone8,
          iksMilestone9,
          iksMilestone10,
          iksMilestone11,
          iksMilestone12,
        ],
      },
      futurePathway: [
        {
          title: "Multilingual Knowledge Hub",
          description:
            "Compiling comprehensive IKS Student Handbooks and Teacher's Manuals in 22 constitutional languages.",
        },
        {
          title: "National IKS Olympiad",
          description:
            "Launching a pan-India competitive assessment program to spark healthy motivation and structured learning.",
        },
        {
          title: "Visual Storytelling Assets",
          description:
            "Deployment of 10 customised educational standee sets mapping out 30 unique foundational areas of IKS.",
        },
      ],
      featuredCourse: {
        title: "IKS AWARENESS COURSE",
        description:
          "An Online Certificate Course for Educators, Facilitators & Curious Minds. Seed contemporary classrooms with traditional insights.",
        fee: "₹101",
        duration: "10 Months",
        schedule: "Every Friday | 7:00 PM – 8:00 PM IST",
        modules: "30+ Immersive Learning Modules",
        certificationRequirement:
          "5 Graded Compulsory Quizzes spread systematically across the tenure",
        stagesTitle: "The Curricular Journey: The Pañcha Kośa Framework",
        stagesDescription:
          "This course treats IKS not as a dead relic, but as an active lens for knowing and being, progressively mapped from outer layers of physical reality to inner layers of consciousness:",
        link: "https://online.rishihood.edu.in/courses/IKS-AC",
        stages: [
          "Annamaya Kosha ( Sacred Geography & Foundations)",
          "Prāṇamaya Kosha (Vital Forces & Practical Life)",
          "Manomaya & Vijñānamaya Kosha (Mind, Intellect, & Science)",
          "Ānandamaya Kosha (Culmination & Inner Experience)",
        ],
      },
      team: [
        {
          name: "Prof. Sampadananda Mishra",
          role: "Academic Architect",
          title: "Director, CHS",
          img: sampadananda,
        },
        {
          name: "Smt. Vandana Govil",
          role: "Global Patron",
          title: "Visionary Supporter",
          img: vandana,
        },
        {
          name: "Shri Neelabh Kumar Sharma",
          role: "Executive Strategy",
          title: "Asst. Director, CHS",
          img: neelabh,
        },
        {
          name: "Shri Dipankar Bhattacharya",
          role: "Program Manager",
          title: "Manager, Content & Research",
          img: dipankar,
        },
        {
          name: "Dr Diwakar Sharma",
          role: "Core Team",
          title: "Research Assistant",
          img: diwakar,
        },
      ],
    },
  },
  {
    id: 11,
    title:
      "Effect of Sanskrit Chandas (Metres) on Children with Learning Disabilities",
    description:
      "This two-year interdisciplinary research project aims to examine how the rhythmic precision of Sanskrit Chandas can enhance focus, memory, and emotional balance in children with specific learning disabilities. Integrating classical Sanskrit wisdom with modern neuroscience, the project employs cognitive and neuroimaging assessments to evaluate the impact of Chandas recitation on cognitive processes.",
    status: "ongoing",
    leader: "Prof. Sampadananda Mishra",
    sponsors: ["IKS Division, Ministry of Education, GoI"],
    slug: "sanskrit-chandas-learning-disabilities",
    image: chandasProject,
    detailedContent: {
      duration: "2025 - Present",
      intro:
        "The research project Effect of Sanskrit Chandas (Metres) on Children with Learning Disabilities aims to explore the cognitive and therapeutic potential of Sanskrit Chandas for children with learning disabilities. Rooted in ancient Indian traditions, Chandas have long been regarded as integral to linguistic, poetic, and musical expression, influencing cognition, memory, concentration, and emotional well-being.",
      about: [
        "The project seeks to scientifically examine whether structured recitation and auditory exposure to Sanskrit metres can improve cognitive abilities, enhance attention span, increase focus and memory, and support emotional regulation in children diagnosed with learning disabilities. By bridging Sanskrit prosody with modern neuroscience and cognitive science, the project aspires to contribute both to Indian Knowledge Systems and contemporary educational and therapeutic practices.",
        "Recent studies have highlighted the role of rhythm and structured sound patterns in cognitive development and neuroplasticity. Building on these insights, this project proposes investigating the impact of Sanskrit Chandas using advanced neuroscientific methods such as EEG and fMRI. The study aims to map neural responses and analyse behavioural outcomes associated with reciting and listening to Sanskrit metres.",
        "The research is being conducted in multiple phases, including pilot neuroimaging studies, experimental interventions, cognitive and behavioural assessments, and comprehensive data analysis. The findings are expected to contribute towards the development of culturally rooted, non-invasive, and accessible interventions for children with learning disabilities.",
      ],
      impacts: [
        {
          title: "Scientific Validation",
          description:
            "To analyse the neuroscientific effects of the Sanskrit Chandas on brain activity and behavioral outcomes.",
        },
        {
          title: "Therapeutic Potential",
          description:
            "Exploring Chandas as a low-cost, culturally rooted, and non-invasive cognitive intervention for inclusive education.",
        },
      ],
      framework: {
        description:
          "The project adopts an interdisciplinary methodology integrating Sanskrit studies, neuroscience, psychology, cognitive science, and education.",
        blueprint: [
          {
            title: "Literature Review",
            description:
              "Comprehensive study on Sanskrit Chandas, cognition, and neuroplasticity.",
          },
          {
            title: "Neuroimaging Studies",
            description:
              "Advanced research using EEG and fMRI to map neural responses.",
          },
          {
            title: "Behavioral Assessments",
            description:
              "Participant observation and individual/group-based intervention studies.",
          },
        ],
      },
      objectives: [
        "To analyse the neuroscientific effects of the Sanskrit Chandas on brain activity",
        "To study the impact of Chandas on attention, memory, concentration, and emotional regulation",
        "To evaluate the effectiveness of Chandas-based interventions for children with learning disabilities",
        "To develop structured Chandas-based educational and therapeutic models",
        "To integrate Sanskrit prosody with modern neuroscience, psychology, and education",
        "To create scalable frameworks for incorporating Chandas into special education and cognitive therapy practices",
      ],
      futurePathway: [
        {
          title: "Research Publications",
          description:
            "Scientific studies and academic documentation on the cognitive impact of Chandas.",
        },
        {
          title: "Educational Resources",
          description:
            "Integrating Sanskrit Chandas into cognitive learning frameworks and special education.",
        },
        {
          title: "Policy Recommendations",
          description:
            "Integrating Indian Knowledge Systems into inclusive education practices.",
        },
      ],
      currentStatus:
        "The project is currently ongoing. Preliminary groundwork, literature review, research design, and collaborations with schools, therapists, and research institutions are underway in the study's initial phase.",
      team: [
        {
          name: "Prof. Sampadananda Mishra",
          role: "Principal Investigator",
          title: "Director, CHS",
          img: sampadananda,
        },
        {
          name: "Neelabh Kumar Sharma",
          role: "Project Coordinator",
          title: "Assistant Director (Research & Admin)",
          img: neelabh,
        },
        {
          name: "Tanushree S. Ranjangaonkar",
          role: "Research Assistant",
          title: "",
          img: tanushree,
        },
      ],
    },
  },
  {
    id: 12,
    title: "Integral Humanism Initiative",
    description:
      "The Integral Humanism Initiative (IHI) at the Centre for Human Sciences seeks to explore and develop a holistic vision of humanity through the philosophical framework of Ekatma Manava Darshan or Integral Humanism, propounded by Pt. Deendayal Upadhyaya.",
    status: "ongoing",
    leader: "Prof. Sampadananda Mishra",
    sponsors: ["Star Pipe Foundry, Rajkot"],
    slug: "integral-humanism-initiative",
    image: ihiProject,
    detailedContent: {
      duration: "2023 - Present",
      intro:
        "The Integral Humanism Initiative (IHI) at the Centre for Human Sciences seeks to explore and develop a holistic vision of humanity through the philosophical framework of Ekatma Manava Darshan or Integral Humanism, propounded by Pt. Deendayal Upadhyaya.",
      about: [
        "Initiated in 2023 with the support of Star Pipe Foundry, Rajkot, the initiative undertakes interdisciplinary research on the relevance of indigenous Indian thought in addressing contemporary social, political, economic, educational, and spiritual challenges.",
        "Integral Humanism emerges as an alternative philosophical framework rooted in a consciousness-centric understanding of life. It envisions an organic harmony between material and spiritual dimensions and views the human being not merely as a physical or economic entity, but as an integral synthesis of Body, Mind, Intellect, and Soul.",
        "The initiative undertakes rigorous academic research on the philosophy of Pt. Deendayal Upadhyaya and its intellectual resonances with thinkers such as Sri Aurobindo, Swami Vivekananda, Adi Shankaracharya, and other philosophers of Bharat.",
      ],
      sections: [
        {
          title: "Philosophical Roots",
          content: [
            "Pt Deen Dayal Upadhyay’s concept of “Integral Humanism” advocates a human-centric worldview, seeking harmony between material and spiritual aspects. Ekatma Manav Darshan and Integral Education are key components, emphasizing the interconnectedness of all forms of life. Along with Pt. Deen Dayal Upadhyaya, the centre’s work will also focus on Swami Vivekananda, Sri Aurobindo, and their profound philosophies, which have striking similarities with Ekatma Manava Darshan.",
          ],
          image: ihiPhilosophicalRoots,
        },
        {
          title: "Relevance in the Modern World",
          content: [
            "**Failures of Absolute Models**\nThe failures of various economic and social models have led to a realization of the importance of Integral Humanism. Pt Deen Dayal Upadhyay’s philosophy provides a human-centric perspective, promoting organic unity and integrity between materiality and spirituality. His thoughts on nationalism, economics, politics, and spirituality remain relevant in a world dominated by greed and identity conflicts.",
            "**Indian Thought vs Western Concept**\nIndian thought, unlike the Western concept, views individuals as universes and emphasizes interconnectedness. Pt Deen Dayal Upadhyay’s philosophy goes beyond Western frameworks, promoting “Decolonization” by valuing Sanskrit, heritage, and political activism. His ideas on Rajneeti, Arthaneeti, Samaj, and Rashtra highlight the importance of duty-oriented governance and the role of families in societal strengthening.",
          ],
        },
      ],
      impacts: [
        {
          title: "Holistic Well-being",
          description:
            "Advocates harmony over conflict, cooperation over competition, and holistic well-being over material excess.",
        },
        {
          title: "Dharmic Principles",
          description:
            "Proposes that economic growth and political organisation must remain rooted in ethical and dharmic principles.",
        },
      ],
      objectives: [
        "Compare Integral Humanism with other social theories (capitalism, communism, socialism).",
        "Explore similarities with Sri Aurobindo’s Integral Education.",
        "Propose a Value Education intervention based on SDGs in the context of Ekatma Manava Darsan.",
        "Evaluate government policies under Antyodaya.",
        "Create awareness in academic, rural, and corporate circles.",
        "Imbibe ideas in the younger generation through workshops and classes.",
        "Examine ideology through multidisciplinary research.",
        "Spread ideas in rural and remote areas.",
        "Acquaint the program with the teacher community.",
        "Develop a new generation of thinkers aligned with Deen Dayal ji’s ideology.",
      ],
      framework: {
        description:
          "The project currently focuses on three broad sectors: Academia, Social and Economic Studies, and Corporate and Organisational Thought.",
        blueprint: [
          {
            title: "Academic Research",
            description:
              "Extensive study of the writings and ideas of Pt Deendayal Upadhyaya, Sri Aurobindo, and Swami Vivekananda.",
          },
          {
            title: "Social & Economic Studies",
            description:
              "grassroots development models and community-based empowerment practices.",
          },
          {
            title: "Corporate Thought",
            description:
              "Exploring how traditional Indian values can contribute to contemporary business environments.",
          },
        ],
      },
      milestones: {
        title: "Milestones",
        content: [
          {
            text: "The Integral Humanism Initiative (IHI), rooted in the theoretical framework of Pandit Deendayal Upadhyaya, has achieved significant academic and field-based milestones. Following extensive field studies in locations like Chitrakoot and Pondicherry, the team organized a landmark international conference in 2023, resulting in published proceedings and an upcoming edited volume of articles. Other tangible outputs include a research methodology book, a detailed field study report, and the Sanatana Drsti, a compilation of ancient verses reflecting the vision of Ekatma Manava Darshan (EMD). Moreover, PI Dr. Sampadananda Mishra translated core lectures into Sanskrit for Central Sanskrit University. Also, the team continues to produce a 200-part blog series and a comprehensive glossary of EMD ideals.",
            images: [ihiMilestone1, ihiMilestone2],
          },
          {
            text: 'Practical engagement and capacity building remain central to the initiative, exemplified by the training of nine interns and six researchers to date. The project\'s reach was further extended through the Ekatmabodha and Chiti Prabha exhibitions, which visually articulated the philosophy of integral living. Seeking to ground theory in practice, the IHI team engaged with various experts and institutions to evaluate their work. This included a visit to KDBA Vidyalaya in Madhya Pradesh to observe tribal education models and an interaction with Dr. Mahesh Chandra Sharma, who emphasized the need for a contextual glossary and the integration of IH into teacher training programs.\n\nThe initiative also explores the philosophical intersections between Deendayal Upadhyaya’s EMD and Sri Aurobindo’s Integral Education. During a dialogue with Alok Pandey ji, the team discussed shifting human consciousness as a prerequisite for political progress and the necessity of a curriculum that fosters conscious choice. Similarly, the interaction with Kittu Reddy Da underscored the importance of experiential learning and storytelling over dry theory when teaching young children. These discussions highlighted a shared vision of a "spiritualized society" where education serves as a tool for divine manifestation and national service.',
            images: [
              ihiMilestone3,
              ihiMilestone4,
              ihiMilestone5,
              ihiMilestone6,
            ],
          },
          {
            text: 'To ensure contemporary relevance, the team consulted Deshpandey ji, who challenged the initiative to move beyond mere preservation toward "creative originality" and self-reliance. He advocated for a holistic vision that adapts to modern technological advancements while maintaining India’s historical legacy. Collectively, these milestones and interactions reflect a robust effort to transform Integral Humanism from a historical philosophy into a living, academic, and practical framework for future societal growth.',
            image: ihiMilestone7,
          },
        ],
      },
      team: [
        {
          name: "Prof. Sampadananda Mishra",
          role: "Principal Investigator",
          title: "Director, CHS",
          img: sampadananda,
        },
        {
          name: "Neelabh Kumar Sharma",
          role: "Project Coordinator",
          title: "Assistant Director (Research & Admin)",
          img: neelabh,
        },
        {
          name: "Anusree S.L.",
          role: "Assistant Professor",
          title: "CHS",
          img: anusree,
        },
        {
          name: "Vishnu M.",
          role: "Research Assistant",
          title: "CHS",
          img: vishnu,
        },
        {
          name: "Sidhartha Kumar Nayak",
          role: "Research Assistant",
          title: "CHS",
          img: sidharth,
        },
      ],
      researchersTrained: [
        {
          name: "Abhishek Tripati",
          role: "Research Associate",
          img: abhishekTrained,
        },
        {
          name: "Siddarth Rana",
          role: "Research Associate",
          img: sidharthaTrained,
        },
        {
          name: "Riya Vardhan Saxena",
          role: "Research Associate",
          img: riyaTrained,
        },
        {
          name: "Rithin Kumar Miriyala",
          role: "Research Associate",
          img: rithinTrained,
        },
        {
          name: "Akhil Kumar Singh",
          role: "Research Associate",
          img: akhilTrained,
        },
        { name: "Swati Semwal", role: "Research Assistant", img: swatiTrained },
        { name: "Tanu", role: "Research Assistant", img: tanuTrained },
      ],
    },
  },
  {
    id: 13,
    title: "Translation - Vashishtha Kavyakatha Ganapati Muni's Works",
    description:
      "This project aims to translate the works of Kavyakanth Vashishtha Ganapati Muni from Sanskrit into English and Hindi, opening new vistas for further research in academia.",
    status: "ongoing",
    leader: "Prof. Sampadananda Mishra",
    sponsors: ["Vande Matram Library Trust"],
    slug: "ganapati-muni-translation",
    image: kavyakanth3,
    detailedContent: {
      duration: "2022 - Present",
      intro:
        "Translation of Kavyakantha Vashishtha Ganapati Muni's Works. A joint initiative by Centre for Human Sciences, Rishihood University & Vande Mataram Library Trust.",
      about: [
        "Vashishtha Ganapati Muni is a prominent name among the greatest and most prolific scholars that India has produced in the modern age. The volume of his writings is vast, and their quality is remarkable. But the tragedy is that after his death, very little research has been done on his works. The numerous Sanskrit writings of the Muni are not very popular even in academia.",
        "His writings cover a wide variety of topics –“ praises and prayers to various deities (stotras), poetic compositions (kavyas), philosophy (darshanam), logic (nyayashastra), medical science (ayurveda), astrology and astronomy (jyotishashastra), commentaries (bhashya), novel (akhyayika), letters (patrani) and many other important works like bharatacharitramimamsa which deals with the Vedic origin of the characters of the Mahabharata, mahavidyasutra which is a complete text dealing exclusively with the ten Wisdom Goddesses of the Tantra, where he has presented all the correlations of the mahavidyas from outer ritual to the highest spiritual knowledge.",
        "When the freedom fighters were busy overseeing the freedom of Mother India from the hands of the foreigners, it was the Muni who, in 1934 prepared the constitution for India in Sanskrit. This work has 560 sutras. Indranisaptashati is another important work of the Muni that bears testimony to his deep love for India. There are 700 verses, divided into 7 centuries. Each century is further divided into four stabakas. In the twenty-fourth verse of each stabaka, the poet seeks the grace of the Divine Mother as an instrument in the immense task of serving his country in order that it regains its past glory. Here in this composition, the Muni prays again and again to Goddess Indrani for the upliftment and protection of his country at this juncture, when human efforts are not enough to release her from the bondage of darkness and inertia.",
        "All compositions of the Muni, whether those are in verse or in the form of aphorisms (sutras) or in prose (gadya), were all spontaneous, a result of his tapas, an outpouring of his soul in seeking or gratitude to the Divine.",
        "Therefore, translation becomes an important tool in order to popularise Ganapati Muni's works, so that the entire world can benefit from the vast reservoir of knowledge that his works contain. This project aims to translate Muni's works from Sanskrit (source language) into Hindi and English (target languages), two of the most prominent languages in India. The translation of Muni's works will open new vistas for further research in academia.",
      ],
      impacts: [
        {
          title: "Versatile Genius",
          description:
            "Muni was a yogi, poet, philosopher, critic, and scholar whose writings cover spirituality, cosmology, metaphysics, and science.",
        },
        {
          title: "Global Reach",
          description:
            "Translating these works opens new vistas for further research in academia and brings them to a wider global audience.",
        },
      ],
      sections: [
        {
          title: "Who was Kavyakantha Vashishtha Ganapati Muni?",
          content: [
            "India has produced many exceptional poets and scholars, among whom, Kavyakanth Vashishtha Ganapati Muni is a prominent name in the modern era. He was born on 17th November 1878 in Kalavarayi, a small village in the Vizag district of Andhra Pradesh. He was a yogi, poet, philosopher, critic, scholar, an eloquent speaker, and an ardent devotee of Mother India. He was single-minded about the attainment of India's freedom through the power of his tapas and believed that the future of India rests on a complete revival of the Vedic truths. He untiringly endeavoured to reveal the inner significances of the Vedic hymns.",
            "Ganapati Muni's story is beautifully depicted in his biography, Vashishtha Vaibhavam, composed by Shri Kapali Shastri. Ganapati Muni was educated at home by his father, who, like his ancestors, was well-versed in Mantra Shastra, Astrology, and Ayurveda. It is said that he could prepare a panchangam (almanac) at the tender age of ten.",
            "After studying classical Sanskrit poetry, he devoted himself to grammar and poetics. He completely immersed himself in the writings of Vyasa and Valmiki and read their works repetitively. This gained him great expertise in the study of the Mahabharata.",
            "His horizon widened, and his intellect mellowed with an ever-deepening perception. He was married at an early age to Srimati Vishalakshi, but this did not stop him from pursuing his spiritual and scholarly expedition. Like the ancient Rishis, Ganapati sought to experience immense strength and power through tapasya, mantra japa, and meditation.",
            "He used to visit one sacred place after another and stay there for a few days or even months to pursue his tapasya, even when he was just 18 years of age. On one such visit to Bhubaneswar, in Orissa, at the famous Lingaraj temple of Lord Siva, during his tapas, the Muni had a vision in which Goddess Lalitambika (Bhubaneshwari) appeared before him, offering divine nectar. As Ganapati tasted this heavenly nectar, the Goddess watched him with a sweet smile, full of grace. From then onwards, the sweetness of the nectar became an integral part of him. After this incident, Ganapati's intellect developed a rare sharpness, and he attained complete mastery over poetry. Indeed, the literary works composed after this incident are endowed with a distinct sweetness and grace.",
            "It was in Kashi that Ganapati learned that an assembly of scholars (harisabha) was to be organised in the city of Nabadwipa in Bengal. The assembly was meant to showcase scholars' scholarship. Ganapati's friends advised him to obtain a letter of introduction and participate in the assembly. The twenty-two-year-old Muni attended the assembly and proved himself to be the best among them. Because of this, he was honoured with the title of –˜Kavyakanth' by the eminent scholars who attended the harisabha. Kavyakanth can be translated as \"one with a poetic voice.\"",
            "The Muni then returned to the south in his 25th year. From Kanchipuram, he came to Arunachala (Thiruvannamalai) in 1903 to perform tapas. He visited Sri Brahmana Swamy twice before accepting a teaching job in Vellore in 1904. Later in 1907, he resigned from his job at Vellore and returned to Arunachala. The Muni still felt that his life's purpose was not fulfilled, and he approached Brahmana Swamy for his grace and to gain inner realisation, peace, and the true import of tapas, which he still lacked. On 18th February 1907, the Muni approached Brahmana Swamy, who was staying in the Virupaksha cave and prostrating himself at his feet, prayed for enlightenment about the nature of tapas. For quite sometime Brahmana Swamy gazed silently at Kavyakantha. Then he broke his 11-year-long silence and spoke gently, If one watches where his notion of –˜I' springs, the mind will be absorbed into that. That is tapas. If a mantra is repeated and attention is directed to the source of the mantra's sound, the mind will be absorbed in it. That is tapas.",
            "The Muni was filled with joy to have found his guru. He conferred the full name of Bhagavan Sri Ramana Maharshi to Brahmana Swamy, whose original name was Venkataraman. Thus, the meeting was of profound significance not only for Kavyakantha but also for the world at large, which could learn from such a high authority about the real stature of Bhagavan Sri Ramana Maharshi, the Silent Sage of Arunachala. Following this momentous meeting, Ganapati composed his great devotional poem, Umasahasram, a thousand-verse poem in praise of Uma, the Divine Mother, as part of his tapas in gratitude to the great Goddess for having given him the Maharshi as his Guru (Master). This work is the magnum opus of Sri Vasishtha Ganapati Muni.",
            "Ganapati Muni passed away in 1936, leaving behind a remarkable legacy for us to cherish and propagate. Vasishtha Kavyakantha Ganapati Muni was endowed with such unique scholarship and the ability to express himself that he could write or speak elaborately on any topic with apparent ease. Therefore, his writings cover a wide range of topics, including spirituality, cosmology, metaphysics, science, poetry, linguistics, etc. He composed poetry and sutras, wrote commentaries, and penned novels, articulating his views on many serious topics with force, intensity, fluency, lucidity, and loftiness.",
            "In addition to being a poet, patriot, yogi, Tantrik, and a Rishi with right vision, the Muni was an excellent avadhani. He possessed an exceptional retentive memory, a great power of concentration, the ability to compose unblemished extempore poetry, spontaneous creativity, imagination, poetic ability, and quick thinking, all of which add greatly to his consummate scholarship and literary genius.",
          ],
          image: kavyakanth4,
        },
        {
          title: "The Works of Ganapati Muni",
          content: [
            "As a scholar-poet, Vasishtha Ganapati Muni has many spiritual and other writings in Sanskrit to his credit. Umasahasram, Gitamala, Ramanagita, Ramanacatvarimshat, and Saddarshanam are a few titles well-known among his disciples and others. But very little is known about his other numerous Sanskrit writings, covering a wide variety of topics –“ stotras, kavyas, darshana, nyayashastra, ayurveda, jyotishashastra, bhashya, akhyayika, patrani and many research works. His versatility can also be judged from his samrajya-nibandhanam, a proposed constitution for India and lalibhashopadesha, a new language for the people of India. These compositions, whether in verse (shokas) or in the form of aphorisms (sutras) or prose (gadya), were all spontaneous, a result of his tapas, an outpouring of his soul in seeking or gratitude to the Divine.",
            "His stotrakavyas, umasahasram, indranisaptashati, pracandacanditrishati, and gitamala are meant for those longing for a great spiritual realisation. The Indrasahashranama is a composition of a thousand names of Indra culled from the Rigveda, and strung into a garland of one hundred and eight verses. The Ramanacatvarimshat, 40 verses in praise of Bhagavan Sri Ramana Maharshi, is chanted daily both at the Sri Ramana Ashramam and in the homes of Sri Ramana Maharshi's innumerable devotees. The Muni had a unique ability to render philosophical thoughts in the form of poetry (shlokas), and his vishvamimamsa, ramanagita, saddarshanam, and tattvaghantashatakam remain testimony to this. Ramanagita is a record of questions posed by disciples and the answers given by the Maharshi, and is one of the most cherished writings of the Muni. His Saddarshanam is the Sanskrit rendering of Sri Maharshi's Tamil writing, Ulladu Narpadu (Forty Verses on Reality), on which his beloved and learned disciple, Sri T.V. Kapali Sastriar, has written a faithful commentary in Sanskrit, reflecting the spirit of Sri Maharshi's original teachings.",
            "From the wide variety of his sutra writings, it would be difficult to single out any one as more meritorious than the other. Dashamahavidyasutram (the ten cosmic powers of the Divine Mother as described in the tantras) is an outstanding composition in which the Muni has described the ten cosmic aspects of the Divine Mother and their significance. Here, he has also brought out the association between these ten cosmic aspects of the Mother, as described in the Tantra, and the corresponding Vedic deities. Thereby, he has not only been able to bring forth a link among the Vedas, Upanishads and Tantras, but has also been successful in dispelling several misconceptions about the significance of these deities. These compositions reflect the Muni's great powers of Yogic perception. The way in which he has expounded the different deities, such as Kali, Tara, Bhuvaneshvari, Tripurasundari, Pracandacandi, etc., and correlated them with Vedantic concepts has once and for all removed all antagonisms and bridged the so-called gulf between the Vedantic and Tantric schools of philosophy.",
            "Rajayoga-sarasutra is a short and concise exposition of the Upanishadic methods of the inner quest. The Caturvyuhasutra is a revelation of the cosmic divinities, wherein the Muni has expounded the four important emanations –“ akasha, kala, vidyut, and surya –“ of the Vedic deity Indra. Jaiminiyatarkavartikam is his own interpretation of the Jaimini sutras, in which he argues that the Vedas are indeed paurusheya (of human origin). Further, in this, he has given his own interpretation of the Mimamsa philosophy, placing it on a higher pedestal in relation to Vedanta. His Shabdapramanacarca also discusses the origin of the Vedas. Pancajanacarca and Vivahadharmasutram are related to social aspects. In the former one, the practice of untouchability is condemned with the authority of the shastras. In the latter, he deals with marriage as a sacrament. His other sutra writings also include cikitsanushasanam (Ayurveda) and ganaka kanthabharanam (Astronomy).",
            "The prose writings of Vasishtha Ganapati Muni, too, are extensive and include commentaries on several texts, including the Vedas and Upanishads; a study of the different characters in the great epic poem Mahabharata; letters to Sri Ramana Maharshi, The Mother of the Sri Aurobindo Ashram, and many others. His commentaries on Rigvedic mantras and the Isopanishad, though brief, are revealing and illuminating. The Muni has given his own original spiritual interpretation of the Mantras, and he was highly critical of the ritualistic interpretation of the Rigvedic Mantras by Sayana, a 12th-century commentator on the Vedas. The Muni's commentary on the Ishopanishad is original and is in the light of the teachings of Sri Ramana Maharshi. His Bharata-caritramimamsa is unique as it establishes a link between some of the important characters of the Mahabharata and those mentioned in the Vedic texts. Ramanagita, Saddarshana, and the commentary on the Upadeshasararam are amongst the most popular writings of the Muni.",
            "His Sanskrit novel, Purna, though incomplete, is unique in many ways. The style and diction that the Muni used here make it an unparalleled novel of his time. It not only depicts the Muni's ability to write beautiful Sanskrit prose spontaneously, but also records his power to express the feelings of the heart, not just the logic of the mind.",
            "In the letters of the Muni to Sri Maharshi and The Mother of the Sri Aurobindo Ashram, one can find the art of letter writing in Sanskrit. Through these letters, he was able to express his deepest aspirations, concepts and thoughts. However, it is difficult to summarise the Muni's thoughts, perceptions, and literary ability. The Muni was indeed a versatile genius and can be compared with Kalidasa and Shankara in poetic renderings, with Vyasa in sutra writings and with Patanjali, Shabara and Shankara in writing commentaries. The writings of the Muni are not just products of literary activity but records of his unique Yogic experiences and subtle visions, which will serve as a guiding spirit and light for centuries to come.",
          ],
          image: kavyakanth2,
        },
      ],
      framework: {
        description:
          "This project proposes facilitating the translation of Ganapati Muni's works from Sanskrit (source language) into English and Hindi (target languages).",
        blueprint: [
          {
            title: "Target Languages",
            description:
              "Sanskrit into English and Hindi, broadening the work's reach to a wider audience.",
          },
          {
            title: "Books Translated",
            description:
              "The project aims to translate eleven books by Ganapati Muni.",
          },
          {
            title: "Scholarly Precision",
            description:
              "Translations accompanied by detailed annotations explaining linguistic and philosophical nuances.",
          },
          {
            title: "Review Committee",
            description:
              "A dedicated committee reviews and approves all translated works.",
          },
        ],
      },
      currentStatus:
        "The project is currently ongoing. So far, most of the volumes have been translated into Hindi, while the English translations are currently in progress.",
      team: [
        {
          name: "Prof. Sampadananda Mishra",
          role: "Principal Investigator",
          title: "Director, CHS",
          img: sampadananda,
        },
      ],
    },
  },
  {
    id: 14,
    title: "Sanskrit Literature for Children",
    description:
      "This project, in collaboration with Central Sanskrit University, New Delhi, under the Ashtadashi Scheme, created ten children's books in Sanskrit aimed at developing stories, rhymes, songs, and playlets.",
    status: "completed",
    leader: "Prof. Sampadananda Mishra",
    sponsors: ["Central Sanskrit University, New Delhi"],
    slug: "sanskrit-literature-children",
    image: slcBanner,
    detailedContent: {
      duration: "2023 - 2026",
      intro:
        "The project Sanskrit Literature for Children was undertaken by the Centre for Human Sciences, Rishihood University, in association with Central Sanskrit University, New Delhi, under the Ashtaadashi Scheme. The project aimed to encourage the creation of high-quality Sanskrit literature for children through stories, rhymes, songs, playlets, and other creative literary forms suitable for young learners.",
      about: [
        "Recognising the need for engaging and accessible Sanskrit content for children, the project brought together writers, educators, and creative practitioners to contribute original works in simple and child-friendly Sanskrit. The initiative focused on developing literature that could nurture imagination, language learning, creativity, and cultural rootedness among children.",
        "The project encouraged innovative literary and pedagogical approaches, including stories, poems, songs, anecdotes, and classroom-based teaching methods that could make Sanskrit learning joyful, interactive, and meaningful. Special emphasis was placed on simple language, child-centric themes, and the incorporation of new Sanskrit vocabulary relevant to children's everyday lives.",
        "In addition to literary contributions, the project invited works on navÄcÄra (innovation in teaching and learning), encouraging educators to share classroom experiments, creative pedagogical practices, and innovative methods for effectively teaching Sanskrit to children.",
        "As part of the project, ten Sanskrit children's books were successfully published, contributing significantly to the growing body of contemporary Sanskrit children's literature. These publications represent an important step towards revitalising Sanskrit learning among young readers and promoting creative writing in Sanskrit for future generations.",
        "The project also helped create a broader network of Sanskrit writers, teachers, and educators interested in children's literature and innovative Sanskrit pedagogy, thereby strengthening ongoing efforts to develop Sanskrit educational resources for children.",
      ],
      books: [
        {
          title: "Krīḍākautukī",
          author: "Sampadananda Mishra",
          image: kridakautuki,
          links: {
            amazon:
              "https://www.amazon.in/Kr%C4%ABd%C4%81kautuki-%E0%A4%95%E0%A5%8D%E0%A4%B0%E0%A5%80%E0%A4%A1%E0%A4%BE%E0%A4%95%E0%A5%8C%E0%A4%A4%E0%A5%81%E0%A4%95%E0%A5%80-Sampadananda-Mishra/dp/9347691151",
            garuda:
              "https://garudalife.in/kridakautuki-%E0%A4%95%E0%A5%8D%E0%A4%B0%E0%A5%80%E0%A4%A1%E0%A4%BE%E0%A4%95%E0%A5%8C%E0%A4%A4%E0%A5%81%E0%A4%95%E0%A5%80",
            exoticIndia:
              "https://www.exoticindiaart.com/book/details/kridakautuki-hch387/",
          },
        },
        {
          title: "Abhyāsalaharī",
          author: "Asha Agrawal",
          image: abhyasalahari,
          links: {
            amazon:
              "https://www.amazon.in/Abhy%C4%81salahar%C4%AB-%E0%A4%85%E0%A4%AD%E0%A5%8D%E0%A4%AF%E0%A4%BE%E0%A4%B8%E0%A4%B2%E0%A4%B9%E0%A4%B0%E0%A5%80-Asha-Agrawal/dp/9347691771",
            garuda: "https://garudalife.in/abhyasalahari",
            exoticIndia:
              "https://www.exoticindiaart.com/book/details/abhyasalahari-hch381/",
          },
        },
        {
          title: "Ramyanāṭakāni",
          author: "Arya Chandrashekhara",
          image: ramyanatakani,
          links: {
            amazon:
              "https://www.amazon.in/Ramyan%C4%81%C8%9Bak%C4%81ni-%E0%A4%B0%E0%A4%AE%E0%A5%8D%E0%A4%AF%E0%A4%A8%E0%A4%BE%E0%A4%9F%E0%A4%95%E0%A4%BE%E0%A4%A8%E0%A4%BF-Arya-Chandrashekhara/dp/9347691437",
            exoticIndia:
              "https://www.exoticindiaart.com/book/details/ramyanatakani-hch380/",
          },
        },
        {
          title: "Kathāślokaviṃśatikā",
          author: "Sampadananda Mishra",
          image: kathaslokavinshatika,
          links: {
            amazon:
              "https://www.amazon.in/Kath%C4%81%C5%9Blokavim%C5%9Batik%C4%81-%E0%A4%95%E0%A4%A5%E0%A4%BE%E0%A4%B6%E0%A5%8D%E0%A4%B2%E0%A5%8B%E0%A4%95%E0%A4%B5%E0%A4%BF%E0%A4%82%E0%A4%B6%E0%A4%A4%E0%A4%BF%E0%A4%95%E0%A4%BE-Sampadananda-Mishra/dp/9347691119",
            flipkart:
              "https://www.flipkart.com/hi/kathlokavimatik/p/itmf6510fc074142",
            exoticIndia:
              "https://www.exoticindiaart.com/book/details/kathashlokavinshatika-hch386/",
          },
        },
        {
          title: "Laghugalpalatikā",
          author: "Upasika Ghosh, Vishnu Madhusudhanan",
          image: laghugalpalatika,
          links: {
            amazon:
              "https://www.amazon.in/Laghugalpalatik%C4%81-%E0%A4%B2%E0%A4%98%E0%A5%81%E0%A4%97%E0%A4%B2%E0%A5%8D%E0%A4%AA%E0%A4%B2%E0%A4%A4%E0%A4%BF%E0%A4%95%E0%A4%BE-Upasika-Ghosh/dp/9347691755",
            garuda:
              "https://garudalife.in/laghugalpalatika-%E0%A4%B2%E0%A4%98%E0%A5%81%E0%A4%97%E0%A4%B2%E0%A5%8D%E0%A4%AA%E0%A4%B2%E0%A4%A4%E0%A4%BF%E0%A4%95%E0%A4%BE",
            exoticIndia:
              "https://www.exoticindiaart.com/book/details/laghugalpalatika-hch382/",
          },
        },
        {
          title: "Kathāmālikā",
          author: "Madhusudan Mahapatra",
          image: kathamalika,
          links: {
            amazon:
              "https://www.amazon.in/Kath%C4%81m%C4%81lik%C4%81-%E0%A4%95%E0%A4%A5%E0%A4%BE%E0%A4%AE%E0%A4%BE%E0%A4%B2%E0%A4%BF%E0%A4%95%E0%A4%BE-Madhusudan-Mahapatra/dp/B0GGZ8382K",
            exoticIndia:
              "https://www.exoticindiaart.com/book/details/kathamalika-hch385/",
          },
        },
        {
          title: "Kathā Bhāratī",
          author: "Radhika Ranjan Das",
          image: kathabharati,
          links: {
            amazon:
              "https://www.amazon.in/Katha-Bh%C4%81rat%C4%AB-Radhika-Ranjan-Das/dp/9347691275",
            exoticIndia:
              "https://www.exoticindiaart.com/book/details/katha-bharati-hch383/",
          },
        },
        {
          title: "Kākaḥ Kāko Vako Vakaḥ",
          author: "Narayana Dash",
          image: kakahkako,
          links: {
            amazon:
              "https://www.amazon.in/K%C4%81kah-K%C4%81ko-Vako-Vakah-%E0%A4%95%E0%A4%BE%E0%A4%95%E0%A4%83/dp/9347691283",
            exoticIndia:
              "https://www.exoticindiaart.com/book/details/kakah-kako-vako-vakah-children-s-story-collection-hch388/",
          },
        },
        {
          title: "Śabdakrīḍā",
          author: "Priyanka Salekar",
          image: shabdakrida,
          links: {
            amazon:
              "https://www.amazon.in/%C5%A0abdakr%C4%ABd%C4%81-%E0%A4%B6%E0%A4%AC%E0%A5%8D%E0%A4%A6%E0%A4%95%E0%A5%8D%E0%A4%B0%E0%A5%80%E0%A4%A1%E0%A4%BE-Priyanka-Salekar/dp/934769195X",
            garuda: "https://garudalife.in/sabdakrida",
            exoticIndia:
              "https://www.exoticindiaart.com/book/details/sabdakrida-hch389/",
          },
        },
        {
          title: "Rāmāyaṇakathāmañjarī",
          author: "Sangeeta Sharma",
          image: ramayanakathamanjari,
          links: {
            amazon:
              "https://www.amazon.in/R%C4%81m%C4%81ya%C5%86akath%C4%81ma%C3%B1jar%C4%AB-%E0%A4%B0%E0%A4%BE%E0%A4%AE%E0%A4%BE%E0%A4%AF%E0%A4%A3%E0%A4%95%E0%A4%A5%E0%A4%BE%E0%A4%AE%E0%A4%9E%E0%A5%8D%E0%A4%9C%E0%A4%B0%E0%A5%80-Sangeeta-Sharma/dp/9347691666",
            exoticIndia:
              "https://www.exoticindiaart.com/book/details/ramayana-kathamanjari-hch384/",
          },
        },
      ],
      team: [
        {
          name: "Prof. Sampadananda Mishra",
          role: "Principal Investigator",
          title: "Director, CHS",
          img: sampadananda,
        },
      ],
    },
  },
  {
    id: 15,
    title: "Avadhanakala and Consciousness Studies",
    description:
      "The Avadhanakala and Consciousness Studies project focused on developing cognitive faculties and included research in Avadhanakala, practical implications of Yogic shastras, and a comparative study of Indian psychology, yoga, and consciousness studies.",
    status: "completed",
    leader: "Prof. Sampadananda Mishra",
    sponsors: [
      "Indian Knowledge Systems (IKS) Division, Ministry of Education, Government of India",
    ],
    slug: "avadhanakala-consciousness-studies",
    image: avadhanakalaBanner,
    detailedContent: {
      duration: "2022–“2025",
      intro:
        "The Centre for Human Sciences, Rishihood University, conducted the project Avadhanakala and Consciousness Studies with the support of the Indian Knowledge Systems (IKS) Division, Ministry of Education, Government of India. The project focused on the revival, documentation, research, and dissemination of the ancient Indian art of multiple concentration known as Avadhanakala.",
      about: [
        "Avadhanakala is a remarkable literary and cognitive tradition that demonstrates extraordinary abilities of concentration, memory, multitasking, creativity, and mental discipline. Historically practised in Sanskrit and prominently preserved in the Telugu and Kannada traditions, Avadhanakala integrates literature, music, mathematics, philosophy, astrology, and other knowledge systems into highly sophisticated performances that demand simultaneous attention and recollection.",
        "The project explored Avadhanakala not only as a performing art but also as a significant resource for Indian psychology, consciousness studies, cognitive development, and education. Through research, workshops, performances, publications, courses, and public engagement initiatives, the project worked towards bringing this rare tradition into contemporary academic and educational discourse.",
      ],
      sections: [
        {
          title: "RATIONALE",
          content: [
            "Although Avadhanakala survives today in a few linguistic and cultural traditions, the number of practising Avadhanis has steadily declined. The art has largely remained confined to performances and scattered documentation, while its deeper cognitive, psychological, and educational dimensions have remained underexplored.",
            "The project addressed this gap by studying Avadhanakala through literature review, participant observation, interviews with Avadhanis, workshops, surveys, and documentation. The project also sought to connect traditional Indian understandings of memory, concentration, and consciousness with contemporary discussions in cognitive science and education.",
          ],
        },
        {
          title: "OUTCOMES: MAJOR ACTIVITIES AND ACHIEVEMENTS",
          content: [
            "Avadhana Sangama: The project organised Avadhana Sangama events that brought together practitioners of diverse forms of Avadhanakala, including Netraavadhanam, Ghantavadhanam, Ganitavadhanam, Yogasutravadhanam, Chitrakalavadhanam, Sahityavadhanam, BhagavadgÄ«tÄvadhÄnam, TÄlavadhÄnam, and more. These gatherings became important platforms for documentation, performance, training, and cultural exchange.",
            "Workshops and Educational Outreach: The project developed educational activities and workshops to enhance memory, concentration, creativity, and cognitive abilities among learners. Workshops such as 'The Marvels of Avadhanakala' introduced students to various aspects of memory, attention, and multiple concentration through interactive exercises and demonstrations.",
            "Balavadhanam: The project developed Balavadhanam, a structured programme for children designed to strengthen memory, observation, creativity, and concentration through carefully curated activities inspired by Avadhanakala.",
            "Engagement: More than 860 participants, including students and teachers, engaged in workshops, performances, lecture series, and training programmes conducted as part of the project.",
            "Courses and Lecture Series: As part of the project, a 4-credit course titled 'Avadhana –“ Cultivating Cognitive Mastery' was developed to integrate traditional knowledge systems with contemporary educational approaches. The project also conducted a 12-lecture online lecture series on Avadhanakala, creating a valuable digital resource for learners and researchers.",
          ],
        },
        {
          title: "IMPACT",
          content: [
            "The project demonstrated the relevance of Avadhanakala in contemporary educational and cognitive contexts. By integrating traditional Indian knowledge systems with modern pedagogical approaches, the project created new possibilities for research, cognitive training, cultural preservation, and public engagement.",
            "The project also contributed towards documenting lesser-known Avadhana traditions, developing educational models inspired by Avadhanakala, and expanding public awareness of this unique Indian cognitive art form through workshops, publications, performances, and digital outreach.",
          ],
        },
        {
          title: "FUTURE DIRECTIONS",
          content: [
            "The project has laid the foundation for further research, educational programmes, field documentation, and national outreach related to Avadhanakala. Future initiatives aim to document regional Avadhana traditions, expand educational integration, and develop advanced courses and training programmes focused on cognitive development and Indian knowledge systems.",
          ],
        },
      ],
      books: [
        {
          title: "The Wonder that is Avadhanam",
          author: "Sampadananda Mishra",
          image: wonderAvadhanam,
          links: {
            amazon: "https://lnkd.in/d3wJaNf4",
            flipkart: "https://lnkd.in/d2xaA_R2",
            khanna: "https://lnkd.in/dd55er4f",
          },
        },
        {
          title: "Avadhana Tradition in Odisha",
          author: "Prateek Pattanaik",
          image: traditionOdisha,
          links: {
            amazon: "https://lnkd.in/dwZDKjxa",
            flipkart: "https://lnkd.in/dEqSDV6S",
            khanna: "https://lnkd.in/dAsY7JUz",
          },
        },
        {
          title:
            "The Art of Avadhana: Unveiling the Secrets of Human Attention and Memory",
          author: "S. Vaishnavi",
          image: artAvadhana,
          links: {
            amazon: "https://lnkd.in/dE6N9VU8",
            flipkart: "https://lnkd.in/dtsjCSWy",
            khanna: "https://lnkd.in/dbvzwK5z",
          },
        },
        {
          title: "जैन धर्म में अवधान",
          author: "Surbhi Bhagat",
          image: jainAvadhana,
          links: {
            amazon: "https://lnkd.in/dBVmCBaf",
            flipkart: "https://lnkd.in/dpBMYz6t",
            khanna: "https://lnkd.in/dix45nD2",
          },
        },
      ],
      team: [
        {
          name: "Prof. Sampadananda Mishra",
          role: "Principal Investigator",
          title: "Director, CHS",
          img: sampadananda,
        },
        {
          name: "Aarti Panchal",
          role: "Research Assistant",
          title: "",
          img: aartip,
        },
        {
          name: "Damini Roy",
          role: "Research Assistant",
          title: "",
          img: damini,
        },
        {
          name: "Neelabh Kumar Sharma",
          role: "Research Associate",
          title: "",
          img: neelabh,
        },
      ],
    },
  },
  {
    id: 16,
    title: "Role of CRPs in Empowering Rural Communities",
    description:
      "Community Resource Persons (CRPs) served as grassroots change-makers, mobilising rural communities and strengthening Self-Help Groups under DAY-NRLM. This study empirically examined their selection, training, autonomy, and impact in Uttar Pradesh.",
    status: "completed",
    leader: "Prof. Sampadananda Mishra",
    sponsors: ["Indian Council of Social Science Research (ICSSR)"],
    slug: "crp-empowering-rural-communities",
    image: crpProjectBanner,
    detailedContent: {
      duration: "2023-2024",
      intro:
        "This project delves into the optimal utilization and role of Community Resource Persons (CRPs) within poverty-stricken areas across five selected districts of Uttar Pradesh. The Deendayal Antyodaya Yojana-National Rural Livelihoods Mission (DAY-NRLM) stands as a pivotal initiative in India's efforts toward poverty alleviation.",
      about: [
        "Despite existing studies on poverty alleviation and related schemes, there remains a gap in specifically focusing on the socio-economic impact of the Deendayal Antyodaya Yojana and the role of CRPs. CRPs, deeply embedded within local communities, serve as catalysts for change by actively mobilizing communities, facilitating the formation of SHGs, and providing crucial capacity-building support to SHG members.",
      ],
      objectives: [
        "To critically evaluate the efficacy of the CRP selection criteria employed in identifying individuals for community development by examining their socio-economic backgrounds.",
        "To analyze how the empowerment of CRPs with autonomy influences their effectiveness in implementing community development initiatives.",
        "To assess the actual effect of CRPs on reducing poverty within communities, using socio-economic conditions as a pivotal parameter.",
        "To explore the socio-economic role of CRPs in strengthening community participation and decision-making processes within DAY-NRLM initiatives.",
      ],
      sections: [
        {
          title: "METHODS",
          content: [
            "The study investigates the role of Community Resource Persons (CRPs) within poverty-stricken areas across five selected districts categorized by Niti Ayog's National Multidimensional Poverty Index: A Progress Review 2023. Utilizing an empirical research approach, the study examines 550 relevant samples from 1200 respondents. The districts under scrutiny include Balrampur, Chitrakoot, Gonda, Kaushambi, and Siddharthnagar.",
            "Comprehensive data on the number of CRPs at the block level, Self-Help Groups (SHGs), and other stakeholders–”District Collectors, District Mission Managers, Block Mission Managers–”are gathered through primary data collection methods, along with information sourced from the DAY-NRLM websites and Annual Reports published by the Ministry of Rural Development (MoRD).",
            "The report is structured into six sections, providing an evaluation framework, demographic analysis, and findings pertaining to relevance, effectiveness, efficiency, sustainability, and monitoring mechanisms.",
          ],
        },
        {
          title: "DATA COLLECTION",
          content: [
            "The assessment encompassed 22 blocks spanning 5 districts and entailed the gathering of 500 quantitative data samples along with 50 qualitative samples, totaling 550 collected samples. The overall sample size targeted was 1200 respondents, of whom 900 consented to participate in the primary data collection process.",
            "In the quantitative sample, the total number of Community Resource Persons (CRPs) amounted to 500. Demographic, social, and economic characteristics were examined, encompassing age, marital status, educational attainment, religious affiliation, social category, housing type, and income source.",
            "The qualitative data collection delved into motivations for joining the DAY-NRLM as CRPs, challenges encountered while working in this role, and examples of innovative approaches adopted by CRPs.",
            "Field studies and data collection in Balrampur, Chitrakoot, Gonda, Kaushambi, and Siddharthnagar.",
          ],
          images: [crpImpact1, crpImpact2, crpImpact3],
        },
      ],
      impactsTitle: "FINDINGS",
      impacts: [
        {
          title: "Enhanced Representation",
          description:
            "Substantial representation of marginalized communities among CRPs ensures diverse voices are heard, promoting equity and social justice.",
        },
        {
          title: "Transparency and Awareness",
          description:
            "High awareness of selection criteria fosters trust and collaboration between CRPs and community members.",
        },
        {
          title: "Empowerment and Autonomy",
          description:
            "CRPs exhibit a sense of autonomy in decision-making, enabling them to respond effectively to community needs and foster innovation.",
        },
        {
          title: "Contribution to Poverty Reduction",
          description:
            "Creating local employment, providing access to education, and offering financial support to break the cycle of poverty.",
        },
        {
          title: "Incentive-driven Participation",
          description:
            "Aligning incentives with community priorities enhances engagement and ensures program responsiveness.",
        },
        {
          title: "Multifaceted Impact",
          description:
            "Improving access to education, fostering local job creation, and providing essential healthcare facilities in rural areas.",
        },
      ],
      team: [
        {
          name: "Prof. Sampadananda Mishra",
          role: "Project Director & Co-ordinator",
          title: "Director, CHS, Rishihood University",
          img: sampadananda,
        },
        {
          name: "Prof. Sanjeev Kumar",
          role: "Project Director",
          title: "Dean, RSPL, Rishihood University",
          img: sanjeevKumar,
        },
        {
          name: "Dr. Durgesh Rai",
          role: "Project Director",
          title: "Associate professor, RSPL, Rishihood University",
          img: durgeshRai,
        },
        {
          name: "Dr. Sakshi Vermani",
          role: "Project Director",
          title: "Associate Professor, ScoPE, Rishihood University",
          img: sakshiVermani,
        },
        {
          name: "Dr. Dhiraj Kumar Sharma",
          role: "Research Associate",
          title: "",
          img: user,
        },
        {
          name: "Dr. Shruti Sharma",
          role: "Research Assistant",
          title: "",
          img: shrutiSharma,
        },
        {
          name: "Mr. Sonu Maurya",
          role: "Field Investigator",
          title: "",
          img: user,
        },
        {
          name: "Mr. Abhishek Yadav",
          role: "Field Investigator",
          title: "",
          img: user,
        },
        {
          name: "Mr. Pranav Asthana",
          role: "Field Investigator",
          title: "",
          img: user,
        },
        {
          name: "Mr. Amit Chaturvedi",
          role: "Field Investigator",
          title: "",
          img: user,
        },
        {
          name: "Dr. Akhil Kumar Singh",
          role: "Research Consultant",
          title: "CHS, Rishihood University",
          img: akhilTrained,
        },
        {
          name: "Ms. Anusree S.L.",
          role: "Research Consultant",
          title: "CHS, Rishihood University",
          img: anusree,
        },
      ],
    },
  },
];

// Events for the Events page and homepage
export const events = [
  {
    id: 1,
    title: "Philosophy of Mind in Indian Thought",
    description:
      "A comprehensive exploration of consciousness studies in classical Indian philosophical traditions and their contemporary relevance.",
    type: "Conference",
    date: {
      day: "15",
      month: "Sept",
    },
    time: "10:00 AM - 4:00 PM",
    location: "Main Auditorium",
    slug: "philosophy-mind",
    speakers: [
      {
        name: "Dr. Rajesh Mehta",
        affiliation: "Rishihood University",
        bio: "Leading scholar in Indian philosophical traditions and consciousness studies.",
      },
      {
        name: "Prof. Sarah Thompson",
        affiliation: "Oxford University",
        bio: "Comparative philosopher specializing in Eastern and Western conceptions of mind.",
      },
    ],
    registrationLink: "#",
    image:
      "https://images.unsplash.com/photo-1503428593586-e225b39bddfe?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 2,
    title: "Research Methodology for Humanities",
    description:
      "Hands-on workshop on qualitative research methods, archival research, and interpretive approaches to humanities scholarship.",
    type: "Workshop",
    date: {
      day: "22",
      month: "Sept",
    },
    time: "2:00 PM - 5:00 PM",
    location: "Seminar Hall B",
    slug: "research-methodology",
    speakers: [
      {
        name: "Dr. Vikram Rathore",
        affiliation: "Rishihood University",
        bio: "Research methodologist with expertise in qualitative approaches to humanities research.",
      },
    ],
    registrationLink: "#",
    image:
      "https://images.unsplash.com/photo-1431540015161-0bf868a2d407?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 3,
    title: "Ethics in the Digital Age",
    description:
      "Distinguished lecture exploring ethical frameworks for technology governance and digital citizenship in contemporary society.",
    type: "Lecture",
    date: {
      day: "30",
      month: "Sept",
    },
    time: "3:00 PM - 5:00 PM",
    location: "Conference Hall",
    slug: "ethics-digital-age",
    speakers: [
      {
        name: "Dr. Arun Sharma",
        affiliation: "Indian Institute of Technology",
        bio: "Expert in digital ethics and technology policy with over 20 years of experience.",
      },
    ],
    registrationLink: "#",
    image:
      "https://images.unsplash.com/photo-1563986768609-322da13575f3?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 4,
    title: "Cultural Heritage and Contemporary Art",
    description:
      "Symposium exploring the influence of traditional artistic forms on contemporary creative expressions in visual and performing arts.",
    type: "Symposium",
    date: {
      day: "10",
      month: "Oct",
    },
    time: "11:00 AM - 6:00 PM",
    location: "Art Gallery",
    slug: "cultural-heritage-art",
    speakers: [
      {
        name: "Ananya Roy",
        affiliation: "National School of Design",
        bio: "Contemporary artist whose work bridges traditional and modern aesthetic paradigms.",
      },
      {
        name: "Prof. David Chen",
        affiliation: "Museum of Modern Art",
        bio: "Curator specializing in Asian artistic traditions and their contemporary expressions.",
      },
    ],
    registrationLink: "#",
    image:
      "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 5,
    title: "Language, Literature and Identity",
    description:
      "Annual conference examining the role of linguistic and literary traditions in shaping individual and collective identities.",
    type: "Conference",
    date: {
      day: "20",
      month: "Oct",
    },
    time: "9:00 AM - 5:00 PM",
    location: "Main Auditorium",
    slug: "language-literature-identity",
    speakers: [
      {
        name: "Dr. Meera Krishnan",
        affiliation: "Rishihood University",
        bio: "Literary scholar specializing in comparative literature and identity studies.",
      },
      {
        name: "Prof. Amitav Ghosh",
        affiliation: "Columbia University",
        bio: "Award-winning author and scholar of postcolonial literature.",
      },
    ],
    registrationLink: "#",
    image:
      "https://images.unsplash.com/photo-1532153259564-a5f24f254bd6?auto=format&fit=crop&w=800&q=80",
  },
];

// Events for the three new sections
export const conferenceEvents = [
  {
    id: 101,
    title:
      "3rd International Scientific–“Spiritual Practical Conference on Universal Principles and Practices of Integral Education",
    heading:
      "3rd International Scientific–“Spiritual Practical Conference on Universal Principles and Practices of Integral Education",
    description:
      "The 3rd International Scientific–“Spiritual Practical Conference successfully convened a global cohort of scholars, practitioners, and spiritual leaders to explore Integral Education–”a transformative philosophy viewing learning as an evolutionary process of consciousness. Building on previous themes of Yoga and Healing, this edition solidified a multi-year international collaboration aimed at integrating academic rigour with spiritual practice.",
    type: "Conference",
    date: "January 24-25, 2026",
    slug: "universal-principles-practices-integral-education",
    image: confMain,
    link: "/events/conference/universal-principles-practices-integral-education",
    fullHeading:
      "3rd International Scientific–“Spiritual Practical Conference on Universal Principles and Practices of Integral Education",
    overview:
      "The 3rd International Scientific–“Spiritual Practical Conference successfully convened a global cohort of scholars, practitioners, and spiritual leaders to explore Integral Education–”a transformative philosophy viewing learning as an evolutionary process of consciousness. Building on previous themes of Yoga and Healing, this edition solidified a multi-year international collaboration to integrate academic rigour with spiritual practice.\nThe event achieved a truly global footprint, featuring active participation from six countries–”India, Russia, Ukraine, Poland, Belarus, and Norway–”and was supported by a robust international audience joining via virtual platforms.",
    programArchitecture: {
      description:
        "The two-day intensive schedule was structured to bridge theoretical frameworks with practical, lived experiences through:",
      items: [
        "19 Technical Sessions on Universology and Causal-Systemic approaches.",
        "7 Invited Talks from distinguished international experts.",
        "2 Dedicated Research Sessions featuring 7 peer-reviewed papers.",
      ],
    },
    keyHighlights: {
      title: "Key Highlights and Milestones",
      items: [
        {
          heading: "Inaugural Foundation",
          text: 'Opening on Vasant Panchami, the conference was sanctified by Vedic invocations. Leadership from Rishihood University and international organising secretaries from Russia and Poland set the stage for a "science-spirituality" synthesis.',
        },
        {
          heading: "Literary Launch",
          text: "The official release of the book, Universal Principles and Practices of Integral Education, served as a scholarly milestone, documenting the collective wisdom of this international partnership.",
        },
        {
          heading: "Keynote Insight",
          text: 'Prof. Pankaj Gupta delivered a pivotal address on the ontological shift from "doing" to "being" in modern pedagogy.',
        },
      ],
    },
    corePillars: [
      {
        heading: "1. Philosophical & Invited Insights",
        text: 'Distinguished speakers explored the "Science of Living" (Dr Anju Khanna), the "Information Excess" crisis (Shri Mohit Bansal), and the "Lived Experience" of integral systems (Ms Ritaja Mishra). These talks emphasised that education must address the five aspects of the human being: physical, vital, mental, psychic, and spiritual.',
      },
      {
        heading: "2. Technical & Practical Applications (Universology)",
        text: 'Led largely by Prof. Polyakov Vitalii Andreevich and international practitioners, these sessions focused on:\nCausal-Systemic Approaches: Understanding universal laws and human development.\nHealing Modalities: Practical masterclasses in Pyramid Healing, 4-Count Breathing, and the "Balance of Four Elements."\nEducational Leadership: Prof. Sampadananda Mishra redefined the Guru-Shishya relationship for the 21st century.',
      },
      {
        heading: "3. Empirical Research Contributions",
        text: 'Research scholars provided contemporary relevance to ancient principles, presenting findings on:\nThe impact of Yoga on academic stress and quality of life.\nThe "Integral Man" framework as a solution to capitalist/socialist educational binaries.\nThe role of Music and Dance in vital education and mental health.',
      },
    ],
    consensus: {
      title: "Consensus and Forward Outlook",
      text: "The conference concluded by reaffirming the three strategic aims of the International Scientific School of Universology:",
      items: [
        "Conscious Evolution: Shifting human development from reactive to intentional growth.",
        "Civilizational Integration: Fostering a unified global dialogue between Eastern spiritual wisdom and Western systemic science.",
        "Practical Outcomes: Ensuring that spiritual insights are translated into actionable educational and healing practices.",
      ],
      footer:
        'By providing the "land of the Rishis" as a fertile ground for dialogue, Rishihood University has reinforced its position as a global hub for Integral Education, ensuring that the light of consciousness continues to guide the path toward human perfection.',
    },
    gallery: [confSlide1, confSlide2, confSlide3, confSlide4],
  },
  {
    id: 102,
    title:
      "Indian Council of Philosophical Research sponsored World Philosophy Day Lecture Series on Philosophical Contribution of Contemporary Thinkers",
    heading:
      "Indian Council of Philosophical Research sponsored World Philosophy Day Lecture Series on Philosophical Contribution of Contemporary Thinkers",
    description:
      "The Indian Council of Philosophical Research sponsored World Philosophy Day Lecture Series on \u201cPhilosophical Contribution of Contemporary Thinkers\u201d was organised by the Centre for Human Sciences, Rishihood University, in partnership with the Group of Adult Education at the School of Social Sciences, Jawaharlal Nehru University, on 9 March 2024. The lecture series explored the philosophical contributions of major modern Indian thinkers and their relevance to contemporary society, education, democracy, spirituality, and human consciousness.",
    type: "Conference",
    date: "March 09, 2024",
    slug: "world-philosophy-day-lecture-series",
    image: confPhilosophyImage,
    link: "/events/conference/world-philosophy-day-lecture-series",
    fullHeading:
      "Indian Council of Philosophical Research sponsored World Philosophy Day Lecture Series on Philosophical Contribution of Contemporary Thinkers",
    convenor:
      "Prof. Sampadananda Mishra, Director, Centre for Human Sciences, Rishihood University",
    overview:
      "The Indian Council of Philosophical Research sponsored World Philosophy Day Lecture Series on \u201cPhilosophical Contribution of Contemporary Thinkers\u201d was organised by the Centre for Human Sciences, Rishihood University, in partnership with the Group of Adult Education at the School of Social Sciences, Jawaharlal Nehru University, on 9 March 2024. The lecture series explored the philosophical contributions of major modern Indian thinkers and their relevance to contemporary society, education, democracy, spirituality, and human consciousness.",
    inauguralSession: {
      title: "Inaugural Session",
      text: "The lecture series began with the Rishihood tradition of Ek\u0101grat\u0101 through a minute of silence. Sampadananda Mishra, Director of the Centre for Human Sciences, welcomed the participants and spoke on the significance of the lecture series and the rationale behind selecting the five thinkers \u2014 Sri Aurobindo, Deendayal Upadhyaya, Madan Mohan Malaviya, Ram Manohar Lohia, and Jiddu Krishnamurti.",
    },
    presidentialAddressShort: {
      title: "Presidential Address",
      text: "Kaushal Sharma delivered the presidential address, highlighting the significance of Indian civilization and its relevance to the National Education Policy. He emphasised the transition from Western philosophy to Indian philosophy and advocated for a greater place for Indian philosophical traditions within educational curricula. He further discussed philosophy as a timeless quest for truth and stressed the importance of integrating Indian philosophical values into contemporary education for holistic human development.",
    },
    introductionDetailed: {
      title: "Introduction",
      text: "The Indian Council of Philosophical Research sponsored World Philosophy Day Lecture Series on \u201cPhilosophical Contribution of Contemporary Thinkers\u201d was organized by the Centre for Human Sciences, Rishihood University, in partnership with the Group of Adult Education at the School of Social Sciences, Jawaharlal Nehru University on 9th March 2024. The lecture series began with the Rishihood Tradition of Ekagrata, by observing a minute of silence. Prof. Sampadananda Mishra, director, Centre for Human Sciences, welcomed all the participants and discussed the significance of the lecture series and the idea behind the selection of five thinkers: Sri Aurobindo, Pandit Deendayal Upadhyaya, Madan Mohan Malviya, Ram Manohar Lohiya, and Jiddu Krishnamurthy. The welcome address was followed by the felicitation of invited speakers and special guests.",
      images: [philosophyIntro1, philosophyIntro2],
    },
    presidentialAddressDetailed: {
      title: "Presidential Address",
      text: "Following the welcome speech, Prof. Kaushal Sharma, Dean of the School of Social Science at JNU, delivered the presidential address, an integral part of the event. His address encompassed several key points regarding the significance of Indian civilization and its alignment with the National Education Policy. Firstly, Prof. Sharma underscored the value of Indian civilization, emphasizing its importance in shaping the educational landscape of the nation. He highlighted how Indian civilization serves as a foundational pillar for the National Education Policy, indicating its intrinsic relevance to contemporary educational frameworks. Furthermore, Prof. Sharma delved into the transition period from Western philosophy to Indian Philosophy, shedding light on the evolving philosophical landscape. He advocated for a greater emphasis on Indian philosophy within educational curricula, recognizing its profound insights and contributions to humanity. The nature of philosophy became a focal point of Prof. Sharma's address. He elucidated that at the core of philosophy lies the perpetual quest for truth, a timeless pursuit that transcends temporal boundaries. Prof. Sharma emphasized that while the manifestations of philosophy may evolve with time, its fundamental essence remains constant.\n\nMoreover, Prof. Sharma elucidated the value system inherent in Indian philosophy and its potential impact on the education system. He stressed the necessity of integrating Indian philosophical principles into educational frameworks, citing their potential to foster holistic development and critical thinking among learners. In summary, Prof. Sharma's presidential address encapsulated the essence of Indian civilization, the transition within philosophical paradigms, and the imperative of incorporating Indian philosophical tenets into contemporary education systems. His insights provided a thought-provoking foundation for further discourse and exploration within the World Philosophy Day Lecture Series.",
      images: [philosophyPresAddress1, philosophyPresAddress2],
    },
    lectures: [
      {
        id: 1,
        title: "Integral Philosophy for Global Harmony: Sri Aurobindo's Vision",
        speaker: "Dr. Ramesh Bijlani",
        speakerDesignation: "Trustee, Sri Aurobindo Ashram-Delhi branch",
        link: "https://www.youtube.com/watch?v=ExIek_MciBE&list=PLNolcybM1tDgBR4h4vA5uZXHGZDccRod7&index=1&t=18s",
        description:
          "Dr. Ramesh Bijlani, Trustee, Sri Aurobindo Ashram-Delhi branch, delivered the first lecture of the series with an insightful discourse on the topic \"Integral Philosophy for Global Harmony: Sri Aurobindo's Vision.\" Commencing his speech with a profound quote from Sri Aurobindo's Integral Non-dualistic philosophy, Dr. Bijlani aimed to elucidate the rationality underlying Sri Aurobindo's intricate philosophical framework. Dr. Bijlani then delved into the significance of The Life Divine, a key text in Sri Aurobindo's philosophy, to illuminate the principles guiding human thought processes. Sri Aurobindo's philosophy, rooted in experiential understanding, was described as \"Integral Philosophy\" or the totality of an individual. Expanding on the concept of the \"Totality of Person,\" Dr. Bijlani emphasized that beyond the realms of mind and self, an individual's totality includes the intricate interplay of thinking, emotions, and the physical body. He elucidated that the organization of body, mind, and ego collectively forms a unified entity.\n\nThe exploration continued into the realm of consciousness, wherein Dr. Bijlani posited that consciousness is essentially awareness, with varying degrees determining human nature. He drew connections between consciousness and global harmony, asserting that harmony on a global scale should be rooted in human unity, which, in turn, emanates from the principles of oneness and love. Dr. Bijlani concluded his discussion by shedding light on Sri Aurobindo's approach to the world, envisioning it as a cohesive whole. He highlighted the historical duality in human tendencies, demonstrating the perpetual struggle between conflicting forces since ancient times.\n\nIn his conclusion, Dr. Bijlani conveyed the lesson that collective military conquests by nations, driven by rulers seeking economic and political benefits, lead to inevitable collapse. Instead, he advocated for a shift in focus towards psychological oneness, emphasizing that fostering harmony is achievable through a united and interconnected human consciousness.",
        images: [philosophyLecture1Img1, philosophyLecture1Img2],
      },
      {
        id: 2,
        title:
          "Integral Humanism in the 21st Century: Pandit Deen Dayal Upadhyaya's Relevance",
        speaker: "Shri Deepak Sharma",
        speakerDesignation:
          "Member of the Central Working Committee and All India Associate Head of Treasury of the Swadeshi Jagaran Manch",
        link: "https://www.youtube.com/watch?v=2RSBGAZYWNs&list=PLNolcybM1tDgBR4h4vA5uZXHGZDccRod7&index=2",
        description:
          "Shri Deepak Sharma, member of the Central Working Committee and All India Associate Head of Treasury of the Swadeshi Jagaran Manch, delivered a thought-provoking speech on \"Integral Humanism in the 21st Century: Pandit Deen Dayal Upadhyaya's Relevance.\" Initiating his address with the definitions of Parasparavalamban and swalamban, Shri Sharma emphasized the inherent interdependence among all beings in the world. He introduced the concept of Vasudhaivakutumbakam or Sarve Bhavanthu Sukhino from the Bharatiya tradition, describing it as the foundational principle of Bharatiya chintan (Indian thought).\n\nDrawing a distinction between science and philosophy, Shri Sharma highlighted India's unique system and its distinctive contribution to the global landscape. He then delved into a discussion on the world's GDP rate and India's role in it, emphasizing the importance of Vasudhaiva Kutumbakam for social-based development. Shri Sharma expounded on the economic evolution, pointing out the increase in economic units at the village level and the rise of cluster-based job facilities. Discussing the imperative of prosperity, he underscored the significance of \"Economic Evolution\" in the contemporary era.\n\nFurthermore, Shri Sharma addressed the crucial role of youth in economic development, asserting that the construction of demands precedes manufacturing. Reflecting on global trends, he highlighted the shift from communism to ongoing capitalism, marking the current era. In this context, he underscored the necessity of integral humanism, a concept proposed by Pandit Deen Dayal Upadhyaya. In summary, Shri Deepak Sharma's insightful speech explored the relevance of integral humanism in the 21st century, weaving together principles of interdependence, economic evolution, and the importance of youth in the context of a shifting global landscape.",
        images: [philosophyLecture2Img1, philosophyLecture2Img2],
      },
      {
        id: 3,
        title: "Madan Mohan Malviya: Reviving Indian Philosophy and Education",
        speaker: "Dr. Ved Prakash Singh",
        speakerDesignation: "Secretary General of Mahamana Malviya Mission",
        link: "https://www.youtube.com/watch?v=6lKhkfsal3s&list=PLNolcybM1tDgBR4h4vA5uZXHGZDccRod7&index=3",
        description:
          "Dr. Ved Prakash Singh, Secretary General of Mahamana Malviya Mission, delivered an enlightening talk on \"Madan Mohan Malviya: Reviving Indian Philosophy and Education.\" Commencing his discourse with a focus on Indian Philosophy, Dr. Singh emphasized that it embodies the timeless essence of Sanatana Philosophy, originating from the Vedic era. Madan Mohan Malaviya, a prominent Indian educationist and social reformer who lived from 1861 to 1946, took center stage in Dr. Singh's presentation. Driven by the conviction that education was the catalyst for societal and economic progress, Malaviya advocated for its accessibility to all, irrespective of caste, gender, or socio-economic background. Positioned as a national movement leader and a fervent patriot dedicated to the principles of Sanatanism and Hindu harmony, Malaviya staunchly supported the traditional Indian education system. He believed in its profound value in nurturing moral values and spiritual development.\n\nDr. Singh elucidated the underlying philosophy of religion according to Malaviya, stressing its role in fostering peace, harmony, and happiness within the country. Malaviya envisioned education as a cornerstone grounded in a sense of national identity and pride, aimed at steering India towards strength and self-reliance. Instrumental in establishing the Banaras Hindu University (BHU) in 1916, Malaviya ji sought to promote the revival of traditional Indian knowledge systems while embracing modern education. BHU was envisioned as a melting pot where students from diverse backgrounds could converge to learn, exchange ideas, and cultivate a robust sense of national identity. Malaviya ji's advocacy extended to women's education, viewing it as pivotal for empowerment and emancipation. He ardently believed in providing women with equal educational opportunities, considering education essential in dismantling the deep-seated barriers of caste and gender that had impeded Indian society for centuries. Dr. Singh underscored that Malaviya ji's educational philosophy was deeply rooted in national pride, social justice, and inclusivity. The overarching vision was to make education accessible to all, contributing to the development of a robust and self-reliant India, free from the social and economic inequalities of the past.",
        images: [philosophyLecture3Img1, philosophyLecture3Img2],
      },
      {
        id: 4,
        title: "Ram Manohar Lohia and the Idea of Indian Democracy",
        speaker: "Dr. Pintu Kumar",
        speakerDesignation:
          "Associate Professor at Motilal Nehru College Evening, University of Delhi",
        link: "https://www.youtube.com/watch?v=vEU6OLvqNac&list=PLNolcybM1tDgBR4h4vA5uZXHGZDccRod7&index=4",
        description:
          'Dr. Pintu Kumar, Associate Professor at Motilal Nehru College Evening, University of Delhi, delivered an insightful lecture on "Ram Manohar Lohia and the Idea of Indian Democracy." Dr. Kumar commenced his presentation with a brief introduction to Ram Manohar Lohia, highlighting his fervent dedication to liberating socialism from the constraints of European Marxism and international communism. Lohia, Dr. Kumar emphasised, was deeply committed to localizing socialism by adapting it to the unique needs and aspirations of newly emerging developing countries like India. Despite his reservations about capitalism, Lohia integrated certain principles such as freedom and dissent, drawn from its ideology, which significantly improved the conditions of the working class, facilitating their transition into the middle class in Europe.\n\nCentral to Lohia\'s conceptualization of socialism was the vision of establishing a just, egalitarian, and democratic socio-economic and political order capable of fostering the comprehensive development of the Indian masses. Dr. Kumar underscored that for Lohia, democracy transcended its mere functional aspects; it embodied a profound meaning where individuals themselves held the reins of power and were the architects of their destiny. To Lohia, democracy represented a potent equalizing force, ensuring a decentralized socio-economic and political order where every individual had an equal opportunity to flourish. Dr. Kumar stressed that only in an environment characterized by freedom, fairness, and equality could individuals achieve holistic development. Lohia envisioned democracy not merely as a system of governance but as a transformative ideology that empowered individuals and communities to shape their collective destiny.',
        images: [philosophyLecture4Img1, philosophyLecture4Img2],
      },
      {
        id: 5,
        title: "Beyond Boundaries: Jiddu Krishnamurti's Philosophy of Freedom",
        speaker: "Dr. Richa Kapoor Mehra",
        speakerDesignation:
          "Associate Professor at Global Jindal University, Sonepat",
        link: "https://www.youtube.com/watch?v=sKfdOS1KBUw&list=PLNolcybM1tDgBR4h4vA5uZXHGZDccRod7&index=5",
        description:
          "Dr. Richa Kapoor Mehra, Associate Professor at Global Jindal University, Sonepat, delivered a captivating discourse titled \"Beyond Boundaries: Jiddu Krishnamurti's Philosophy of Freedom.\" Her presentation delved into the life and teachings of Jiddu Krishnamurti (JK), born on May 11, 1895, in Madanapalle, South India. Over nearly six decades, JK extensively traveled worldwide, engaging diverse audiences in discussions on the urgent need for a profound transformation in humanity. Diverging from conventional philosophers and religious leaders, JK refrained from aligning with any specific doctrine, focusing instead on addressing universal concerns in our daily lives. The content of the talk drew from JK's unique insights into the human mind, avoiding reliance on traditional knowledge. JK distanced himself from religious affiliations, sects, and political ideologies, emphasizing the divisive nature of such distinctions that lead to conflicts among individuals.\n\nDr. Kapoor underscored the importance of a holistic understanding of fundamental concepts such as freedom, love, truth, hatred, meditation, and time, emphasizing their interconnectedness. A central theme in JK's philosophy was the interdependence of individual and social transformation. He emphasised that true freedom, often idealized, is not an external goal but requires a profound inner transformation. Living within the constraints of desires and conditioned minds is akin to imprisonment, making the pursuit of freedom elusive. Challenging conventional notions of freedom linked to choices and jobs, JK asserted that genuine freedom lies beyond external circumstances. He argued that having choices leads to inner confusion and uncertainty, highlighting that freedom is not about something or from something but an ongoing inquiry and exploration within oneself. Dr. Kapoor stressed the importance of constant self-questioning and awareness in achieving true freedom, encouraging the audience to break free from past conditionings and biases. In conclusion, Dr. Richa Kapoor Mehra's presentation offered a profound exploration of Jiddu Krishnamurti's philosophy of freedom. Listeners were encouraged to transcend boundaries, challenge preconceptions, and embark on a journey of self-discovery for genuine liberation.",
        images: [
          philosophyLecture5Img1,
          philosophyLecture5Img2,
          philosophyLecture5Img3,
        ],
      },
    ],
    concludingSessionDetailed: {
      title: "Concluding Remarks and Vote of Thanks",
      text: "In the concluding remarks, Prof. Natraju Adarasupally provided a comprehensive summary of the five lectures delivered throughout the day, encapsulating the key points and insights shared by each speaker. His summary aimed to reinforce the main themes and ideas discussed, ensuring that the audience departed with a clear understanding of the significance and relevance of the topics covered.\n\nFollowing Prof. Natraju Adarasupally's summary, Neelabh Kumar Sharma, Research Associate, Centre for Human Sciences, Rishihood University, delivered a vote of thanks for the session, expressing gratitude to the speakers, organizers, sponsors, and attendees who contributed to the success of the ICPR sponsored World Philosophy Day Lecture Series. His words of appreciation acknowledged the collaborative effort and dedication that made the event possible, highlighting the importance of philosophical discourse in fostering intellectual growth and societal development.",
      images: [philosophyConcludingImg1, philosophyConcludingImg2],
    },
  },
  {
    id: 103,
    title: "Conference on Philosophy of Indian Pedagogy",
    heading: "Conference on Philosophy of Indian Pedagogy",
    description:
      "Organised by the Centre for Human Sciences, Rishihood University, in collaboration with the Indian Knowledge Systems Programme at IIT Delhi, and generously supported by the Indian Council of Philosophical Research.",
    type: "Conference",
    date: "November 16-17, 2024",
    slug: "philosophy-of-indian-pedagogy",
    image: pedagogyBanner,
    link: "/events/conference/philosophy-of-indian-pedagogy",
    fullHeading: "Conference on Philosophy of Indian Pedagogy",
    convenor:
      "Organised by the Centre for Human Sciences, Rishihood University, in collaboration with the Indian Knowledge Systems Programme at IIT Delhi, and generously supported by the Indian Council of Philosophical Research.",
    overview:
      "In the evolving field of education, it is essential to revisit and reassess the fundamental philosophies that guide pedagogy. India's rich heritage of ancient wisdom and diverse cultural traditions provides a unique foundation for innovative educational paradigms that bridge tradition and modernity.\n\nAncient Indian seers envisioned human growth as a holistic process encompassing physical, intellectual, moral, and spiritual dimensions. This comprehensive view shaped the ancient Indian education system, nurturing both knowledge and character. However, modern educational systems have increasingly focused on skills and behaviours necessary for specific occupations, often at the expense of holistic development. This shift necessitates a re-evaluation of Indian pedagogy to better align with its broader vision.\n\nTo reimagine Indian pedagogy, it is crucial to integrate ancient wisdom with contemporary educational philosophies. By examining the teachings of influential educational philosophers such as Rousseau, Montessori, Pestalozzi, Bertrand Russell, Paulo Freire, and Piaget, alongside Indian nationalist leaders like Swami Vivekananda, Mahatma Gandhi, Rabindranath Tagore, and Sri Aurobindo, we can develop an educational framework that emphasises comprehensive learning–”learning to learn, know, do, live together, and be.\n\nThe National Education Policy (NEP) 2020 has initiated a significant transformation in the educational landscape, highlighting the importance of well-trained facilitators and culturally relevant content. Indian pedagogy, with its focus on holistic development grounded in concepts such as the four puruá¹£Ärthas and paÃ±cakoÅ›as, is vital to achieving educational goals in the Indian context. This is also a significant tenet of living and learning at Rishihood University.\n\nThe two-day round table conference brought together educators, scholars, policymakers, and thought leaders. The goal was to explore the core elements of Indian pedagogy and envision a path forward, creating an educational methodology that resonates with ancient India's spiritual and cultural heritage while addressing contemporary needs.",
    programArchitecture: {
      description: "Objectives of the Conference:",
      items: [
        "Facilitated concentrated discussions on key aspects of Indian educational pedagogy.",
        "Explored both traditional and modern educational philosophies.",
        "Developed a comprehensive understanding of Indian pedagogy.",
        "Formulated a framework integrating ancient Indian wisdom with contemporary educational practices.",
        "Promoted a holistic and value-oriented education system.",
      ],
    },
    corePillars: [
      {
        heading: "Ancient Indian Pedagogy",
        text: "Examination of ancient educational practices and philosophies, emphasising their holistic approach to learning and character development.",
      },
      {
        heading: "Basic Foundation of Indian Pedagogy",
        text: "Understanding the fundamental principles and values underlying Indian education.",
      },
      {
        heading: "Psychology and Education",
        text: "Understanding the psychological foundations of Indian education and their impact on teaching and learning.",
      },
      {
        heading: "Methods of Indian Pedagogy",
        text: "Exploring traditional and modern teaching methods, focusing on experiential learning, discussion, and spiritual growth.",
      },
      {
        heading: "Indian Quest for Knowledge",
        text: "Investigating the Indian perspective on knowledge-seeking, including its spiritual and metaphysical dimensions.",
      },
      {
        heading: "Chief Elements of Indian Pedagogy",
        text: "Identifying core components such as respect for diversity, emphasis on cooperation, and integration of spiritual values.",
      },
      {
        heading: "Philosophy of Spiritual Education",
        text: "Discussing the role of spiritual education in shaping students' character and worldview.",
      },
      {
        heading: "Yoga and Education",
        text: "Exploring the contributions of yoga and spiritual practices to educational outcomes and holistic growth.",
      },
      {
        heading: "Role of Teachers",
        text: "Analysing the role of teachers in shaping the learning environment, fostering moral and intellectual growth, and embodying ideal characteristics.",
      },
      {
        heading: "True Aim of Life",
        text: "Deliberating on philosophical aspects of education and their implications for defining the true aim of life.",
      },
      {
        heading: "Characteristics of Ancient Indian Education",
        text: "Examining unique traits, such as the guru-Å›iá¹£ya relationship, that distinguish ancient Indian education.",
      },
      {
        heading: "Ideal Teachers, Ideal Parents, & Ideal Learners",
        text: "Identifying the qualities of ideal participants in the educational process, including teachers, parents, and students.",
      },
      {
        heading: "Teacher Education",
        text: "Discussing strategies for preparing and training teachers to embody Indian pedagogical principles.",
      },
      {
        heading: "A Value-Oriented Education",
        text: "Addressing the importance of incorporating values into education to foster ethical behaviour.",
      },
      {
        heading: "Philosophy of Indianness",
        text: "Delving into the unique philosophical perspective of India and its influence on educational outcomes.",
      },
    ],
    consensus: {
      title: "Implementation, Outcomes & Conclusion",
      text: "The conference was structured to encourage open dialogue and collaborative problem-solving. Each session included expert speakers, panel discussions, and interactive workshops to facilitate the exchange of ideas.",
      items: [
        "At the end of the conference, a comprehensive report was compiled, summarising key insights and recommendations for advancing Indian pedagogy.",
        "The outcomes were envisioned as a guiding document for educational policymakers and institutions, contributing to the development of a holistic and value-driven educational system in India.",
        "By embracing a pedagogy that integrates traditional wisdom with contemporary needs, the initiative sought to bridge the gap between tradition and progress, fostering an education system that promotes the highest human welfare.",
        "Conclusion: This initiative sought to cultivate an educational framework deeply rooted in India's rich heritage while addressing modern challenges. By integrating ancient wisdom with contemporary educational practices, it aimed to develop an education system that prepares individuals not only for professional success but also for meaningful, ethical, and harmonious living.",
      ],
      footer: "Conference on Philosophy of Indian Pedagogy",
    },
  },
  {
    id: 104,
    title: "Advancing Integral Humanism in the 21st Century",
    heading: "Advancing Integral Humanism in the 21st Century",
    description:
      "The International Conference on Integral Humanism explored the contemporary relevance and application of the philosophy of Deendayal Upadhyaya through interdisciplinary discussions on education, governance, ethics, and holistic human development.",
    type: "Conference",
    date: "April 12-14, 2024",
    slug: "advancing-integral-humanism",
    image: advancingIntegralBanner,
    link: "/events/conference/advancing-integral-humanism",
    fullHeading: "Advancing Integral Humanism in the 21st Century",
    overview:
      "The International Conference on Integral Humanism drew inspiration from the profound philosophy of Deendayal Upadhyaya and aimed to foster a comprehensive understanding of this worldview and its contemporary significance. Emphasising academic rigour and philosophical exploration, the conference served as a platform for scholars, researchers, and practitioners from diverse fields to engage in meaningful discourse.\n\nThe conference had three primary aims:\n\n• To explore Integral Humanism (Ekatma Manava Darśana) in depth, considering its relevance in addressing modern global challenges and advancing human well-being.\n• To encourage interdisciplinary dialogue by fostering discussions on the intersections of Integral Humanism with education, psychology, ethics, governance, and socio-economic development.\n• To analyse and explore the practical application and implementation of this philosophy on the ground, especially in school education.\n\nIntegral Humanism, deeply rooted in holistic human development, remains highly relevant in the contemporary world. It offers profound insights into addressing complex issues such as sustainability, social justice, ethical governance, and comprehensive education. By revisiting and reinterpreting this philosophy, the conference sought to enrich contemporary knowledge systems and practices. Participants contributed rigorous academic papers, engaged in thought-provoking discussions, and generated actionable insights, ultimately gaining a deeper appreciation of the potential of Integral Humanism to guide positive change across various domains.\n\nThe conference brought together scholars, researchers, policymakers, and practitioners to explore the multifaceted dimensions of Integral Humanism and its contemporary relevance. It served as a platform for rigorous academic discourse, fostering cross-disciplinary interactions and promoting actionable insights aligned with the principles of Integral Humanism articulated by Pandit Deendayal Upadhyaya.",
    programArchitecture: {
      description: "Goals and Objectives:",
      items: [
        "To foster academic dialogue and exchange of ideas that advance the understanding and application of Integral Humanism in contemporary contexts.",
        "To encourage interdisciplinary collaboration and cross-sectoral engagement, promote holistic solutions to pressing societal issues.",
        "To provide a platform for researchers and scholars to present and discuss their findings, thereby enriching the academic discourse surrounding Integral Humanism.",
        "To generate actionable recommendations for policymakers, educators, and practitioners seeking to integrate the principles of Integral Humanism into their respective domains.",
      ],
    },
    keyHighlights: {
      title: "Conference Overview",
      items: [
        {
          heading: "Vertical 1",
          text: "Philosophical and Conceptual Foundations of Integral Humanism",
        },
        {
          heading: "Vertical 2",
          text: "Integral Humanism in the 21st-Century World",
        },
        {
          heading: "Vertical 3",
          text: "Symposium on Integrating Integral Humanism Values into School Education",
        },
      ],
    },
    corePillars: [
      {
        heading: "Philosophical Foundations in School Classrooms",
        text: "Strategies for translating the principles of Integral Humanism into age-appropriate philosophical concepts in the school setting.\n\nPractical approaches to incorporating philosophical discussions into various subjects in school education.",
      },
      {
        heading: "Interactive Learning Tools and Resources in Schools",
        text: "Development and implementation of engaging tools and resources that resonate with the values of Integral Humanism in the school environment.\n\nUtilising technology and multimedia for interactive learning experiences within the context of school education.",
      },
      {
        heading: "Assessment of Values in School Education",
        text: "Methods for assessing the integration of Integral Humanism values into educational outcomes within the school system.\n\nIncorporating value-based assessment into existing evaluation frameworks for school education.",
      },
      {
        heading:
          "Teacher Training and Professional Development for School Educators",
        text: "Effective training programmes for educators on the philosophical foundations of Integral Humanism within the context of school education.\n\nContinuous professional development initiatives to strengthen teachers' ability to integrate values into their teaching practices within the school setting.",
      },
    ],
    consensus: {
      title: "Outcomes",
      text: "The conference comprised three verticals — two thematic sessions and one focused symposium. The thematic sessions focused on major themes to address current challenges and opportunities across sectors while honouring the philosophy of Integral Humanism.",
      items: [
        "An edited volume of selected papers, categorised by conference themes, was proposed as a key outcome of the conference.",
        "These themes included economics, politics, education, foreign policy, agriculture, and rural development, as well as conceptual and philosophical explorations.",
        "The symposium focused specifically on integrating Integral Humanism values into school education.",
      ],
      footer: "Advancing Integral Humanism in the 21st Century",
    },
    patron: {
      name: "Shri Shobhit Mathur",
      designation: "Vice Chancellor,\nRishihood University",
      image: patronShobhit,
    },
    convener: {
      name: "Prof. Sampadananda Mishra",
      designation: "Director- Centre for Human Sciences,\nRishihood University",
      image: convenerSampadananda,
    },
    organizers: {
      items: [
        {
          name: "Neelabh Kumar Sharma",
          designation: "Research Associate, Centre for Human Sciences",
        },
        {
          name: "Anusree S.L",
          designation: "Research Associate, Integral Humanism Initiative",
        },
        {
          name: "Dr. Akhil Singh",
          designation: "Research Associate, Integral Humanism Initiative",
        },
      ],
    },
    knowledgePartners: {
      images: [prajnaPravahLogo],
    },
  },
  {
    id: 106,
    title:
      "International Conference on Universal-Integral Multilevel Education in the Spirit of the New Age",
    heading:
      "International Conference on Universal-Integral Multilevel Education in the Spirit of the New Age",
    description:
      "International Conference on Universal-Integral Multilevel Education in the Spirit of the New Age, Organised by International Scientific School of Universology in association with the Centre for Human Sciences, Rishihood University, Sonipat, India, on 3-4 February 2024, at The International Centre, Goa, Dona Paula, Goa",
    type: "Conference",
    date: "February 3-4, 2024",
    slug: "universal-integral-multilevel-education-new-age",
    image: universalConfBanner,
    link: "/events/conference/universal-integral-multilevel-education-new-age",
    fullHeading:
      "International Conference on Universal-Integral Multilevel Education in the Spirit of the New Age",
    overview:
      "The International Conference on Universal-Integral Multilevel Education in the Spirit of the New Age provided a platform for insightful discussions and practical exchanges to advance education in alignment with humanity's evolving needs. The diverse range of topics covered underscored the importance of holistic approaches and conscious evolution in education. The conference concluded with a sense of gratitude and anticipation for future collaborations in the journey towards universal integral education.",
    corePillars: [
      {
        heading: "Day 1",
        text: "The inaugural day of the conference began with an Invocation and welcome by Prof. Sampadananda Mishra, Ms Mariana, and Ms Tatiana. Prof. Polyakov, founder of the International Scientific School of Universology, delivered the keynote speech on “Universology – A New Scientific Paradigm of the New Era,” focusing on the synthesis of spiritual and cultural heritage. He discussed various topics, including the changing world order, the human development plan, and the concept of unified energy systems.\n\nMs Tatiana spoke about the “Transforming Power of Consciousness of the New Era,” highlighting seven main directions, including systemology, philosophy, and universal modelling. Ms Mariana discussed the “Integral Worldview in the Education of the New Era,” emphasising the triple integrity of education and the goals of education today.\n\nProf. Sampadananda Mishra elaborated on “New Education for New Consciousness,” emphasising The Mother’s Symbol of 12 values and the fundamental principles of new education. Dr Akhil talked about “Transforming Dualistic Mindset to Universal in Students,” focusing on inner curriculum and awareness of universal being.\n\nMs Grishaeva discussed the “Implementation of Educational Programs of the New Era,” emphasising conscious travel. Dr Astha focused on the “Liberating Purpose of Education,” drawing from the ideas of Western and Indian thinkers. Ms Sivko talked about practical ideas to actualize universalization, introducing the concept of a vibration passport.\n\nMs Anusree explored “Sri Aurobindo’s Integral Education Curriculum through the Lens of Auroville Model,” discussing integral development. Dr Vladimir spoke on “In Search of an Integral Paradigm of Knowledge,” touching on The Mother’s vision and technological consciousness. Mr Neelabh explored “Vedic Siksha,” stressing the vedic context of education.\n\nMs Tyageva concluded with a talk on the “City of the Future,” an experiment in creating a universal model society based on harmony and Vaastushastra principles.",
      },
      {
        heading: "Day 2",
        text: "The second day commenced with Prof. Sampadananda Mishra elaborating on the significance of Pancha Mahabhutas in education. Prof. Polyakov discussed universal algorithms for human existence and origin. Sessions included talks on the flow of unity of the divine hierarchy, universal traditions and culture, and the path of humanity’s development through love.\n\nShort presentations by affiliating institutions covered topics such as universal forecasting, nature-oriented living, and social consultancy. Prof. Sampadananda Mishra introduced practices for purifying the Panchamahabhutas through the chakra-purification mantra.\n\nOther sessions focused on new life management programs, energetic modelling of surroundings, and the energy of the family. Practical sessions led by Mariana explored the 7 levels of human relationships and manifestation in the surrounding world.\n\nThe conference concluded with a demonstration of the proposed activities and thank-you notes expressing gratitude to all participants and organisers for their insightful contributions.",
      },
    ],
    gallery: [
      universalConfBanner,
      universalConf1,
      universalConf2,
      universalConf3,
      universalConf4,
      universalConf5,
      universalConf6,
      universalConf7,
      universalConf8,
      universalConf9,
      universalConf10,
      universalConf11,
      universalConf12,
      universalConf13,
      universalConf14,
    ],
  },
  {
    id: 107,
    title: "Sri Aurobindo Youth Conference",
    heading: "Sri Aurobindo Youth Conference",
    description:
      "The one-day Sri Aurobindo Youth Conference was held at Ramjas College on 27 January 2024. Jointly organised by Auroville Foundation and the Centre for Human Sciences, the conference brought together 200 students from various colleges of Delhi University to explore the teachings of Sri Aurobindo",
    type: "Conference",
    date: "January 27, 2024",
    slug: "sri-aurobindo-youth-conference",
    image: youthConfBanner,
    link: "/events/conference/sri-aurobindo-youth-conference",
    fullHeading: "Sri Aurobindo Youth Conference",
    overview:
      "A wave of spiritual inquiry resonated across Ramjas College, Delhi University, on January 27th, 2024, as the one-day Sri Aurobindo Youth Conference unfolded. The event, a collaboration between The Auroville Foundation and the Centre for Human Sciences, brought together 200 eager young minds from across Delhi University colleges to delve into the profound teachings of Sri Aurobindo.\n\nThe conference commenced with a ceremonial lighting of the lamp, followed by a warm message from Dr Jayanti Ravi ji, Secretary of the Auroville Foundation. She ignited the spark of curiosity by introducing Sri Aurobindo's five dreams, each beckoning a transformative future. Dr Ravi ji extended a heartfelt invitation to the youth, urging them to visit Auroville, the city embodying these dreams.",
    corePillars: [
      {
        heading: "Inaugural & Keynote Sessions",
        text: "Keynote speaker Prof. Ramesh Bijlani ji took the stage, communicating to the youth the spellbinding messages of Sri Aurobindo. His words resonated with the yearning for purpose and meaning that pulses within young hearts. Mr Amit Gujral further illuminated the path with a lucid exposition of Sri Aurobindo’s Integral Yoga, a roadmap for individual and collective transformation. Ms Ritika Goyel delved into the realm of spirituality, guiding the audience towards an understanding of our inherent divine essence.",
      },
      {
        heading: "Exploring Sri Aurobindo’s Vision",
        text: "The diverse facets of Sri Aurobindo’s vision were further explored through talks on Integral Education by Ms Anuradha Agrawal and Sri Aurobindo’s Nationalism by Mr Lakshya from the Auroville Foundation. Ms Anju Kahanna inspired the youth by showcasing the ongoing activities of the Sri Aurobindo Ashram Delhi branch.\n\nProf. Sampadananda Mishra, Director of the Centre for Human Sciences at Rishihood University, offered enriching insights on Indian knowledge systems through the lens of Sri Aurobindo’s philosophy.",
      },
      {
        heading: "Engagement & Dialogue",
        text: "Throughout the day, Mollika Ganguly, the program coordinator, and Neelabh Sharma from the Centre for Human Sciences adeptly navigated the sessions, fostering a dynamic space for dialogue and engagement. The participants were further immersed in the transformative power of Sri Aurobindo’s life through screenings of two inspiring films.\n\nAs the conference drew to a close, a palpable sense of awakening pulsed through the room. Certificates and gift bags from Auroville, tangible tokens of the day’s journey, were distributed to each participant.",
      },
      {
        heading: "Conclusion & Gratitude",
        text: "The success of the conference owes a deep debt of gratitude to Dr Pallavi Jain from Ramanujan College, whose dedication ensured the enthusiastic participation of students, and to Manu Vats from Rishihood University for floor management and for arranging the sumptuous breakfast and lunch for all participants. Gratitude to both Ramjas College and Ramanujan College for their constant support in organising the conference.\n\nThe Sri Aurobindo Youth Conference was not merely an event; it was a catalyst for change. It planted a seed of awareness within the hearts of young minds, urging them to embrace their potential as co-creators of a brighter future. As these budding seeds blossom, inspired by the eternal wisdom of Sri Aurobindo, we can confidently usher in a new dawn of human evolution, infused with the spirit of divine transformation.",
      },
    ],
    gallery: [youthConfBanner, youthConf1, youthConf2, youthConf3, youthConf4],
  },
  {
    id: 108,
    title: "Avadhāna Saṅgama: Cultivating Cognitive Mastery",
    heading: "Avadhāna Saṅgama: Cultivating Cognitive Mastery",
    description:
      "The Centre for Human Sciences at Rishihood University organised a unique conference on Avadhānakalā, titled “Avadhāna Saṅgama: Cultivating Cognitive Mastery”, from 11 to 14 September 2023 at Tirupati, Andhra Pradesh.",
    type: "Conference",
    date: "September 11-14, 2023",
    slug: "avadhana-sangama-cognitive-mastery",
    image: avadhanaSangamaBanner,
    link: "/events/conference/avadhana-sangama-cognitive-mastery",
    fullHeading: "Avadhāna Saṅgama: Cultivating Cognitive Mastery",
    overview:
      "The Centre for Human Sciences at Rishihood University organised a unique conference on Avadhānakalā, titled “Avadhāna Saṅgama: Cultivating Cognitive Mastery”, from 11 to 14 September 2023 at Tirupati, Andhra Pradesh.\n\nThe conference was organised by the Centre for Human Sciences (CHS), Rishihood University, as part of the Avadhānakalā and Consciousness Studies project funded by the Indian Knowledge Systems Division. The conference was organised in collaboration with the National Sanskrit University.",
    corePillars: [
      {
        heading: "The Art of Multiple Concentration",
        text: "Avadhānakalā has been a cultural phenomenon across India for millennia, yet it has not been studied or documented as extensively as it deserves. In a world where even a few seconds of attention have become challenging, there are still individuals of rare capacity who stand out for their extraordinary powers of attention, concentration, creativity, focus, and memory. The secret of this rare capacity lies in Avadhānakalā — the ancient Indian art of multiple concentration.\n\nEmbodying the five “Dh’s” — Dhairya (perseverance), Dhāraṇā (retentive capacity), Dhārā (creative flow), Dhoraṇī (creative style), and Dhīṣaṇā (sharp intelligence) — Avadhānīs continually refine their memory, concentration, creativity, and ability to simultaneously handle multiple challenges specifically designed to test their power of Avadhāna.",
      },
      {
        heading: "Diverse Spheres of Avadhāna",
        text: "Through Avadhāna Saṅgama, the conference offered a unique cultural experience by exploring the ancient Indian art of multiple concentration, memory, and extempore creativity across varied spheres. It brought forth this unique cultural legacy and highlighted cherished performers from diverse spheres of Avadhānakalā, including:\n\n• Chitra (painting)\n• Gaṇita (mathematics)\n• Ghaṇṭā (gongs and bells)\n• Netra (eye movements)\n• Nṛtya (dance)\n• Sāhitya (literature)\n• Tāla (music)",
      },
      {
        heading: "Inspiration and Cultural Revival",
        text: "Through experiential, dialectical, and performance-based interactions with the Avadhānīs, the conference offered attendees a treasure trove of knowledge and inspiration. For younger participants in particular, it sought to sow the seeds of inspiration and cultural revival by showcasing the remarkable skill and creativity of the Avadhānīs and encouraging a deeper appreciation of this art form.\n\nIn today’s rapidly evolving entertainment and media landscape, art forms like Avadhānakalā need to reach wider audiences. Rather than lowering attention spans from minutes to seconds, the conference highlighted how we can learn from the Avadhānīs to optimise our vital energies and sustain mental attention for extended periods. Coupled with the sacred sounds of Sanskrit, Telugu, Kannada, and Hindi, Avadhānakalā emerged as a dazzling art form that displays the heights of human potential and creativity, inspiring individuals towards deeper mental and personal development.",
      },
    ],
    gallery: [avadhanaSangamaBanner, avadhanaSangama1, avadhanaSangama2],
  },
  {
    id: 109,
    title: "Six-Day Bharatiya Bhasha Mahotsav at Rishihood University",
    heading: "Six-Day Bharatiya Bhasha Mahotsav at Rishihood University",
    description:
      "The Centre for Human Sciences, Rishihood University, in association with the Bharatiya Bhasha Samiti, Ministry of Education, Government of India, organised a six-day event at Rishihood University from 11th to 16th December 2022 to celebrate the Bharatiya Bhasha Diwas.",
    type: "Conference",
    date: "11-16 December, 2022",
    slug: "bharatiya-bhasha-mahotsav",
    image: bhashaMahotsavBanner,
    link: "/events/conference/bharatiya-bhasha-mahotsav",
    fullHeading: "Six-Day Bharatiya Bhasha Mahotsav at Rishihood University",
    overview:
      "The Centre for Human Sciences, Rishihood University, in association with the Bharatiya Bhasha Samiti, Ministry of Education, Government of India, organised a six-day event at Rishihood University from 11th to 16th December 2022 to celebrate the Bharatiya Bhasha Diwas. The event featured various activities, including a guest lecture, an exhibition, a folk song and dance competition, an essay writing competition, a drama competition, and a two-day national seminar, all based on the theme of the Wonders of Bharatiya Bhasha.",
    corePillars: [
      {
        heading: "Introduction",
        text: "The Centre for Human Sciences, Rishihood University, in association with the Bharatiya Bhasha Samiti, Ministry of Education, Government of India, organised a six-day event at Rishihood University from 11th to 16th December 2022 to celebrate the Bharatiya Bhasha Diwas. The event featured various activities, including a guest lecture, an exhibition, a folk song and dance competition, an essay writing competition, a drama competition, and a two-day national seminar, all based on the theme of the Wonders of Bharatiya Bhasha.",
        images: [bhashaMahotsavIntro],
      },
      {
        heading: "Day 1 (11th December 2022)",
        text: "The first day began with the inauguration of the six-day celebration at 3:00 pm. The presence of Prof. Rajendrakumar Anayath ji, Hon’ble Vice-Chancellor, Deenbandhu Chhotu Ram University of Science and Technology, Sonipat, and Shri Shobhit Mathur ji, Hon’ble Vice-Chancellor, Rishihood University, graced the inaugural event.\n\nThe event started with Ekagrata, with a minute of silence, as is the culture at Rishihood University. This was followed by the deep prajjwalan. In which the esteemed guests formally inaugurated the event by lighting the lamp. The invocation mantra was chanted by Sakshi Chauhan, a student of the PGDPL programme at Rishihood University. The welcome address was delivered by Dr Rama Nand Malviya ji, Proctor and Library In-Charge at Rishihood University. He highlighted the importance of the multilingual identity of India and thanked Bharatiya Bhasha Samiti for celebrating Bharatiya Bhasha Diwas and giving the younger generation an opportunity to showcase their talent in their mother tongue.\n\nShri Shobhit Mathur ji, in his address, explained the importance of learning and imparting education in one's mother tongue, drawing on examples from his own life. He highlighted how difficult it becomes, even for exceptionally talented and smart people, to work in a language that is foreign to them. And therefore, it becomes extremely essential to educate our younger generation in our mother tongue, at least at our home, as they can easily learn English at school, but if we do not pass on our tongue to our children, then the language will eventually become extinct, as we can see in the second generation of many families that migrated from India towards the West.\n\nIn the guest lecture on ‘The Merits of Knowing Local Indian Languages’, Prof. Rajendrakumar Anayath ji explained how mankind is characterised by the use of language for communication and how this ability helps mankind progress. He briefly explained the development of language from ancient times, how communication evolved from cave paintings to oral tales and the use of rhetoric, to the age of printing, when recording became convenient, and to the present, characterised by the internet. He clarified that it was not Gutenberg who first invented movable-type printing, and that the Bible was not the first book to be printed.\n\nClay printing technique was first invented by Bi Sheng, from China, about 700 years before Gutenberg, and the first book to be printed was a Buddhist text by the name Vajracchedikā Prajñāpāramitā Sūtra or the Diamond Sutra. He also briefly explained the development of literature and how it progressed from an educative tool to a tool of propaganda in the 20th century, using George Orwell’s 1984 as an example. Talking about India, he explained that India has more than 19,500 dialects and 1069 languages as mother tongues, of which 121 have more than 10,000 speakers. India also has 66 scripts, two official languages and 22 official languages.\n\nOf these languages, Hindi is spoken by more than 52 crore people, and 43.6 per cent of the population considers Hindi their first language.\n\nDeliberating upon the purpose and benefits of knowing a language and reading novels, he explained how we have very little time when it comes to having an understanding of how others feel, and it is only by reading novels that we get to experience others. He explained that we can never fully understand the true meaning of altruism without literature, as it gives us the opportunity to put ourselves in others' shoes and understand their experiences.\n\nIn the final part of his lecture, Prof. Anayath spoke about the nuances of bilingualism and multilingualism. He referred to Critical Period Theory, according to which children learn languages more easily and learning a language in childhood gives a more holistic grasp of its social and emotional context. He also pointed out that there is less emotional bias when a person learns and uses a second language. He also referred to research showing that being multilingual helps us think more logically and helps prevent Alzheimer’s and dementia. He stressed that there is no age limit to learning an extra language, as it certainly gives us extra mileage in life. The lecture was followed by a brief question-and-answer session in which Prof. Anayath addressed participants' doubts.\n\nAn exhibition on the Wonders of Bharatiya Bhasha was held in a beautifully decorated exhibition hall, showcasing many interesting facts about the six classical languages of India: Sanskrit, Odia, Tamil, Telugu, Malayalam, and Kannada. Apart from these, many daily-use household objects like electronics, kitchen items, bathroom accessories, beauty products, ornaments, etc., were on display with their Sanskrit names along with a blank sheet of paper on which the audience wrote the name of the objects in their local tongue. The exhibition also displayed several posters depicting Sanskrit terminology for human body parts, birds, animals, and plants, as well as ancient Indian games, puzzles, and riddles.\n\nA signature campaign on the theme “Meri Bhasha Meri Pehchaan” was also organised, in which the participants wrote their names in their mother tongue.\n\nThe vote of thanks was delivered by Neelabh Sharma, coordinator of the six-day event. The day ended with Dharana, marked by a minute of silence.",
        images: [
          bhashaImage2,
          bhashaImage10,
          bhashaImage16,
          bhashaImage35,
          bhashaImage49,
          bhashaImage51,
          bhashaImage59,
          bhashaImage63,
          bhashaImage77,
          bhashaImage104,
          bhashaImage111,
        ],
      },
      {
        heading: "Day 2 (12 December 2022)",
        text: "On the second day, a singing and dancing competition was organised in the mini auditorium of Rishihood University. The participating students presented singing and dancing performances in their mother tongue. The singing competition featured participants performing Hindi, Gharwali, Marathi, Manipuri, and Gujarati songs, and the folk dance performances included Bharatnatyam, Manipuri, and popular Hindi songs.",
        images: [
          bhashaImage13,
          bhashaImage36,
          bhashaImage70,
          bhashaImage103,
          bhashaImage107,
        ],
      },
      {
        heading: "Day 3 (13 December 2022)",
        text: "Painting and essay-writing competitions were held on the third day. The students showcased their talent by creating beautiful drawings and paintings based on the theme of “My language. My Identity”. The students also wrote wonderful and informative essays on the theme of “Salient Features of My Mother Tongue” in Indian languages such as Hindi, Tamil, and Kannada.",
        images: [
          bhashaImage6,
          bhashaImage17,
          bhashaImage55,
          bhashaImage71,
          bhashaImage82,
          bhashaImage87,
          bhashaImage91,
          bhashaImage101,
        ],
      },
      {
        heading: "Day 4 (14 December 2022)",
        text: "Nukkad natak and drama competition were organised on the fourth day of the event. The students from various departments participated and gave performances in various Indian languages. The spectacular Ramleela performed by the students was the main point of attraction for the audience.",
        images: [bhashaImage23, bhashaImage73, bhashaImage94],
      },
      {
        heading: "Day 5 (15 December 2022)",
        text: 'A two-day national seminar on ‘The Wonders of Bharatiya Bhasha’ was organised at Rishihood University, where eight renowned scholars from various parts of India presented talks centred on the salient features of each classical language of India. Prof. Radha Vallabh Tripathi ji, ex-vice chancellor, Rashtriya Sanskrit Sansthan, graced the occasion as the chief guest and Prof. Balram Singh, Professor and President at Institute of Advanced Sciences, Dartmouth, delivered the special address.\n\nThe two-day national seminar started with Ekagrata, by observing a minute of silence, which was followed by a beautiful invocation of the divine by Sakshi Chauhan, a learner at Rishihood University. After this, all the esteemed guests came forward for the deep prajjwalan and formally inaugurated the seminar with the invocation to Agni. After this, Prof. Shobhit Mathur ji and Shri Sahil Agarwal ji felicitated the guests by presenting them with tokens of honour.\n\nThe welcome address was given by Prof. Sampadananda Mishra ji, director of the Centre for Human Sciences and convenor of the six-day event. He beautifully explained that there can be no existence without language, and that unless there is the lamp of language to enlighten us, the entire world will be submerged in darkness. He also pointed out the challenges that a multilingual country like India faces and thanked the Bharatiya Bhasha Samiti for their efforts to address these challenges.\n\nProf. Shobhit Mathur ji spoke about the need to impart higher education in Indian languages, drawing on his own experience of how several countries in North America, South America, Africa, and China are using their local languages for education and innovation. He spoke of the inferiority complex that Indians suffer from because of which we value English more than our own languages and even go on to promote English by rewarding those who speak it well, both in educational and work spaces. Speaking about how Language acts as a vehicle for culture. He explained how Rishihood University is working to encourage the use of Indian languages across both academic and non-academic fronts.\n\nIn the special address, Prof. Balram Singh ji explained how language relates to culture, dress, food, and ideas. With a small anecdote from his personal life, he explained how we, intentionally or unintentionally, prefer English because of the fear of valuing one Indian language over another. Building upon the importance of language, he explained the etymology of the word “vyakti” in India, as a vyakti is the one who expresses. He also underlined the importance of translation in strengthening our cultural unity. He deliberated on how sounds affect our nervous system and genetic structure, highlighted the scientific nature of Indian languages and their intonations, and explained how, despite the diversity of languages in India, there is an essential coherence in the structures of all Indian languages. He stressed the importance of valuing the scientific and philosophical foundations of our own languages and of taking this legacy forward.\n\nIn the chairperson’s address, Prof. Radha Vallabh Tripathi ji began by congratulating Rishihood University on its endeavour to take the Indian legacy forward to younger generations. He explained the importance of multilingualism in the Indian context. Talking about the difference between the concepts of languages and dialects, he explained that this distinction is essentially foreign and that no such concept existed in India, where we value one more than the other. Explaining the cultural consciousness of India, he pointed out how India adopted even English as one of its official languages, even after it was forced upon us, and how our literary giants like Raja Rao have proven that we can also use English in our own way, giving way to the acceptance of Indian English as a standard language. He related it to the use of the word “Hindu”, and even if we accept that it was given to us by the foreign invaders with a derogatory connotation, we accepted it and proudly demonstrated to the entire world who a Hindu really is. He pointed out that there is no harm in accepting knowledge and development from other parts of the world, but the important thing is how we integrate it with our own cultural ethos to produce something better for the entire world. He spoke about the development of literature in India and referred to poets such as Kabir and Tagore, who wrote in multiple languages. He ended his address by pointing out the challenge of unifying India\'s many languages under a single cultural consciousness.\n\nThe technical session resumed after the lunch break. Dr Subrat Kumar Prusty ji, Member Secretary of the Institute of Odia Studies and Research, Bhubaneswar, Odisha, spoke on the “Origin and Development of Odia Language and Literature”. He deliberates on the contributions of Adivasi languages to the development of Odia. He explained that there are two ways language is expressed: first, through folk forms, and second, through cave paintings. He also explained how songs sung at various occasions, like childbirth, marriage, and funeral, serve as the basis for the development of literature. Talking about script development, he explained the importance of cave paintings and how the Brahmi script served as the basis for the development of other Indian scripts. Tracing the historical development of Odia, he explained how it borrows not just from Sanskrit but also from Buddhist and Jain literature.\n\nDr M Krishna Rao ji, Assistant Professor of Sanskrit at Sri Venkateswara College, University of Delhi, spoke on the development of the Telugu language and literature. He traced the history of Telugu over the last 1200 years. He explained the classification and categorisation of the prominent Dravidian languages and pointed out the different names used for Telugu, like Andhram, Tenugu, Andhra, Telugu, Vadugu, etc. and the logic behind the use of such terminologies. He referred to various ancient texts, such as the Ramayana, the Mahabharata, and the Manusmriti, in which Andhra and its culture are mentioned. Tracing the history of the development of Telugu literature, Dr Rao remarked that most of the ancient literature in Telugu is available only in oral tradition and also pointed out some major authors and works in Telugu. He concluded by pointing out some interesting facts about the Telugu language, such as its being called the "Italian of the East" because of its syntactic similarities to Italian. Though Telugu originates from Tamil, 75% of its vocabulary, along with grammar, is similar to Sanskrit.\n\nIn his talk, Prof. Purushottama Bilimale ji, Professor, Jawaharlal Nehru University, spoke on ‘Continuity, Change and Sustainability of Classical Kannada Literature.’ He started by pointing out the diversity of languages in India and explained the need to preserve them, as most are on the verge of extinction. He traced the development of Kannada in four stages, starting from 450 CE, along with the major authors and works produced during each epoch. He talked about important works such as Kavirajamarga, Vaddaradhane of Shivakotyacharya, Chavundaraya’s Trishasthi Lakshana Mahapurana, Adipurana of Pampa, Shantipurana of Ponna, Ajitha Tirthankara Purana of Ranna, and authors such as Vikramarjuna Vijaya of Pampa, Sahasa Bhima Vijaya of Ranna, Nagavarma 2, Nagachandra, etc. He concluded his talk by speaking about the significant features of Kannada like Campu form, marga (classical) and desi (indigenous), vocabulary, epic conventions, laukika and agamika kavyas, etc.\n\nThe first day of the seminar concluded with Dharana, by observing a minute of silence, after which the speakers and participants proceeded for high tea.',
        images: [
          bhashaImage4,
          bhashaImage8,
          bhashaImage14,
          bhashaImage19,
          bhashaImage21,
          bhashaImage22,
          bhashaImage25,
          bhashaImage27,
          bhashaImage30,
          bhashaImage32,
          bhashaImage34,
          bhashaImage45,
          bhashaImage47,
          bhashaImage52,
        ],
      },
      {
        heading: "Day 6 (16 December 2022)",
        text: "The final day of the seminar began with Ekagrata, by observing a minute of silence.\n\nThe first talk of the day was delivered by Prof. Madhusudan Penna ji, Kavikulaguru Kalidas Sanskrit University, Ramtek, Nagpur, Maharashtra. He spoke about the salient aspects of the Sanskrit language and literature. He presented Sanskrit as the mother of all languages and that it is the best medium of expression. He talked about Panini, his Ashtadhyayi, and the intricacies of Sanskrit grammar. He spoke about the Sanatana philosophy and the notions of Jag, Jiva, atman and Brahma. He also pointed to the vishwavidyalayas and the knowledge traditions in India dating back to ancient times. He explained that many of our developments are attributed to the West and that this was due to the lack of innovative methods of teaching and learning in the Middle Ages. He also explained the contributions of various rishis across multiple domains of knowledge, including language, mathematics, geography, astronomy, and aviation. He concluded by discussing interesting aspects of Sanskrit language and literature and addressing participants' questions.\n\nDr V. Ananthi, Assistant Professor at the University of Delhi, spoke about the salient features of the Tamil language and literature. She began by pointing out the differences between the Aryan and Dravidian languages and explained that Tamil is the most prominent among the Dravidian languages. She also deliberate upon the important literary works and authors who contributed to the development of Tamil literature. She quoted Dr Ambedkar, who said that Tamil represents the identity of India. She concluded her session by addressing the participants' questions.\n\nThe final talk was delivered after lunch break by Prof. Krishnan Unni P ji, who spoke about the Malayalam language and literature. He began his talk by pointing out the conflicts arising from linguistic identities. He stressed that the issue of origin is itself a very problematic idea, as it is a function of socio-economic, political and cultural change. He also deliberated upon the effects of colonisation on the local languages of the colonised people. He explained Sanskrit's influence on Malayalam, citing numerous references. He concluded his talk by thanking Bharatiya Bhasha Samiti and Rishihood University for organising the event, where the participants got to learn so much about the languages of India.\n\nIn the valedictory session, Prof. Madhusudan Penna ji and Prof. Shobhit Mathur ji distributed certificates and prizes to the winners of the singing, dancing, essay writing, painting and drama competitions.\n\nThe vote of thanks was delivered by Neelabh Sharma. The event ended with Dharana, by observing a minute of silence, after which the participants proceeded to high tea.",
        images: [
          bhashaImage54,
          bhashaImage72,
          bhashaImage78,
          bhashaImage90,
          bhashaImage95,
          bhashaImage97,
          bhashaImage106,
          bhashaImage109,
          bhashaImage112,
          bhashaImage113,
        ],
      },
    ],
  },
  {
    id: 110,
    title:
      "Sanskrit Children’s Literature | Sahitya Akademi | Rishihood University",
    heading:
      "Sanskrit Children’s Literature | Sahitya Akademi | Rishihood University",
    description:
      "Centre for Human Sciences, Rishihood University, in association with the Sahitya Akademi organized a one-day symposium on Sanskrit Children’s Literature at Rishihood University on 25th November 2022.",
    type: "Conference",
    date: "November 25, 2022",
    slug: "sanskrit-childrens-literature",
    image: sanskritChildrenBanner,
    link: "/events/conference/sanskrit-childrens-literature",
    fullHeading: "One-Day Symposium on Sanskrit Children’s Literature",
    overview:
      "Centre for Human Sciences, Rishihood University, in association with the Sahitya Akademi, organised a one-day symposium on Sanskrit Children’s Literature at Rishihood University on 25th November 2022. The symposium focused on the role of stories in shaping lives and the importance of creating new literature in Sanskrit for children to maintain the vitality of Indian civilization.",
    corePillars: [
      {
        heading: "Inaugural Session",
        text: "The Inaugural Session started with Mangalacharan and Ghan Path by the learners of Panini Mahavidyalaya, Sonipat. Shri N. Suresh Babu ji, Deputy Secretary of Sahitya Akademi, gave the welcome address. He explained the role of stories in shaping our lives from early childhood and highlighted the importance of technology in creating and disseminating new literature for children. Prof. Abhiraj Rajendra Mishra ji, Convener, Sanskrit Advisory Board, Sahitya Akademi, gave the introductory remarks in which he spoke about the importance of language and stories as carriers of culture and memory. Referring to the cultural similarities between the Vedic and the Mesopotamian civilisations, he explained that the Mesopotamian civilisation has been lost to oblivion, but ours still survives because of the Vedas, the Upanishads, the Puranas, and other great texts that have withstood the brunt of time. And in this respect, the creation and propagation of stories in Sanskrit becomes even more important for maintaining the vitality of our great civilisation.",
      },
      {
        heading: "Keynote Address",
        text: "In the Keynote address, Prof. Sampadananda Mishra ji, Director, Centre for Human Sciences, Rishihood University, explained that children are naturally optimistic and that, through stories, we can impart moral values to them and help them become self-aware. He emphasised the need to create high-quality literary content that can be used in Sanskrit teaching while also being profitable for publishers.",
      },
      {
        heading: "Thematic Sessions",
        text: "The symposium had two sessions in which five papers were presented. In the first session, Shri Aravind Kumar Tiwari presented the paper titled “An Overview of Sanskrit Children’s Literature.” Dr Surachana Trivedi ji spoke about the types of Sanskrit Children’s Literature, and Acharya Dhananjay Shastri explained the nuances of translating Children’s literature from Indian and foreign languages into Sanskrit.\n\nIn the second session, Shri Ajay Kumar Mishra explained how to create qualitative literature for children in Sanskrit. Shri Mukesh Sharma presented a review of the literature for children available in Sanskrit. Rishihood University’s Vice Chancellor, Shri Shobhit Mathur ji, addressed the audience with his electronic message. The concluding remarks were given by Prof. Abhiraj Rajendra Mishra ji.",
      },
      {
        heading: "Exhibition and Performance",
        text: "An exhibition titled “Why your child should learn Sanskrit” was on display at the symposium. About 100 students from three gurukuls participated in the symposium, along with their acharyas. The symposium concluded with a beautiful presentation of a one-act play in Sanskrit by the young learners of Guru Virjanand Sanskritkulam, followed by Dharana, by observance of a minute of silence.",
        images: [sanskritChildrenBanner],
      },
    ],
    videoUrl: "https://www.youtube.com/live/c2ErToV8F-k?si=6pL4rwls-16PlyBT",
  },
  {
    id: 111,
    title:
      "Role and Relevance of Knowledge Management in New Education Policy 2022: Indian Philosophical Viewpoint",
    heading:
      "Role and Relevance of Knowledge Management in New Education Policy 2022: Indian Philosophical Viewpoint",
    description:
      "The Centre for Human Sciences, in association with the Central Library at Rishihood University, organised this webinar on 10 July 2022. Priya M. Vaidya, Professor of Philosophy at the University of Mumbai, spoke on the importance of a value-based life and the Indian approach to education.",
    type: "Conference",
    date: "July 10, 2022",
    slug: "knowledge-management-nep-2022",
    image: nep2020Image,
    link: "/events/conference/knowledge-management-nep-2022",
    fullHeading:
      "Role and Relevance of Knowledge Management in New Education Policy 2022: Indian Philosophical Viewpoint",
    overview:
      'The Centre for Human Sciences, in association with the Central Library at Rishihood University, organised a webinar titled "The Role and Relevance of Knowledge Management in the New Education Policy 2022: An Indian Philosophical Viewpoint" on 10th July 2022. Dr Priya M Vaidya, Professor of Philosophy at the University of Mumbai, explained the importance of value-based life and the Indian approach to education. She emphasised that the Indian approach has always been to move from knowledge towards wisdom, and that Indian knowledge has always had a spiritual dimension. She differentiated between the modes and methods of knowledge management in India and the West and explained that for Westerners, knowledge management is specifically oriented towards the effective use of knowledge within a company, whereas the Indian method is focused towards integration, holistic development, has a strong epistemological base and is grounded in the four purusharthas of Dharma, Artha, Kama and Moksha. She stressed that the holistic approach to knowledge management is not just focused on the production of an employable workforce but also on an empathetic workforce. She highlighted the need for sustainable development, technological advancement, multidisciplinary skills, and the connection between the human mind and machines. She also stressed the need for the creation of scholarship media in India and emphasised that India can learn professionalism from the West, while the West can learn spirituality from India, thereby leading towards the creation of true global citizens.',
    videoUrl: "https://www.youtube.com/live/b6IfG91bDvw?si=4QM4kBRhrnVss8UC",
  },
  {
    id: 112,
    title: "Sri Aurobindo and India’s Renaissance",
    heading: "Sri Aurobindo and India’s Renaissance",
    description:
      "As part of the 150th Birth Anniversary celebrations of Sri Aurobindo and the 75th year of India’s Independence, the international conference “Sri Aurobindo and India’s Renaissance” was organised from 1–3 August 2021. The conference explored Sri Aurobindo’s vision of Indian renaissance, human consciousness, spirituality, and the future evolution of humanity in the context of India’s cultural and intellectual resurgence.",
    type: "Conference",
    date: "August 1-3, 2021",
    slug: "aurobindo-indias-renaissance",
    image: aurobindoRenaissanceBanner,
    link: "/events/conference/aurobindo-indias-renaissance",
    fullHeading: "Sri Aurobindo and India’s Renaissance",
    overview:
      "As part of the 150th Birth Anniversary celebrations of Sri Aurobindo and the 75th year of India’s Independence, the international conference “Sri Aurobindo and India’s Renaissance” was organised from 1–3 August 2021. The conference explored Sri Aurobindo’s vision of Indian renaissance, human consciousness, spirituality, and the future evolution of humanity in the context of India’s cultural and intellectual resurgence.",
    simpleFlow: [
      {
        text: "**Sri Aurobindo and India’s Renaissance**\n**International Conference | 1–3 August 2021**\n**The Rishi of Indic Renaissance – Celebrating 150 Years**\n\nOrganised by",
      },
      {
        images: [iiasLogo],
      },
      {
        images: [aurovedaLogo],
      },
      {
        heading: "Concept Note",
        text: "Sri Aurobindo has been hailed as a Yuga Puruṣa — one who embodies not only the salient features or movements of the age, but who also transforms it in his person. We usually encounter such beings as one age begins and another ends, and they seem to appear only to facilitate the transition of a nation or civilisation through its most seismic upheavals and shifts. India and the entire globe are presently being birthed into a new age in which Sri Aurobindo’s life and work continue to offer significant insights.\n\nAs an earthly man, Sri Aurobindo was a great revolutionary who fought and nearly gave up his life for India's freedom. After the 1857 “Indian Mutiny” or the “First War of Independence,” India lay crushed and broken under the realm of the so-called Pax Britannica. In such a dark era, Sri Aurobindo emerged as one of the early leaders who decisively turned the Indian National Congress towards its settled aim of Pūrṇaswarājya — complete freedom from British rule and self-reliance based on India’s own innate genius.\n\nBut Sri Aurobindo was more than a revolutionary. He may truly be considered a light of the nation. At a time when the nation was floundering in doubt and uncertainty about its own destiny and dharma, he revealed who and what we are — in heart, mind, body, and soul. He carried forward the great task initiated by Ramakrishna and Swami Vivekananda to revitalise the Indian people and brought it to a new fullness, breadth, and intensity.\n\nSri Aurobindo revealed the deeper meaning of India’s ancient texts and reminded us that we are the inheritors of the ancient flame passed down by the Ṛṣis. He showed not only India’s past and subdued present but also its future possibilities as a leader and mentor of humanity — Jagadguru. He awakened a latent national spirit and restored self-belief and gaurava, without which no great national enterprise can be envisioned or realised. Through a vast synthesis of Indian philosophical traditions, much like the Bhagavad Gītā of Sri Krishna, he reconciled diverse darśanas while preserving their essential truths and values.\n\nSri Aurobindo also engaged deeply with the West, not in conflict but in mutual understanding, recognising the value of Western contributions to humanity while simultaneously demonstrating the profound significance of India’s integral worldview. He emphasised that foundational components of Indian civilisation possess immense worth and utility, often surpassing modern materialistic paradigms in their understanding of life as an integrated whole.\n\nSri Aurobindo observed that “all great movements of life in India have begun with new spiritual thought and usually a new religious activity.” He believed that the Indian renaissance was not an imitation of the West but a uniquely Indian awakening rooted in spirituality and human consciousness. According to him, this renaissance had the potential not only to transform India but also to contribute significantly to humanity's future evolution.\n\nSri Aurobindo also analysed fundamental concepts such as mind and consciousness, and their transformation, especially how consciousness shapes the lives, thoughts, actions, and nature of both individuals and societies. Many of these ideas travelled far beyond India and influenced developments in psychology, neuroscience, and consciousness studies.\n\nThe international conference discussed and addressed these issues in depth. It explored Sri Aurobindo’s ideas on Indian renaissance, New India, human consciousness, spirituality, technology, and the future evolution of humanity. The conference also examined the contemporary relevance of his vision in the context of India’s intellectual, cultural, and spiritual resurgence.",
      },
      {
        heading: "Themes and Topics Explored",
        style: "program",
        text: "The conference explored themes such as:\n\n• Sri Aurobindo’s conception of a new Yuga\n• Indian Renaissance in comparison with the European Renaissance\n• Sri Aurobindo’s vision of New India and post-independence India\n• Public policy implications of Sri Aurobindo’s insights\n• Human consciousness, psychology, and spirituality\n• Artificial consciousness and its ethical implications\n• Technology, neuroscience, and consciousness studies\n• The journey of Sri Aurobindo’s ideas to the West\n• India’s civilizational identity and nationalism",
      },
      {
        heading: "Conference Information",
        text: "The conference was conducted online. Research papers presented at the conference were proposed for publication as a compendium following the event.",
      },
    ],
  },
  {
    id: 113,
    title: "Yogic Approach to True Leadership",
    heading: "Yogic Approach to True Leadership",
    description:
      "The webinar on Yogic Approach to True Leadership was conducted on June 21st 2021 To celebrate the 7th International Day of Yoga. Padmashri Shovana Narayanan, renowned Indian Kathak Artist, Sh. Shubha Vilas, Lifestyle Coach, Author & Story Teller, and Acharya Pratishtha, Indian Classical Dance & Yoga Exponent were the guest speakers for the event.",
    type: "Conference",
    date: "June 21, 2021",
    slug: "yogic-approach-true-leadership",
    image: mantraYogaCourse,
    link: "/events/conference/yogic-approach-true-leadership",
    fullHeading: "Yogic Approach to True Leadership",
    overview:
      "The webinar on Yogic Approach to True Leadership was conducted on June 21st 2021, to celebrate the 7th International Day of Yoga. Padmashri Shovana Narayanan, renowned Indian Kathak Artist, Sh. Shubha Vilas, Lifestyle Coach, Author & Storyteller, and Acharya Pratishtha, Indian Classical Dance & Yoga Exponent, were the guest speakers at the event. The event was hosted by Shivshankar ji and moderated by Dr Sampadananda Mishra. The event started with the address of Shri Suresh Prabhu ji, Chancellor of Rishihood University. He underlined the need for leaders at various levels and domains of society and the importance of these leaders in realising the true potential of Bharat.",
    corePillars: [
      {
        heading: "Perspectives on Leadership",
        text: "In her address, Padmashree Smt Shovana Narayan ji shared her perspectives on leadership and how yoga can help in producing leaders for the nation. She highlighted the attributes of a true leader and the example they set for the world, which motivate and guide future generations. She also stressed the need to cultivate sensitivity towards each and every being, concern for others, and a sense of brotherhood as a way of life.",
      },
      {
        heading: "Qualities of a Good Leader",
        text: "Shri Shubha Vilas ji spoke on the qualities of a good leader. Speaking about a great leader, he says that a great leader is the one who knows the value of balance and maintains that balance in all kinds of calamities and unfavourable circumstances, and he explained this with the example of Shri Krishna. He also quotes from Patanjali’s Yoga Sutra to outline the five qualities of a leader. Using Shri Ram as an example, he explains that a leader needs to overcome their ego to lead.",
      },
      {
        heading: "Yoga in Daily Life",
        text: "Acharya Pratishtha ji spoke on the meaning of yoga and what it means in essence. She explains that full perfection in one’s work is yoga, and if one is working perfectly, yoga has already happened in one's life. She explains how to become a true leader; it becomes very important to incorporate yoga into our lives to keep our body, mind, spirit, and consciousness healthy. She explained how one should begin their day to achieve optimal productivity with a very short meditative practice.\n\nThe event ended with a vote of thanks given by Dr Sampadananda Mishra.",
      },
    ],
    videoUrl: "https://www.youtube.com/live/W9zXY8BOMFA?si=5-_hcw00kYQbGbnc",
  },
];

export const workshops = [
  {
    id: 201,
    title: "An Introduction to Kashmir Shaivism",
    description:
      "Introduction to Kashmir Shaivism was a one-day workshop that introduced participants to the core concepts and practices of this ancient philosophy. Kashmir Shaivism is a non-dualistic tradition that emphasises the essential unity of all things and the liberation of individual consciousness from the limitations of ego and separation.\n\nDuring the workshop, participants learnt about the cosmology of Kashmir Shaivism, including the five elements, the three guá¹‡as, and the various levels of consciousness. They explored the concept of Åšiva-Åšakti, the dynamic interplay between the masculine and feminine energies that underlie all creation. Participants also delved into the practices of Kashmir Shaivism, including mantra-japa, meditation, and visualisation.\n\nThe workshop included a blend of lecture-style presentations, guided meditations, and group discussions. Participants had the opportunity to ask questions and participate in experiential learning exercises that deepened their understanding of this rich spiritual tradition. By the end of the workshop, participants had gained a foundational understanding of Kashmir Shaivism along with practical techniques for integrating its teachings into their spiritual practice.\n\nIn an enlightening workshop, Sthaneshwar Timalsina guided participants through the rich and ancient tradition of Kashmir Shaivism. The workshop explored profound concepts and practices that emphasise non-duality, unity, and the liberation of individual consciousness from ego and separation.",
    type: "Workshop",
    date: "July 22, 2023",
    slug: "kashmir-shaivism",
    image: kashmirShaivismBanner,
    videoUrl: "https://www.youtube.com/watch?v=6bu6Gk8g9mc",
    link: "/events/workshop/kashmir-shaivism",
  },
  {
    id: 202,
    title: "Workshop On Bhavani Bharati –“ Poetry in Motion",
    heading: "Workshop On Bhavani Bharati –“ Poetry in Motion",
    date: "April 29 - 30, 2023",
    venue: "Rishihood University (OFFLINE MODE & ONLINE MODE)",
    slug: "bhavani-bharati",
    image: bhavaniPoster,
    type: "Workshop",
    description:
      "Centre for Human Sciences and Strings –˜N' Steps jointly organised a two-day workshop to set the poetic excellence of BhavÄnÄ« BhÄratÄ« into rhythmic motion.\n\nDo you remember how, as children, most of us danced to rhymes while learning a language? Why? Because dance is one of the easiest ways of expressing ideas. Language is the expression of thoughts. Dance transcends these thoughts both to the inner self and to spectators in a poetic and creative way. Hence, it is called poetry in motion.\n\nBhavÄnÄ« BhÄratÄ«, a Sanskrit poem composed in ninety-nine verses by Sri Aurobindo, invokes Mother India as BhavÄnÄ« BhÄratÄ«. This poem possesses immense power to arouse the Åšakti within. In this workshop, selected verses were taught through dance. The students learnt the significance of the poem and the meanings of the verses, set to dance, movements, and expressions. The workshop concluded with a choreographic presentation on BhavÄnÄ« BhÄratÄ«.",
    facilitators: [
      {
        name: "Prof. Sampadananda Mishra",
        title: "Director, Centre for Human Sciences, Rishihood University",
        image: sampadanandaWorkshop,
      },
      {
        name: "Sangeeta Majumder",
        title:
          "Internationally acclaimed Kathak Dancer, Founder-Strings –˜N' Steps, ICCR & Doordarshan Artist",
        image: sangeetaWorkshop,
      },
    ],
    link: "/events/workshop/bhavani-bharati",
  },
  {
    id: 203,
    title: "Two-Day Training Workshop on Translation & Culture",
    date: "January 22-23, 2023",
    slug: "translation-culture",
    image: translationWorkshop1,
    type: "Workshop",
    description:
      "Chanakya University, in association with the Centre for Human Sciences, organised a two-day training workshop on Translation & Culture. The workshop was sponsored by Bharatiya Bhasha Samiti.\n\nHeld on 21–“22 January 2023 at Sri Aurobindo Ashram, the workshop focused on exploring the nuances of translation and its deep relationship with culture, language, and knowledge traditions.",
    driveLink:
      "https://drive.google.com/drive/folders/18I_2-cyOiB173SxIh53Po3PFi0iypxjQ?usp=sharing",
    secondaryImage: translationWorkshop2,
    link: "/events/workshop/translation-culture",
  },
  {
    id: 204,
    title:
      "An Introduction to the Ashtadhyayi of Panini in Light of the Recent Claim by a Cambridge University Scholar",
    date: "December 27, 2022",
    slug: "ashtadhyayi-panini",
    image: paniniWorkshop,
    type: "Workshop",
    speaker: "Prof. Sampadananda Mishra",
    speakerTitle: "Director, Centre for Human Sciences, Rishihood University",
    description:
      "As we are all aware, a claim was recently made by Rishi Rajpoot, a scholar from the University of Cambridge, regarding the solution to an ancient problem in PÄá¹‡ini's Aá¹£á¹­ÄdhyÄyÄ«. This research was presented as a landmark contribution towards the application of Sanskrit grammar in computational systems and the teaching of Sanskrit to computers.\n\nThe workshop focused on examining this ancient problem in the Aá¹£á¹­ÄdhyÄyÄ« in the light of these recent developments and the wider implications of such claims for Sanskrit studies and computational linguistics.",
    link: "/events/workshop/ashtadhyayi-panini",
  },
];

export const centreEvents = workshops;

export const mediaEvents = [
  {
    id: 301,
    title: "Rishihood University Sets Up Centre For Human Sciences",
    description:
      "News feature on the establishment of the Centre for Human Sciences and its mission to advance interdisciplinary research in humanities.",
    type: "Press Release",
    date: "May 17, 2022",
    slug: "chs-establishment",
    image:
      "https://images.unsplash.com/photo-1504711434969-e33886168f5c?auto=format&fit=crop&w=800&q=80",
    link: "https://indiaeducationdiary.in/rishihood-university-sets-up-centre-for-human-sciences/",
  },
  {
    id: 302,
    title: "Rishihood Hosts Sri Aurobindo Lectures",
    description:
      "A media coverage of the prestigious lecture series on Sri Aurobindo's philosophy and its contemporary relevance hosted at Rishihood University.",
    type: "Media Coverage",
    date: "August 13, 2022",
    slug: "aurobindo-lectures-media",
    image: aurobindoLecturesMedia,
    link: "https://www.bweducation.com/article/rishihood-hosts-sri-aurobindo-lectures-442027",
  },
  {
    id: 303,
    title:
      "GCE hosted National Seminar on –˜Integral Education of Sri Aurobindo'",
    description:
      "GCE hosted National Seminar on –˜Integral Education of Sri Aurobindo and its Implications for India's National Resurgence through Quality Teacher Education' at Govt. College of Education under the aegis of IQAC and RUSA on 22nd February.\n\nThe seminar was inaugurated by Prof. Sampadananda Mishra. He reiterated that the aim of Integral education is to amalgamate life, yoga and education as purang vidya. He also highlighted the concepts of aesthetic development, knowing thyself and discipline as given by Sri Aurobindo.",
    type: "Event Coverage",
    date: "February 23, 2023",
    slug: "integral-education-seminar",
    image: inMediaMain,
    link: "/events/media/integral-education-seminar",
    fullHeading:
      "GCE hosted National Seminar on –˜Integral Education of Sri Aurobindo and its Implications for India's National Resurgence through Quality Teacher Education'",
    gallery: [inMedia1, inMedia2, inMedia3, inMedia4, inMedia5],
  },
];

// For backward compatibility
export const pastEvents = [
  ...conferenceEvents,
  ...centreEvents,
  ...mediaEvents,
].slice(0, 4);

// Blogs for the Blog page and homepage
export const blogs = [
  {
    id: 1,
    title:
      "Trident Of Humanism : Integration Mutual Dependence, and Co-existence",
    excerpt:
      "Foundation of humanity is embedded in the pursuit of balance integration of humans and its surroundings.",
    author: {
      name: "Abhishek Tripathi and Neelabh Sharma",
      avatar: abhishekTrained,
    },
    date: "June 2, 2026",
    slug: "trident-of-humanism",
    content: `
      <p>Foundation of humanity is embedded in the pursuit of balance integration of humans and its surroundings. Human societies in various cultures and geographies have offered paths to this very integration, for the co-existence and mutual dependence of forms of lives on each other. The material (Bhautik) basis of integration demonstrates a fundamental part in achieving the goal of mutual dependence; however, the spiritual integration helps us achieve the understanding of the co-existence of the smallest to the grandest, all forms, and of all nature, char aur achar (animate and inanimate). Both, the material and spiritual integration combined, results into a balance functioning of world. Hence, it contributes to the wholistic wellbeing of the individual, and the communities.</p>

      <p>Communities, societies, and nations have developed localise methods in their respective living traditions – a reason for living, for the purpose, and meaning of life for the well-being of the people. Some of the examples include the nature-connect relation of tribal societies across the world, the Japanese way of Ikigai, Bhutan’s Gross National happiness, and the Nordic nations exceptional way of balancing welfare state generosity and cohesion amongst different income and social groups.</p>
      
      <p>In India, many traditions depicting “way of life”, “finding meaning and purpose of life”, such traditions allude to India’s diversity and plurality of its nature of seeking. Ancient Indian philosophical and practice traditions have influenced the recent development of methods and approach of holistic well-being. During the freedom movement and post independent India, some of the key terms that emerge during this discussion include Sarvodaya, Swarajya, Swadeshi, Trusteeship, Ram-Rajya, Integral Education, Man-Making Education, Gram-Rajya, Antoyadaya, Ekatma Manav darshan. These terms hold significant importance in shaping the practical implementation of material and spiritual integration of human and its environment in contemporary India.</p>
      
      <p>Progress of Humanity is rooted in the philosophy of integration, mutual dependence, and co-existence. The material basis of integration provides the necessary support for achieving the goal of mutual dependence, while spiritual integration keeping the realm of creation and the creator linked throughout.</p>
      
      <p><em>Acknowledgement: The short writing piece is result of the Integral Humanism Initiative Project Team discussion at the Centre of Human Sciences, Rishihood University.</em></p>
      <div class="mt-8 pt-6 border-t border-gray-100 text-sm">
        <p class="text-gray-500 font-medium">– Abhishek Tripathi and Neelabh Sharma Research Associates, Integral Humanism Initiative, Centre for Human Science, Rishihood University</p>
      </div>
    `,
    image: tridentHumanismBlogImage,
    categories: ["Integral Humanism Initiative (IHI)"],
  },
  {
    id: 10,
    title: "A Straight Line From Humanism to Integral Humanism",
    slug: "straight-line-humanism-to-integral-humanism",
    date: "June 2, 2026",
    excerpt:
      "Exploring the evolution of humanism from Vedic times to Pt. Deen Dayal Upadhyay's Integral Humanism.",
    author: {
      name: "Anusree.S.L Research Associate, CHS, Rishihood University",
      avatar: anusree,
    },
    content: `
      <p>India has a rich spiritual and material tradition of values regarding human existence. The Vedas and Upanishads are the basic pillars of Indian civilization, providing fundamental insights into human existence and our values. The oldest document, the Rig Veda, declares that all human beings are equal and brothers, while the Atharva Veda describes that all human beings have equal rights over water and food (natural resources). The Upanishads are primordial sources of ‘Dharma’, which is a comprehensive term for all human rights and duties. Observing these is essential for securing peace, well-being, and happiness for individuals and society.</p>

      <p>The erosion of humanity in society has led to massive devaluation in the socio-cultural and economic spheres. To address this problem, it is high time that we understand Pt. Deen Dayal Upadhyay’s concept of Integral Humanism. Before entering into the comprehensive vision of Integral Humanism, we need to understand the fundamentals of humanism. Although the word humanism entered the scene as a product of the Western Renaissance, the concept existed in Indian culture long before that. While Westerners define humanism according to their culture, in India, the scope and essence of the concept is different. We must understand some basic elements of the concept, such as the concept of humanism in the Indian perspective, why Integral Humanism in India, and why Integral Humanism got more acceptance than M.N. Roy’s Radical Humanism, etc.</p>

      <h3>Humanism in Indian Perspective:</h3>
      <p>Referring to the source of fundamental rights incorporated in our constitution, the Supreme Court of India has said this;</p>
      <blockquote class="my-6 border-l-4 border-[#CC0033] pl-4 italic text-gray-600">
        “These fundamental rights represent the basic values cherished by the people of this country since the Vedic times, and they are calculated to protect the dignity of the individual and create conditions in which every human being can develop his personality to the fullest extent” (Maneka Gandhi vs. Union of India-1978 (1) SCC 248)
      </blockquote>

      <p>From the above statement, we can get some highest values which followed by Indian tradition. If we search about the concept of Humanism in Google, we get;</p>
      <blockquote class="my-6 border-l-4 border-[#CC0033] pl-4 italic text-gray-600">
        “Humanism is a philosophy or a way of thinking about the world. It is a set of ethics or ideas about how people should live and act. People who hold this set of ethics are called humanists. The concept of humanism refers primarily to a system of thought, which focuses on the autonomy of the individual. So, Humanism is the product of renaissance and reformation in Europe and found its fullest expression in the American and French revolution”.
      </blockquote>

      <p>The cultural gap between the Western and Indian concepts of humanism is evident from their above definitions. Western humanism places great emphasis on the individual’s potential for greatness through reason, creativity, and education and is often associated with secularism, human rights, and equality. The term “Humanism” was coined by F.J. Niethammer for educational purposes. On the other hand, Indian humanism cannot be understood in the same sense as Western humanism. The Indian perspective on humanism is based on the principle of “Vasudhaiva Kutumbakam”, meaning “the world is one family”, which emphasizes the interconnectedness of all beings and the need for compassion and respect towards all life forms. Indian humanism also emphasizes the concept of “dharma”, which refers to the righteous way of living and performing one’s duties towards society, family, and the environment. It encourages individuals to seek knowledge, cultivate empathy and compassion, and practice non-violence in all aspects of life. Furthermore, Indian humanism places great importance on “seva”, or selfless service to others, using one’s skills and resources to help those in need and promote the well-being of society as a whole. Lastly, Indian humanism recognizes that the ultimate goal of human life is not just material success or individual happiness, but the attainment of spiritual enlightenment and liberation from the cycle of birth and death. Indian humanism offers a holistic and inclusive perspective on human well-being and encourages individuals to live in harmony with themselves, others, and the natural world.</p>

      <h3>Integral Humanism: Summary of Definition</h3>
      <p>Integral Humanism, a concept developed by Pandit Deen Dayal Upadhyaya, highlights the significance of individuals as the fundamental units of a nation. Similar to cells in a human body that form organs, individuals combine to form different societal systems. The state comprises multiple systems such as family, court, and government that function based on the nation’s self-consciousness or demanding force known as Dharma. Chiti, the self-consciousness created by Dharma, is what sustains India as a nation. Every nation has its chiti that, when combined, creates the self-consciousness of humanity. The collective self-consciousness acts as the self-consciousness of the universe, which embodies the vision of oneness of humanity known as Integral Humanism. Upadhyaya presented this concept as a new vision of development for India, emphasizing cultural and spiritual values, the interdependence of individuals and society, and the need for a decentralized and self-reliant economy promoting social and economic justice. Integral Humanism appealed to those in India who were disillusioned with the Western ideas of industrialization and modernization dominating the development models at the time, offering a unique way of thinking that emphasized human well-being and social justice.</p>

      <h3>Integral Humanism and Radical Humanism</h3>
      <p>In India, Radical Humanism is a philosophical and social movement that emerged in the mid-20th century in India. It was founded by M.N. Roy, a prominent Indian political theorist and activist. The basic tenet of Radical Humanism is the primacy of the individual over all institutions, including the state, religion, and society. It emphasizes reason, ethics, and freedom, and rejects dogma and superstition. Radical Humanism advocates for the establishment of a secular and democratic society based on the principles of equality, justice, and human rights.</p>

      <p>But, Radical Humanism did not gain as much acceptance as Integral Humanism in India. One reason for this may be that Radical Humanism was seen as too extreme and focused only on individualism, without considering the larger social and cultural context. In contrast, Integral Humanism emphasized the interdependence of the individual and society and the importance of cultural and spiritual values in addition to individual freedom. Integral Humanism also had roots in India’s unique cultural and spiritual heritage, which made it more appealing to many Indians.</p>

      <p>The journey from Indian humanism to Integral Humanism reflects a growing awareness of the need for a more holistic and balanced approach to development that considers a society’s cultural and spiritual values. Integral Humanism represents a unique blend of traditional Indian humanist values with modern political and economic thinking, and it continues to influence Indian political thought and practice today.</p>

      <div class="mt-8 pt-6 border-t border-gray-100 text-sm text-gray-500 font-medium">
        <p>– Anusree.S.L Research Associates, Centre for Human Science, Rishihood University</p>
      </div>
    `,
    image: blog6,
    categories: ["Integral Humanism Initiative (IHI)"],
  },
  {
    id: 2,
    title: "Let us begin with one minute of silence!",
    excerpt:
      "What is meant to be in free space to you? – some say our frozen air-conditioned room with Netflix and hunched body on the couch, while others may find it in a terrace view...",
    author: {
      name: "Riya Vardhan Saxena",
      avatar: riyaTrained,
    },
    date: "June 2, 2026",
    slug: "one-minute-silence",
    content: `
      <p>What is meant to be in free space to you? – some say our frozen air-conditioned room with Netflix and hunched body on the couch, while others may find it in a terrace view of the horizon at dawn or dusk. Someone known to me considers reciting mantras as free space, while others finds it in meditation. This space keeps on fluctuating in the internal and external sense. Nevertheless, dreaming while sleeping can be the best free space for most of the students. Also, composing a song can be a free space where one can come out with unbridled words and feelings in the lyrics. For someone free flowing of the limbs can be a free space. for some, free space might be their hostel room, and for some their office cabin. Everyone with their past experiences defines their free space.</p>

      <p>For a bird who flies in the sky, when put into a cage, aspires to be a part of her free space i.e., sky, for a fish who lives in the pond, suddenly bound to an aquarium, screams for her free space. For a pet, whom you take for a walk on a daily routine or leave free on the streets for strolls, yells like anything when you leave for your holiday plans and locks him inside. The concept of free space is not limited to the birds, fishes, and pets, but to the entire ecosystem which included the most yearning specie called “Man”.</p>

      <p>Before you progress to read the full blog, I would like you to leave a crowed place or some attentive desk, rather read it while sitting on a fully comfortably couch or a bean bag. Yes, no issues I can extend some writeup till the time you catch your couch. What if I begin with the story featuring a crow and a greasy pitcher searching for stones to reach the last line- “ghade me dale kankad, Uper aa gya paani, kauwa ne pe lia paani, khatam kahani” I hope you found a comfortable place to sit through. Ha ha ha</p>

      <p>Let’s come to the point of free space now which I experienced and found as a beacon to way my thoughts. Last month in March I attended some art and theatre workshops in Delhi, where I attended four workshops – On Dialog Delivery by Kriti Pant, On Movements and Expressions by Savita Rani, On Sound Design and Music in Theatre by Suman Balakrishnan, and last but not the least Ways of seeing a theatre by Vikram Phukam. You all might be wondering why I told you to sit on a comfy soft couch. So yes relax, deep breaths, relax close your eyes, and think as if you are going to be a part of my class session today, For the one who don’t know how to dance, let’s do it together, and you need to be calm down, and down and down. I hope there is nothing in your mind rather than your presence with yourself. Now think what it meant to you – “your presence with yourself”. It is as simple as you are feeling the process of breathing touching every wall of your organs while breathing. Stop feeling drowsy rather activate your mind 1,2,3, go. Don’t leave aside feeling the deep breaths, inhale…… and then exhale…… now you all may stand, close your eyes (stand as if you rotate your arms, or kick with your leg so it doesn’t collide with the wall or any object), the deep breath and start moving your limbs you wish to move, feel the air that your limbs are crossing, feel everything, now it’s the time to move two limbs at a time, enjoy the music of the movements, and yes you have started dancing even though you don’t know how to dance, here my inference with the dance was with the jammed limbs and giving them a movement. So, my task is done. Relax and now you can sit comfortably. Have you noticed I gave you your free space to think, to feel, and to move around and you were successful in performing something out of it. This is a power of free space in the mind. To accomplish anything that we need is the concentration and comfort of our mind and body. Why I gave you an example of my workshops just because every workshop begins with the free space to energize our body and mind, to what you are pursuing. You might have noticed why everything begins with one-minute silence and ends with one-minute silence in the Rishihood premise. It is the most powerful sandwich activity which mentally absorbs the crux of the filling. Hence 1-minute silence doesn’t mean you have to count 59, 58,56,45,32,21,12,9, 8, 4,3,2,1, no, a big no, it is for opening the pores of the mind. Like a baton to activate your mind and presence. I hope this blog will help to all the family members of Rishihood University. In the end, I would like to say – “Lost in your free space and give birth to your creativity”. – Riya Vardhan Saxena</p>

      <div class="mt-8 pt-6 border-t border-gray-100 text-sm">
        <p class="text-gray-500 font-medium">– Riya Vardhan Saxena, Research Associate, Centre for Human Sciences, Rishihood University</p>
      </div>
    `,
    image: silenceBlogImage,
    categories: ["Integral Humanism Initiative (IHI)"],
  },
  {
    id: 3,
    title: "Reconnecting with Nature through Integral Humanism Approach",
    excerpt:
      "The Earth is facing numerous environmental crises today. It is crucial to explore alternative approaches like Integral Humanism.",
    author: {
      name: "Akhil K Singh",
      avatar: akhilTrained,
    },
    date: "June 2, 2026",
    slug: "reconnecting-nature-ih",
    content: `
      <p>The Earth is facing numerous environmental crises today, including climate change, deforestation, and air and water pollution. These problems primarily stem from our unsustainable production and consumption patterns, leading to the over-exploitation of natural resources and environmental degradation. As we grapple with these challenges, it is crucial to explore alternative approaches to development that promote sustainability and social welfare. One such approach is Integral Humanism, which can help us overcome our tendency to over-exploit nature by promoting a more sustainable and integrated approach to development.</p>
      
      <p>As a passionate nature enthusiast and keen observer, I have always been concerned about the disconnect between humans and the environment. Our forgetfulness about our deep interconnectedness with nature makes us feel separate from it, leading us to exploit and use it for personal benefit. Consequently, our tendency to over-exploit nature has resulted in numerous environmental crises. I often wondered how we could change our understanding of our relationship with the Earth to ensure a sustainable future. When I discovered the concept of integral Humanism, I found a potential solution to this pressing issue.</p>
      
      <p>My journey into integral Humanism began when I stumbled upon the works of Pandit Deendayal Upadhyaya, an Indian philosopher who championed this holistic approach to life. Integral Humanism emphasizes the interconnectedness of humans, nature, and the cosmos, seeking to balance life’s material, intellectual, and spiritual aspects. The more I delved into integral Humanism, the more I realized it could provide a framework for redefining our relationship with nature and overcoming our tendency to over-exploit the environment.</p>
      
      <p>At its core, Integral Humanism is a philosophy that stresses the importance of preserving and promoting cultural and spiritual values while fostering social welfare and economic progress. It recognizes the interdependence of all living beings and the environment, emphasizing the need for developing a more responsible, compassionate, and sustainable relationship with the environment. So, how can understanding Integral Humanism help us overcome our tendency to over-exploit nature? Here are some ways:</p>
      
      <p><strong>Rediscovering Our Connection to Nature:</strong> Integral Humanism teaches us the importance of recognizing our deep connection with nature. We often forget that we are part of the environment, not separate entities that can exploit it without consequences. By embracing our interconnectedness with the natural world, we can develop a sense of responsibility and duty towards it. This profound understanding can enable us to become more conscious of our actions and their environmental impact, leading to more mindful consumption and better resource management.</p>
      
      <p><strong>Developing Self-Reliance:</strong> Integral Humanism emphasizes the importance of self-reliance and decentralization, helping us reduce our dependence on natural resources and promoting more sustainable production and consumption practices. By relying on local resources and encouraging decentralized decision-making, we can minimize our impact on the environment and promote ecological sustainability. As responsible citizens, we can actively encourage self-reliance by learning about sustainable practices such as composting, rainwater harvesting, and organic farming. Adopting these practices in our daily lives can reduce our environmental impact and promote sustainable living.</p>
      
      <p><strong>Promoting Holistic Development:</strong> Integral Humanism recognizes that economic progress is not the only goal but rather a means to an end that aims to improve the quality of life for all individuals, especially the marginalized and vulnerable. This perspective can help us develop a more balanced and integrated approach to development, prioritizing social welfare and environmental sustainability over short-term economic gains. To achieve harmony with nature, we need to balance our needs and desires with the well-being of the environment. This means stepping away from the relentless pursuit of material wealth and adopting a lifestyle that prioritizes the long-term health of our planet. In our lives, we can consciously adopt more sustainable practices, such as reducing waste, conserving water, and supporting local, organic agriculture. No matter how small, every action counts towards building a more sustainable future.</p>
      
      <p><strong>Cultivating Compassion for All Living Beings:</strong> One of the most transformative aspects of integral Humanism is its emphasis on developing compassion and empathy for all living beings, including animals, plants, and ecosystems. By nurturing these emotions, we can overcome our tendency to exploit nature for short-term gains and instead prioritize its well-being. Adopting a more compassionate mindset may lead us to make more eco-conscious choices, such as supporting conservation efforts, adopting a plant-based diet, and reducing our carbon footprint. Fostering a sense of compassion for all life forms is a crucial step in building a more sustainable relationship with the environment. Consequently, understanding Integral Humanism may help us to realize the importance of balancing material progress and spiritual growth. Through this philosophy, I’ve learned to recognize the limitations of material wealth and focus on nurturing my intellectual, emotional, and spiritual well-being.</p>
      
      <p>Therefore, in sum, by cultivating a more balanced approach to life, we can develop a deeper appreciation for the natural world and our role in protecting it. We should also strive to share this understanding with others, inspiring them to seek balance and harmony with the environment. As a result, understanding Integral Humanism can help us overcome our tendency to over-exploit nature by promoting a more responsible, compassionate, and sustainable relationship with the environment. We all can contribute to this effort by developing self-reliance, promoting holistic development, and preserving cultural and spiritual values. By adopting these principles in our daily lives, we can help build a more just and sustainable society where people and the environment can thrive together.</p>
      
      <div class="mt-8 pt-6 border-t border-gray-100 text-sm text-gray-500 font-medium">
        <p>– Akhil K Singh Research Associates, Centre for Human Science, Rishihood University</p>
      </div>
    `,
    image: reconnectingNatureBlogImage,
    categories: ["Integral Humanism Initiative (IHI)"],
  },
  {
    id: 4,
    title: "Exploring the Colours Of Onam",
    excerpt:
      "India, a land known for its vibrant diversity, hosts a multitude of festivals, among which Onam shines as a radiant star.",
    author: {
      name: "Anusree.S.L Research Associate, IHI, CHS, Rishihood University",
      avatar: anusree,
    },
    date: "June 2, 2026",
    slug: "colours-of-onam",
    content: `
      <p>India, a land known for its vibrant diversity, hosts a multitude of festivals, among which Onam shines as a radiant star. Celebrated in the picturesque state of Kerala, often referred to as “God’s Own Country,” Onam is a cherished harvest festival that encapsulates the essence of unity and diversity. This remarkable festival takes place during the month of Shravan, known as “chingam” in Malayalam, typically falling in August or September. Kerala’s beautiful landscape, decorated with lush greenery, majestic mountains, calm lakes, and flowing rivers, forms the backdrop for Onam’s festivities. The festival spans ten joyous days, enveloping the entire state in its embrace. Amidst the revelry, the first and tenth days hold special significance, symbolizing the grandeur of Onam.</p>

      <div class="my-8">
        <img src="${onamSec1Image}" alt="Onam Celebration Landscape" class="w-full h-auto object-cover" />
      </div>

      <p>What distinguishes Onam is its power to transcend divisions, uniting people of diverse religions, castes, and creeds under the common banner of togetherness. The festival marks the transition from the harsh month of Karkidakam to Chingam, promising prosperity to farmers and turning Onam into a celebration of harvest. This spirit of unity goes beyond religious boundaries, fostering a sense of belonging among all. The heartwarming tale of Onam traces back to Mahabali, the beloved mythical king of Kerala, whose visit to his subjects on the day of Thiruvonam is celebrated with joy. Mahabali, a just and charitable ruler, governed with equity, erasing the lines of poverty, crime, and cruelty. Despite being a demon king, his reign was an epitome of prosperity, his subjects adoring him.</p>

      <div class="my-8">
        <img src="${onamSec2Image}" alt="Mahabali and Vamana Legend" class="w-full h-auto object-cover" />
      </div>

      <p>The legend continues with Lord Vishnu’s Vamana Avatar, a Brahmin boy who sought land from Mahabali, eventually covering the entire universe in just two steps. Mahabali, realizing the deity’s identity, humbly offered his head for the third step. In this act of devotion, he was sent to the netherworld with the promise to visit his people annually. This tale of sacrifice, symbolized by the folk song “Maveli nadu vaneedum kalam,” is integral to Onam’s celebration. The festival’s ten days are marked by various customs and traditions, each contributing to the festival’s grandeur. The vibrant Pookalam, the captivating boat race Vallamkali, traditional dances like Pulikali and Kathakali, and the sumptuous Ona Sadhya feast served on plantain leaves are integral components of Onam’s charm.</p>
      
      <div class="my-8">
        <img src="${onamInner}" alt="Onam Celebration" class="w-full h-auto object-cover" />
      </div>

      <p>Amidst these festivities, the significance of Thrikkakara temple adds historical depth to the celebration. Thrikkakara, a place linked to Mahabali’s legend, epitomizes the spirit of Onam. Cheraman Perumal, the emperor of Kulasekharam, initiated the Onam festival as a means of uniting local kings and nobility. This practice spread across the state, turning Onam into a unifying force. Onam also stands as a celebration of Kerala’s rich farming traditions. As Chingam follows the rainy season, it brings with it the promise of a bountiful harvest. The ten days leading up to Onam serve as a preparatory period for the next farming cycle, symbolizing the unity of communities working hand-in-hand with nature.</p>
      
      <p>Beyond the festivities, Onam conveys a profound message. Just as a rainbow paints the sky with a spectrum of colours, Onam paints Kerala with unity, love, and the beauty of diversity. As we partake in the festival’s joy, let us remember that Onam’s values echo the principles of integral humanism, encouraging us to foster unity amidst diversity and celebrate every individual’s worth. In this Onam, let us unite in the spirit of Oneness, echoing the essence of integral humanism that this vibrant festival embodies.</p>
    `,
    image: onamMainImage,
    categories: ["Integral Humanism Initiative (IHI)"],
  },
  {
    id: 5,
    title: "Mindful Gamification and Mental Well-being",
    excerpt:
      "Exploring the impact of 'Buddhi-Yoga' and mindful gamification on social-emotional development.",
    author: {
      name: "Rajat Pratap Singh, Intern at Centre for Human Sciences (IHI), Rishihood University",
      avatar: user,
    },
    date: "June 2, 2026",
    slug: "mindful-gamification",
    content: `
      <p>I was fortunate to have participated in a recently conducted workshop on ‘Gamification’ conducted at Rishihood University by Aman Gopal, the visionary founder of Khol Khel. The session commenced with an anecdote shared by Mr. Gopal about his daughter’s interest in board games like Ludo. Concerned about the potential negative effects of such games on children’s mental and spiritual growth, and recognizing a lack of alternatives in the market, he delved into the realm of games. This marked the inception of Khol Khel in the early 2000s. Aman Gopal emphasized that a ‘Game’ is not a mere peripheral activity but significantly impacts mental well-being. His thought-provoking inquiries such as ‘where does ‘play’ transition into ‘sport’, and ‘are you playing the game or is the game playing you’, prompted profound contemplation on the pervasive yet incompletely comprehended phenomenon of gaming. He asserted that the Game itself influences us, shaping not only how we play but also instilling lasting habits and attitudes beyond the gaming experience.</p>

      <p>Aman Gopal elucidated that game designers have a primary goal: to sell. Gamification theories underscore elements like heroism, rewards, acknowledgment, and hierarchy, which contribute to this process. Successful gamification involves embedding these aspects, exploiting human vulnerabilities such as desire, anger, attachment, greed, pride, and delusion. Games thus tap into fundamental aspects of human nature. Can we, based on these structures, create something novel that also enriches the social-emotional development of children? This question led Khol Khel to develop ‘Buddhi-Yoga’ – a board game that ingeniously incorporates the core mechanics of Snake and Ladder, albeit with distinctive modifications.</p>

      <p>Buddhi-Yoga replaces conventional numerical blocks with content rooted in Indian tradition. Negative behaviors, attitudes, or thoughts lead to regression, while positive ones lead to progression. For instance, blocks symbolizing Avidya, Durbuddhi, and Adharma result in descending to Kama, Krodha, and Moha. Ladders are substituted by ropes, which elevate players from attributes like Daya or compassion to higher states such as Brahma-Loka or Gyana to Anand-Loka. Additionally, the blocks are organized as word-clouds, connecting each block with its relevant qualities. The primary aim of Buddha-Yoga, as emphasized by Aman Gopal, is to align players’ experiential selves with the ethical education imparted. While society advocates values like cooperation, traditional games often promote conflict and competition, exemplified by classics like Monopoly. Buddhi-Yoga endeavors to guide young minds towards ‘collaboration’. Drawing from the ancient Indian concept of Sarpa-Rajju, wherein darkness (ignorance) leads to mistaking a rope for a snake, the game underscores the importance of discernment in distinguishing right from wrong, highlighting the repercussions of poor choices. The Indian concepts of ‘papa-punya’ and ‘purushartha’ are also effectively embedded in the game. Good thoughts lead to good action, which in turn, evokes good thoughts. But the objective before the player is to transcend this realm of ‘papa-punya’ and go beyond, into ‘purushartha’ which comes in proximity of Vaikuntha-Loka.</p>

      <p>The workshop featured an engaging activity, prompting participants to address four questions: Why do we play? Why do we learn? Why do we work? What guides our decision-making? Analysis of responses revealed predominantly individualistic and competitive perspectives. This underscores the relevance of Buddhi-Yoga. The workshop also witnessed insightful contributions from faculty and students, enriching the discussion. Sanjeev Ji, Dean of Rashtram School of Leadership, inquired about India’s frameworks for comprehending Gamification. In response, Aman Gopal referenced Someshwara’s Manasollasa, stating that the Game not only brings enjoyment to the player but also impacts the player in return. He drew parallels with the story of Hidimba, who taught her son Ghatotkacha life skills through animals who were treated as ‘gurus’. Aman Gopal also contrasted India’s historical approach of experimenting on humans before animals with the contemporary Western practice. Overall, the workshop provided a profoundly effective and thought-provoking experience, leaving participants not only well-informed about the realm of gaming but also prompting contemplation on deep philosophical inquiries about agency and free will.</p>

      <p>From the very beginning of the workshop, I was drawn into a world of contemplation I hadn’t previously explored. The workshop opened my eyes to the idea that games are far more than mere entertainment; they are intricate tools that can shape our mental and emotional landscapes. Aman Gopal’s emphasis on the impact of games on mental well-being prompted me to consider the subtle ways in which various gaming experiences influence our thoughts, behaviors, and attitudes. This experience has ignited a curiosity in me to explore the deeper connections between seemingly unrelated domains and to approach education and personal development with a more holistic and integrated mindset.</p>

      <div class="mt-8 pt-6 border-t border-gray-100 text-sm">
        <p class="text-gray-500 font-medium">– Rajat Pratap Singh, Intern at Centre for Human Sciences (IHI), Rishihood University</p>
      </div>
    `,
    image: aiRoboticsBlogImage,
    categories: ["Integral Humanism Initiative (IHI)"],
  },
  {
    id: 6,
    title:
      "An Overview of Sri Aurobindo’s Writings about Social and Political Philosophy",
    excerpt:
      "Sri Aurobindo's comprehensive vision for the transformation of society and the evolution of humanity.",
    author: {
      name: "Anusree.S.L Research Associate, IHI, CHS, Rishihood University",
      avatar: anusree,
    },
    date: "June 2, 2026",
    slug: "aurobindo-socio-political",
    content: `
      <h3>Introduction to Socio-Political Approach on Sri Aurobindo</h3>
      <p>Sri Aurobindo developed a unique socio-political approach through his extensive writings and teachings. His works, particularly “The Human Cycle” and “The Ideal of Human Unity“, present a comprehensive vision for the transformation of society and the evolution of humanity. At the core of Sri Aurobindo’s socio-political philosophy is the idea that human society is a dynamic and evolving entity, constantly progressing towards higher stages of development. He believed that the ultimate aim of society should be the realization of the full potential of the individual and the establishment of a harmonious and progressive collective life.</p>
      
      <p>According to Sri Aurobindo, the evolution of society unfolds through various stages, each marked by a dominant principle or consciousness. These stages include the tribal, feudal, and modern individualistic phases. However, he argued that these stages were transitional, and that humanity was destined to move towards a higher, more integrated form of social organization. Sri Aurobindo envisioned a future society that he called the “Spiritual Age” or the “Supramental Society“. In this society, the emphasis would shift from individual self-interest to a collective well-being based on spiritual principles. He believed that a new consciousness, the supramental consciousness, would emerge, transforming not only individuals but also the entire social fabric.</p>
      
      <p>To bring about this transformation, Sri Aurobindo emphasized the importance of inner growth and spiritual development. He believed that individual transformation was a prerequisite for societal change. He advocated for the development of integral education, which would nurture all dimensions of an individual’s being—physical, mental, emotional, and spiritual. In Sri Aurobindo’s socio-political approach, the role of leadership was crucial. He envisioned a leadership that would be spiritually enlightened and guided by a higher wisdom, working for the upliftment of society as a whole. Sri Aurobindo rejected traditional models of governance, such as autocracy or democracy, in favour of a more evolved form of leadership that transcended personal ambitions and vested interests.</p>
      
      <p>While Sri Aurobindo’s socio-political approach may seem idealistic, he acknowledged the challenges in its realization. He recognized the necessity of a gradual and progressive approach, where each individual plays a role in the transformation of society. He believed in the power of collective effort and the potential of humanity to overcome its limitations and move towards a higher and more harmonious existence. Sri Aurobindo’s socio-political approach is rooted in a spiritual understanding of human potential and the transformative power of consciousness. It emphasizes the need for inner growth, integral education, enlightened leadership, and collective efforts to create a society that is more aligned with higher principles and values.</p>

      <h3>An Overview of Sri Aurobindo’s Socio-Political Works</h3>
      <p>Sri Aurobindo’s literary journey commenced during his time in England. The Complete Works of Sri Aurobindo, consisting of 36 Volumes, began to be published by Sri Aurobindo Ashram in 1997. Among his extensive writings, five volumes stand out as particularly significant in showcasing Sri Aurobindo’s Social and Political philosophy. Here, we present a list of these volumes along with brief descriptions of their content:</p>
      
      <div class="space-y-6 my-8">
        <div class="border-l-4 border-[#CC0033] pl-4">
          <h4 class="font-bold text-lg">● Early Cultural Writings (Volume 1)</h4>
          <p class="mt-1"><strong>About the work:</strong> In this text he mentioned the early essays and other prose writings on literature, education, art and other cultural subjects. The volume includes the Harmony of virtue, Bankim Chandra Chatterji, Essays on Kalidasa and the Mahabharata, The national value of Art, Conversations of Deed, The Chandernagore Manuscript, Book Reviews, Bankim-Tilak-Dayananda and Baroda speeches and reports. Most of these pieces were written between 1890 and 1910, a few between 1910 and 1920.</p>
          <p class="mt-1 text-sm italic text-gray-600"><strong>Note:</strong> This work represents one of Sri Aurobindo’s earliest writings, and thus, it contains only a few references to socio-political philosophy. Nonetheless, we can still glean some fundamental ideas from the book.</p>
        </div>

        <div class="border-l-4 border-[#CC0033] pl-4">
          <h4 class="font-bold text-lg">● Bande Mataram (Volume 6-7)</h4>
          <p class="mt-1"><strong>About the work:</strong> All surviving political writings and speeches from 1890 to 1908. The two volumes consist primarily of 353 articles originally published in the nationalist newspaper Bande Mataram between August 1906 and May 1908. Also included are political articles written by Sri Aurobindo before the start of Bande Matram, speeches delivered by him between 1907 and 1908, articles from his manuscripts of that period that were not published in his lifetime, and an interview of 1908.</p>
          <p class="mt-1 text-sm italic text-gray-600"><strong>Note:</strong> This was published during the nationalism movement period.</p>
        </div>

        <div class="border-l-4 border-[#CC0033] pl-4">
          <h4 class="font-bold text-lg">● Karmayogin (Volume 8)</h4>
          <p class="mt-1"><strong>About the work:</strong> All surviving political writings and speeches of 1909 and 1910. This volume consists primarily of articles originally published in the nationalist newspaper Karmayogin between June 1909 and February 1910. It also includes speeches delivered by Sri Aurobindo in 1909.</p>
          <p class="mt-1 text-sm italic text-gray-600"><strong>Note:</strong> 1908 – 09 Sri Aurobindo was in Alipore Jail. After came back from Alipore, he wrote Karmayogin.</p>
        </div>

        <div class="border-l-4 border-[#CC0033] pl-4">
          <h4 class="font-bold text-lg">● The Human Cycle – The Ideal of Human Unity – War and Self-Determination (Volume 25)</h4>
          <p class="mt-1"><strong>About the works:</strong> Three works of social and political philosophy. In “The Human Cycle”, Sri Aurobindo traces the evolution of human society and suggests where it is headed. In “The Ideal of Human Unity”, he examines the possibility of the unification of the human race. In “War and Self-Determination”, he discusses the sovereignty of nations in the aftermath of the first world war. These works were first serialized in the monthly review ARYA between 1915 and 1920; later Sri Aurobindo revised them for publication.</p>
          <p class="mt-1 text-sm italic text-gray-600"><strong>Note:</strong> Primary important work for understanding Sri Aurobindo’s Socio-political approach.</p>
        </div>

        <div class="border-l-4 border-[#CC0033] pl-4">
          <h4 class="font-bold text-lg">● The Renaissance in India with a Defense of Indian Culture (Volume 20)</h4>
          <p class="mt-1"><strong>About the Work:</strong> Essays on the value of Indian civilization and culture. This volume consists of three series of essays and one single essay:
            <ul class="list-disc pl-6 mt-1 space-y-1">
              <li>The Renaissance in India.</li>
              <li>Indian Culture and External Influence</li>
              <li>Is India Civilized?</li>
              <li>Defense of Indian Culture.</li>
            </ul>
            They were first published in the monthly review ARYA between 1918 and 1921. In 1913, they first appeared in a book under the title the foundations of Indian culture.
          </p>
          <p class="mt-1 text-sm italic text-gray-600"><strong>Note:</strong> In this work, He slightly mention the social and political philosophy. This writing also response the criticism of Indian culture. In that sense, this text is not very important from the socio-political perspective. Even though, if we take up it, there is an interesting session in the Renaissance in India, called “Indian Polity”. In this session beautifully explained the past political form which existed in India.</p>
        </div>
      </div>

      <h3>Crux of Sri Aurobindo’s All Works</h3>
      <p>Sri Aurobindo’s literary works exhibit a dual focus on individual and collective aspects, encompassing diverse themes presented in distinct styles. For instance, a comparative analysis of “Human Cycle“, “Life Divine” and “Synthesis of Yoga” reveals their unique qualities, while concurrently highlighting the underlying coherence of Sri Aurobindo’s overarching vision. Despite apparent disparities in content, an integral perspective consistently emerges, providing a unified framework for comprehending the world. Even within the realm of social and political philosophy, which may seem distinct from the spiritual synthesis expounded in “Synthesis of Yoga” a discernible thread manifests: a global outlook centred on the evolutionary progression of consciousness permeates these texts. Through Sri Aurobindo’s socio-political lens, we perceive a narrative delineating the growth of consciousness, ultimately presenting the story of human beings and their communities.</p>

      <h3>Conclusion</h3>
      <p>Sri Aurobindo envisions a future society, the “Spiritual Age” or the “Supramental Society“, where collective well-being and spiritual principles take precedence over individual self-interest. This transformative vision is rooted in the understanding that societal change necessitates individual growth and spiritual development. Central to Sri Aurobindo’s sociopolitical approach is the importance of integral education and enlightened leadership. He emphasizes the need for education that nurtures all aspects of an individual’s being, and for leaders who possess spiritual wisdom and work towards the upliftment of society. Sri Aurobindo challenges traditional models of governance, advocating for a leadership that transcends personal ambitions and vested interests.</p>
      
      <p>While the realization of Sri Aurobindo’s socio-political vision may pose challenges, he recognizes the power of collective effort and the potential of humanity to overcome limitations. His approach underscores the significance of inner transformation, integral education, enlightened leadership, and collective endeavours in creating a society aligned with higher principles and values. Through a comparative analysis of Sri Aurobindo’s works, it becomes evident that despite variations in content and style, a coherent and integral perspective underlies his writings. This perspective emphasizes the evolutionary growth of consciousness and presents a narrative of human and communal development.</p>
      
      <p>Understanding of Sri Aurobindo’s socio-political approach provides valuable insights into his philosophy, its relevance in contemporary times, the interplay between spirituality and societal transformation, the practicality of his proposals, the role of leadership and education, comparative evaluations, and practical recommendations for fostering a conscious and progressive society. Sri Aurobindo’s socio-political philosophy offers a holistic and transformative perspective on society, urging individuals and communities to strive for higher ideals and contribute to the growth of collective consciousness.</p>
      
      <p><em>Reference: (From Shri Devdip Ganguli’s talk about Sri Aurobindo’s Socio-Political Philosophy)</em></p>

      <div class="mt-8 pt-6 border-t border-gray-100 text-sm text-gray-500 font-medium">
        <p>– Anusree.S.L, Research Associates, Integral Humanism Initiative(IHI), Centre for Human Science, Rishihood University</p>
      </div>
    `,
    image: aurobindoSocioPoliticalBlogImage,
    categories: ["Philosophy", "Integral Humanism Initiative (IHI)"],
  },
  {
    id: 7,
    title: "The Power of Humility: Fueling the Quest for Lifelong Learning",
    slug: "power-of-humility-lifelong-learning",
    date: "June 2, 2026",
    excerpt:
      "Discover how humility can serve as a powerful alternative approach to progress and a vital characteristic of effective leadership.",
    author: {
      name: "Damini Roy, Research Associate, Avadhānakalā and Consciousness Studies, CHS",
      avatar: damini,
    },
    content: `
      <p>Do you carry a gesture of humility every day? If not, then why not to sling it now within. Let me tell you about the magic behind Humility, a levitating element that can have a profound impact on the overall personality of a human being. It sets the tone for a positive, inclusive, and supportive world environment. Often perceived as a characteristic associated with modesty and self-effacement, sometimes contrary to the notion of progress. However, when we delve deeper into the concept, we can discover, “How humility can serve as a powerful alternative approach to progress”?</p>
      
      <p>It gives a way for societies to acknowledge that there is always more to learn and room for improvement. It fosters a mindset of continuous learning and growth, encouraging individuals to seek knowledge, challenge their assumptions, and embrace new perspectives. This willingness to learn and evolve is crucial for progress. Humility promotes the recognition of openness to collaboration. By embracing humility, individuals are more open to recognizing the values of diverse ideas and experiences and hence can encourage the sharing of knowledge, innovation, and collective problem-solving, all of which contribute to progress. It also allows individuals to accept constructive feedback and recognize their own intentions. Enables individuals to embrace feedback as an opportunity for growth and development rather than perceiving it as a threat or a blow to their ego. This feedback loop, driven by humility, facilitates personal and collective progress. Humans can overcome the fear of failure and foster an environment that encourages experimentation, and enhance their emotional intelligence, leading to improved cognitive abilities related to social interactions and emotional understanding. It fuels curiosity and a growth mindset. When individuals approach learning with humility, they are more likely to embrace challenges, seek new knowledge, and persist in the face of difficulties. This mindset stimulates cognitive skills such as problem-solving, critical thinking, creativity, etc. Intellectual humility, a subset of humility, involves recognizing the limits of one’s knowledge and being open to the possibility of being wrong. Such a type of mindset encourages individuals to engage in constructive discussions. Such Intellectual humility fosters cognitive skills related to analytical thinking, logical reasoning, and evaluating evidence. It also promotes cognitive flexibility, which is the ability to adapt one’s thinking and approach based on new information or changing circumstances. By being open-minded and willing to revise their beliefs and opinions, individuals can enhance cognitive abilities and expand a more well-rounded and adaptable mind.</p>
      
      <p>Humility is often regarded as a vital characteristic of effective leaders. By embracing humility, leaders can open themselves up to valuable insights, personal growth, and enhanced relationships within their teams.</p>
      
      <p>Here are several key points highlighting the significance of humility in leadership:</p>
      
      <h3>Higher Self-control</h3>
      <p>Humility promotes self-control and emotional intelligence in leaders. Humble leaders are less likely to react impulsively or let their ego drive their actions. Instead, they exhibit self-control, maintain composure, and make thoughtful decisions. This ability to manage emotions and act with restraint fosters a more harmonious and productive work environment.</p>
      
      <h3>Better work performance</h3>
      <p>Humility positively impacts work performance. Humble leaders create an atmosphere where individuals feel safe to take risks, learn from their mistakes, and openly communicate. This leads to increased creativity within the team. Additionally, humble leaders empower their team members, allowing them to grow and develop their skills, which ultimately enhances overall work performance.</p>
      
      <h3>Soothing the Soul</h3>
      <p>Humility has a profound impact on the leader’s own well-being. By embracing humility, Leaders get-go of ego-driven behaviours and focus on the greater good. This allows them to experience a sense of peace and contentment, leading to reduced stress and a healthier work-life balance. A leader who is at peace with themselves can effectively inspire and guide others toward success.</p>
      
      <h3>Listening and Learning</h3>
      <p>Humility allows leaders to truly listen to others. By acknowledging that they don’t have all the answers, Humble leaders are open to different perspectives, ideas, and feedback. This enables them to learn from the experiences and knowledge of their team members, promoting a culture of continuous learning and improvement.</p>
      
      <p>Hence, Humility encourages us to recognize our fallibility, appreciate the contributions of others, and pursue progress with a sense of responsibility and respect. In this way, humility can serve as a powerful alternative to progress, one that promotes sustainable and meaningful advancement for individuals and society. By practicing humility leaders can create a harmonious and successful work environment that promotes the growth and development of individuals and the organization.</p>
      
      <div class="mt-8 pt-6 border-t border-gray-100 text-sm text-gray-500 font-medium">
        <p>– Damini Roy, Research Associate, Avadhānakalā and Consciousness Studies, CHS</p>
      </div>
    `,
    image: blog15,
    categories: ["Integral Humanism Initiative (IHI)"],
  },
  {
    id: 8,
    title: "Mechanics of Social Order Cube Efforts in Integral Humanism",
    slug: "mechanics-of-social-order-cube-integral-humanism",
    date: "June 2, 2026",
    excerpt:
      "Exploring the socio-chemical equation for Integral Humanism and the cubic model of Purushārthas as presented by Pt. Deendayal Upadhyaya.",
    author: {
      name: "Anusree.S.L Research Associate, IHI, CHS, Rishihood University",
      avatar: anusree,
    },
    content: `
      <p>Based on my readings, I realized that the concept of integral humanism as a journey from homo-sapiens to homo-nova can be understood in the context of the purushārthas, which are the four pillars of human aspiration in Indian perspective. Homo-sapiens, or modern humans, are seen as the starting point of this journey. However, integral humanism posits that there is still much room for growth and development in the human experience, and that we have the potential to transcend our current state and become something greater. The term "homo-nova" refers to a new form of human being that is more evolved and integrated than our current state. It suggests a future state of humanity that is more in tune with our inner selves, more conscious and aware, and more connected to the world around us. This new form of human being would be characterized by a greater sense of harmony and balance, both within ourselves and with the world around us. purushārthas suggests that individuals are the building blocks of states and societies. Everyone’s pursuit of the purushārthas - dharma, artha, kāma, and moksha - contributes to the overall well-being and prosperity of the society.</p>
      
      <h3>Pandit Deendayal Upadhyay’s Approach on Purushārthas</h3>
      <p>The ancient concept of purushārtha is rooted in Indian philosophy and encompasses four main pillars of human aspiration: dharma (righteousness), artha (material wealth), kāma (pleasure), and moksha (liberation). These four purushārthas are seen as the ultimate goals of human life and are meant to provide a framework for understanding and pursuing a meaningful and fulfilling life. Pandit Deendayal Upadhyaya, also developed a concept of purushārtha that differs in some respects from the ancient concept. Upadhyaya ji's concept of purushārtha is rooted in the idea of integral humanism, which emphasizes the need for a holistic approach to human development that takes into account the individual, society, and the environment.</p>
      
      <p>In Upadhyaya ji's concept of purushārtha, the focus is on the idea of "Antyodaya," or the upliftment of the most vulnerable and marginalized sections of society. He believed that the pursuit of dharma, artha, and kāma must be balanced with a sense of social responsibility and a commitment to the well-being of the less fortunate. While the ancient concept of purushārtha emphasizes the pursuit of individual goals and aspirations, Upadhyaya ji's concept stresses the importance of social welfare and the idea of the "common good." He believed that society and the individual are interdependent, and that the pursuit of individual goals must be balanced with a sense of duty towards the larger community.</p>
      
      <p>While both the ancient concept of purushārtha and Deendayal Upadhyaya ji's concept share some similarities, such as the emphasis on dharma and the pursuit of a meaningful life, Upadhyaya's concept places a greater emphasis on social responsibility and the idea of the common good, reflecting a more modern and inclusive approach to the concept of purushārtha.</p>
      
      <h3>Derivation of Equation for Integral Humanism: On the Basis of purushārtha</h3>
      <p>We have thought of life as integrated not only in the case of collective or social life but also in individual life. The individual and society cannot be separated from each other. The four purushārthas are what the cohesion between the two generates. From this perspective, we can recreate a socio-chemical equation for Integral humanism.</p>
      
      <p><strong>Derivation Steps:</strong></p>
      
      <div class="flex flex-col items-center my-8">
        <div class="flex items-center gap-4 text-lg font-medium">
          <span>Individual + Society</span>
          <div class="flex flex-col items-center">
            <span class="text-xs text-gray-500 mb-1">Properties of purushartha</span>
            <div class="flex items-center">
              <div class="h-px w-24 bg-black"></div>
              <div class="w-2 h-2 border-t border-r border-black rotate-45 -ml-2"></div>
            </div>
          </div>
          <span>Integral Humanism</span>
        </div>
      </div>

      <div class="space-y-1 mb-8">
        <p>Individual = Body + Heart + Intellect + Soul</p>
        <p>Society = Determination + Country + Constitution + Culture</p>
        <p>Properties of Purushārthas = Education + Performance + Sacrifice + Yogakshema</p>
        <p class="text-sm italic text-gray-500">(Nb: Here ‘+’ symbol act as the separation symbol, it doesn’t mean addition.)</p>
      </div>

      <p>If we can abbreviate the above concepts, it will act as a formula of Integral Humanism. So the abbreviations are given below;</p>

      <div class="space-y-1 my-8">
        <p>Body + Heart + Intellect + Soul = BHIS</p>
        <p class="text-sm italic text-gray-500">(Nb: BHIS , pronounced as ‘Be-His’ it represented as Individual or self)</p>
        <p>Determination + Country + Constitution + Culture = DC<sup>3</sup></p>
        <p>Education + Performance + Sacrifice + Yogakshema = EPSY</p>
      </div>

      <p>From these abbreviations, instead of</p>

      <div class="flex flex-col items-center my-8">
        <div class="flex items-center gap-4 text-lg font-medium">
          <span>Individual + Society</span>
          <div class="flex flex-col items-center">
            <span class="text-xs text-gray-500 mb-1">Properties of purushartha</span>
            <div class="flex items-center">
              <div class="h-px w-24 bg-black"></div>
              <div class="w-2 h-2 border-t border-r border-black rotate-45 -ml-2"></div>
            </div>
          </div>
          <span>Integral Humanism</span>
        </div>
      </div>

      <p>We can derive an equation like,</p>

      <div class="flex flex-col items-center my-8">
        <div class="flex items-center gap-4 text-xl font-bold text-[#CC0033]">
          <span>BHIS + DC<sup>3</sup></span>
          <div class="flex flex-col items-center">
            <span class="text-xs text-gray-500 font-normal mb-1">EPSY</span>
            <div class="flex items-center">
              <div class="h-px w-24 bg-[#CC0033]"></div>
              <div class="w-2 h-2 border-t border-r border-[#CC0033] rotate-45 -ml-2"></div>
            </div>
          </div>
          <span>IH</span>
        </div>
      </div>

      <h3>Graphical Representation:</h3>
      <img src="${equationGraph}" alt="Integral Humanism Equation" class="my-8 rounded-xl shadow-lg border border-gray-100 mx-auto" />
      <p><em>(Reference from: Integral Humanism An Analysis of Some Basic Elements Deendayal Upadhyaya written by Dr. Mahesh Chandra Sharma)</em></p>
      
      <h3>Explanation:</h3>
      <p>The aggregate of the body, heart, intellect, and soul (BHIS) is what constitutes the individual, and happiness the satisfaction of these four components. Such an individual contains BHIS, similarly society contains Determination, Culture, Constitution and Country (DC3). The well-being, progress and refinement of these four constituents is essential. As in the case of an individual, we should think of all these elements in the case of the group or the collective also possesses them. From the individual to nation, the nation is the largest unit of a collective. Like individual, A nation must have these four components. These two units are connected to each other with the help of four properties or pillars (EPSY) of Purushārthas. Education, Performance, Sacrifice and Yogakshema (EPSY), these four elements linking the individual and society unify the individual and the collectivity. Education flows from the individual to the society due to performance from the individual to the society. Performance and sacrifice go together. In the absence of Performance (karma), society is not able to create wealth. Acquisition and property from the individual to the society and sacrifice, giving again, from the individual to society.</p>
      
      <h3>Mechanics of Social Order Cube Efforts:</h3>
      <img src="${socialOrderCube}" alt="Social Order Cube" class="my-8 rounded-xl shadow-lg border border-gray-100 mx-auto" />
      <p><em>(Reference from: Integral Humanism An Analysis of Some Basic Elements Deendayal Upadhyaya written by Dr. Mahesh Chandra Sharma)</em></p>
      
      <p>The concept of Artha (wealth) and Dharma (duty) being interdependent and mutually supportive is a fundamental aspect of Indian thought and is closely tied to the concept of Purushārthas. According to this philosophy, wealth (Artha) and duty (Dharma) are not opposites, but rather they form a complementary relationship. Dharma, which includes religious, moral, and ethical duties, provides the foundation for the creation and sustenance of wealth. It is believed that if individuals perform their duties in society, it will create a harmonious environment that is conducive to the generation of wealth. For example, if farmers perform their duties by cultivating crops and providing food for society, it will lead to the creation of wealth in the form of agricultural produce.</p>
      
      <p>On the other hand, the pursuit of wealth is necessary to fulfill one's material needs and desires, which is the purushārtha of Artha. The pursuit of wealth, however, must be in accordance with Dharma and ethical principles. Wealth creation through unethical means is not considered desirable and is likely to have negative consequences for individuals and society. Kama (desire) is another purushārtha that is closely related to Artha and Dharma. While Artha can help fulfill our desires, it is important to remember that desire should be kept in check and regulated by Dharma. Excessive consumption or pursuit of material wealth is not considered desirable in Indian philosophy, as it can lead to a loss of balance and harm to oneself and society.</p>
      
      <p>Dharma and Artha form the basis for each other, while Kama and Moksha appear to be contradictory. However, the pursuit of Kama is necessary to fulfill the material desires of an individual, and Moksha is the ultimate goal of human life, representing spiritual liberation or enlightenment. In the cubic model of Integral Humanism, Deendayal Upadhyaya represented the four Purushārthas as four sides of a cube, with each side representing one Purushartha. The cube represents completeness, and all four Purushārthas are necessary for a complete and fulfilling life.</p>
      
      <p>The wise understand that all four Purushārthas are interconnected, and it is essential to keep all four in mind while pursuing any one of them. For example, the pursuit of wealth or Artha must be in accordance with Dharma, and the pursuit of Kama must be regulated by both Dharma and Artha. Ultimately, the ultimate goal of human life is Moksha, or spiritual liberation, which is achieved by balancing all four Purushārthas in life.</p>

      <p>The four Purushārthas represent the fundamental desires of human life, and they are interconnected and interdependent. The pursuit of a complete and fulfilling life involves balancing all four Purushārthas, with Moksha as the ultimate goal. The cubic model of Integral Humanism represents this concept and emphasizes the importance of keeping all four Purushārthas in mind while pursuing any one of them.</p>
      <div class="mt-8 pt-6 border-t border-gray-100 text-sm">
        <p class="text-gray-500 font-medium">– Anusree.S.L, Research Associates, Integral Humanism Initiative(IHI), Centre for Human Science, Rishihood University</p>
      </div>
    `,
    image: socialOrderCubeBlogImage,
    categories: ["Integral Humanism Initiative (IHI)"],
  },
  {
    id: 9,
    title:
      "Nurturing Curiosity through the Interplay of Embodied Cognition, Integral Humanism, and Ancient Indian Learning",
    slug: "nurturing-curiosity-embodied-cognition-integral-humanism",
    date: "June 2, 2026",
    excerpt:
      "How a holistic approach to education can nourish curiosity, empowering individuals to flourish intellectually, emotionally, and socially.",
    author: {
      name: "Akhil K Singh Research Associates, Integral Humanism Initiative(IHI), Centre for Human Science, Rishihood University",
      avatar: akhilTrained,
    },
    content: `
      <p>Curiosity is an incredible force that resides deep within us, driving us to question, explore, and acquire knowledge [1]. From the very moment we enter this world, it ignites a powerful desire for discovery, propelling us forward on a journey of growth and progress [2]. In this blog, I aim to weave together the captivating realms of integral humanism, the ancient Indian education system, embodied cognition, and the development of curiosity. By intertwining these fascinating concepts, we can unlock insights into how a holistic approach to education can nourish curiosity, empowering individuals to flourish intellectually, emotionally, and socially.</p>

      <p>At the heart of holistic education lies integral humanism, a philosophy that lays the groundwork for the development of the complete individual. It recognizes the interconnected nature of our physical, intellectual, emotional, and spiritual aspects [3]. Pioneered by visionaries like Pandit Deen Dayal Upadhyaya and Sri Aurobindo, integral humanism finds its roots in the Vedas, capturing the essence of a well-rounded human being. It acknowledges that we are not separate entities but rather a harmonious fusion of body, heart, intellect, and soul. Moreover, it embraces the idea that we are intricately intertwined with society and the environment. Pandit Deen Dayal Upadhyaya eloquently encapsulates this concept through his notion of vyashti, samashti, and parameshti. These ideas underscore the fact that we are not passive receptacles of information, but rather active participants in the dynamic process of knowledge creation and understanding.</p>

      <p>Drawing inspiration from the ancient Indian education system, such as the Gurukula system, we discover invaluable lessons from our past. In this ancient system, students lived closely with their teachers, forming a tight-knit community that nurtured experiential learning, moral values, and character development [4]. The emphasis on integrating various subjects and arts cultivated interdisciplinary thinking, opening doors to curiosity as students unveiled the connections between different domains of knowledge. Furthermore, the ancient system embraced questioning and exploration, recognizing that curiosity serves as the key to unlocking profound understanding and wisdom.</p>

      <p>Now, let us venture into the realm of embodied cognition—a concept firmly grounded in the intricate bond between mind and body—which further enriches our understanding of curiosity’s development. Embodied cognition suggests that our mental faculties emerge from the physical interactions we have with the world [5]. It highlights the profound influence of our physical experiences on our cognitive processes. By engaging our bodies through hands-on activities, sensory experiences, and movement, we tap into the power of embodied cognition, enhancing learning and curiosity [6]. When students actively participate in their learning journey, forging connections between abstract concepts and tangible experiences, they deepen their understanding and ignite a flame of curiosity that beckons them to explore further [7].</p>

      <p>That means, to cultivate curiosity in modern education, we should try to harmoniously blend the principles of integral humanism, embodied cognition, and ancient Indian education model. Traditional (current mainstream) education systems often stifle curiosity by fixating on rote memorization and standardized testing, neglecting the holistic development of individuals. By embracing a curiosity-driven approach, we can transform education into a dynamic and captivating process. One strategy that holds tremendous promise is project-based learning. This approach grants students the freedom to investigate real-world problems and unleash their creativity in finding innovative solutions. Collaborative activities foster critical thinking skills, teamwork, and a sense of curiosity as students actively participate in the learning process. Encouraging self-directed learning, wherein students pursue their passions and delve into their interests, nurtures curiosity and a genuine love for acquiring knowledge that extends beyond the boundaries of traditional subjects. There is no doubt that when individuals are encouraged to explore, question, and seek knowledge, they become more adept at identifying problems, developing creative solutions, and adapting to an ever-changing world [8].</p>

      <p>Furthermore, a curiosity-driven education reaps profound personal benefits. It instils a lifelong love for learning, empowering individuals to continually seek knowledge and expand their intellectual horizons. Curiosity also enhances well-being, as individuals derive immense joy and fulfillment from the pursuit of understanding. Moreover, curiosity cultivates a sense of wonder, fostering empathy, cultural understanding, and open-mindedness [9]. In turn, this leads to harmonious social interactions and the creation of a more inclusive society.</p>

      <p>Of course, implementing a curiosity-driven education system is not without its challenges. It necessitates reevaluating traditional assessment methods, empowering teachers to adopt innovative teaching practices, and fostering an inclusive and supportive learning environment. However, the potential benefits that lie ahead are immeasurable, equipping individuals with the tools necessary to thrive in an ever-evolving world.</p>

      <p>Hence, by embracing the essence of integral humanism, drawing wisdom from the ancient Indian education system, and tapping into the transformative power of embodied cognition, we have the capacity to revolutionize education. In doing so, we can instill a curiosity-driven approach at its core, inherently recognizing the vital importance of nurturing curiosity and empowering individuals to become lifelong learners, critical thinkers, and contributors to society. By fostering the holistic development of the mind and body, we create an educational ecosystem that celebrates curiosity, fosters innovation, and cultivates individuals who are well-equipped to navigate the complexities of the world.</p>

      <div class="mt-8 pt-8 border-t border-gray-100">
        <h4 class="font-bold mb-4">References:</h4>
        <ul class="text-sm space-y-2 list-none p-0 text-gray-500">
          <li>[1] D. E. Berlyne, “A Theory of Human Curiosity,” Br. J. Psychol. Gen. Sect., vol. 45, no. 3, pp. 180–191, 1954, doi: 10.1111/j.2044-8295.1954.tb01243.x.</li>
          <li>[2] G. Ofer and J. Durban, “Curiosity: Reflections on Its Nature and Functions,” Am. J. Psychother., vol. 53, no. 1, pp. 35–51, Jan. 1999, doi: 10.1176/appi.psychotherapy.1999.53.1.35.</li>
          <li>[3] V. V. Nene, Pt. Deendayal Upadhyay Ideology and Preception-Part-2: Integral Humanism, vol. 2. Suruchi Prakashan, 2014.</li>
          <li>[4] A. S. Altekar, Education in ancient India. Gyan Publishing House, 2009.</li>
          <li>[5] M. Wilson, “Six views of embodied cognition,” Psychon. Bull. Rev., vol. 9, no. 4, pp. 625–636, 2002.</li>
          <li>[6] A. K. Singh and H. N. V, “Embodied education: A pathway towards more integrated learning,” Contemp. Educ. Dialogue, vol. 18, no. 2, pp. 202–225, 2021.</li>
          <li>[7] S.-M. Lee, “Curiosity and experience design: developing the desire to know and explore in ways that are sociable, embodied and playful,” Jun. 2016, Accessed: Jun. 01, 2023. [Online]. Available: <a href="https://era.ed.ac.uk/handle/1842/20977" target="_blank" rel="noopener noreferrer" class="text-[#CC0033] hover:underline">https://era.ed.ac.uk/handle/1842/20977</a></li>
          <li>[8] M. Zuss, The Practice of Theoretical Curiosity, vol. 20. in Explorations of Educational Purpose, vol. 20. Dordrecht: Springer Netherlands, 2012. doi: 10.1007/978-94-007-2117-3.</li>
          <li>[9] K. S. Walters, Re-Thinking Reason: New Perspectives in Critical Thinking. SUNY Press, 1994.</li>
        </ul>
        <p class="mt-6 text-sm text-gray-500 font-medium">– Akhil K Singh Research Associates, Integral Humanism Initiative(IHI), Centre for Human Science, Rishihood University</p>
      </div>
    `,
    image: nurturingCuriosityBlogImage,
    categories: ["Integral Humanism Initiative (IHI)"],
  },
  {
    id: 11,
    title:
      "Unveiling the Depths of Kashmir Shaivism: A Recap of the Profound Session",
    slug: "unveiling-depths-kashmir-shaivism",
    date: "July 22, 2023",
    excerpt:
      "Exploring the historical, cultural, philosophical, and meditative aspects of Kashmir Shaivism as discussed by Acharya Prof. Sthaneshwar Timalsina.",
    author: {
      name: "Centre for Human Sciences",
      avatar: logo,
    },
    content: `
      <p>In the realm of spiritual exploration, there are moments that stand out as transformative milestones. Such an occasion unfolded on the 22nd of July, 2023, when the renowned scholar, Acharya Prof. Sthaneshwar Timalsina, graced an audience with his illuminating insights on Kashmir Shaivism. This workshop was organised by Centre for Human Sciences in association with Vimarsha Foundation, unfolded like a journey into the heart of an ancient tradition that has left an indelible mark on the tapestry of Indian philosophy.</p>

      <h3>A Glimpse into the Expertise of the Speaker</h3>
      <p>Acharya Prof. Sthaneshwar Timalsina is a luminary in the field of Hindu philosophy, particularly adept in the domains of Vedanta, Yoga, and Tantra. As the founder of the Vimarsha Foundation and currently a professor of Religious Studies at San Diego State University, USA, his expertise has extended across continents, bridging the gap between academic rigor and spiritual wisdom.</p>

      <h3>Traversing the Terrain: Kashmir Shaivism’s Historical and Cultural Landscape</h3>
      <p>Acharya Timalsina initiated the discourse by setting the stage, painting a vivid picture of the historical and cultural context in which Kashmir Shaivism emerged. He skillfully navigated through the tapestry of marginalizations, hegemony, and colonization that have woven the intricate fabric of this tradition. With this backdrop, the audience was primed to delve into the multifaceted world of Kashmir Shaivism.</p>

      <h3>Session 1: Unearthing the Literary and Philosophical Roots</h3>
      <p>In the first session, Acharya Timalsina embarked on a journey to uncover the literary and philosophical roots of Kashmir Shaivism. He eloquently illuminated the intersections of Vedantic, Tantric, and Puranic traditions within this profound philosophy. Notably, the Trika tradition, intimately intertwined with Samkhya philosophy, was underscored for its pivotal role. The discourse expanded to encompass the regional variations in literature across the Indian subcontinent, lending insight into the depth and diversity of thought that Kashmir Shaivism embraces. The session also unfurled the scrolls of Agamas, Siddhantas, and commentaries, giving attendees a glimpse into the literary tapestry of this tradition.</p>

      <h3>Session 2: The Essence of Kashmir Shaivism’s Philosophical Vision</h3>
      <p>Central to Kashmir Shaivism’s philosophical canvas is the concept of completeness and oneness in Shiva. Acharya Timalsina meticulously explored this cardinal tenet, unraveling the threads of Panchakarma and Trika – two concepts that emanate from this foundational value. The lecture delved into the attributes of consciousness, shedding light on the intricate philosophical landscape that Kashmir Shaivism offers to seekers.</p>

      <h3>Session 3: The Meditative Odyssey</h3>
      <p>Stepping into the realm of practice, Acharya Timalsina unveiled the meditative approach of Kashmir Shaivism. Attendees were treated to an exposition of diverse meditation techniques and practices that form the very backbone of the spiritual journey within this tradition. As seekers, this session provided a roadmap to traverse the inner landscapes and connect with the profound teachings of Kashmir Shaivism.</p>

      <h3>Session 4: Bridging Minds through Interaction</h3>
      <p>The culmination of this enlightening session manifested as an interactive exchange between Acharya Timalsina and the engaged audience. A platform for questions, insights, and clarifications, this segment fostered a sense of intellectual camaraderie. Attendees seized the opportunity to pose questions, seek guidance, and share reflections, further enriching their understanding of Kashmir Shaivism.</p>

      <h3>Key Takeaways: Nurturing Integral Humanism</h3>
      <p>As the curtains drew on this transformative session, the audience departed with a trove of key takeaways. Integral Humanism emerged as a philosophical root, emphasizing the harmony of completeness and oneness within the Supreme Consciousness. The amalgamation of Vedic, Tantric, and Puranic traditions illustrated the interconnectedness that lies at the heart of Kashmir Shaivism.</p>

      <p>In conclusion, the session with Acharya Prof. Sthaneshwar Timalsina on that July day was a tapestry woven with threads of historical context, philosophical insights, and practical wisdom. Attendees departed with a newfound understanding of Kashmir Shaivism and its intricate tapestry of thought, as well as a deeper connection to the profound heritage of Indian philosophy. The session served as a reminder that the pursuit of knowledge and spiritual wisdom is a perpetual journey, one that continues to enrich the lives of seekers across the globe.</p>
    `,
    image: shaivismBlogImage,
    categories: ["IKS"],
  },
  {
    id: 12,
    title:
      "Exploring the Nexus of Spirituality and Politics with Sri Aurobindo",
    slug: "exploring-nexus-spirituality-politics-sri-aurobindo",
    date: "July 24, 2023",
    excerpt:
      "Rishihood University’s Center for Human Science recently played host to two transformative sessions guided by the expertise of Dr. Lakshmi Bandlamudi, exploring the convergence of spirituality and politics.",
    author: {
      name: "Dr. Lakshmi Bandlamudi",
      avatar: lakshmiBandlamudi,
    },
    content: `
      <p>In the heart of intellectual exploration, moments leave an indelible mark on our understanding of the world. Rishihood University’s Center for Human Science recently played host to two such transformative sessions, both guided by the expertise of Dr. Lakshmi Bandlamudi, a distinguished psychology professor at LaGuardia College, City University of New York (CUNY). These sessions, held on the 24th of July, journeyed into uncharted territory where spirituality and politics converge, unlocking a realm of thought-provoking insights.</p>

      <h3>Session 1: Bridging Spirituality and Politics with Sri Aurobindo</h3>
      <p>The first session, an integral part of the ICPR Sponsored Lecture Series on Sri Aurobindo’s Political and Cultural Philosophy, aimed to illuminate the deeper connection between spirituality and politics. Dr. Lakshmi Bandlamudi delved into the concept of ‘Swachhta’ in the political context, a term that transcends the boundaries of mere physical cleanliness. By intertwining ethical conduct, transparency, and responsible governance, ‘Swachhta’ transforms into a beacon of integrity and societal well-being.</p>

      <h3>Sri Aurobindo’s Integral Vision: A Holistic Paradigm</h3>
      <p>Dr. Bandlamudi’s discourse unfolded the teachings of Sri Aurobindo, a visionary philosopher who sought to harmonize the material and spiritual dimensions of life. This integral vision emerged as a guiding force, ushering a profound shift in political thinking. Attendees were led to perceive how this vision, intricately woven with ethics and spirituality, can drive principled leadership and inspire a purpose-driven approach to decision-making.</p>

      <h3>Session 2: Culmination of Spiritual Wisdom and Political Governance</h3>
      <p>The second session resonated with the same core themes, underlining the need to integrate spirituality and politics. Dr. Bandlamudi emphasized that the integration of spiritual values into politics isn’t a mere abstraction; it’s a potent catalyst for change. Sri Aurobindo’s teachings stood as a testament to the potential of this integration, as attendees delved deeper into the ideals of inclusivity, compassion, and sustainable development that it nurtures.</p>

      <h3>Key Takeaways: A Pathway to Holistic Governance</h3>
      <p>Both sessions culminated in a cascade of insights that reverberated in the minds of participants. The importance of ethical governance, the harmonization of spirituality and politics, and the resonance of Sri Aurobindo’s integral vision echoed as key takeaways. Attendees were left with a newfound perspective on the potential of principled, spiritually-informed leadership in catalyzing holistic societal well-being.</p>

      <h3>Harmonizing for a Better Tomorrow</h3>
      <p>In summary, these two sessions at Rishihood University’s Center for Human Science epitomized the convergence of intellect and spirituality. Dr. Lakshmi Bandlamudi, with her expertise and profound understanding, guided participants on a journey that highlighted the importance of intertwining spirituality and politics. The integration of spiritual values into political thought is not an esoteric pursuit; it’s a transformative step towards compassionate, inclusive governance that lays the foundation for a harmonious and sustainable society. As the echoes of these sessions continue to resonate, they inspire us to approach the intersection of spirituality and politics with a renewed sense of purpose and collective well-being.</p>
    `,
    image: spiritualityPoliticsBlogImage,
    categories: ["Philosophy"],
  },
  {
    id: 13,
    title:
      "Revelation of the Roots and Essence of Antyodaya: A Journey Through Indian Philosophical Wisdom",
    slug: "revelation-roots-essence-antyodaya-indian-philosophy",
    date: "June 2, 2026",
    excerpt:
      "Antyodaya, pioneered by Pandit Deendayal Upadhyay, isn’t just a new idea—it’s a revival of our ancient philosophies, tailored to meet the challenges of today. Its roots run deep in India’s traditional wisdom, reflecting a timeless ethos rather than a modern innovation.",
    author: {
      name: "Anusree.S.L Research Associate, IHI, CHS, Rishihood University",
      avatar: anusree,
    },
    content: `
      <p>Antyodaya, pioneered by Pandit Deendayal Upadhyay, isn’t just a new idea—it’s a revival of our ancient philosophies, tailored to meet the challenges of today. Its roots run deep in India’s traditional wisdom, reflecting a timeless ethos rather than a modern innovation. To grasp the essence of Antyodaya, we must journey back to its origins. Exploring its genesis reveals the intricate tapestry of Indian thought that birthed this profound concept. Through the lens of Advaita philosophy, we uncover the interconnectedness of all life forms and the harmony between society and nature at the heart of Antyodaya. This exploration isn’t merely an academic pursuit; it’s a rediscovery of our cultural identity. Antyodaya isn’t just about the present—it’s about honoring our past while embracing the challenges of the future. It’s a testament to the resilience of India’s philosophical heritage, offering insights that resonate with the rhythm of our collective consciousness.</p>

      <h3>Genesis of Antyodaya:</h3>
      <p>The roots of Antyodaya delve deep into the expressions of Indian scriptures, notably found in the profound verses of the Vedas. These ancient texts envision the upliftment of the entire world, establishing the welfare of all as their fundamental premise. The Vedic dictum,</p>
      
      <blockquote class="my-6 border-l-4 border-[#CC0033] pl-4 italic text-gray-600">
        सर्वे भवन्तु सुखिनः।<br/>
        सर्वे सन्तु निरामयाः।<br/>
        सर्वे भद्राणि पश्यन्तु।<br/>
        मा कश्चित् दुःखभाग् भवेत्।<br/>
        <span class="text-xs font-normal block mt-1 text-gray-500">(Sarve bhavantu sukhinah। Sarve santu niramayah। Sarve bhadrani pashyantu। Ma kashchit duhkha-bhag bhavet।)</span>
      </blockquote>
      
      <p>‘May everyone be happy and healthy. Let all witness the good, and let no one suffer,’ This verse expresses the sentiment of well-being and prosperity for all beings, wishing happiness, health, and the absence of suffering for everyone. It encapsulates the essence of ultimate elevation.</p>

      <p>The Ishavasyopanishad’s inaugural verse echoes the sentiment, proclaiming,</p>
      
      <blockquote class="my-6 border-l-4 border-[#CC0033] pl-4 italic text-gray-600">
        ईशावास्यमिदं सर्वं यत्किञ्च जगत्यां जगत्।<br/>
        तेन त्यक्तेन भुञ्जीथा मा गृधः कस्यस्विद्धनम्।।<br/>
        <span class="text-xs font-normal block mt-1 text-gray-500">(Ishavasyamidam sarvam yat kinchit jagatyanjagat. Tena tyaktena bhunjithah ma gridhah kasyashvidhanam.)</span>
      </blockquote>

      <p>“All that is animate or inanimate in this world is enveloped and indwelled by the Divine. By renunciation, enjoy the fruits of your actions; do not covet what belongs to others.”</p>
      
      <p>This verse encapsulates the idea of recognizing the divine presence in everything, promoting a sense of detachment, and encouraging individuals to enjoy the fruits of their actions without harboring a desire for others’ possessions. It emphasizes the principle of detachment and contentment, aligning with the spiritual wisdom found in the Upanishads.</p>

      <p>Similarly, the Bhagavad Gita emphasizes <strong>आत्मवत् सर्वभूतेषु (Atmavat Sarvabhuteshu)</strong> and <strong>सर्वभूतहिते रतः (Sarvabhutahito Ratah)</strong> conveying the profound idea of ultimate rise and interconnected oneness. Antyodaya, a term not confined to Hindu scriptures, also finds resonance in Jainacharya Samanta Bhadra’s words. He equates ‘Sarvodaya’ and ‘Antyodaya,’ affirming their common goal of contemplating the comprehensive development of creation.</p>

      <p>The recurring query, ‘May everyone be happy and healthy. Let everyone see the good, and let no one suffer,’ conceals the very essence of Antyodaya. Reiterated in the Ishavasyo Upanishad and the Gita, these verses emphasize the spirit of Antyodaya, urging a collective pursuit of ultimate rise and well-being for all beings.</p>

      <p>In essence, the genesis of Antyodaya lies in the timeless wisdom inscribed within these sacred texts, transcending religious boundaries and echoing a universal call for holistic development and unity.</p>

      <h3>Advaita Philosophy and Antyodaya:</h3>
      <p>The essence of Antyodaya, resonates deeply with the principles of Advaita philosophy, offering a profound vision for societal transformation and harmony. In Pandit ji’s fervent opposition to prevalent societal evils and exploitative practices, he underscores the urgent need to embrace Antyodaya as a guiding principle, heralding an era of compassion and equity in Indian society.</p>

      <p>At its core, Antyodaya reflects the essence of Advaita philosophy, emphasizing the interconnectedness of all beings and the inherent unity of existence. Pandit ji’s vision encourages individuals to embrace a sense of brotherhood towards every living being and cultivate empathy for all human beings. This ethos, deeply rooted in Advaita teachings, fosters a harmonious societal order where the welfare of each individual is cherished and protected.</p>

      <p>The principle of Antyodaya extends beyond mere human relations; it encompasses a profound reverence for the natural world and a commitment to reducing human-made inequalities. Upholding the principles of Advaita, pandit ji envisions a society where societal structures are in harmony with nature, reflecting the inherent balance and interconnectedness of the universe.</p>

      <p>In embracing Antyodaya, individuals are called to embody the spirit of unity and compassion, akin to the fragrant flowers blooming in the branches of the Antyodaya tree. This imagery vividly captures the transformative power of embracing Advaita philosophy, fostering a society where empathy and equality flourish.</p>

      <p>Moreover, Antyodaya’s resonance with the natural order echoes the timeless wisdom of scholars like Darwin and Huxley, who recognized the inherent laws of nature and the importance of peaceful coexistence among all beings. Through Antyodaya, Pandit ji presents a compelling vision for societal well-being, rooted in the principles of Advaita philosophy and grounded in a deep reverence for all life forms.</p>

      <h3>An Integrated Society:</h3>
      <p>Antyodaya envisions the establishment of a society that transcends the shackles of class, caste, and exploitation, aiming to nurture holistic growth and egalitarianism for all. At its heart, this vision strives to equip every individual with the means and opportunities essential for their comprehensive development and well-being. Antyodaya advocates for a social structure that functions not for the benefit of a privileged few, but for the collective welfare of all members, ensuring equal rights and opportunities irrespective of their social status or origins.</p>

      <p>In the contemporary context, marked by scientific advancements and democratic principles, the concept of a holistic societal revolution takes center stage. Antyodaya recognizes the inherent synergy between capital and intelligence, underscoring their complementary roles in fostering societal progress and prosperity. Through this inclusive approach, Antyodaya endeavors to establish a harmonious equilibrium where every individual is esteemed and empowered to contribute meaningfully to society.</p>

      <p>At the core of realizing Antyodaya’s vision lies the purification of individual lives, wherein personal virtues such as truth, non-violence, and selflessness seamlessly integrate into the social fabric. As emphasized by Acharya Vinoba and Gandhiji, the journey towards societal transformation commences with individual introspection and moral refinement. Thus, Antyodaya transcends mere theoretical constructs; it beckons individuals to embody the values they aspire to see manifested in the broader societal framework.</p>

      <p>Antyodaya represents more than a mere blueprint for societal restructuring; it embodies a profound call to action for individuals to cultivate empathy, compassion, and integrity in their daily lives. Through collective endeavor and steadfast commitment to universal values, Antyodaya paves the way for the emergence of an integrated society founded on principles of equity, justice, and human dignity.</p>

      <h3>Future of Antyodaya:</h3>
      <p>In contemplating the future of Antyodaya, one cannot help but envision a society guided by its profound ideals. Despite the challenges and complexities of the modern world, the essence of Antyodaya remains steadfast, offering a beacon of hope and direction. If Pandit Deendayal Upadhyay were among us today, his visionary leadership would undoubtedly navigate the course of societal evolution, fostering an environment where every individual thrives and contributes meaningfully to the collective welfare.</p>

      <p>As we reflect on the essence of Antyodaya, we unearth not just a contemporary concept but a philosophy deeply ingrained in India’s cultural and philosophical tapestry. It serves as a timeless reminder of our shared heritage and collective aspirations for a harmonious and integrated society. Through adherence to its principles, we forge a path forward that aligns with the intrinsic values of Indian wisdom, fostering unity, compassion, and equitable progress for all.</p>

      <p>The future of Antyodaya beckons us to embrace its principles wholeheartedly, weaving them into the fabric of our social, political, and economic structures. By doing so, we honor the legacy of Pandit Deendayal Upadhyay and chart a course towards a brighter, more inclusive future, where the ideals of Antyodaya serve as guiding lights illuminating the path ahead.</p>

      <p>The journey through Antyodaya is a testament to the resilience of India’s philosophical heritage, offering insights that resonate with the rhythm of our collective consciousness. As we continue to explore its depths, we embark on a path towards a more harmonious and integrated society, guided by the timeless wisdom of Antyodaya.</p>
    `,
    image: antyodayaBlogImage,
    categories: ["Integral Humanism Initiative (IHI)"],
  },
  {
    id: 14,
    title:
      "Ancient Advancements in Robotics and Machines: Unraveling the Secrets of Samarangana Sutradhara",
    slug: "ancient-robotics-machines-samarangana-sutradhara",
    date: "June 3, 2026",
    excerpt:
      "The history of robotics and machinery in ancient India remains a fascinating topic, often overlooked in modern narratives. Ancient texts like the Samarangana Sutradhara provide intriguing descriptions of robots and machines.",
    author: {
      name: "Prof. Sampadananda Mishra, Director, Centre for Human Sciences",
      avatar: sampadananda,
    },
    content: `
      <p>The history of robotics and machinery in ancient India remains a fascinating topic, often overlooked in modern narratives. However, the ancient texts like Artha Shastra, Samarangana Sutradhara, Valmiki Ramayana, Vyasa’s Mahabharatha, Vaimanika Shastra – Yantra Sarvasva (seemingly of doubtful origin), and Yantrarnava provide intriguing descriptions and mentions of robots and machines, showcasing the depth of knowledge and ingenuity present in ancient Indian society.</p>

      <h3>King Bhojadeva and the समराङ्गण सूत्रधार (Samarangana Sutradhara)</h3>
      <p>At the heart of this exploration is King Bhojadeva, a distinguished ruler of the Paramara dynasty, renowned for his erudition and multifaceted talents. His opus magnum, the Samarangana Sutradhara, encompasses various subjects such as Vastu, architecture, yantra vidhanam (machines), town planning, and more.</p>

      <h3>Yantra Vidhanam</h3>
      <p>Chapter thirty-one of the समराङ्गण सूत्रधार (Samarangana Sutradhara) is dedicated to Yantra Vidhanam, providing insights into the creation and utilization of mechanical contrivances. While the text may not reveal all procedures and techniques, Bhojadeva’s reasons for such secrecy will be explored in detail.</p>
      <p>The chapter’s contents shed light on the advanced robotics and machines that were part of everyday life in ancient India. From automation in agriculture to the construction of elaborate temples and palaces, the ancient people displayed remarkable proficiency in employing machines for various tasks.</p>

      <h3>Yantras and Vimanas</h3>
      <p>The Samarangana Sutradhara also delves into vimanas, ancient flying machines, offering intriguing insights into early concepts of aviation and aeronautics in India.</p>

      <h3>The Skill of Traditional Experts</h3>
      <p>Unlike the present era where robot-making knowledge is widely accessible, ancient India kept the craft of constructing robots and machines a well-guarded secret, exclusively entrusted to traditionally trained skilled experts. We explore the reasons behind this selective dissemination of knowledge.</p>

      <h3>The Dual Meaning of “Samarangana”</h3>
      <p>The word “समराङ्गण samarāṅgaṇa” itself holds dual meanings – “Samara (समरः)” signifying battle and mortal beings (स+मरः) and “Anganam (अङ्गनम्) ” representing a place, yard or a house. So, समराङ्गण samarāṅgaṇa altogether a battlefield or a house or dwelling place for a mortal being. We focus on the latter meaning to understand the remarkable developments in robotics and machinery in ancient homes and society.</p>

      <p>Summarily, समराङ्गण सूत्रधार samarāṅgaṇa sūtradhāra provides a captivating glimpse into the advanced knowledge and creativity that flourished in ancient India concerning robotics, machinery, and aeronautics. King Bhojadeva’s work reflects a sophisticated understanding of mechanical contrivances and their applications, from daily life to grand architectural feats. As we delve into the pages of this ancient text, we come to appreciate the ingenuity and mastery of the past, inspiring a deeper appreciation for the roots of robotics and machinery that continue to shape our world today.</p>

      <h3>The Yantra-vidhāna Chapter of समराङ्गण सूत्रधार samarāṅgaṇa sūtradhāra – A Summary</h3>
      <p>As mentioned above, the thirty-first chapter of the renowned समराङ्गण सूत्रधार samarāṅgaṇa sūtradhāra, authored by the erudite King Bhojadeva of the Paramara dynasty, delves into the fascinating world of mechanical contrivances or yantras. Although the chapter provides only a glimpse of the procedures and crafting of yantras, it offers valuable insights into the advanced knowledge and developments in robotics and machines during ancient times.</p>

      <h3>Salutations to Lord Shiva</h3>
      <p>The chapter commences with heartfelt salutations to Lord Shiva, the Vanquisher of cupid (Kamadeva), and the divine creator of the universe and all beings. King Bhojadeva attributes the essence of Dharma, Artha, Kama, and Moksha to this sacred source.</p>

      <blockquote class="my-6 border-l-4 border-[#CC0033] pl-4 italic text-gray-600">
        धर्मार्थकाममोक्षाणां यदेकमिह कारणम्<br/>
        <span class="text-xs font-normal block mt-1 text-gray-500">(dharmārthakāmamokṣāṇāṃ yadekamiha kāraṇam.- 31.2)</span>
      </blockquote>

      <h3>Deciphering the Concept of Yantras</h3>
      <p>In the samarāṅgaṇa sūtradhāra, the term ‘yantra’ is unveiled, and its significance is explained. Yantras are mechanical contrivances designed to control the movement of beings, guiding them away from mere whimsical pursuits. The word yantra comes from the root-sound ‘yam’ meaning ‘to control’. These ingenious creations, in a true sense, serve as tools of control and inspiration for beings to act in accordance with a higher purpose.</p>

      <blockquote class="my-6 border-l-4 border-[#CC0033] pl-4 italic text-gray-600">
        यदृच्छया प्रवृत्तानि भूतानि स्वेन वर्त्मना।<br/>
        नियम्यास्मिन् नयति यत् तद्यन्त्रमिति कीर्तितम्॥<br/>
        <span class="text-xs font-normal block mt-1 text-gray-500">(yadṛcchayā pravṛttāni bhūtāni svena vartmanā. niyamyāsmin nayati yat tadyantramiti kīrtitam..31.3)</span>
      </blockquote>

      <p>An instrument or apparatus that controls beings moved off wantonly by their own path, truly is called Yantra or Mechanical contrivance. This verse highlights the concept of a yantra or mechanical contrivance as an instrument that controls and guides beings in their actions, steering them away from mere whimsical pursuits and directing them towards a purposeful path.</p>

      <blockquote class="my-6 border-l-4 border-[#CC0033] pl-4 italic text-gray-600">
        स्वरसेन प्रवृत्तानि भूतानि स्वमनीषया।<br/>
        कृतं यस्माद् यमयति तद्वा यन्त्रमिति स्मृतम्॥<br/>
        <span class="text-xs font-normal block mt-1 text-gray-500">(svarasena pravṛttāni bhūtāni svamanīṣayā. kṛtaṃ yasmād yamayati tadvā yantramiti smṛtam..31.4)</span>
      </blockquote>

      <h3>Elements and Bija (Seeds) of Yantras</h3>
      <p>The chapter elucidates the fundamental elements underlying the construction of yantras – Earth, Water, Fire, Air, and Ether. These elements are referred to as “Bijas,” symbolizing the foundational components that infuse life into the mechanical contrivances.</p>

      <ul class="list-disc pl-6 mb-6 text-gray-700 space-y-2">
        <li><strong>The Role of Mercury:</strong> Mercury, an essential element revered in ancient India for its unique properties, finds a prominent place in the discussion. King Bhojadeva highlights Mercury’s significance and classifies it as a constituent material falling under the Earth element due to its Parthiva (earthen) nature.</li>
        <li><strong>Yantras as Instruments of Control and Inspiration:</strong> Yantras served as powerful instruments of control and inspiration, directing beings towards purposeful actions driven by inspiration and intention. These mechanical contrivances exemplify the synergy between ancient knowledge and technological advancements.</li>
        <li><strong>Secrecy and Limited Insight:</strong> While the chapter offers a glimpse into the world of yantras, King Bhojadeva points out the reasons for not providing a complete insight into their construction. The preservation of such knowledge was kept exclusive to traditionally trained skilled experts, safeguarding the sanctity of this profound science.</li>
      </ul>

      <h3>Conclusion</h3>
      <p>As we explore the essence of yantras and their significance in controlling and inspiring beings, we gain a deeper appreciation for the ingenuity and wisdom of our ancestors. The mention of elements and the significance of Mercury further emphasizes the harmonious relationship between ancient knowledge and technological advancements. Although much remains veiled in secrecy, the Samarangana Sutradhara serves as a remarkable testament to the exceptional advancements in robotics and machines during the ancient times, inspiring us to delve further into our historical heritage.</p>
      
      <p>To be continued…</p>

      <div class="mt-8 pt-6 border-t border-gray-100 text-sm">
        <p class="mb-2">Read the first article here: <a href="https://wordpress-1632790-6462461.cloudwaysapps.com/artificial-intelligence-and-robotics-a-journey-through-ancient-indian-texts/" target="_blank" rel="noopener noreferrer" class="text-[#CC0033] hover:underline font-semibold font-montserrat">Artificial Intelligence and Robotics: A Journey through Ancient Indian Texts</a></p>
        <p>For further details on Robotics in Ancient India Project visit: <a href="https://wordpress-1632790-6462461.cloudwaysapps.com/chs/robotics-in-ancient-india/" target="_blank" rel="noopener noreferrer" class="text-[#CC0033] hover:underline font-semibold font-montserrat">Robotics in Ancient India Project</a></p>
      </div>
    `,
    image: roboticsBlogImage,
    categories: ["Robotics"],
  },
  {
    id: 15,
    title: "Quest 1 : Taking a trek through our Mind’s terrain",
    slug: "quest-1-trek-through-minds-terrain",
    date: "June 3, 2026",
    excerpt:
      "As humans, we have many remarkable wonders hidden between the span of our foreheads. Join me on this virtual quest and let’s explore one such wonder of our mind today – our Memory.",
    author: {
      name: "Damini Roy, Research Associate, Avadhānakalā and Consciousness Studies, CHS",
      avatar: damini,
    },
    content: `
      <p>As humans, we have many remarkable wonders hidden between the span of our foreheads. Seven Wonders of the World? Nay, I say there are Infinite Wonders of the World within our Minds! Don’t believe me yet? Join me on this virtual quest and let’s explore one such wonder of our mind today – our Memory.</p>

      <p>We will start with a quick stop to my favourite cafe first: Nostalgia Cafe. I want you to close your eyes and picture your favourite food. Is it your dadima’s achaar, or your father’s chai? Or perhaps it is the warm jalebi you secretly ate at the market corner, along with your neighbourhood friends on wintry mornings…</p>

      <p>Chances are that whatever food you thought of, an associated memory popped up alongside too. And now, I’ll share a tidbit on why this happened – as we walk over from Nostalgia Cafe to our next stop on this quest.</p>

      <p>The Yogis termed this aspect of our mind the <em>Citta</em>, or storehouse of memories. The stronger the emotional attachment, the more vivid the memory…which is why so many of us have warm and fuzzy memories of our childhood that we can recollect, but perhaps not a clue what last month’s grocery list was! I can see you smiling, perhaps you agree too?</p>

      <p>Memory is a fascinating aspect of human cognition, which is central to our sense of self and identity. In the Western tradition, memory has been studied and understood through psychological and neuroscientific perspectives, whereas in the Yogic tradition, memory is considered a multidimensional phenomenon that is closely linked to consciousness and spirituality.</p>

      <p>So you see, our ability to remember past events accurately helps us make sense of the present and plan for the future. In this manner, Memory becomes a crucial asset for us even in the modern world. This brings us to our second stop on today’s quest: Vantage Point.</p>

      <p>Did you know that today, the average person can only hold about 4 or 5 items in their working memory at once?<sup>1</sup> This is in sharp contrast to this Jain monk<sup>2</sup> who memorised and recalled with 100% accuracy over 5,000 random words and objects…imagine that.</p>

      <p>And now, can you imagine men and women with such remarkable memories that they can remember, word-for-word and without the aid of any recording device or even pen and paper, more than 2,000 shlokas in Sanskrit over the course of several days? If this is mind-boggling, hang on to your hats – these men and women are not just masters of memory, they are creative geniuses who have composed those very verses – and that too, in Sanskrit!</p>

      <p>This rare group is called Avadhanis, practitioners of an ancient Indian art form called <strong>Avadhanakala</strong>. Here from Vantage Point, I think you can see the view clearly too now…the secret to preserving our Memory and expanding our Consciousness beyond what the modern world calls “mental constraints” lies in exploring the lives and practices of such Avadhanis – who are living proof of our Mind’s most vital assets. Today, we will explore Memory further.</p>

      <h3>Why does Memory matter?</h3>
      <p>Memory is a critical aspect of human cognition, which plays a vital role in shaping our identity and sense of self. In this regard, Western and Yogic perspectives offer different insights into the nature of memory and its relationship to consciousness and spirituality.</p>

      <p>The Western perspective on memory distinguishes between different types of memory, such as sensory memory, short-term memory, and long-term memory. Sensory memory is the immediate and brief memory of sensory stimuli, while short-term memory refers to the temporary storage of information that is actively being processed, and long-term memory refers to the relatively permanent storage of information that can be retrieved later.</p>

      <p>On the other hand, the Yogic perspective on memory is multidimensional and is closely linked to consciousness and spirituality. The Upanishads provide valuable insights into the nature of memory and its relationship to consciousness and spirituality. For example, this quote from the Taittiriya Upanishad (2.1.1) tells us:</p>

      <blockquote class="my-6 border-l-4 border-[#CC0033] pl-4 italic text-gray-600">
        “सत्यंज्ञानमनन्तंब्रह्म”<br/>
        <span class="text-xs font-normal block mt-1 text-gray-500">[satyam jnanam anantam brahma] <sup>3</sup></span>
      </blockquote>

      <p>Or “Truth, knowledge, and infinity constitute Brahman (the ultimate reality).” This suggests that memory and mind are manifestations of the infinite Brahman, and therefore, they have a deep connection to the ultimate reality. Such thoughts are yet to be empirically proved by the material world, but the fact that memory is not simply a passive mechanism for storing information but in fact, an active process that shapes our perception of reality, gives us more inspiration to explore this aspect of our Mind.</p>

      <p>By recognizing the interconnectedness of consciousness and memory, we can gain a deeper understanding of our own selves and the world around us. With this view before our eyes, one can only wonder and become more curious about these Avadhanis…who are they and how can they achieve such remarkable mental feats? To find out more, stay tuned for our next Quest. We will continue our journey through the Mind’s terrain, only this time – we will be led by an Avadhani!</p>

      <p>Signing off for now…<br/>
      Your trek guide,<br/>
      <strong>Damini</strong>.</p>

      <div class="mt-8 pt-6 border-t border-gray-100 text-sm">
        <p class="mb-4 text-gray-600"><strong>About this series:</strong> Set in a conversational tone, the author wishes to embark on a journey with the readers, gradually discovering different aspects of the Mind in context of the Avadhanakala and Consciousness Studies project at the Centre for Human Sciences. If you wish to learn more about what Avadhanakala is, please explore our webpage: <a href="https://wordpress-1632790-6462461.cloudwaysapps.com/researchprojects-avadhankala/" target="_blank" rel="noopener noreferrer" class="text-[#CC0033] hover:underline font-semibold font-montserrat">Avadhanakala Webpage</a></p>
        <p class="mb-6 text-gray-600"><strong>About the author:</strong> Damini is a Research Associate at the Centre for Human Sciences. An avid reader, yoga asana and dhyana practitioner, Damini finds solace in Mother Nature. As part of the Rishihood family, she will be working to uncover unique aspects of the ancient Vedic art of Avadhānakalā or multiple concentration.</p>
        
        <h4 class="font-bold text-[#333A3D] mb-3">Endnotes:</h4>
        <ol class="list-decimal pl-5 space-y-2 text-gray-500">
          <li>The concept of limited working memory capacity was first proposed by George A. Miller in his influential paper “The Magical Number Seven, Plus or Minus Two: Some Limits on Our Capacity for Processing Information”, published in the journal Psychological Review in 1956. In this paper, Miller suggested that the human working memory capacity is limited to about seven (plus or minus two) chunks of information. Since then, several studies have confirmed that the average working memory capacity is closer to 4 or 5 chunks of information, rather than 7. One such study was published in the journal Memory & Cognition in 2001, titled “The magical number 4 in short-term memory: A reconsideration of mental storage capacity” by Nelson Cowan. If you are keen to explore this aspect further, type the phrase “working memory capacity” in online databases.</li>
          <li>“A Master of Memory in India Credits Meditation for His Brainy Feats” <a href="https://www.nytimes.com/2014/11/18/world/asia/prodigy-in-india-credits-feats-of-memory-to-meditation-and-jainism.html" target="_blank" rel="noopener noreferrer" class="text-[#CC0033] hover:underline font-semibold font-montserrat">New York Times Article</a></li>
          <li>The quote “Satyam Jnanam Anantam Brahma” is from the Taittiriya Upanishad, which is a part of the Krishna Yajurveda. The verse appears in the second half of the Upanishad, in the section known as the Bhrigu Valli or Anandavalli, which is the seventh and final chapter of the Taittiriya Upanishad. The verse is found in the first section of the Bhrigu Valli, and it is the third anuvaka (section) of that section. The written reference for the verse is Taittiriya Upanishad 2.1.1.</li>
        </ol>
      </div>
    `,
    image: quest1MindTerrainImage,
    categories: ["Avadhanakala"],
  },
  {
    id: 16,
    title: "Ghaṇṭāvadhānam: An Artistic Marvel of Sound and Mind",
    slug: "ghantavadhanam-artistic-marvel-sound-mind",
    date: "June 3, 2026",
    excerpt:
      "Ghaṇṭāvadhānam is a unique and awe-inspiring performance art that showcases the extraordinary capabilities of the human mind, combining sound, concentration, and linguistic prowess.",
    author: {
      name: "Prof. Sampadananda Mishra, Director, Centre for Human Sciences",
      avatar: sampadananda,
    },
    content: `
      <p>In the Avadhāna tradition in Bharat, there exist various forms of Avadhāna of which much is not known. Recently, in the Avadhana Sangama program organised by the Centre for Human Sciences, Rishihood university in collaboration with the National Sanskrit University, Tirupati, we had invited two women Ghaṇṭāvadhāni-s (Dr. Bulusu Aparna and Udaya Chandrika from Andhra Pradesh) for giving a performance of the Ghaṇṭāvadhānam. It is here for the first time I experienced the mesmerizing demonstration of Ghaṇṭāvadhānam by the two extremely talented women who have kept the tradition alive.</p>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-4 my-8">
        <img src="${ghantaSec1}" alt="Ghaṇṭāvadhānam performance 1" class="w-full h-auto object-cover" />
        <img src="${ghantaSec2}" alt="Ghaṇṭāvadhānam performance 2" class="w-full h-auto object-cover" />
        <img src="${ghantaSec3}" alt="Ghaṇṭāvadhānam performance 3" class="w-full h-auto object-cover" />
      </div>

      <p>Indeed, Ghaṇṭāvadhānam is a hidden gem, a mesmerising art form that beautifully combines the realms of sound, concentration, and linguistic prowess. For those unfamiliar with this mesmerizing practice, I write this article by delving deep into the intricacies and wonders of Ghaṇṭāvadhānam.</p>

      <h3>The Essence of Ghaṇṭāvadhānam</h3>
      <p>Ghaṇṭāvadhānam is a unique and awe-inspiring performance art that showcases the extraordinary capabilities of the human mind. At its core, it involves one participant conveying a sentence or verse solely through the sounds created using a plate and spoon. Meanwhile, the other participant, often referred to as the Ghaṇṭāvadhāni, listens with acute attention and accurately reproduces the given sentence based solely on the sounds they hear.</p>

      <h3>The Artistry Behind the Practice</h3>
      <p>This art form requires a profound level of focus, concentration, and exceptional listening skills. The Ghaṇṭāvadhāni who receives the sentence must be adept at interpreting the subtle nuances in the sounds created, while the Ghaṇṭāvadhāni who reproduces the sentence must possess remarkable linguistic abilities to decode the auditory cues. The synergy between minds of the two Ghaṇṭāvadhāni-s and the harmony of sound leaves the audience in awe!</p>
      
      <p>The process begins with the communicator selecting a sentence or verse and passing it on to one of the two Ghaṇṭāvadhāni-s on the stage ready to perform. Then the Ghaṇṭāvadhāni who receives the message creates distinct sounds on a plate using a spoon, each sound corresponding to a specific syllable or element of the sentence. The other Ghaṇṭāvadhāni receives the sounds, deciphers them and recreates the given message accurately. Please note that here language is not a barrier. One can provide the message in any language.</p>

      <h3>The Astonishing Result</h3>
      <p>What makes Ghaṇṭāvadhānam truly mind-blowing is the precision and accuracy with which the sentence is conveyed and reproduced. It serves as a testament to the incredible power of the human mind and its ability to process and interpret complex auditory information. The communication transcends the boundaries of spoken language and relies purely on the nuances of sound – no matter whatever the language may be.</p>

      <h3>The Cultural Significance</h3>
      <p>Ghaṇṭāvadhānam is a cultural treasure that has been passed down through generations in Bharat. It exemplifies the country’s deep-rooted traditions of art, language, and intellectual pursuits. The performers not only display remarkable skill but also preserve and promote the cultural heritage of Bharat.</p>

      <h3>Appreciating Ghaṇṭāvadhānam</h3>
      <p>Ghaṇṭāvadhānam is a true marvel that deserves recognition and appreciation on a broader scale. It highlights the incredible capabilities of the human mind and the beauty of artistic expression. As spectators, we can marvel at the dedication and talent of those who practise this art form.</p>
      
      <p>In a world where technology often dominates our senses, Ghaṇṭāvadhānam reminds us of the power of the human mind and the rich cultural diversity that Bharat offers. It’s a reminder that art, in all its forms, continues to thrive and evolve, transcending the boundaries of time and technology.</p>
      
      <p>So, the next time you come across the term Ghaṇṭāvadhānam, take a moment to appreciate the intricate dance of sound and mind that unfolds within this remarkable art form. It’s a testament to the boundless potential of human creativity and a reminder of the wonders that can be achieved when tradition and innovation intersect. Ghaṇṭāvadhānam truly showcases the limitless power of the human mind.</p>

      <div class="mt-8 pt-6 border-t border-gray-100 text-sm">
        <p class="mb-4 text-gray-600 font-semibold">PS: As a part of the Avadhānakalā and Consciousness Studies project at the Centre for Human Sciences, Rishihood University, our attempt has been to discover the various types of avadhāna-s still in practice today. We express our gratitude to the IKS Division of the Ministry of Education, Govt. of India for their support in carrying out this research work.</p>
        <p class="text-gray-500 font-medium">– Prof. Sampadananda Mishra, Director, Centre for Human Sciences</p>
      </div>
    `,
    image: ghantaBlogImage,
    categories: ["Avadhanakala"],
  },
  {
    id: 17,
    title: "The Enigmatic Tale of Kumbhakarna: A Mechanical Marvel in Ramayana",
    slug: "enigmatic-tale-kumbhakarna-mechanical-marvel-ramayana",
    date: "June 3, 2026",
    excerpt:
      "Through intriguing verses in the Valmiki Ramayana, we uncover a fascinating perspective that portrays Kumbhakarna as a mechanical marvel, crafted for destruction.",
    author: {
      name: "Dr. Sampadananda Mishra, Director, Centre for Human Sciences, Rishihood University",
      avatar: sampadananda,
    },
    content: `
      <p>In the Ramayana of Valmiki one finds a number of captivating narratives and mysterious characters. One among them is the enigmatic figure of Kumbhakarna, whose extraordinary nature has puzzled scholars and enthusiasts alike. Through intriguing verses in the Ramayana, one uncovers a fascinating perspective that portrays Kumbhakarna as a mechanical marvel, crafted for destruction. Let’s delve into the verses that shed light on this unique aspect and explore the concept of Kumbhakarna as a formidable machine.</p>

      <h3>Verse 1: The Creation of Kumbhakarna</h3>
      <p>In the Ramayana, one discovers a hidden truth about Kumbhakarna’s origin. Seeing Kumbhakarna the creator Brahma was frightened (vitatrāsa prajāpatiḥ). Then he cursed him saying that you will sleep like a dead body for long. The verse “dhruvam loka vināśāya paulastyenāsi nirmitaḥ” suggests that Kumbhakarna was “built/created/manufactured” by Visrava Rishi, his father, with a specific purpose – the destruction of people. This intriguing description raises questions about the nature of Kumbhakarna and hints at a deeper mystery surrounding his existence.</p>

      <blockquote class="my-6 border-l-4 border-[#CC0033] pl-4 italic text-gray-600">
        ध्रुवम् लोकविनाशाय पौलस्त्येनासि निर्मितः |<br/>
        तस्मात्त्वमद्यप्रभृति मृतकल्पः शयिष्यसे ||<br/>
        <span class="text-xs font-normal block mt-1 text-gray-500">dhruvam loka vināśāya paulastyenāsi nirmitaḥ .<br/>tasmāt tvam adya prabhṛti mṛta kalpaḥ śayiṣyase ..<br/>-Valmiki Ramayana 6.61.24</span>
      </blockquote>

      <h3>Verse 2: Kumbhakarna as a Yantram</h3>
      <p>As Kumbhakarna approaches the Vanara army, they witness his colossal form crushing everything under his feet. Overwhelmed by fear, the monkeys start to flee. However, Vibhishana intervenes and enlightens them about Kumbhakarna’s true nature. He refers to Kumbhakarna as a “yantram,” a machine advancing forward. This revelation instils courage in the monkeys, as they now understand the enigma behind Kumbhakarna’s extraordinary abilities.</p>

      <blockquote class="my-6 border-l-4 border-[#CC0033] pl-4 italic text-gray-600">
        उच्यन्ताम् वानराः सर्वे यन्त्रमेतत्समुच्छ्रितम् |<br/>
        इति विज्ञाय हरयो भविष्यन्तीह निर्भयाः ||<br/>
        <span class="text-xs font-normal block mt-1 text-gray-500">ucyantām vānarāḥ sarvĕ yantram etatsamucchritam .<br/>iti vijṇāya harayŏ bhaviSyantīha nirbhayāḥ ..<br/>-Valmiki Ramayana 6.61.33</span>
      </blockquote>

      <h3>Verse 3: The Mechanical Anatomy</h3>
      <p>During the fierce battle, Kumbhakarna hurls the monkeys into his mouth, akin to a gaping hole in the earth. However, to their astonishment, the monkeys emerge unharmed from his nostrils and ears. This baffling display of Kumbhakarna’s anatomy adds to the notion of him being a mechanical marvel. Such a phenomenon defies natural laws, implying that Kumbhakarna’s form might be an intricate creation rather than a conventional living being.</p>

      <blockquote class="my-6 border-l-4 border-[#CC0033] pl-4 italic text-gray-600">
        प्रक्षिप्ताः कुम्भकर्णेन वक्त्रे पातालसंनिभे |<br/>
        नासापुटाभ्यां निर्जग्मुः कर्णाभ्याम् चैव वानराः ||<br/>
        <span class="text-xs font-normal block mt-1 text-gray-500">prakṣiptāḥ kumbhakarṇena vaktre pātāla samnibhe .<br/>nāsāpuṭābhyām nirjagmuḥ karṇābhyām caiva vānarāḥ ..<br/>-Valmiki Ramayana 6.67.36</span>
      </blockquote>

      <p>The verses in the Ramayana that describe Kumbhakarna’s creation and his unique abilities offer a remarkable perspective on his character. The portrayal of Kumbhakarna as a machine, designed for destruction, challenges traditional interpretations of this enigmatic figure. It adds an exciting layer of complexity to the epic, inviting one to ponder the nature of ancient knowledge and its potential to envision extraordinary beings.</p>

      <p>The enigma of Kumbhakarna continues to capture our imagination, as we contemplate the possibility of ancient societies envisioning machines and automata. The Ramayana stands as a testament to the richness of Indian Knowledge Tradition, where the boundaries between tradition and advanced technology blur. The tale of Kumbhakarna serves as a reminder of the profound wisdom embedded within ancient epics, inviting one to explore the realms of imagination, history, and the human fascination with the extraordinary.</p>

      <div class="mt-8 pt-6 border-t border-gray-100 text-sm">
        <p class="text-gray-500 font-medium">– Dr. Sampadananda Mishra, Director, Centre for Human Sciences, Rishihood University</p>
      </div>
    `,
    image: kumbhakarnaBlogImage,
    categories: ["Robotics"],
  },
  {
    id: 18,
    title: "Avadhānakalā – Shedding Light on the Journey to Mastering the Mind",
    slug: "avadhanakala-journey-mastering-mind",
    date: "June 3, 2026",
    excerpt:
      "Exploring the disciplines and steps of mental training, like Alpagrāhi and Bahugrāhi, that enable practitioners to unlock the hidden powers of concentration and master the restless mind.",
    author: {
      name: "Dr. Sampadananda Mishra, Director, Centre for Human Sciences, Rishihood University",
      avatar: sampadananda,
    },
    content: `
      <p class="italic text-gray-500 mb-6">(In the last episode on Avadhānakalā we provided a brief introduction to the art of Avadhānakalā. In this episode our focus is on how the mind of the Avadhāni functions.)</p>

      <p>The human mind is a mysterious and powerful entity capable of achieving remarkable feats. However, most of us remain unaware of the full potential of our minds and its ability to concentrate and grasp multiple objects simultaneously. For this the mind has to be educated properly and raised from its ordinary state to the higher state where it is capable of concentrating the attention intensely. How does one discipline the mind and have mastery over it?</p>

      <p>The concept of mastering the restless dualistic mind (cañcalaṃ manaḥ) and cultivating a deeper Self-awareness through yogic power of concentration (ekāgratā) is rooted in various spiritual and philosophical traditions. The understanding is that the human mind tends to be restless, fluctuating between various thoughts, emotions, and perceptions, often leading to a sense of duality and separation between ourselves and the world around us.</p>

      <p>The restless and conditioned mind is often driven by habitual thought patterns, past experiences, cultural influences, societal conditioning and so on. It tends to create a sense of separation and division, viewing the world as ‘us’ versus ‘them’ or ‘self’ versus ‘other’. This being the case, it is essential to develop a deeper understanding and awareness that transcends conditioned thinking. This means going beyond the limitations of the conditioned mind and cultivating a broader perspective that acknowledges the interconnectedness of all things. By developing the power of concentration, one can gradually quiet the restless mind and access deeper states of awareness.</p>

      <p>In a world increasingly driven by artificial intelligence, there exists an extraordinary human ability that surpasses the capabilities of even the most advanced technologies—the mind of an Avadhāni. Rooted in ancient practices and deep discipline, the mind of an Avadhāni operates consciously, fueled by the power of concentration, retention, and recollection. It’s important to explore the fascinating ways through which an Avadhāni attains such heightened mental prowess, showcasing how their mind transcends the mechanical intelligence of AI.</p>

      <h3>Understanding the Mind of an Avadhāni</h3>
      <p>An Avadhāni is an individual who possesses a remarkable talent for conscious multitasking, memory, and creativity. These gifted individuals are known for performing intricate mental feats, such as composing poetry or solving complex problems, while simultaneously engaging in multiple tasks. Most Avadhāni-s confirm that sixty percent of the talent that they have is gifted and the rest they develop by performing Avadhanam regularly.</p>
      
      <p>The journey towards Avadhāni-level mental capabilities begins with rigorous discipline. The Avadhāni-s follow a systematic approach to hone their minds, incorporating practices like dhāranā (concentration) and meditation. These disciplines lay the groundwork for cultivating a focused and undistracted mind.</p>
      
      <p>At the heart of an Avadhāni’s mental power lies the art of dhāranā – concentrated attention. They practice intense concentration, fixing their mind on a single point or object. Through this process, they develop an unwavering focus that allows them to delve into profound levels of awareness.</p>
      
      <p>Avadhāni-s constantly educate their minds to stimulate growth. They engage in regular mental exercises, such as memorizing vast amounts of information, mastering multiple languages, and exploring diverse topics. This continuous learning enhances their cognitive abilities and strengthens their neural connections.</p>
      
      <p>Through consistent mental education and practice, Avadhāni-s attain exceptional powers of retention and recollection. They can recall vast amounts of information with remarkable accuracy, making them walking libraries of knowledge.</p>
      
      <p>The mind of an Avadhāni operates consciously. The creativity, problem-solving skills, and decision-making abilities of the Avadhāni-s stem from their deep understanding of the interconnectedness of knowledge and ideas.</p>
      
      <p>Avadhāni-s foster creativity and imagination by pushing the boundaries of their minds. They engage in tasks that require out-of-the-box thinking, such as spontaneously composing poetry, solving puzzles, and crafting intricate stories.</p>
      
      <p>Avadhāni-s possess heightened emotional intelligence, allowing them to connect deeply with others, perceive subtle emotions, and understand complex human interactions.</p>
      
      <p>The mind of an Avadhāni stands as a testament to the extraordinary potential of the human intellect. Through rigorous discipline, the practice of dhāranā, and constant mental education, these remarkable individuals achieve a level of concentration, creativity, and memory retention that surpasses even the most advanced AI systems. In a world increasingly reliant on artificial intelligence, the Avadhāni’s mind serves as a reminder of the boundless capabilities that reside within us, waiting to be unlocked through dedication and training.</p>

      <h3>Training the Mind</h3>
      <p>There are innumerable ways by which the mind is trained to develop within itself the ability of multiple concentration. In the ancient text, titled Nandi Sutra, available in Jain tradition, we discover a process of mental training, which enables practitioners to unlock these hidden powers and attain tremendous spiritual development. Let’s delve into the steps of the training the mind to understand how it can transform the way the human mind can function.</p>

      <h4>The Alpagrāhi and Bahugrāhi Steps: Grasping the Single Thought Point and Widening the Scope of Concentration</h4>
      <p>The first step of this practice begins with the Alpagrāhi step, where the practitioner learns to concentrate on a single thought point or object. At the outset, the focus is on a small object for a brief duration. This step lays the foundation for the subsequent stages and initiates the mind into the art of concentration. As the training progresses, the practitioner enters the Bahugrāhi step. Here, the scope of concentration expands, and the duration of focus increases. The practitioner is encouraged to carry their mind inwards with each inhalation and outwards with each exhalation, encompassing the entire process of breathing from the navel to the lungs.</p>

      <h4>Ekavidhagrāhi and Bahuvidhagrāhi: Concentrating on Single and Multiple Objects</h4>
      <p>The next unit of concentration involves Ekavidhagrāhi and Bahuvidhagrāhi. The former involves focusing on a single class of objects, while the latter requires concentration on several classes of objects simultaneously. An example of Bahuvidhagrāhi is the practice of watching and feeling the breath vibrations on the tip of the nose amidst the various bodily sensations.</p>

      <h4>Kshipragrāhi and Ciragrāhi: The Power of Intuitive Flash and Deliberate Grasping</h4>
      <p>In the third unit, practitioners learn Kshipragrāhi and Ciragrāhi. Kshipragrāhi allows the mind to grasp an object instantaneously through an intuitive flash. For instance, the practitioner can glance at a room and instantly recall every detail, from the color of the walls to the furniture arrangement. Ciragrāhi, on the other hand, involves a slower and deliberate grasping of information.</p>

      <h4>Anisritgrāhi and Nisritagrāhi: Grasping the Whole from a Part and Vice Versa</h4>
      <p>The final unit of this practice comprises Anisritgrāhi and Nisritagrāhi. Anisritgrāhi enables the practitioner to perceive and understand a whole situation or group of objects by focusing on just one item within it. Conversely, Nisritagrāhi allows them to extract specific details from a broader context and comprehend the significance of a single item.</p>
      
      <p>This practice, which exists among the Jain monks even today, serves as a poignant reminder of the vast potential that lies within the human mind, awaiting exploration. With dedicated training and understanding, one can tap into these powers, leading to a deeper connection with our inner selves and the world around us.</p>

      <div class="mt-8 pt-6 border-t border-gray-100 text-sm">
        <p class="text-gray-500 font-medium">– Dr. Sampadananda Mishra, Director, Centre for Human Sciences, Rishihood University</p>
      </div>
    `,
    image: avadhanaMindBlogImage,
    categories: ["Avadhanakala"],
  },
  {
    id: 19,
    title: "The अवधान avadhāna Tradition",
    slug: "avadhana-tradition",
    date: "June 3, 2026",
    excerpt:
      "Exploring the rich history, literary feats, and items (like niṣidhākṣaram, samasyāpūraṇam, dattapadaracanam) of the ancient Indian art of Avadhāna.",
    author: {
      name: "Dr. Sampadananda Mishra, Director, Centre for Human Sciences, Rishihood University",
      avatar: sampadananda,
    },
    content: `
      <p>Looking at the oral tradition of learning Vedas one comes to know that it was through this high power of concentration that ancient Indian sages were able to memorise all the Vedas and to have mastery over several disciplines. From this tradition branched forth several types of अवधान avadhāna or feats of concentration. Gradually, अवधान avadhāna developed as a literary activity or feat.</p>

      <p>In this type of literary activity the अवधानी avadhānī exhibits the power of simultaneous and multiple concentration on different things or items belonging to literature. This first arose naturally in Sanskrit and later evolved in other Indian languages too. However, only Kannada and Telugu have maintained this heritage intact, while the latter has taken this scholarly literary feat to very great heights.</p>

      <p>In an अवधान avadhāna performance the अवधानी avadhānī is asked different types of questions and given various tasks by a number of scholars. He must answer the questions, step by step, in four rounds, through extempore metrical compositions according to the specifications given by the questioners, without taking any help from any book or writing material. The whole show is an oral outpour. The number of scholars who ask the questions may be eight, hundred, or even a thousand. If the number is eight then the performance is called अष्टावधान aṣṭāvadhāna or Eight-fold Concentration and the person is called अष्टावधानी aṣṭāvadhānī; if the number is hundred it is called शतावधान śatāvadhāna and in the case of a thousand it is called सहस्रावधान sahasrāvadhāna. While the अष्टावधान aṣṭāvadhāna lasts for two hours, the शतावधान śatāvadhāna goes on for two days and the सहस्रावधान sahasrāvadhāna, takes all of 20 days. The scholars who ask questions to the अवधानी avadhānī are called पृच्छक-s pṛcchaka-s or questioners. Each पृच्छक pṛcchaka asks questions related to one particular theme.</p>

      <h3>अष्टावधान aṣṭāvadhāna — The Eight-fold Concentration</h3>
      <p>Among the various types of अवधान avadhāna, the अष्टावधान aṣṭāvadhāna is the most common and popular. Here, the अवधानी avadhānī has to confront eight scholars who ask questions on eight different themes. Composition of verses in an enigmatic way, such as by eliminating several vital letters or by using several chosen letters, or by the employment of unusual words; several types of verbal acrobatics; non-stop versification at a high speed; identifying and commenting on select verses from the vast body of classical literature; providing solutions to literary riddles without violating the rules of versification; playing chess; counting the irregular rings of a bell or the number of flowers thrown on the back; indulging in lively yaks of wit; participating in Sastric debates; mental arrangement of a cluster of cluttered letters into a meaningful verse, etc. are some of the distinctive items implemented in an अष्टावधान aṣṭāvadhāna. These items are not fixed. They may vary from performance to performance.</p>
      
      <p>In the usual अष्टावधान aṣṭāvadhāna program the following are in practice:</p>
      
      <ul class="list-disc pl-5 space-y-2 mb-6">
        <li><strong>निषिधाक्षरम् niṣidhākṣaram:</strong> In this item the questioner specifies a theme and a particular meter and asks the अवधानी avadhānī to compose a poem according to his specifications. The essential condition is that the composition has to be made syllable by syllable. After each syllable is mentioned by the अवधानी avadhānī, the questioner tries to anticipate the word the अवधानी avadhānī has in his mind and prohibits the use of the next syllable. The अवधानी avadhānī has thus to find at each step an alternate possibility and compose the verse, while adhering to the topic and the meter given by the questioner.</li>
        <li><strong>समस्यापूरणम् samasyāpūraṇam:</strong> Here the questioner gives the last पाद pāda or quarter verse composed by him, which contains something ambiguous or contradictory in its meaning. The अवधानी avadhānī must compose the remaining three पाद-s pāda-s in the same meter, in such a way, that when the 4th पाद pāda is added the contradiction disappears and the verse takes an interesting meaning.</li>
        <li><strong>दत्तपदरचनम् dattapadaracanam:</strong> The questioner here specifies a meter and a topic and gives four unrelated words (which however must conform to the specified metre), and asks the अवधानी avadhānī to compose a verse where each one of the four words is incorporated in each quarter.</li>
        <li><strong>वर्णनम् varṇanam:</strong> The questioner here gives the description of a particular subject or scene and asks the अवधानी avadhānī to compose a verse in a particular meter specified by him.</li>
        <li><strong>आशुरचनम् āśuracanam:</strong> The questioner here specifies a meter and a subject and the अवधानी avadhānī must compose an entire verse immediately, in one go conforming to the meter and the subject.</li>
        <li><strong>व्यस्ताक्षरकथनम् vyastākṣarakathanam:</strong> The questioner here interrupts the अवधानी avadhānī repeatedly and gives at random the serial numbers of syllables in a poem, which he has in his mind. The अवधानी avadhānī must remember and rearrange the syllables in the right order to find the poem.</li>
        <li><strong>घण्टावादनम् ghaṇṭāvādanam:</strong> A bell is rung at irregular intervals during the period of the अवधान avadhāna. The अवधानी avadhānī has to tell at the end of the performance how many times the bell was rung.</li>
        <li><strong>अप्रस्तुतप्रङ्गः aprastutapraṅgaḥ:</strong> This questioner intervenes at any moment during the performance asking the अवधानी avadhānī all types of questions, humorous, absurd, deep, to divert his attention and break his concentration. The अवधानी avadhānī, on a priority has to reply to the अप्रस्तुतप्रङ्गः aprastutapraṅgaḥ in an entertaining manner, before proceeding with the other questions. अप्रस्तुतप्रङ्गः aprastutapraṅgaḥ literally means irrelevant context or not suitable to time and subject.</li>
      </ul>

      <p>To make the task even more difficult, the अवधानी avadhānī has to compose the poems in four rounds, stanza by stanza. In each round he must remember the question asked earlier by the पृच्छक pṛcchaka and the stanzas already composed by him and continue from that point. Only for the आशुरचनम् āśuracanam he has to compose all the four lines at a stretch.</p>
      
      <p>At the end the अवधानी avadhānī has to recite each श्लोक śloka composed by him in its entirety, serially, item by item, except for आशु āśu. This is called धारणा dhāraṇā.</p>

      <div class="mt-8 pt-6 border-t border-gray-100 text-sm">
        <p class="mb-2 text-gray-500 font-medium">Reference: Vasishtha Ganapati Muni — An अवधानी avadhānī Par-excellence</p>
        <p class="text-gray-500 font-medium">– Dr. Sampadananda Mishra, Director, Centre for Human Sciences, Rishihood University</p>
      </div>
    `,
    image: avadhanaTraditionImage,
    categories: ["Avadhanakala"],
  },
  {
    id: 20,
    title: "Quest 2: Taking a trek through our Mind’s terrain",
    slug: "quest-2-trek-through-minds-terrain",
    date: "June 3, 2026",
    excerpt:
      "Welcome back! On our second adventure together, we will explore the intricate connection between mind, memory vis a vis human consciousness.",
    author: {
      name: "Damini Roy, Research Associate, Avadhānakalā and Consciousness Studies, CHS",
      avatar: damini,
    },
    content: `
      <h3>Connecting our Human Existence with Memory</h3>
      <p>Welcome back! On our second adventure together, we will explore the intricate connection between mind, memory vis a vis human consciousness. If you’re curious what we covered on our last trek through the Mind’s terrain, you can explore more here.</p>
      
      <p>As we discovered on our previous Quest, the human mind is a treasure trove of wonders, and memory is one such wonder that is central to our sense of self and identity. And interestingly, this very memory of ours can serve as a powerful tool in navigating our daily life better, as well as in making sense of our human existence.</p>
      
      <p>In order to experience this for ourselves, let’s take a trek this time to a special location called the Mind Mirror. From our last stop at Vantage Point, the walk down to the mirror is a short one. As we walk over, allow me to share a short story…</p>
      
      <p>Once upon a time, there was a king who was very proud of his memory. He could remember everything he had ever learned, and he could recite long passages of scripture from memory. One day, the king decided to test his memory against that of a sage.</p>
      
      <p>The king invited the sage to his palace and challenged him to a memory contest. The sage agreed, and the two of them began to recite passages of scripture from memory. The king was amazed at the sage’s memory. The sage could recite passages that the king had never even heard of.</p>
      
      <p>After a while, the king was exhausted. He could not remember any more passages, but the sage continued to recite. Finally, the king gave up. He admitted that the sage had a better memory than he did.</p>
      
      <p>The sage smiled and said, “Memory is not the only thing that matters. What matters more is the mind. A good mind can learn and remember anything. A bad mind can forget even the simplest things.”</p>
      
      <p>The king was humbled by the sage’s words. He realized that he had been too proud of his memory. He vowed to use his mind to learn and grow, rather than to simply boast about his abilities.</p>
      
      <p>And here we are! At our trek location for today: the Mind Mirror…</p>
      
      <h3>Experiencing the Mind Mirror</h3>
      <p>Isn’t it intriguing? Here we are in the middle of the forest and lush wilderness, and we find ourselves looking into this large, oval mirror. With ornate crests and edges – it certainly is not an ordinary object. So let’s explore…what this Mind Mirror reveals to us.</p>
      
      <p>Think back to the story we just heard on our way over here. The king who was so proud of his memory. And the humble lesson he learned at the hands of the sage. What does this show us? One aspect is that the desire to know our mind and explore its abilities goes back thousands and thousands of years…from kings to sages and even householders, we have all perhaps been fascinated by those who possess a superior grasp of the Mind’s abilities. And yet, despite the fact that we have had millennia to explore and learn more about our mind and its skills, we still have so much left to explore.</p>
      
      <p>In our country today, we have rare kinds of artists called Avadhanis – the practitioners of an ancient art form called Avadhanakala. Avadhanis are masters of memory who can remember thousands of words and objects without the aid of any recording device or even pen and paper. What makes this feat of memory more amazing is also that they are creative geniuses who compose thousands of verses in Sanskrit impromptu over the course of their literary performances. You may wonder – “what else can they do?”</p>
      
      <p>Avadhanis are living proof of the Mind’s most vital assets, and their practices can help us explore the true potential of our Memory and Consciousness. One reason why is perhaps because we experience that memory is not just a passive mechanism for storing information, but an active process that shapes our perception of reality. In this regard, Western and Yogic perspectives offer different insights into the nature of memory and its relationship to consciousness and spirituality. The Yogic perspective on memory is multidimensional and is closely linked to consciousness and spirituality. To understand this better, we can take inspiration from the Upanishads. For instance, we see here in this shloka from the Katha Upanishad ——</p>
      
      <blockquote class="my-6 border-l-4 border-[#CC0033] pl-4 italic text-gray-600">
        स्मृतिः सर्वेषामेव भूतानां बीजम्।<br/>
        <span class="text-xs font-normal block mt-1 text-gray-500">Smṛtiḥ serveṣāmeva bhūtānāṃ bījam।</span>
      </blockquote>

      <p class="font-semibold text-gray-600">Translation:</p>
      <p class="italic text-gray-600 mb-6">Memory is the seed of all beings.</p>
      
      <p>This shloka illustrates that in the context of understanding our human existence, memory is the foundation of all knowledge and experience. It is through memory that we are able to learn and grow, and it is through memory that we are able to connect with our past, present, and future.</p>
      
      <p>The Upanishads offer valuable insights into the nature of memory and its relationship to consciousness and spirituality. The Upanishads teach us that memory is not simply a function of the brain. It is also a spiritual faculty. It is through memory that we are able to achieve liberation from the cycle of birth and death. These insights can help us to understand the importance of memory in our lives and to use our memory to achieve our spiritual goals.</p>
      
      <p>Memory is an active process that shapes our perception of reality, and therefore, recognizing the interconnectedness of consciousness and memory can lead to a deeper understanding of ourselves and the world around us. Memory is not just a passive mechanism for storing information, but it is an active process that shapes our perception of reality. By recognizing this, we can unlock our Mind’s infinite wonders and explore the mysteries that lie within.</p>
      
      <p>Signing off for now…<br/>
      Your trek guide,<br/>
      <strong>Damini</strong>.</p>

      <div class="mt-8 pt-6 border-t border-gray-100 text-sm">
        <p class="mb-4 text-gray-600"><strong>About this series:</strong> Set in a conversational tone, the author wishes to embark on a journey with the readers, gradually discovering different aspects of the Mind in context of the Avadhanakala and Consciousness Studies project at the Centre for Human Sciences.</p>
        <p class="text-gray-600"><strong>About the author:</strong> Damini is a Research Associate at the Centre for Human Sciences. An avid reader, yoga asana and dhyana practitioner, Damini finds solace in Mother Nature. As part of the Rishihood family, she will be working to uncover unique aspects of the ancient Vedic art of Avadhānakalā or multiple concentration.</p>
      </div>
    `,
    image: quest2MindMirrorImage,
    categories: ["Avadhanakala"],
  },
  {
    id: 21,
    title:
      "Artificial Intelligence and Robotics: A Journey through Ancient Indian Texts",
    slug: "ai-robotics-journey-ancient-indian-texts",
    date: "June 3, 2026",
    excerpt:
      "Discover early concepts of Artificial Intelligence and mechanical contrivances in ancient Indian texts, showcasing the depth of knowledge present in our heritage.",
    author: {
      name: "Dr. Sampadananda Mishra, Director, Centre for Human Sciences, Rishihood University",
      avatar: sampadananda,
    },
    content: `
      <p>The concept of Artificial Intelligence (AI) and Robotics has captured the human imagination for decades, but its origins stretch back far beyond the technological revolution of the 20th century. While most of us credit the computer scientists and the pioneers of the 1950s for laying the foundation of AI, there exists a lesser-known, yet captivating narrative buried within the ancient Indian texts. These sacred texts, belonging to thousands of years ago, provide glimpses of artificial beings endowed with intelligence and consciousness, long before computers and algorithms became a reality. There are intriguing references and narratives in the ancient Indian texts that indicate a fascination with mechanical contrivances and automation. Nonetheless, the glimpses of mechanical devices, automata, and sophisticated engineering found in ancient texts, puranic narrations, and temple architecture provide fascinating insights into the innovative and intellectually curious nature of ancient Indian civilization.</p> 

      <p>It is the awe-inspiring technological achievements mentioned in historical and sacred texts of Indian origin that trigger the quest to explore the roots of artificial intelligence. Despite the fact that it is important to recognize the brilliance of ancient civilizations and their contributions to the world of technology, it is also necessary to dig deep into human history, discovering early concepts of Artificial Intelligence in ancient Indian texts.</p>

      <p>Venturing into the realm of Indian knowledge tradition, one uncovers a rich variety of narratives involving artificial life, robots, and self-moving machines. We find in ancient Indian texts, such as the Ramayana and Mahabharata, stories showcasing the existence of automatons created by divine beings like Vishwakarma and Maya. These can be considered the world’s earliest science fiction tales, where cultures imagined the marvels of artificial existence with divine imagination and skill. Furthermore, Ancient Indian texts, such as the Arthashastra by Chanakya and the Samarangana Sutradhara by King Bhoja, mention the existence of yantras, mechanical devices, and automata. These yantras were intricate machines with various mechanisms designed to perform specific tasks, such as operating doors, musical instruments, or even complex war machines. These texts provide valuable insights into the advancements in engineering and technology during that time.</p>

      <p>However, it is essential to acknowledge that these ancient stories are not direct precursors to modern AI technology. Instead, they offer a fascinating glimpse into the human desire to create intelligent beings and machines even in ancient times. The intricate blend of technology and mythology serves as a testament to the creativity and brilliance of our ancestors.</p>

      <p>To truly appreciate the wisdom embedded within these ancient texts, one must recognize that technological marvels described in stories and episodes in the Ramayana, Mahabharata, Puranas, and other texts are not merely fantastical tales but also reflections of the human fascination with AI-like constructs. As technology has progressed, we can now look back and discern the echoes of AI concepts in these age-old narratives. The scientific community’s growing interest in Sanskrit as a natural language input to computers further strengthens the link between ancient wisdom and modern AI. The classical language, often regarded as “Natural Language” due to its closeness to human thought processes, provides a unique perspective for enhancing natural language comprehension in machines.</p>

      <p>While these ancient narrations might not directly lead to the development of modern AI, they inspire us to reflect on the unyielding human spirit to explore the realms of possibilities. The convergence of ancient wisdom with modern science, including the potential of Sanskrit as a natural language input, emphasizes the significance of embracing our rich cultural heritage to pave the way for a smarter, better future. As we progress in the age of AI, let us not forget to acknowledge the roots that extend deep into the sands of time, reminding us that our journey into the future is an inseparable continuum of our past.</p>

      <p>(To be continued)</p>

      <div class="mt-8 pt-6 border-t border-gray-100 text-sm">
        <p class="text-gray-500 font-medium">– Dr. Sampadananda Mishra, Director, Centre for Human Sciences, Rishihood University</p>
      </div>
    `,
    image: aiRoboticsBlogImage,
    categories: ["Robotics"],
  },
  {
    id: 22,
    title: "Ramesh Bhutada’s Generous Grant for the Integral Humanism Project",
    slug: "ramesh-bhutada-grant-integral-humanism",
    date: "June 3, 2026",
    excerpt:
      "Indian American businessman Ramesh Bhutada has made a generous commitment of Rs 1 crore to the Integral Humanism Project at Rishihood University.",
    author: {
      name: "Centre for Human Sciences",
      avatar: logo,
    },
    content: `
      <p>In a remarkable display of generosity and commitment to social progress, Indian American businessman Ramesh Bhutada has made an important commitment of Rs 1 crore to the Integral Humanism Project at Rishihood University. This substantial contribution reflects Bhutada’s unwavering dedication to fostering education and nurturing the values that underpin a harmonious society. His philanthropic endeavors serve as an inspiring example for others, and his support will undoubtedly leave a lasting impact on the lives of countless individuals.</p>

      <p>Ramesh Bhutada has long been recognized as a visionary leader and a champion of philanthropic causes. Throughout his successful career, he has exemplified the principles of integrity, compassion, and the pursuit of excellence. His business acumen and dedication to ethical practices have earned him respect and admiration within the Indian American community and beyond.</p>

      <p>Bhutada, the CEO of Houston-based Star Pipe Products, said he made the donation so that the youth can gain the knowledge and understanding of Pandit Deendayal Upadhyaya’s idea of Integral Humanism which offers a comprehensive framework for societal development that combines holistic individual growth, socio-economic justice, cultural preservation, environmental sustainability, and ethical leadership. It provides a vision for a harmonious and inclusive society, where individuals are empowered, traditions are respected, and progress is achieved in a balanced and sustainable manner.</p>

      <p>Rishihood University’s Center for Human Science was established in 2022 to delve into the depths of human potential and societal well-being. The center serves as a hub for interdisciplinary research, innovative educational programs, and impactful community initiatives. “The Integral Humanism Project is one of the flagship initiatives of the Center for Human Sciences. Shri Ramesh Bhutada’s grant to the Center for Human Science will enable the institution to undertake applied research, organize transformative seminars and conferences, and implement educational programs that encourage holistic development and integral humanism”, says Dr. Sampadananda Mishra, Director, Center for Human Sciences.</p>

      <p>More details of the project are here: <span class="font-semibold text-[#CC0033]">Integral Humanism Initiative</span></p>
    `,
    image: bhutadaGrantBlogImage,
    categories: ["Integral Humanism Initiative (IHI)"],
  },
  {
    id: 23,
    title: "How Can Humility Enrich Your Life?",
    slug: "how-can-humility-enrich-your-life",
    date: "June 3, 2026",
    excerpt:
      "Discover how cultivating humility can lead to a happier and more fulfilling life, drawing lessons from the ancient Indian art of Avadhānakalā.",
    author: {
      name: "Damini Roy, Research Associate, Avadhānakalā and Consciousness Studies, CHS",
      avatar: damini,
    },
    content: `
      <p>The word “humility” comes from the French word “humilitas,” which in turn, is derived from the Latin word “humilis,” meaning “close to the ground.” The word “humility” first appeared in English in the 14th century, and has since been used to describe a quality of groundedness, non-ostentation and modesty.</p>

      <p>In Sanskrit, humility can be equated to the word ‘विनम्रता’ or vinamratā. “A subhāṣita (Sanskrit: सुभाषित) is a short memorable verse, generally meant to convey a truth, advice, lesson or sometimes even a riddle on some fundamental facet of life.” Here is a subhāṣita on humility:</p>

      <blockquote class="my-6 border-l-4 border-[#CC0033] pl-4 italic text-gray-600 font-serif whitespace-pre-line">
        भवन्तिनम्रास्तरवः फলোद्गमैः
        नवाम्बुभिर्भूरिविलम्बिनो घनाः ।
        अनुद्धताः सत्पुरुषाः समृद्धिभि:
        स्वभाव एवैषः परोपकारिणाम्॥
      </blockquote>

      <p><strong>Meaning:</strong><br/>
      On bearing fruits, trees bend (i.e. become humble),<br/>
      with recently gathered water, clouds hang very low,<br/>
      wealthy good men maintain non-arrogant nature;<br/>
      This is the nature of benevolent people.</p>

      <p>Seen as a human virtue, humility simply refers to the state of being humble, down-to-earth and modest. It is a quality that is characterized by a lack of arrogance, conceit, or pride. Humility is an important human trait because it helps us to be more open to learning, more willing to help others, and more forgiving of ourselves and others. This means that humility can become an enabler of a happier and more fulfilling life for us!</p>

      <p>In fact, there is a very special group of people called ‘Avadhanis’ who can teach us a lot about how to apply humility to make our lives better. Avadhanis are practitioners of an ancient Indian art form called Avadhānakalā – the art of multiple concentration. Mostly applied in the sphere of Sahitya or literature, Avadhanis create extempore versification in Sanskrit as a response to multiple questioners (without the support of any pen, paper or recording device!). So how do they do it?</p>

      <ul class="list-disc pl-6 my-4 space-y-2">
        <li><strong>Openness to guidance:</strong> When they are humble, Avadhanis are more open to receiving guidance from the divine. This helps them in composing extempore verses during their Sahitya Avadhana performances. Many Avadhanis, in fact, seek to evoke this divine power of creation by personifying their wishes as invocations to goddess Saraswati at the start of the performance.</li>
        <li>Similarly for the rest of us, when we are humble then we are also more receptive to the messages that are being sent to us by divine channels.</li>
        <li><strong>Heightened receptivity:</strong> Humility helps us to let go of our ego, and this enables growth on all fronts: professional, personal, spiritual!</li>
        <li>Whether an Avadhani or us – when we are humble, we connect more seamlessly with our true selves and with the divine consciousness.</li>
        <li><strong>Cultivating mindfulness:</strong> During an Avadhanakala performance, it definitely helps an Avadhani to stay humble and grounded in the present moment. This allows her/him to adjust the pace of their prose delivery based on the audience’s engagement level.</li>
        <li>For us beyond the Avadhanakala sphere, mindfulness and focussing on the present moment is both meditative and productive. It reduces anxiety while harnessing our mind’s power to complete tasks with swiftness and ease.</li>
        <li><strong>Appreciating the little things:</strong> Nature has a way of humbling us, whether it is standing under a roaring waterfall or witnessing the horizon from the mountain tops. This feeling of humility in the midst of nature can help us in acknowledging all the small things in our life too, that are truly precious and peace-giving.</li>
        <li>For Avadhanis, having gratitude for the rest of their lives and all the small things that make it precious allows them to remain connected with society, engaged with life, and also inspired to keep unlocking the full potential of their Avadhanakala practice.</li>
      </ul>

      <p>So how might we cultivate more humility in ourselves? There are many ways to cultivate humility in our lives. One way is to practice gratitude. When we are grateful for what we have, it helps us to see the good in the world and to be less focused on ourselves. Another way to cultivate humility is to spend time with people who are different from us. When we spend time with people who are different from us, it helps us to see the world from a different perspective and to be more open-minded. Here are some more ways to cultivate humility in ourselves through simple ways:</p>

      <ul class="list-disc pl-6 my-4 space-y-2">
        <li><strong>Be open to feedback:</strong> When someone gives us feedback, we should be open to hearing it, even if it’s not something we want to hear. Feedback can help us to grow and improve. By staying humble, we can keep evolving and growing as an individual and learn from all the feedback we receive.</li>
        <li><strong>Be willing to help others:</strong> When we see someone who needs help, we should be willing to lend a hand. Helping others makes us feel good and it also makes the world a better place. This also reminds us that nobody is above needing help, sometimes it’s us and sometimes it’s someone else – thereby, helping us stay humble and accept the changing situations.</li>
        <li><strong>Be forgiving of ourselves and others:</strong> Everyone makes mistakes. When we make a mistake, we should forgive ourselves and learn from it. We should also be forgiving of others when they make mistakes. This allows us to remain both humble and kind.</li>
        <li><strong>Build strong relationships:</strong> Humility helps us to build strong relationships with others. When we are humble, we are more likely to be open to others, to listen to their ideas, and to be supportive. And let’s be honest, who would not like to be friends with or work with such an individual?</li>
        <li><strong>Meditate more often:</strong> Meditation (especially mindfulness-based and silent meditation) can help us to become more aware of our thoughts and feelings, and to let go of our ego. This can help us to be more humble, grounded and rooted. The ripple effect of such a personality is obviously felt across family and work spheres.</li>
      </ul>

      <p>Humility is a valuable trait that can help us live happier, healthier, and more successful lives. By practicing humility, we can become better people and make the world a better place for all. After reading this article, if you’re curious to explore more about what Avadhānakalā is – please visit our project page: <span class="font-semibold text-[#CC0033]">Avadhānakalā and Consciousness Studies</span></p>

      <div class="mt-8 pt-6 border-t border-gray-100 text-sm">
        <p class="mb-4 text-gray-600"><strong>About the author:</strong> Damini is a Research Associate at the Centre for Human Sciences. An avid reader, yoga asana and dhyana practitioner, Damini finds solace in Mother Nature. As part of the Rishihood family, she will be working to uncover unique aspects of the ancient Vedic art of Avadhānakalā or multiple concentration.</p>
      </div>
    `,
    image: humilityLifeBlogImage,
    categories: ["Avadhanakala"],
  },
];

// Internships for the Internships page

// PhD Programs for the PhD page
export const phdPrograms = [
  {
    id: 1,
    title: "PhD in Sanskrit and Classical Studies",
    researchAreas: [
      "Sanskrit language, literature, and textual traditions",
      "Classical linguistics, vyākaraṇa, and etymology",
      "Sanskrit manuscript studies and textual criticism",
      "Children's Literature in Sanskrit",
      "Traditional sciences in Sanskrit sources",
    ],
  },
  {
    id: 2,
    title: "PhD in Indian Philosophy and Integral Humanism",
    researchAreas: [
      "Classical Indian philosophical systems",
      "Integral Humanism and contemporary applications",
      "Comparative study of Indian thinkers",
      "Ethical, social, and political thought in India",
      "Civilizational perspectives on society and development",
    ],
  },
  {
    id: 3,
    title: "PhD in Indian Knowledge Systems, Education, and Spirituality",
    researchAreas: [
      "Indian Knowledge Systems (IKS)",
      "Yoga and Spirituality",
      "Integral Education and educational philosophy",
      "Sri Aurobindo’s thoughts and teachings",
      "Knowledge traditions and contemporary challenges",
    ],
  },
  {
    id: 4,
    title: "PhD in Specialized Indian Studies",
    researchAreas: [
      "Studies on Kavyakantha Ganapati Muni",
      "Indic intellectual history and knowledge traditions",
      "Interdisciplinary applications of Bharatiya thought",
      "Indigenous frameworks for social and cultural development",
      "Emerging domains within Indian Knowledge Systems",
    ],
  },
];

// PhD Scholars for the PhD page
export const phdScholars = [
  {
    id: 1,
    name: "MS Chaitra",
    yearJoined: 2023,
    supervisor: "Prof. Sampadananda Mishra",
    image: chaitra,
  },
  {
    id: 2,
    name: "Anup Sharma",
    yearJoined: 2025,
    supervisor: "Prof. Sampadananda Mishra",
    image: anupSharma,
  },
];
// Publications for the Publications page
export const publications_ = {
  journals: [
    {
      id: 1,
      title: "Journal of Indian Philosophical Studies",
      description:
        "A peer-reviewed journal publishing original research on classical and contemporary Indian philosophical traditions.",
      frequency: "Biannual",
      editors: ["Dr. Rajesh Mehta", "Dr. Vikram Rathore"],
      issues: [
        {
          volume: "Vol. 5, Issue 2",
          date: "July 2023",
          articles: [
            {
              title: "Epistemological Foundations of NyÄya Logic",
              authors: "Dr. Rajesh Mehta",
            },
            {
              title: "The Concept of Self in Advaita VedÄnta and Phenomenology",
              authors: "Dr. Sarah Thompson, Dr. Amit Kumar",
            },
          ],
        },
        {
          volume: "Vol. 5, Issue 1",
          date: "January 2023",
          articles: [
            {
              title:
                "Ethics of Artificial Intelligence: Perspectives from Indian Philosophy",
              authors: "Dr. Vikram Rathore",
            },
            {
              title:
                "Buddhist Theories of Consciousness and Contemporary Cognitive Science",
              authors: "Dr. David Wong, Dr. Sunita Verma",
            },
          ],
        },
      ],
    },
    {
      id: 2,
      title: "South Asian Cultural Studies Review",
      description:
        "An interdisciplinary journal examining cultural expressions, performances, and social practices across South Asia.",
      frequency: "Quarterly",
      editors: ["Dr. Priya Nagarajan", "Dr. Leela Prasad"],
      issues: [
        {
          volume: "Vol. 7, Issue 3",
          date: "August 2023",
          articles: [
            {
              title:
                "Digital Mediation of Folk Performance Traditions in Rural Maharashtra",
              authors: "Dr. Leela Prasad",
            },
            {
              title:
                "Heritage Tourism and Local Communities: Case Studies from Rajasthan",
              authors: "Dr. Arjun Singh, Neha Patel",
            },
          ],
        },
        {
          volume: "Vol. 7, Issue 2",
          date: "May 2023",
          articles: [
            {
              title:
                "Urban Spaces and Cultural Identity in Contemporary Indian Cinema",
              authors: "Dr. Priya Nagarajan",
            },
            {
              title:
                "Textile Traditions and Gender in South Indian Craft Communities",
              authors: "Dr. Ananya Roy",
            },
          ],
        },
      ],
    },
  ],
  books: [
    {
      id: 1,
      title: "Indian Philosophy in the 21st Century: Contemporary Dialogues",
      authors: ["Dr. Rajesh Mehta", "Dr. Vikram Rathore (Eds.)"],
      publisher: "Oxford University Press",
      year: 2022,
      description:
        "A collection of essays exploring the relevance of classical Indian philosophical traditions for addressing contemporary philosophical questions.",
      cover:
        "https://images.unsplash.com/photo-1589829085413-56de8ae18c73?auto=format&fit=crop&w=800&q=80",
    },
    {
      id: 2,
      title:
        "Digital Heritage: Preserving Cultural Memory in the Age of Technology",
      authors: ["Dr. Arjun Singh"],
      publisher: "Routledge",
      year: 2023,
      description:
        "An examination of theoretical frameworks and practical approaches for digital preservation of cultural heritage materials.",
      cover:
        "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?auto=format&fit=crop&w=800&q=80",
    },
    {
      id: 3,
      title: "Ecological Ethics in Hindu Traditions",
      authors: ["Dr. Sunita Verma"],
      publisher: "SUNY Press",
      year: 2021,
      description:
        "A study of environmental ethics in Hindu texts and practices, with implications for contemporary environmental challenges.",
      cover:
        "https://images.unsplash.com/photo-1533669955142-6a73332af4db?auto=format&fit=crop&w=800&q=80",
    },
    {
      id: 4,
      title:
        "Narrative Forms in Indian Literatures: Traditional and Contemporary",
      authors: ["Dr. Meera Krishnan"],
      publisher: "Penguin Random House India",
      year: 2023,
      description:
        "An analysis of storytelling techniques in Indian literary traditions and their evolution in contemporary writing.",
      cover:
        "https://images.unsplash.com/photo-1476275466078-4007374efbbe?auto=format&fit=crop&w=800&q=80",
    },
  ],
  articles: [
    {
      id: 1,
      title:
        "The Concept of Consciousness in Advaita VedÄnta and Its Contemporary Relevance",
      authors: ["Dr. Rajesh Mehta"],
      journal: "Journal of Consciousness Studies",
      volume: "Vol. 28, No. 3",
      year: 2023,
      pages: "45-67",
      doi: "10.1080/09687599.2023.123456",
    },
    {
      id: 2,
      title:
        "Digital Archives and Community Ownership: Ethical Considerations in Heritage Digitization",
      authors: ["Dr. Arjun Singh", "Neha Patel"],
      journal: "Digital Humanities Quarterly",
      volume: "Vol. 16, No. 2",
      year: 2022,
      pages: "112-135",
      doi: "10.4000/dhq.2022.654321",
    },
    {
      id: 3,
      title:
        "Ethical Frameworks for Artificial Intelligence: Perspectives from Indian Philosophy",
      authors: ["Dr. Vikram Rathore"],
      journal: "AI & Society",
      volume: "Vol. 37, No. 4",
      year: 2022,
      pages: "789-810",
      doi: "10.1007/s00146-022-789456",
    },
    {
      id: 4,
      title: "The Rasa Theory and Contemporary Film Aesthetics",
      authors: ["Dr. Priya Nagarajan"],
      journal: "Asian Cinema",
      volume: "Vol. 33, No. 2",
      year: 2022,
      pages: "234-256",
      doi: "10.1386/ac.2022.56789",
    },
    {
      id: 5,
      title:
        "Traditional Ecological Knowledge Systems and Sustainable Water Management",
      authors: ["Dr. Sunita Verma", "Dr. Anand Kumar"],
      journal: "Environmental Conservation",
      volume: "Vol. 49, No. 3",
      year: 2023,
      pages: "312-330",
      doi: "10.1017/S037689292300123",
    },
    {
      id: 6,
      title: "Gender and Authority in Medieval Bhakti Poetry",
      authors: ["Dr. Meera Krishnan"],
      journal: "Journal of South Asian Literature",
      volume: "Vol. 44, No. 1",
      year: 2023,
      pages: "78-96",
      doi: "10.1353/jsl.2023.5678",
    },
  ],
};

export interface Book {
  id: number;
  topic: string;
  authors: string[];
  cover: any;
  link: string;
  price?: number;
}

export const publications: {
  ebooks: any[];
  books: Book[];
  newsletters: any[];
  ritvik2025: any[];
  ritvik2026: any[];
  exhibitions: any[];
} = {
  ebooks: [
    {
      id: 1,
      topic: "Integral Humanism & Corporates",
      name: "Exploring the Real-World Effectiveness and Sustainable Influence of Integrating Integral Humanism Philosophies into Corporate Practices",
      description:
        "This e-book, prepared by Evarist P. K. Nayak as part of his internship under the Integral Humanism Initiative at the Centre for Human Sciences, explores the practical application of Integral Humanism principles within corporate environments through a case study based on Rishihood University and its employees. The study examines key workplace challenges such as mentorship, leadership, communication, workload, and organizational culture, while proposing solutions rooted in the philosophy of Deendayal Upadhyaya.\n\nUsing interviews, questionnaires, and secondary research, the e-book highlights how principles such as Antyodaya, Sambhāṣaṇa, Sahakāra, and Guru-Śiṣya Sambandha can contribute to more ethical, inclusive, and sustainable workplace practices. It further emphasises mentorship and holistic development as essential components for creating supportive and value-oriented organizational cultures.",
      author: [
        {
          name: "Evarist P. K. Nayak",
          profile: "#",
        },
      ],
      cover: ihiProject,
      link: "/assets/Ebooks/Evarist.pdf",
    },
    {
      id: 2,
      topic: "Core Philosophy of Pt. Deendayal Upadhyaya",
      name: "Integral Humanism: A Guide to Its Core Philosophy",
      description:
        "This e-book, prepared by Mohit Verma under the IKS Winter Internship Programme at the Centre for Human Sciences, presents a simplified and structured introduction to the philosophy of Integral Humanism propounded by Deendayal Upadhyaya. The book explains core concepts such as Dharma, Chiti, Antyodaya, Swadeshi, and the Purusharthas, while connecting them to India’s philosophical traditions and contemporary social, political, and developmental challenges.\n\nOrganized into thematic chapters, the e-book explores the foundational principles of Integral Humanism through concepts like Vyashti, Samashti, Srishti, and Parameshti, highlighting the interconnectedness of the individual, society, nature, and the divine. It further examines ethics, governance, sustainability, decentralization, and holistic development, presenting Integral Humanism as a balanced framework for inclusive and value-based progress in the modern world.",
      author: [
        {
          name: "Mohit Verma",
          profile: "#",
        },
      ],
      cover: advancingIntegralBanner,
      link: "/assets/Ebooks/Mohit verma e-book draft.pdf",
    },
    {
      id: 3,
      topic: "Indian Polity & Panchayati Raj",
      name: "Indian Polity and Panchayati Raj Institutions in Light of Integral Humanism",
      description:
        "This e-book, titled Indian Polity and Panchayati Raj Institutions in Light of Integral Humanism: Perspectives from Sri Aurobindo and Pt. Deendayal Upadhyaya, explores Indian political thought and decentralized governance through the philosophical framework of Integral Humanism. Prepared by Rajat Pratap Singh under the Internship Programme (2023) at the Centre for Human Sciences, the work examines the relationship between Indian polity, village self-governance, and civilizational values rooted in the thought of Sri Aurobindo and Deendayal Upadhyaya.\n\nThe book discusses the historical role of Panchayats, the philosophical foundations of Integral Humanism, and the importance of decentralization, Dharma, civic responsibility, and community participation in governance. It critically analyses post-independence Panchayati Raj institutions, their challenges in fostering genuine social harmony and community empowerment, and the limitations of state-centric development models. Through detailed case studies from Dharwad and Chitrakoot, the e-book highlights practical examples of community-led development rooted in cultural values, local participation, and holistic progress.",
      author: [
        {
          name: "Rajat Pratap Singh",
          profile: "#",
        },
      ],
      cover: crpProjectBanner,
      link: "/assets/Ebooks/Rajat E book merged draft.pdf",
    },
    {
      id: 4,
      topic: "Migration & Challenges",
      name: "The Problem of Migration: Addressing Challenges Through Integral Humanism",
      description:
        "This e-book, The Problem of Migration: Addressing Challenges Through Integral Humanism, examines the economic, social, and psychological challenges faced by labor-class migrants in India through the framework of Integral Humanism. Prepared by Vishal Kumar under the Integral Humanism Initiative Internship Programme [2024–25] at the Centre for Human Sciences, the study explores issues such as low wages, financial exclusion, unsafe working conditions, social alienation, and reverse migration.\n\nDrawing upon the principles of Antyodaya, Parasparāvalambanam, Svāvalamban, and Chiti, the e-book proposes policy recommendations related to financial inclusion, social security portability, affordable housing, rural development, and migrant welfare. Through case studies from states such as Uttar Pradesh, Odisha, Bihar, and Kerala, it highlights practical approaches towards inclusive development, self-reliance, and dignified livelihoods for migrant communities.",
      author: [
        {
          name: "Vishal Kumar",
          profile: "#",
        },
      ],
      cover: crpImpact2,
      link: "/assets/Ebooks/Vishal Kumar's Ebook.pdf",
    },
    {
      id: 5,
      topic: "Sustainable Growth & Living Organization",
      name: "The Living Organization: A Dharmic Approach to Sustainable Growth",
      description:
        "This e-book, The Living Organization: A Dharmic Approach to Sustainable Growth, prepared by Reetika Yadav under the Integral Humanism Initiative Internship Programme [2025] at the Centre for Human Sciences, explores organizational development through the philosophical framework of Integral Humanism. The study critiques profit-centric capitalism and presents the idea of the “Living Organization” rooted in Dharma, decentralization, ethical leadership, and holistic growth.\n\nThrough case studies of organizations such as Aravind Eye Care System, The Art of Living Foundation, and Isha Foundation, the e-book examines how principles such as Antyodaya, Svāvalamban, Chiti, and Virat can shape sustainable, value-based, and socially responsible institutions. It argues for redefining organizational success beyond profit and market growth towards human well-being, ethical governance, and long-term societal impact.",
      author: [
        {
          name: "Reetika Yadav",
          profile: "#",
        },
      ],
      cover: iksProject,
      link: "/assets/Ebooks/Reetika Yadav's Ebook.pdf",
    },
  ],
  books: [
    {
      id: 17,
      topic: "Advancing Integral Humanism in the 21st Century",
      authors: ["Prof. (Dr.) Sampadananda Mishra", "Neelabh Kumar Sharma", "Anusree S.L."],
      cover: advancingIntegralBook,
      link: "https://www.dpspublishinghouse.com/product-page/advancing-integral-humanism-in-the-21st-century",
    },
    {
      id: 16,
      topic: "एकात्ममानवदर्शनम् | Ekatma Mānava Darśanam",
      authors: ["Sampadananda Mishra"],
      cover: ekatmvadBook,
      link: "mailto:res-pub@csu.co.in,sales@csu.co.in?subject=Inquiry%20about%20Ekatma%20Manava%20Darshanam%20Book",
    },
    {
      id: 15,
      topic: "Philosophy of Indian Pedagogy",
      authors: [
        "Prof. (Dr.) Sampadananda Mishra",
        "Neelabh Kumar Sharma",
        "Anusree S.L.",
      ],
      cover: pedagogyBook,
      link: "https://www.flipkart.com/philosophy-indian-pedagogy-nep-2020/p/itmcf718c134f5da",
    },
    {
      id: 5,
      topic: "Krīḍākautukī",
      authors: ["Sampadananda Mishra"],
      cover: kridakautuki,
      link: "https://www.amazon.in/Kr%C4%ABd%C4%81kautuki-%E0%A4%95%E0%A5%8D%E0%A4%B0%E0%A5%80%E0%A4%A1%E0%A4%BE%E0%A4%95%E0%A5%8C%E0%A4%A4%E0%A5%81%E0%A4%95%E0%A5%80-Sampadananda-Mishra/dp/9347691151/ref=sr_1_1?crid=5HQYGWRBVP2J&dib=eyJ2IjoiMSJ9.-t6YhIojJvFRc8rL_oCwlg.S3ASZDArFpbNm4XfT_eg1DQX3jVqGpK_fkTrIvZz02Y&dib_tag=se&keywords=kridakautuki&qid=1779165557&sprefix=kridakautuk%2Caps%2C269&sr=8-1",
    },
    {
      id: 6,
      topic: "Abhyāsalaharī",
      authors: ["Asha Agrawal"],
      cover: abhyasalahari,
      link: "https://www.amazon.in/Abhy%C4%81salahar%C4%AB-%E0%A4%85%E0%A4%AD%E0%A5%8D%E0%A4%AF%E0%A4%BE%E0%A4%B8%E0%A4%B2%E0%A4%B9%E0%A4%B0%E0%A5%80-Asha-Agrawal/dp/9347691771/ref=sr_1_1?crid=3JEYE3DW2MWCZ&dib=eyJ2IjoiMSJ9.uS13vOgZt5x5XecertIZEg.H3qCNMs4hIyximbEZIXOn-seQlX_w2LjFTJNJLzI2XU&dib_tag=se&keywords=abhyasalahari&qid=1779165818&sprefix=abhyasalahari%2Caps%2C251&sr=8-1",
    },
    {
      id: 7,
      topic: "Ramyanāṭakāni",
      authors: ["Arya Chandrashekhara"],
      cover: ramyanatakani,
      link: "https://www.amazon.in/Ramyan%C4%81%C8%9Bak%C4%81ni-%E0%A4%B0%E0%A4%AE%E0%A5%8D%E0%A4%AF%E0%A4%A8%E0%A4%BE%E0%A4%9F%E0%A4%95%E0%A4%BE%E0%A4%A8%E0%A4%BF-Arya-Chandrashekhara/dp/9347691437",
    },
    {
      id: 8,
      topic: "Kathāślokaviṃśatikā",
      authors: ["Sampadananda Mishra"],
      cover: kathaslokavinshatika,
      link: "https://www.amazon.in/Kath%C4%81%C5%9Blokavim%C5%9Batik%C4%81-%E0%A4%95%E0%A4%A5%E0%A4%BE%E0%A4%B6%E0%A5%8D%E0%A4%B2%E0%A5%8B%E0%A4%95%E0%A4%B5%E0%A4%BF%E0%A4%82%E0%A4%B6%E0%A4%A4%E0%A4%BF%E0%A4%95%E0%A4%BE-Sampadananda-Mishra/dp/9347691119/ref=sr_1_1?crid=3E4UMVXO0OITO&dib=eyJ2IjoiMSJ9.Xa_EGhnxBMgZ6M2Lmz7Agg.8y-fyL5_0mk8_KG_hQau1bIr_6pQ1hkdOVKdRrtPL80&dib_tag=se&keywords=kathaslokavimsatika&qid=1779166395&sprefix=kathaslokavimsati%2Caps%2C259&sr=8-1",
    },
    {
      id: 9,
      topic: "Laghugalpalatikā",
      authors: ["Upasika Ghosh", "Vishnu Madhusudhanan"],
      cover: laghugalpalatika,
      link: "https://www.amazon.in/Laghugalpalatik%C4%81-%E0%A4%B2%E0%A4%98%E0%A5%81%E0%A4%97%E0%A4%B2%E0%A5%8D%E0%A4%AA%E0%A4%B2%E0%A4%A4%E0%A4%BF%E0%A4%95%E0%A4%BE-Upasika-Ghosh/dp/9347691755/ref=sr_1_1?crid=167I465H9XIWU&dib=eyJ2IjoiMSJ9.kPtv0Q5CkCjnT3ZYhCKAIQ.eUxnUrf-KO3NGmJvD4rF0oKfRK3QCppSyH3nvPnpKY8&dib_tag=se&keywords=Laghugalpalatika&qid=1779165476&sprefix=laghugalpalati%2Caps%2C248&sr=8-1",
    },
    {
      id: 10,
      topic: "Kathāmālikā",
      authors: ["Madhusudan Mahapatra"],
      cover: kathamalika,
      link: "https://www.amazon.in/Kath%C4%81m%C4%81lik%C4%81-%E0%A4%95%E0%A4%A5%E0%A4%BE%E0%A4%AE%E0%A4%BE%E0%A4%B2%E0%A4%BF%E0%A4%95%E0%A4%BE-Madhusudan-Mahapatra/dp/B0GGZ8382K/ref=sr_1_1?crid=3DRJS1CZ8QHHH&dib=eyJ2IjoiMSJ9.LHoJ7DMnkZjnfkl8NK_pUDnIqFwFyfgRB1qsJOX6e3W0IcwmXmwsdw_ZoU_AdzLb3YJDegFiHurqvhXAUL-MQZSjlcbiXvLnv88kZbscr-w7ta5ASb20b7YzdkrZQEg2RQ5buCrX_Cbq8799N5I1plVfs89gnT-u0XimFpCS_w8SdZnYKiGA7hczfI_AL8mb.4d0aQnt9-ywIihnkw_gKOsj-Ntr9vCL2RjTjvfzNjm8&dib_tag=se&keywords=kathamalika&qid=1779166157&sprefix=kathamali%2Caps%2C252&sr=8-1",
    },
    {
      id: 11,
      topic: "Kathā Bhāratī",
      authors: ["Radhika Ranjan Das"],
      cover: kathabharati,
      link: "https://www.amazon.in/Katha-Bh%C4%81rat%C4%AB-Radhika-Ranjan-Das/dp/9347691275/ref=sr_1_2?crid=3UL1ILA628F64&dib=eyJ2IjoiMSJ9.5sbaXD5NRSjkmUUWdP3ydlTTA78sZTD22ubY2pTjhiW__nDvrvnV2AsUafS7To4sSb0mKn2a0Yqn4opDrtVrZSCbYNXRjSSW6_Zhk7UiDM8DbrOqV7chX157I3u4KeVxznHTNfixER_vuO_y68KJfWQuVbHDtbziW7Te5VRNRdWjJI4hBdrA8Yf7HWFFo6wFj6kQ1ZkfSAKhWMAYMHou4quBffT2VQxZqhbqhKaiXdY.ih9gFZna3C8zVVyrEHJUoegWaSnDbRned5aOd_eGFdY&dib_tag=se&keywords=katha+bharati&qid=1779166555&sprefix=katha+bharat%2Caps%2C258&sr=8-2n",
    },
    {
      id: 12,
      topic: "Kākaḥ Kāko Vako Vakaḥ",
      authors: ["Narayana Dash"],
      cover: kakahkako,
      link: "https://www.amazon.in/K%C4%81kah-K%C4%81ko-Vako-Vakah-%E0%A4%95%E0%A4%BE%E0%A4%95%E0%A4%83/dp/9347691283",
    },
    {
      id: 13,
      topic: "Śabdakrīḍā",
      authors: ["Priyanka Salekar"],
      cover: shabdakrida,
      link: "https://www.amazon.in/%C5%A0abdakr%C4%ABd%C4%81-%E0%A4%B6%E0%A4%AC%E0%A5%8D%E0%A4%A6%E0%A4%95%E0%A5%8D%E0%A4%B0%E0%A5%80%E0%A4%A1%E0%A4%BE-Priyanka-Salekar/dp/934769195X/ref=sr_1_1?crid=17C0NX48SN682&dib=eyJ2IjoiMSJ9.mTXq9mYzTlwhkU8520V8jg.6_swciMhmPP7CVnTNLhQvTPuCTtXwIF1pc9RRLRNeRQ&dib_tag=se&keywords=%E0%A4%B6%E0%A4%AC%E0%A5%8D%E0%A4%A6%E0%A4%95%E0%A5%8D%E0%A4%B0%E0%A5%80%E0%A4%A1%E0%A4%BE&qid=1779166019&sprefix=%E0%A4%B6%E0%A4%AC%E0%A5%8D%E0%A4%A6%E0%A4%95%E0%A5%8D%E0%A4%B0%E0%A5%80%E0%A4%A1%E0%A4%BE%2Caps%2C298&sr=8-1",
    },
    {
      id: 14,
      topic: "Rāmāyaṇakathāmañjarī",
      authors: ["Sangeeta Sharma"],
      cover: ramayanakathamanjari,
      link: "https://www.amazon.in/R%C4%81m%C4%81ya%C5%86akath%C4%81ma%C3%B1jar%C4%AB-%E0%A4%B0%E0%A4%BE%E0%A4%AE%E0%A4%BE%E0%A4%AF%E0%A4%A3%E0%A4%95%E0%A4%A5%E0%A4%BE%E0%A4%AE%E0%A4%9E%E0%A5%8D%E0%A4%9C%E0%A4%B0%E0%A5%80-Sangeeta-Sharma/dp/9347691666/ref=sr_1_1?crid=2FSVDAMAHO66E&dib=eyJ2IjoiMSJ9.7U8UiLM_VggCobPBPltmEjsG2v3Zxj-FigpjwDkAPGfoUP12PHj-nbtx7qg3H3nK-bzUYv1kNEQ0lnWZL65VPfqW_nJ3SG99vgYueNEUz1I.Hxaw5IxAQ3_CPkltb1H9QRXkbDtDhoZAyL3ehfnXfXI&dib_tag=se&keywords=sangeeta+sharma+ramayan&qid=1779801696&s=books&sprefix=sangeeta+sharma+ramaya%2Cstripbooks%2C328&sr=1-1",
    },
    {
      id: 1,
      topic: "The Wonder that is Avadhanam",
      authors: ["Sampadananda Mishra"],
      cover: wonderAvadhanam,
      link: "https://www.amazon.in/dp/9355385153",
    },
    {
      id: 2,
      topic: "Avadhana Tradition in Odisha",
      authors: ["Prateek Pattanaik"],
      cover: traditionOdisha,
      link: "https://www.amazon.in/dp/9355384416",
    },
    {
      id: 3,
      topic:
        "The Art of Avadhana: Unveiling the Secrets of Human Attention and Memory",
      authors: ["S. Vaishnavi"],
      cover: artAvadhana,
      link: "https://www.amazon.in/dp/935538226X",
    },
    {
      id: 4,
      topic: "जैन धर्म में अवधान",
      authors: ["Surbhi Bhagat"],
      cover: jainAvadhana,
      link: "https://www.amazon.in/dp/9355389345",
    },
  ],
  newsletters: [
    {
      id: 1,
      title: "Heritage Insights - January 2024",
      description:
        "A monthly newsletter featuring the latest research, events, and news in Indian heritage studies.",
      link: "https://placehold.co/600x400?text=Heritage%20Insights%20Jan%202024",
      cover:
        "https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=800&q=80",
    },
    {
      id: 2,
      title: "Philosophy Digest - March 2024",
      description:
        "Updates on philosophical research, faculty highlights, and upcoming seminars.",
      link: "https://placehold.co/600x400?text=Philosophy%20Digest%20Mar%202024",
      cover:
        "https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=800&q=80",
    },
    {
      id: 3,
      title: "Culture & Society - April 2024",
      description:
        "Exploring the intersections of culture, society, and tradition in contemporary India.",
      link: "https://placehold.co/600x400?text=Culture%20and%20Society%20Apr%202024",
      cover:
        "https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=800&q=80",
    },
  ],
  ritvik2025: [
    {
      id: 1,
      name: "January 2025 Volume 1 Issue 1",
      link: "/assets/Ritvik 2025 PDFs/January 2025 Volume 1 Issue 1_News letter.pdf",
      date: "January 2025",
      cover: "/assets/Ritvik 2025 PDFs/Covers/January 2025.jpg",
    },
    {
      id: 2,
      name: "February 2025 Volume 1 Issue 2",
      link: "/assets/Ritvik 2025 PDFs/February 2025 Volume 1 Issue 2_News letter.pdf",
      date: "February 2025",
      cover: "/assets/Ritvik 2025 PDFs/Covers/February 2025.jpg",
    },
    {
      id: 3,
      name: "March 2025 Volume 1 Issue 3",
      link: "/assets/Ritvik 2025 PDFs/March 2025 Volume 1 Issue 3_News letter.pdf",
      date: "March 2025",
      cover: "/assets/Ritvik 2025 PDFs/Covers/March 2025.jpg",
    },
    {
      id: 4,
      name: "April 2025 Volume 1 Issue 4",
      link: "/assets/Ritvik 2025 PDFs/April 2025 Volume 1 Issue 4_News letter.pdf",
      date: "April 2025",
      cover: "/assets/Ritvik 2025 PDFs/Covers/April 2025.jpg",
    },
    {
      id: 5,
      name: "May 2025 Volume 1 Issue 5",
      link: "/assets/Ritvik 2025 PDFs/May 2025 Volume 1 Issue 5_News letter.pdf",
      date: "May 2025",
      cover: "/assets/Ritvik 2025 PDFs/Covers/May 2025.jpg",
    },
    {
      id: 6,
      name: "June 2025 Volume 1 Issue 6",
      link: "/assets/Ritvik 2025 PDFs/June 2025 Volume 1 Issue 6_News letter.pdf",
      date: "June 2025",
      cover: "/assets/Ritvik 2025 PDFs/Covers/June 2025.jpg",
    },
    {
      id: 7,
      name: "July 2025 Volume 1 Issue 7",
      link: "/assets/Ritvik 2025 PDFs/July 2025 Volume 1 Issue 7_News letter.pdf",
      date: "July 2025",
      cover: "/assets/Ritvik 2025 PDFs/Covers/July 2025.jpg",
    },
    {
      id: 8,
      name: "August 2025 Volume 1 Issue 8",
      link: "/assets/Ritvik 2025 PDFs/August 2025 Volume 1 Issue 8_News letter.pdf",
      date: "August 2025",
      cover: "/assets/Ritvik 2025 PDFs/Covers/August 2025.jpg",
    },
    {
      id: 9,
      name: "September 2025 Volume 1 Issue 9",
      link: "/assets/Ritvik 2025 PDFs/September 2025 Volume 1 Issue 9_News letter.pdf",
      date: "September 2025",
      cover: "/assets/Ritvik 2025 PDFs/Covers/September 2025.jpg",
    },
    {
      id: 10,
      name: "October 2025 Volume 1 Issue 10",
      link: "/assets/Ritvik 2025 PDFs/October 2025 Volume 1 Issue 10_News letter.pdf",
      date: "October 2025",
      cover: "/assets/Ritvik 2025 PDFs/Covers/October 2025.jpg",
    },
    {
      id: 11,
      name: "November 2025 Volume 1 Issue 11",
      link: "/assets/Ritvik 2025 PDFs/November 2025 Volume 1 Issue 11_News letter.pdf",
      date: "November 2025",
      cover: "/assets/Ritvik 2025 PDFs/Covers/November 2025.jpg",
    },
    {
      id: 12,
      name: "December 2025 Volume 1 Issue 12",
      link: "/assets/Ritvik 2025 PDFs/December 2025 Volume 1 Issue 12_News letter.pdf",
      date: "December 2025",
      cover: "/assets/Ritvik 2025 PDFs/Covers/December 2025.jpg",
    },
  ],
  ritvik2026: [
    {
      id: 1,
      name: "January 2026 Volume 2 Issue 1",
      link: "/assets/Ritvik 2026 PDFs/January 2026 Volume 2 Issue 1_News letter.pdf",
      date: "January 2026",
      cover: "/assets/Ritvik 2026 PDFs/Covers/January 2026.jpg",
    },
    {
      id: 2,
      name: "February 2026 Volume 2 Issue 2",
      link: "/assets/Ritvik 2026 PDFs/February 2026 Volume 2 Issue 2_News letter.pdf",
      date: "February 2026",
      cover: "/assets/Ritvik 2026 PDFs/Covers/February 2026.jpg",
    },
    {
      id: 3,
      name: "March 2026 Volume 2 Issue 3",
      link: "/assets/Ritvik 2026 PDFs/March 2026 Volume 2 Issue 3_News letter.pdf",
      date: "March 2026",
      cover: "/assets/Ritvik 2026 PDFs/Covers/March 2026.jpg",
    },
    {
      id: 4,
      name: "April 2026 Volume 2 Issue 4",
      link: "/assets/Ritvik 2026 PDFs/April 2026 Volume 2 Issue 4_News letter.pdf",
      date: "April 2026",
      cover: "/assets/Ritvik 2026 PDFs/Covers/April 2026.jpg",
    },
    {
      id: 5,
      name: "May 2026 Volume 2 Issue 5",
      link: "/assets/Ritvik 2026 PDFs/May 2026 Volume 2 Issue 5_News letter.pdf",
      date: "May 2026",
      cover: "/assets/Ritvik 2026 PDFs/Covers/May 2026.jpg",
    },
    {
      id: 6,
      name: "June 2026 Volume 2 Issue 6",
      link: "/assets/Ritvik 2026 PDFs/June 2026 Volume 2 Issue 6_News letter.pdf",
      date: "June 2026",
      cover: "/assets/Ritvik 2026 PDFs/Covers/June 2026.jpg",
    },
    {
      id: 7,
      name: "July 2026 Volume 2 Issue 7",
      link: "/assets/Ritvik 2026 PDFs/July 2026 Volume 2 Issue 7_News letter.pdf",
      date: "July 2026",
      cover: "/assets/Ritvik 2026 PDFs/Covers/July 2026.jpg",
    },
    {
      id: 8,
      name: "August 2026 Volume 2 Issue 8",
      link: "/assets/Ritvik 2026 PDFs/August 2026 Volume 2 Issue 8_News letter.pdf",
      date: "August 2026",
      cover: "/assets/Ritvik 2026 PDFs/Covers/August 2026.jpg",
    },
    {
      id: 9,
      name: "September 2026 Volume 2 Issue 9",
      link: "/assets/Ritvik 2026 PDFs/September 2026 Volume 2 Issue 9_News letter.pdf",
      date: "September 2026",
      cover: "/assets/Ritvik 2026 PDFs/Covers/September 2026.jpg",
    },
  ],
  exhibitions: [
    {
      id: 1,
      title: "चिति-प्रभा | Chiti-Prabhā",
      subtitle:
        "The Radiance of National Consciousness: 60 Quotes for a Resurgent India",
      description:
        "The Centre for Human Sciences released Chiti-Prabhā: The Radiance of National Consciousness, a curated poster series featuring 60 significant quotations of Pandit Deendayal Upadhyaya to commemorate the sixtieth anniversary of his historic 1965 Mumbai lectures. Organised around key themes of Integral Humanism, the bilingual series presents reflections on national identity, dharma, democracy, culture, and social harmony, making the philosophical vision of Ekatma Manava Darshan accessible to contemporary audiences.",
      cover: E1,
      link: "/assets/Exhibitions/60 Quotes DDU-compressed.pdf",
    },
    {
      id: 2,
      title: "ग्रन्थमाला | Granthamālā | Our Timeless Heritage",
      subtitle:
        "An Exhibition on Pioneering Series in Indian Knowledge Systems",
      description:
        "The Centre for Human Sciences presented Granthamālā: Our Timeless Heritage, an exhibition highlighting pioneering publication series and textual traditions within the Indian Knowledge Systems. Curated and researched by Prof. (Dr.) Sampadananda Mishra, with research assistance and poster design by Dr. Upasika Ghosh, the exhibition introduced audiences to major Sanskrit series, oriental research publications, manuscript traditions, and institutions that preserved and disseminated India’s intellectual heritage.\n\nFeaturing landmark series such as the Gita Press, the Bibliotheca Indica Series, Kavyamala, and several Sanskrit Granthamālās from across India, the exhibition traced the historical efforts of scholars, presses, universities, and research institutes in safeguarding rare manuscripts and classical knowledge traditions.",
      cover: E2,
      link: "/assets/Exhibitions/IKSHA Sangama - ग्रन्थमाला Our Timeless Heritage - PDF (1)_compressed.pdf",
    },
    {
      id: 3,
      title: "Sri Aurobindo: The Rishi of India’s Renaissance",
      subtitle: "An Exhibition on the Life Journey of Sri Aurobindo",
      description:
        "The Centre for Human Sciences curated Sri Aurobindo: The Rishi of India’s Renaissance, an exhibition tracing the life, spiritual evolution, and national vision of Sri Aurobindo on the occasion of the unveiling of his portrait at Rishihood University. Conceived and curated by Prof. Sampadananda Mishra, with design by Dr. Upasika Ghosh, the exhibition presented Sri Aurobindo’s journey from revolutionary nationalist to spiritual visionary through archival photographs, writings, and thematic narratives. It highlighted key phases of his life including his years in Baroda, the freedom movement, the Alipore Jail experience, the evolution of his yoga in Pondicherry, the role of The Mother, and his vision of humanity’s spiritual future.",
      cover: E3,
      link: "/assets/Exhibitions/Sri Aurobindo exhibition-compressed.pdf",
    },
    {
      id: 4,
      title: "संविद् संविज्ञानम् | Saṁvid Saṁvijñānam",
      subtitle: "An Exhibition on Understanding Integral Psychology",
      description:
        "The Centre for Human Sciences presented Saṁvid Saṁvijñānam, an exhibition on Integral Psychology based on the philosophical and psychological insights of Sri Aurobindo. Curated by Prof. (Dr.) Sampadananda Mishra and Anusree S.L., the exhibition explored key concepts such as the psychic being, planes of consciousness, Integral Yoga, human evolution, and the transformative potential of consciousness through accessible visual and textual presentations.\n\nBlending Sanskrit terminology, philosophical reflections, and artistic representations, the exhibition sought to introduce audiences to a holistic understanding of mind, self, and spiritual evolution rooted in the Indian knowledge tradition.",
      cover: E4,
      link: "/assets/Exhibitions/संविद् संविज्ञानम्  saṁvid saṁvijñānam_compressed.pdf",
    },
  ],
};

export const reports = {
  project: [] as any[],
  events: [
    {
      id: 1,
      title: "3rd International Scientific–Spiritual Practical Conference on Universal Principles and Practices of Integral Education",
      date: "24 - 25 January, 2026",
      description: "The 3rd International Scientific–Spiritual Practical Conference on Universal Principles and Practices of Integral Education brought together scholars, educators, researchers, and practitioners from India, Russia, Ukraine, Poland, Belarus, and Norway to explore education as a process of conscious human development. Hosted at Rishihood University, the conference focused on integrating the physical, vital, mental, psychic, and spiritual dimensions of the learner through a synthesis of science, spirituality, and educational practice.\n\nThe conference featured invited talks, technical sessions, and research presentations on themes such as Integral Education, conscious living, mindfulness, creative drama, educational leadership, teacher development, mental health, yoga, and the role of Indian knowledge traditions in shaping the future of education. Prof. Sampadananda Mishra delivered the welcome address, emphasizing the need to move beyond ego-driven and desire-driven models of education toward an approach centred on the evolving soul and the manifestation of human potential. The conference also witnessed the launch of the volume Universal Principles and Practices of Integral Education and reaffirmed the importance of education as a means for conscious evolution, human unity, and holistic societal transformation.",
      cover: eventReport4,
      link: "/assets/Events/CONFERENCE REPORT_ 3rd International Scientific–Spiritual Practical Conference on Universal Principles and Practices of Integral Education.pdf",
    },
    {
      id: 2,
      title: "Round Table Conference on Philosophy of Indian Pedagogy",
      date: "16-17 November, 2024",
      description: "The Centre for Human Sciences, Rishihood University, in collaboration with the Indian Knowledge Systems Programme at IIT Delhi and with support from ICPR, organized a two-day Round Table Conference on the Philosophy of Indian Pedagogy on 16–17 November 2024. The conference brought together scholars, educators, policymakers, and researchers to explore the foundations of Indian pedagogy and its relevance for contemporary education.\n\nDiscussions focused on holistic learning, Guru–Shishya Paramparā, experiential education, Indian Knowledge Systems, NEP 2020, language, technology, and the role of education in nurturing consciousness, character, and societal responsibility. The deliberations highlighted pathways for integrating India’s educational wisdom with modern pedagogical practices to create a more rooted, value-based, and learner-centric system.",
      cover: eventReport5,
      link: "/assets/Events/Philosophy of Indian Pedagogy - Long Report Final.docx.pdf",
    },
    {
      id: 3,
      title: "Philosophical Contribution of Contemporary Thinkers",
      date: "9 March, 2024",
      description: "The World Philosophy Day Lecture Series on “Philosophical Contribution of Contemporary Thinkers”, sponsored by the Indian Council of Philosophical Research (ICPR), was organized by the Centre for Human Sciences, Rishihood University, in partnership with the Group of Adult Education, School of Social Sciences, Jawaharlal Nehru University, on 9 March 2024. The event brought together eminent scholars and thinkers to explore the philosophical contributions of Sri Aurobindo, Pandit Deendayal Upadhyaya, Madan Mohan Malaviya, Ram Manohar Lohia, and Jiddu Krishnamurti.\n\nThrough a series of insightful lectures and discussions, the programme examined themes such as integral philosophy, human unity, education, democracy, freedom, and social transformation. The lecture series provided a platform for meaningful engagement with contemporary Indian thought and highlighted the continued relevance of these thinkers in addressing present-day intellectual and societal challenges.",
      cover: eventReport6,
      link: "/assets/Events/Report on ICPR Sponsored World Philosophy Day Lecture Series.pdf",
    },
    {
      id: 4,
      title: "International Conference on ‘Advancing Integral Humanism in 21st Century’",
      date: "12 - 14 April, 2024",
      description: "Advancing Integral Humanism in the 21st Century is a comprehensive report of the International Conference organized by the Integral Humanism Initiative at the Centre for Human Sciences, Rishihood University, in collaboration with Prajna Pravah, from 12–14 April 2024. Bringing together scholars, educators, policymakers, and practitioners from India and abroad, the conference explored the philosophical foundations, contemporary relevance, and practical applications of Integral Humanism in education, governance, economics, social development, and international relations.\n\nThe report captures keynote addresses, paper presentations, panel discussions, book launches, and exhibitions that examined Integral Humanism as a holistic framework for addressing contemporary challenges. It highlights themes such as ethical leadership, sustainable development, humanistic education, cultural continuity, social harmony, and the integration of Indian knowledge systems, while proposing pathways for advancing a more balanced, inclusive, and value-based vision for the 21st century.",
      cover: eventReport1,
      link: "https://drive.google.com/file/d/19AtlRQkWZ-r20YbZ4HG-bSAoZfUahl8t/view?usp=drive_link",
    },
    {
      id: 5,
      title: "Jagadguru Shri Shankaracharya Vyakhyanamala",
      date: "20 March 2024",
      description: "The Jagadguru Śrī Śaṅkarācārya Vyākhyānamālā, organized by the Centre for Human Sciences, Rishihood University, with the support of the Bharatiya Bhasha Samiti, Ministry of Education, Government of India, was held on 20 March 2024 at Rishihood University. The event paid tribute to Jagadguru Ādi Śaṅkarācārya through scholarly lectures, a documentary screening, and an exhibition highlighting his life, philosophy, and enduring contributions to Indian civilization.\n\nThe programme featured keynote addresses by Ācārya Pradeep Shastri and Dr. Baldev Anand Sagar, who reflected on Śaṅkarācārya’s Advaita Vedānta, educational vision, and influence on Sanskrit and Indian culture. The event also included an exhibition and documentary that offered participants deeper insights into the philosopher’s life and legacy, fostering meaningful engagement with one of Bharat’s most influential spiritual and intellectual traditions.",
      cover: eventReport7,
      link: "/assets/Events/Report on Jagadguru Shri Shankaracharya Vyakhyanamala.pdf",
    },
    {
      id: 6,
      title: "Empowerment, Sustainability and Harmony in Integral Humanism",
      date: "November, 2023",
      description: "Empowerment, Sustainability and Harmony in Integral Humanism - An Ethnographic Study Report\nSciences, Rishihood University. The report examines how the principles of Integral Humanism can be applied in real-world settings, particularly in the fields of education and socio-economic development. Through field visits to Puducherry, Doddamadhure (Karnataka), and Chitrakoot (Uttar Pradesh), the study explores models inspired by the ideas of Sri Aurobindo and Pt. Deendayal Upadhyaya.\n\nThe report highlights how holistic education, community empowerment, self-reliance, sustainable development, cultural preservation, and grassroots participation can contribute to human well-being and social harmony. By documenting educational institutions, rural development initiatives, and community-led programs, it demonstrates how concepts such as swalamban (self-reliance), parasparavalamban (mutual interdependence), antyodaya (upliftment of the last person), and sarvodaya (welfare of all) can be translated into practical development models. The study concludes that Integral Humanism offers a viable framework for creating balanced, people-centric, and sustainable approaches to education and socio-economic progress.",
      cover: eventReport2,
      link: "/assets/Events/Empowerment, Sustainability and Harmony.pdf",
    },
    {
      id: 7,
      title: "Avadhāna Saṅgama: CULTIVATING COGNITIVE MASTERY",
      date: "11 - 14 September, 2023",
      description: "Avadhāna Saṅgama: Cultivating Cognitive Mastery, held from 11–14 September 2023 at the National Sanskrit University, Tirupati, brought together master Avadhānīs, scholars, practitioners, and enthusiasts to explore the ancient Indian art of Avadhānakalā—the art of multiple concentration. Organized by the Centre for Human Sciences, Rishihood University, in collaboration with the National Sanskrit University, the conference featured lectures, demonstrations, performances, and panel discussions highlighting the cognitive, creative, and cultural dimensions of Avadhānakalā.\n\nThe conference showcased diverse forms of Avadhāna, including Ghantāvadhānam, Tāḷāvadhānam, Gaṇitāvadhānam, Netrāvadhānam, and Sāhitya Avadhānam, while fostering dialogue on its relevance for education, cognitive development, cultural preservation, and public engagement. It also emphasized the need for wider recognition, research, and institutional support for this unique Indian knowledge tradition.",
      cover: eventReport8,
      link: "/assets/Events/Avadhāna Saṅgama-CULTIVATING COGNITIVE MASTERY.pdf",
    },
    {
      id: 8,
      title: "Indic Perspective in Political Science Curricula",
      date: "August, 2023",
      description: "Indic Perspective in Political Science Curricula - A Report on Round Table Discussion\nThis report documents a roundtable discussion organized by the Centre for Human Sciences, Rishihood University, on developing an Indic perspective in Political Science curricula. Bringing together scholars, academicians, and thought leaders, the discussions focused on addressing the dominance of Western frameworks in political science education and exploring ways to integrate India’s civilizational knowledge, political thought, and cultural ethos into academic curricula. Key themes included the distinction between nation and nation-state, decolonization of knowledge systems, the concept of Chitti and Rashtra Swabhav, the relevance of traditional Indian texts, and the need for interdisciplinary approaches to understanding Indian political thought.\n\nThe report also highlights practical challenges such as the lack of accessible resources, inadequate faculty training, fragmented archives, and the need for digitization and preservation of manuscripts. Participants emphasized curriculum development, creation of scholarly resources, establishment of research centres, and building global collaborations to advance Indic studies. Overall, the report serves as a roadmap for enriching political science education through indigenous perspectives while fostering a deeper engagement with India’s intellectual and civilizational heritage.",
      cover: eventReport3,
      link: "https://drive.google.com/file/d/10-ZcW_RyVkE0aisV_c9730QJ9wE6gAiT/view?usp=drive_link",
    },
    {
      id: 9,
      title: "Six-Day Bharatiya Bhasha Mahotsav",
      date: "11-16 December, 2022",
      description: "The Six-Day Bharatiya Bhasha Mahotsav, organized by the Centre for Human Sciences, Rishihood University, in association with the Bharatiya Bhasha Samiti, Ministry of Education, Government of India, was held from 11–16 December 2022 to celebrate Bharatiya Bhasha Diwas. The Mahotsav featured a guest lecture, an exhibition, cultural competitions, and a two-day national seminar, all centered on the theme “Wonders of Bharatiya Bhasha.”\n\nThe event highlighted the richness, diversity, and cultural significance of Indian languages through lectures by eminent scholars, exhibitions on classical languages, folk music and dance performances, essay writing, painting, and drama competitions. The concluding national seminar brought together experts from across the country to discuss the history, literature, and unique features of Sanskrit, Odia, Telugu, Kannada, Tamil, and Malayalam, fostering a deeper appreciation of India’s linguistic heritage.",
      cover: eventReport9,
      link: "/assets/Events/Six day Bhasha Mahotsav.pdf",
    },
    {
      id: 10,
      title: "3-DAY NATIONAL SEMINAR ON SRI AUROBINDO AND SANSKRIT",
      date: "11, 13 November, 2022",
      description: "The three-day National Seminar on Sri Aurobindo and Sanskrit was held from 11–13 November 2022 at Sri Aurobindo Ashram, Delhi Branch. Organized by the Centre for Human Sciences, Rishihood University, in collaboration with several academic and governmental institutions, the seminar formed part of the celebrations of Azadi ka Amrit Mahotsav and the 150th birth anniversary of Sri Aurobindo.\n\nThe seminar brought together scholars, researchers, and practitioners for keynote addresses, plenary sessions, technical paper presentations, Sanskrit poetry recitations, and cultural performances. Through discussions on Sri Aurobindo’s Sanskrit writings, interpretations of the Vedas, Upaniṣads, Gītā, Indian culture, literature, and philosophy, the event highlighted the depth of Sri Aurobindo’s contribution to Sanskrit scholarship and India’s intellectual heritage.",
      cover: eventReport10,
      link: "/assets/Events/Report on National Seminar on Sri Aurobindo and Sanskrit .pdf",
    },
    {
      id: 11,
      title: "The National Seminar on the Herald of the Life Divine",
      date: "26 - 28 May, 2022",
      description: "The three-day National Seminar on The Herald of the Life Divine was organized by the Centre for Human Sciences, Rishihood University, in association with the Indian Council of Philosophical Research (ICPR), from 26–28 May 2022 as part of the 150th birth anniversary celebrations of Sri Aurobindo. The seminar focused on Sri Aurobindo’s magnum opus The Life Divine and brought together eminent scholars, researchers, and practitioners to explore its philosophical, spiritual, educational, and societal dimensions.\n\nThrough keynote lectures, plenary sessions, and research paper presentations, participants engaged with themes such as evolution of consciousness, Integral Yoga, value-based education, spirituality, self-transformation, and the future of humanity. The seminar provided a vibrant platform for interdisciplinary dialogue and deeper engagement with Sri Aurobindo’s vision of the divinization of life and the transformative potential of human consciousness.",
      cover: eventReport11,
      link: "/assets/Events/The National Seminar on the Herald of the Life Divine.pdf",
    },
  ],
  annual: [
    {
      id: 1,
      title: "Integral Humanism Initiative - Annual Report 2025-26",
      date: "2025-26",
      description:
        "Integral Humanism Initiative - Annual Report 2025-26\nThe Integral Humanism Initiative (IHI) Annual Report 2025–26 documents a significant phase in the evolution of the Initiative, marked by a transition from foundational research to large-scale publication, academic outreach, and public engagement. Structured around four key workstreams—Samāyojanam (theoretical frameworks), Saṅkalanam (publications), Samvardhanam (academic engagement), and Samprasāraṇam (digital propagation)—the report showcases efforts to develop robust philosophical frameworks, expand scholarly contributions, and make the principles of Integral Humanism accessible to wider audiences. Key achievements include the development of the BMIS analytical framework, progress on a 200-blog knowledge dissemination project, the creation of the Ekatma Manava Darshana Kośa, publication initiatives, internship-led research, and the compilation of Sanātanadṛṣṭi, a collection of 300 verses reflecting the Sanatana worldview.\n\nThe report also highlights extensive academic participation through conferences, workshops, lectures, research publications, and collaborations with scholars, policymakers, and social leaders. Alongside these activities, the Initiative strengthened its digital presence through social media outreach and public discourse aimed at presenting Integral Humanism as a contemporary framework for addressing social, educational, economic, and cultural challenges. By combining rigorous scholarship, publication efforts, mentorship, and public engagement, the report reflects IHI’s growing role in establishing Integral Humanism as a dynamic and relevant intellectual tradition for the modern world.",
      cover: annualReport1,
      link: "/assets/Annual Report/IHI Annual Report 2025-26.pdf",
    },
    {
      id: 2,
      title: "Integral Humanism Initiative - Annual Report 2024-25",
      date: "2024-25",
      description:
        "Integral Humanism Initiative - Annual Report 2024-25\nThe Integral Humanism Initiative (IHI) Annual Report 2024–25 documents the transition of the Initiative from foundational research to active academic implementation. Building upon the theoretical, empirical, and synthesis phases completed in 2023–24, the report highlights efforts to integrate Integral Humanism into education through structured internship programs, research publications, conferences, glossary development, K–12 educational resources, and the creation of a Postgraduate Diploma in Indian Knowledge Systems. The Initiative focused on translating the philosophy of Pt. Deendayal Upadhyaya into practical pedagogical frameworks, fostering research, content creation, and scholarly engagement among students and educators.\n\nMajor achievements during the year include mentoring interns who produced research articles, e-books, blogs, case studies, and educational games; completing 50 glossary-based blogs on Integral Humanism; organizing an international conference and a roundtable on Indian pedagogy; launching two books; undertaking an ICSSR-supported rural development research project; and advancing K–12 curriculum development rooted in Bharatiya pedagogical principles. The report also outlines future plans such as completing 200 blogs, publishing the Integral Humanism glossary, expanding internship opportunities, developing teacher-training modules, and strengthening awareness programs on Indian Knowledge Systems. Overall, the report reflects IHI’s growing role in creating educational, research, and societal applications of Integral Humanism for contemporary India.",
      cover: annualReport2,
      link: "/assets/Annual Report/ANNUAL REPORT 2024 - 25 (IHI).pdf",
    },
    {
      id: 3,
      title: "Integral Humanism Initiative - Annual Report 2023-24",
      date: "2023-24",
      description:
        "Integral Humanism Initiative - Annual Report 2023-24\nThe Integral Humanism Initiative (IHI) Annual Report 2023–24 presents a comprehensive overview of the initiative’s first year at the Centre for Human Sciences, Rishihood University. Supported by Star Pipe Foundry, Rajkot, the project seeks to explore, document, and apply the principles of Integral Humanism across academic, socio-economic, and corporate domains. Through theoretical research, field studies, scholarly engagement, and pilot implementation activities, the initiative worked to bridge the gap between philosophical ideas and practical applications while promoting values such as Antyodaya, Swalamban, Swadeshi, Sarvodaya, and Vasudhaiva Kutumbakam.\n\nThe report highlights key achievements including field studies in Puducherry, Bengaluru, and Chitrakoot, academic publications, conference presentations, curriculum discussions, community development projects, educational innovations, and the development of resources for schools and higher education. It also outlines the initiative’s future roadmap, which includes creating academic programmes, publishing glossaries and booklets, developing teacher-training modules, expanding research output, and designing educational tools to introduce Integral Humanism and Indian Knowledge Systems to younger generations. Overall, the report reflects the initiative’s effort to build a holistic, value-based framework for education, research, and societal development grounded in Bharatiya thought.",
      cover: annualReport3,
      link: "/assets/Annual Report/ANNUAL REPORT-IHI - 2023-24.pdf",
    },
  ],
};

// Lecture Series for the Lecture Series page
export const lectureSeries = [
  {
    id: 1,
    title: "Distinguished Speaker Series in Indian Philosophy",
    description:
      "A prestigious lecture series featuring eminent philosophers exploring various aspects of classical and contemporary Indian philosophical traditions.",
    upcoming: {
      title:
        "The Relevance of NyÄya Epistemology for Contemporary Philosophy of Science",
      speaker: "Prof. Jonardon Ganeri",
      affiliation: "University of Toronto",
      date: "October 12, 2023",
      time: "5:00 PM - 7:00 PM",
      venue: "Main Auditorium",
      abstract:
        "This lecture will explore how the sophisticated epistemological frameworks developed in the NyÄya tradition can contribute to contemporary discussions in philosophy of science, particularly around questions of scientific realism, theory change, and the social dimensions of scientific knowledge production.",
    },
    past: [
      {
        title:
          "Consciousness Studies: Bridging Classical Indian and Contemporary Approaches",
        speaker: "Prof. Evan Thompson",
        affiliation: "University of British Columbia",
        date: "March 15, 2023",
        image:
          "https://images.unsplash.com/photo-1503428593586-e225b39bddfe?auto=format&fit=crop&w=800&q=80",
      },
      {
        title:
          "Ethics in a Divided World: Insights from Indian Moral Philosophy",
        speaker: "Prof. Arindam Chakrabarti",
        affiliation: "Stony Brook University",
        date: "November 10, 2022",
        image:
          "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=800&q=80",
      },
    ],
  },
  {
    id: 2,
    title: "Cultural Heritage Lecture Series",
    description:
      "A lecture series examining various aspects of tangible and intangible cultural heritage, their preservation, and contemporary relevance.",
    upcoming: {
      title:
        "Living Heritage: Performing Arts Traditions and their Preservation",
      speaker: "Dr. Kapila Vatsyayan",
      affiliation: "India International Centre",
      date: "November 5, 2023",
      time: "4:00 PM - 6:00 PM",
      venue: "Conference Hall",
      abstract:
        "This lecture will examine the challenges and opportunities in preserving performing arts traditions, with special focus on the relationship between documentation, transmission, and living practice in ensuring the continuity of these cultural forms.",
    },
    past: [
      {
        title: "Digital Technologies and Heritage Conservation: New Frontiers",
        speaker: "Prof. Sarah Kenderdine",
        affiliation: "EPFL, Switzerland",
        date: "April 22, 2023",
        image:
          "https://images.unsplash.com/photo-1551285616-d36b31c57b82?auto=format&fit=crop&w=800&q=80",
      },
      {
        title: "Manuscript Traditions and Textual Preservation in South Asia",
        speaker: "Prof. B.N. Goswamy",
        affiliation: "Panjab University",
        date: "February 8, 2023",
        image:
          "https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?auto=format&fit=crop&w=800&q=80",
      },
    ],
  },
  {
    id: 3,
    title: "Contemporary Literature and Society",
    description:
      "A lecture series exploring the relationship between literary expression and social change in contemporary South Asian contexts.",
    upcoming: {
      title:
        "Literary Activism and Social Justice in Contemporary Indian Writing",
      speaker: "Arundhati Roy",
      affiliation: "Author and Activist",
      date: "December 3, 2023",
      time: "6:00 PM - 8:00 PM",
      venue: "Main Auditorium",
      abstract:
        "This lecture will examine the role of literature as a form of social activism, exploring how contemporary Indian writers are engaging with questions of social justice, environmental crisis, and political transformation through their creative work.",
    },
    past: [
      {
        title:
          "Regional Languages and National Narratives in Indian Literature",
        speaker: "Prof. Namwar Singh",
        affiliation: "Jawaharlal Nehru University",
        date: "May 18, 2023",
        image:
          "https://images.unsplash.com/photo-1532153259564-a5f24f254bd6?auto=format&fit=crop&w=800&q=80",
      },
      {
        title: "Digital Media and New Forms of Literary Expression",
        speaker: "Amitav Ghosh",
        affiliation: "Author",
        date: "September 25, 2022",
        image:
          "https://images.unsplash.com/photo-1499951360447-b19be8fe80f5?auto=format&fit=crop&w=800&q=80",
      },
    ],
  },
];

// Media & Gallery content
// Course offerings for the Courses page
export const courseOfferings = [
  {
    id: 1,
    title: "IKS Awareness Course (An Online Certificate Course)",
    description:
      "This certificate course, initiated as part of the IKS Awareness Program for School Children Project, introduces students to the vision of Indian Knowledge Systems through a structured journey across the paÃ±ca koÅ›as - Annamaya, PrÄá¹‡amaya, Manomaya–“VijÃ±Änamaya, and Ä€nandamaya. It presents IKS as a living framework of knowledge, highlighting the interconnectedness of domains such as food, rivers, temples, arts, governance, language, mathematics, and spirituality, rooted in the deeper vision of dharma, puruá¹£Ärtha, and inner evolution.",
    image: iksCourse,
    duration: "40 hours",
    instructor: "Multiple Speakers",
    slug: "iks-awareness-course",
    link: "https://online.rishihood.edu.in/courses/IKS-AC-698eba7f522abf7f621e0f1f",
  },
  {
    id: 2,
    title: "CHANDAS: The Rhythmic Science of Sanskrit Poetry",
    description:
      "This online short certificate course explores Chandas, a fixed and balanced system of the measures of sound, as the ordered measure of the poetic spirit and the foundation of rhythmic movement. The course moves beyond dry rules to reveal how Chandas bridges language with the rhythms of Nature, Music, Mathematics, and the Science of Healing. Ideal for lovers of literature, students of Sanskrit, musicians, and researchers in cognitive sciences seeking to deepen their engagement with the Language of the Gods.",
    image: chandasCourse,
    duration: "8 hours",
    instructor: "Prof. Sampadananda Mishra",
    slug: "chandas-rhythmic-science",
    link: "https://online.rishihood.edu.in/courses/CHANDAS-The-Rhythmic-Science-of-Sanskrit-Poetry-695ce2a4bd9fbf36e15a55de",
  },
  {
    id: 3,
    title: "Understanding Sanskrit Untranslatables",
    description:
      "This online short certificate course offers an in-depth exploration of key Sanskrit terms found in sacred texts such as the Vedas, Upanishads, Gita, Tantra, and Yogic literature. It highlights how these words, rooted in their original sound structures, embody deeper spiritual meanings that cannot be fully captured through translation. This course is ideal for those who wish to explore the beauty, logic, and power of Sanskrit in a way that enhances their understanding of Indian spiritual heritage and its key teachings.",
    image: untranslatablesCourse,
    duration: "16 hours",
    instructor: "Prof. Sampadananda Mishra",
    slug: "sanskrit-untranslatables",
    link: "https://online.rishihood.edu.in/courses/Untranslatable-Sanskrit-Words-Unlocking-the-Wisdom-of-Ancient-Indian-Texts-671b7f1b8e2956428d492ece",
  },
  {
    id: 4,
    title: "Samatvam: Understanding Yogic Equality",
    description:
      "This online short-certificate course introduces learners to the deeper meaning of samatvaá¹ yoga ucyate in the Bhagavad Gita and its application in day-to-day life. The course explores the ideas of Equality (samatva) and Oneness (ekatva) as envisioned by the seers and sages of Bharat, drawing on selected insights from the Vedas, Upanishads, the Gita, and the writings of Sri Aurobindo and the Mother.",
    image: samatvamCourse,
    duration: "6 hours",
    instructor: "Prof. Sampadananda Mishra",
    slug: "yogic-equality",
    link: "https://online.rishihood.edu.in/courses/Understanding-Yogic-Equality--The-Foundation-of-Inner-Progress-663077f36dd46552c99d949d",
  },
  {
    id: 5,
    title: "Samvid: Introduction to the Sacred Texts of Bharat",
    description:
      "This online short-certificate course is designed to introduce learners to the sacred texts of Bharat by delving into the profound wisdom of the Vedas, Upanishads, Gita, epics, and Tantric texts. Gain focused understanding and apply ancient teachings to modern life. Join our transformative online course now and discover how these ancient teachings remain relevant in modern life, guiding us in our daily lives!",
    image: samvidCourse,
    duration: "8 hours",
    instructor: "Prof. Sampadananda Mishra",
    slug: "samvid-sacred-texts",
    link: "https://online.rishihood.edu.in/courses/Introduction-to-the-Sacred-Texts-of-Bharat-642e448ee4b0d1686e7f6c5a",
  },
  {
    id: 6,
    title: "Introduction to Panini and his Ashtadhyayi",
    description:
      "This online short certificate course focuses on the genius of Panini and his work, the Ashtadhyayi. This program introduces Panini and his groundbreaking contributions in a simple and practical way. Whether you're new to Sanskrit or seeking to deepen your understanding, this course is tailored for learners of all levels. Enrol now to understand the fascinating world of Panini's Ashtadhyayi and expand your knowledge!",
    image: paniniCourse,
    duration: "10 hours",
    instructor: "Prof. Sampadananda Mishra",
    slug: "panini-ashtadhyayi",
    link: "https://online.rishihood.edu.in/courses/Introduction-to-Panini-and-his-Ashtadhyayi-63b7f93ee4b0500381f806ca",
  },
  {
    id: 7,
    title: "Mantra Yoga Online Certificate Course",
    description:
      "The Mantra Yoga Online short certificate course is based on ancient mantra chanting practices to awaken the mind and explore primordial sounds. The course offers an experience of alignment with universal consciousness, nurtures affirmative thinking, and embarks on a transformative journey of self-discovery.",
    image: mantraYogaCourse,
    duration: "24 hours",
    instructor: "Prof. Sampadananda Mishra",
    slug: "mantra-yoga",
    link: "https://online.rishihood.edu.in/courses/Mantra-Yoga-626a499c0cf278a7a00ef55b",
  },
  {
    id: 8,
    title: "Sri Aurobindo - The Rishi Of India's Renaissance",
    description:
      "This online certificate course offers a holistic understanding of Sri Aurobindo in just 150 hours! This course is spread over 12 modules, delving into his profound contributions to politics, Indian civilisation, education, arts, literature, consciousness, integral yoga, Vedas, and shastras. Join us to explore his transformative ideas and gain practical solutions for today's challenges.",
    image: aurobindoCourse,
    duration: "150 hours",
    instructor: "Prof. Sampadananda Mishra",
    slug: "sri-aurobindo",
    link: "https://online.rishihood.edu.in/courses/sri-aurobindo-rishi-of-indic-renaissance-course-631b2102e4b02df7a4e4d5c2",
  },
];

// Research areas for the Research page
export const researchAreas = [
  {
    id: 17,
    title: "State-wise Contributions to the Yoga Traditions in India",
    description:
      "The project, State-wise Contributions to the Yoga Tradition in India, aims to document and analyse the diverse regional foundations that have shaped the evolution of yoga across the Indian subcontinent.",
    image: stateWiseYogaProject,
    slug: "state-wise-contributions-yoga-traditions",
    link: "/research-projects/state-wise-contributions-yoga-traditions",
    status: "Ongoing",
    sponsors: ["Haryana State Higher Education Council"],
  },
  {
    id: 10,
    title: "IKS Awareness Program for School Children",
    description:
      "This Program introduces young minds across Bharat to India's civilizational knowledge heritage through workshops, exhibitions, and multilingual resources, reconnecting students, teachers, and parents with timeless Indian Knowledge Systems.",
    image: iksAwarenessProject,
    slug: "iks-awareness-program",
    link: "/research-projects/iks-awareness-program",
    status: "Ongoing",
    sponsors: ["Ms Vandana Govil (NRI, USA)"],
  },
  {
    id: 11,
    title:
      "Effect of Sanskrit Chandas (Metres) on Children with Learning Disabilities",
    description:
      "Examining how the rhythmic precision of Sanskrit Chandas can enhance focus, memory, and emotional balance in children with specific learning disabilities.",
    image: chandasProject,
    slug: "sanskrit-chandas-learning-disabilities",
    link: "/research-projects/sanskrit-chandas-learning-disabilities",
    status: "Ongoing",
    sponsors: ["IKS Division, Ministry of Education, GoI"],
  },
  {
    id: 12,
    title: "Integral Humanism Initiative",
    description:
      "Exploring a holistic vision of humanity by synthesising the profound teachings of Sri Aurobindo, Swami Vivekananda, and Pt. Deendayal Upadhyaya.",
    image: ihiProject,
    slug: "integral-humanism-initiative",
    link: "/research-projects/integral-humanism-initiative",
    status: "Ongoing",
    sponsors: ["Star Pipe Foundry, Rajkot"],
  },
  {
    id: 13,
    title: "Translation - Vashishtha Kavyakatha Ganapati Muni's Works",
    description:
      "This project aims to translate the works of Kavyakanth Vashishtha Ganapati Muni from Sanskrit into English and Hindi, opening new vistas for further research in academia.",
    image: kavyakanth3,
    slug: "ganapati-muni-translation",
    link: "/research-projects/ganapati-muni-translation",
    status: "Ongoing",
    sponsors: ["Vande Matram Library Trust"],
  },
  {
    id: 14,
    title: "Sanskrit Literature for Children",
    description:
      "This project, in collaboration with Central Sanskrit University, New Delhi, under the Ashtadashi Scheme, created ten children's books in Sanskrit aimed at developing stories, rhymes, songs, and playlets.",
    image: slcBanner,
    slug: "sanskrit-literature-children",
    link: "/research-projects/sanskrit-literature-children",
    status: "Completed",
    sponsors: ["Central Sanskrit University, New Delhi"],
  },
  {
    id: 15,
    title: "Avadhanakala and Consciousness Studies",
    description:
      "The Avadhanakala and Consciousness Studies project focused on developing cognitive faculties and included research in Avadhanakala, practical implications of Yogic shastras, and a comparative study of Indian psychology, yoga, and consciousness studies.",
    image: avadhanakalaBanner,
    slug: "avadhanakala-consciousness-studies",
    link: "/research-projects/avadhanakala-consciousness-studies",
    status: "Completed",
    sponsors: [
      "Indian Knowledge Systems (IKS) Division, Ministry of Education, Government of India",
    ],
  },
  {
    id: 16,
    title: "Role of CRPs in Empowering Rural Communities",
    description:
      "Community Resource Persons (CRPs) served as grassroots change-makers, mobilising rural communities and strengthening Self-Help Groups under DAY-NRLM. This study empirically examined their selection, training, autonomy, and impact in Uttar Pradesh.",
    image: crpProjectBanner,
    slug: "crp-empowering-rural-communities",
    link: "/research-projects/crp-empowering-rural-communities",
    status: "Completed",
    sponsors: ["Indian Council of Social Science Research (ICSSR)"],
  },
];

export const mediaGallery = {
  photoGalleries: [
    {
      id: 1,
      title:
        "3rd International Scientific–“Spiritual Practical Conference on Universal Principles and Practices of Integral Education”",
      date: "November 18-20, 2023",
      description:
        "Images from our international conference exploring spiritual and practical dimensions of integral education in modern contexts.",
      images: [
        {
          id: 101,
          src: integralEducation4,
          caption:
            "Inaugural session of the 3rd International Scientific–Spiritual Practical Conference",
        },
        {
          id: 102,
          src: integralEducation1,
          caption: "Group panel discussions during the conference",
        },
        {
          id: 103,
          src: integralEducation2,
          caption: "Key speakers sharing insights on integral practices",
        },
        {
          id: 104,
          src: integralEducation3,
          caption:
            "Participants and delegates interacting in technical sessions",
        },
      ],
    },
    {
      id: 2,
      title:
        "ICPR sponsored World Philosophy Day Lecture Series on Philosophical Contribution of Contemporary Thinkers",
      date: "November 2023",
      description:
        "Lectures and seminars covering the philosophical contributions of contemporary thinkers, sponsored by the Indian Council of Philosophical Research.",
      images: [
        {
          id: 201,
          src: philosophyIntro1,
          caption: "Inaugural ceremony of World Philosophy Day Lecture Series",
        },
        {
          id: 202,
          src: philosophyIntro2,
          caption: "Audience and delegates at the introductory lecture",
        },
        {
          id: 203,
          src: philosophyPresAddress1,
          caption: "Presidential address by esteemed guests",
        },
        {
          id: 204,
          src: philosophyPresAddress2,
          caption: "Honoring guests at the inaugural session",
        },
        {
          id: 205,
          src: philosophyLecture1Img1,
          caption: "Keynote presentation during Session 1",
        },
        {
          id: 206,
          src: philosophyLecture1Img2,
          caption: "Technical panel discussing contemporary Indian thinkers",
        },
        {
          id: 207,
          src: philosophyLecture2Img1,
          caption: "Session 2 guest lecture Q&A",
        },
        {
          id: 208,
          src: philosophyLecture2Img2,
          caption: "Scholars participating in critical debate",
        },
        {
          id: 209,
          src: philosophyLecture3Img1,
          caption: "Session 3 keynote speaker presenting research findings",
        },
        {
          id: 210,
          src: philosophyLecture3Img2,
          caption: "Group discussion on Indian metaphysics",
        },
        {
          id: 211,
          src: philosophyLecture4Img1,
          caption: "Session 4 presentation on moral philosophy",
        },
        {
          id: 212,
          src: philosophyLecture4Img2,
          caption: "Attendees taking notes during lecture series",
        },
        {
          id: 213,
          src: philosophyLecture5Img1,
          caption: "Session 5 session on epistemology",
        },
        {
          id: 214,
          src: philosophyLecture5Img2,
          caption: "Interactive workshop for philosophy learners",
        },
        {
          id: 215,
          src: philosophyLecture5Img3,
          caption: "Closing remarks of Session 5",
        },
        {
          id: 216,
          src: philosophyConcludingImg1,
          caption: "Concluding session and distribution of honors",
        },
        {
          id: 217,
          src: philosophyConcludingImg2,
          caption: "Group photograph of all organizers and guest lecturers",
        },
      ],
    },
    {
      id: 3,
      title:
        "International Conference on Universal-Integral Multilevel Education in the Spirit of the New Age",
      date: "September 2023",
      description:
        "A convergence of educators and thinkers discussing multilevel, holistic education for the modern era.",
      images: [
        {
          id: 301,
          src: universalConfBanner,
          caption: "Universal-Integral Conference Banner",
        },
        {
          id: 302,
          src: universalConf1,
          caption: "Dr. Sampadananda Mishra speaking at the event",
        },
        {
          id: 303,
          src: universalConf2,
          caption: "Eminent speakers sharing their ideas",
        },
        {
          id: 304,
          src: universalConf3,
          caption: "Audience listening to presentation",
        },
        {
          id: 305,
          src: universalConf4,
          caption: "Plenary discussions on multilevel curricula",
        },
        {
          id: 306,
          src: universalConf5,
          caption: "Delegates taking notes during technical sessions",
        },
        {
          id: 307,
          src: universalConf6,
          caption: "Interactive hands-on session on holistic pedagogy",
        },
        {
          id: 308,
          src: universalConf7,
          caption: "Panel discussion on integral science and spiritual science",
        },
        {
          id: 309,
          src: universalConf8,
          caption: "Audience interacting with international speakers",
        },
        {
          id: 310,
          src: universalConf9,
          caption: "Group photo of all conference presenters",
        },
        {
          id: 311,
          src: universalConf10,
          caption: "Closing address by the chief guest",
        },
        {
          id: 312,
          src: universalConf11,
          caption: "Interactive Q&A session with students and researchers",
        },
        {
          id: 313,
          src: universalConf12,
          caption: "Delegates discussing post-conference collaborations",
        },
        {
          id: 314,
          src: universalConf13,
          caption: "Felicitating guest speakers",
        },
        {
          id: 315,
          src: universalConf14,
          caption: "Concluding group picture",
        },
        {
          id: 316,
          src: universalIntegralSub1,
          caption: "Technical session in progress",
        },
        {
          id: 317,
          src: universalIntegralSub2,
          caption: "Session chairs conducting presentations",
        },
        {
          id: 318,
          src: universalIntegralSub16,
          caption: "Special keynote session on inclusive education",
        },
      ],
    },
    {
      id: 4,
      title: "Sri Aurobindo Youth Conference",
      date: "October 12, 2023",
      description:
        "Empowering and inspiring youth to awaken their inner potential through the teachings of Sri Aurobindo.",
      images: [
        {
          id: 401,
          src: youthConfBanner,
          caption:
            "Sri Aurobindo Youth Conference: Inspiring Youth to Awaken the Divine",
        },
        {
          id: 402,
          src: youthConf1,
          caption: "Youth delegates arriving at the conference hall",
        },
        {
          id: 403,
          src: youthConf2,
          caption: "Panel session with young leaders on self-development",
        },
        {
          id: 404,
          src: youthConf3,
          caption: "Group discussions and workshops on integral yoga",
        },
        {
          id: 405,
          src: youthConf4,
          caption: "Participants posing for a group picture at the conclusion",
        },
      ],
    },
    {
      id: 5,
      title: "Avadhāna Saṅgama: Cultivating Cognitive Mastery",
      date: "December 5-6, 2023",
      description:
        "Exploring and demonstrating the ancient art of Avadhana for cognitive and mental enhancement.",
      images: [
        {
          id: 501,
          src: avadhanaSangamaBanner,
          caption: "Inaugural event of Avadhana Sangama",
        },
        {
          id: 502,
          src: avadhanaSangama1,
          caption: "Demonstration of Ashtavadhana by skilled Avadhanis",
        },
        {
          id: 503,
          src: avadhanaSangama2,
          caption: "Audience spellbound by the cognitive feats performed",
        },
      ],
    },
    {
      id: 6,
      title: "Six-Day Bharatiya Bhasha Mahotsav at Rishihood University",
      date: "December 11-16, 2022",
      description:
        "A grand celebration of the rich multilingual heritage of Bharat with lectures, exhibitions, seminars, and student competitions.",
      images: [
        {
          id: 601,
          src: bhashaMahotsavBanner,
          caption: "Bharatiya Bhasha Mahotsav Event Banner",
        },
        {
          id: 602,
          src: bhashaMahotsavIntro,
          caption: "Inaugural ceremony of the six-day festival",
        },
        {
          id: 603,
          src: bhashaImage2,
          caption: "Deep prajjwalan ceremony by Vice Chancellors and guests",
        },
        {
          id: 604,
          src: bhashaImage10,
          caption:
            "Dignitaries addressing the audience on mother tongue learning",
        },
        {
          id: 605,
          src: bhashaImage16,
          caption: "Lecture on the wonders of local Indian languages",
        },
        {
          id: 606,
          src: bhashaImage35,
          caption:
            "Exhibition showcasing Sanskrit names of daily household items",
        },
        {
          id: 607,
          src: bhashaImage49,
          caption: "Traditional folk song and dance performance by students",
        },
        {
          id: 608,
          src: bhashaImage51,
          caption:
            "Drama competition on the theme of local scripts and dialects",
        },
        {
          id: 609,
          src: bhashaImage59,
          caption: "Signature campaign 'Meri Bhasha Meri Pehchaan'",
        },
        {
          id: 610,
          src: bhashaImage63,
          caption: "National seminar on the classical languages of India",
        },
        {
          id: 611,
          src: bhashaImage77,
          caption:
            "Scholars participating in the Odia and Telugu literature panel",
        },
        {
          id: 612,
          src: bhashaImage104,
          caption: "Presentation on Kannada literature history",
        },
        {
          id: 613,
          src: bhashaImage111,
          caption: "Discussion on Sanskrit grammar and teaching methodologies",
        },
        {
          id: 614,
          src: bhashaImage13,
          caption: "Presentation on classical Tamil literature",
        },
        {
          id: 615,
          src: bhashaImage36,
          caption: "Student presentations on regional linguistic identity",
        },
        {
          id: 616,
          src: bhashaImage70,
          caption:
            "Special addresses on sounds, vibration, and nervous system alignment",
        },
        {
          id: 617,
          src: bhashaImage103,
          caption: "Traditional invocation chanted by program learners",
        },
        {
          id: 618,
          src: bhashaImage107,
          caption: "Distribution of awards and participation certificates",
        },
      ],
    },
  ],
  videos: [
    {
      id: 1,
      title:
        "Interview with Dr. Rajesh Mehta: Consciousness Studies in Indian Philosophy",
      date: "August 15, 2023",
      description:
        "An in-depth discussion with our Director on consciousness studies in classical Indian philosophical traditions and their contemporary relevance.",
      thumbnail:
        "https://images.unsplash.com/photo-1569980931877-4ced965a6525?auto=format&fit=crop&w=800&q=80",
      duration: "32:45",
      url: "#",
    },
    {
      id: 2,
      title: "Distinguished Lecture: Ethics for the Digital Age",
      date: "September 30, 2023",
      description:
        "Full recording of Dr. Arun Sharma's distinguished lecture on ethical frameworks for technology governance and digital citizenship.",
      thumbnail:
        "https://images.unsplash.com/photo-1632168557186-3e76d1b92217?auto=format&fit=crop&w=800&q=80",
      duration: "1:15:20",
      url: "#",
    },
    {
      id: 3,
      title:
        "Documentary: Traditional Knowledge Systems and Sustainable Practices",
      date: "June 12, 2023",
      description:
        "A documentary exploring indigenous knowledge systems and their applications for environmental sustainability.",
      thumbnail:
        "https://images.unsplash.com/photo-1601593630408-dd9ea0f237c2?auto=format&fit=crop&w=800&q=80",
      duration: "45:18",
      url: "#",
    },
  ],
  mediaAppearances: [
    {
      id: 1,
      title:
        "Dr. Meera Krishnan on NPR: The Evolution of Narrative Forms in South Asian Literature",
      date: "July 28, 2023",
      medium: "Radio Interview",
      publication: "NPR - All Things Considered",
      description:
        "Dr. Krishnan discusses the transformation of storytelling techniques in contemporary South Asian literature and their cultural significance.",
      link: "#",
    },
    {
      id: 2,
      title:
        "The Times of India: Traditional Knowledge Systems for Modern Challenges",
      date: "August 10, 2023",
      medium: "Newspaper Feature",
      publication: "The Times of India",
      description:
        "A feature article highlighting the Centre's work on integrating traditional knowledge systems with modern approaches to sustainability.",
      link: "#",
    },
    {
      id: 3,
      title: "BBC World Service: Digital Preservation of Cultural Heritage",
      date: "September 5, 2023",
      medium: "Podcast Interview",
      publication: "BBC - The Cultural Frontline",
      description:
        "Dr. Arjun Singh discusses the Centre's initiatives in digital documentation and preservation of cultural heritage artifacts.",
      link: "#",
    },
  ],
};

export const lectureseries = [
  {
    id: 101,
    title:
      "ICPR - Sri Aurobindo's Political and Cultural Philosophy: Nationalism and Swaraj",
    slug: "indian-council-of-philosophical-research",
    image: icprSeriesImage,
  },
  {
    id: 102,
    title: "Ekatma Darshan Series",
    slug: "ekatma-darshan-series",
    image: ekatmaDarshanImage,
  },
  {
    id: 103,
    title: "Avadhanakala",
    slug: "avadhanakala-series",
    image: avadhanakalaImage,
  },
  {
    id: 104,
    title: "Vaicārikī",
    slug: "vaicariki-series",
    image: vaicarikiImage,
  },
];

export const guestlectures = [
  {
    id: 101,
    title: "World Sanskrit Day - Sanskrit for a Joyful Life",
    slug: "sanskrit-for-a-joyful-life",
    name: "Prof. Om Nath Bimali",
    image: omNathBimali,
    date: "August 08, 2026",
    description:
      "On the occasion of World Sanskrit Day, Prof. Om Nath Bimali, H. O. D., Department of Sanskrit, University of Delhi, delivered a lecture on the theme of the celebration - Sukham Jeevan Sanskrit Ashritam (Sanskrit for a Joyful Life).\n\nThe event took place at the Ashok Goel Library on August 08, 2026.",
    videoUrl: "https://www.youtube.com/watch?v=KiEJbcyTIz4",
    speaker: "Prof. Om Nath Bimali",
    speakerTitle: "H. O. D., Department of Sanskrit, University of Delhi",
    duration: "45 minutes",
    topics: [
      "Sanskrit for a Joyful Life",
      "World Sanskrit Day Celebration",
      "Sukham Jeevan Sanskrit Ashritam",
      "Sanskrit and Modern Well-being",
    ],
  },
  {
    id: 102,
    title: "India as a Colonial State: the Crisis of Governance",
    slug: "india-as-a-colonial-state",
    name: "Shri Sankrant Sanu",
    image: sankrantSanu,
    date: "July 24, 2025",
    description:
      "Sankrant Sanu delivered a powerful lecture at Rishihood University, arguing that \"India is Still a Colonial State.\" He details how colonial-era structures persist across India's judiciary, legislature, executive, and education systems. He examines the influence of figures like B.N. Rau in the Constitution's drafting, links corruption to a lack of public accountability, and calls for a revolutionary Right to Legislature (RTL) for direct citizen lawmaking.\n\nThe event was hosted by the Centre for Human Sciences (CHS), Rishihood University, on July 24, 2025, at the Ashok Goel Library.",
    videoUrl: "https://www.youtube.com/watch?v=Qu3KBAz4JVA",
    speaker: "Shri Sankrant Sanu",
    speakerTitle: "Author, Researcher & Entrepreneur",
    duration: "50 minutes",
    topics: [
      "Colonial Persistence in Indian Governance",
      "Judicial and Legislative Reform",
      "Right to Legislature (RTL)",
      "Citizen Lawmaking and Public Accountability",
    ],
  },
  {
    id: 103,
    title: "The Mahabharata: Dialogue, Dharma, and Epistemology",
    slug: "mahabharata-dialogue-dharma-epistemology",
    name: "Dr. Lakshmi Bandlamudi",
    image: lakshmiBandlamudi,
    date: "July 16, 2025",
    description:
      "Dialogic Consciousness, Dharmic Validity, and Epistemological Necessities in Engaging with the Mahabharata.\n\nDr Lakshmi Bandlamudi (Professor of Psychology, CUNY) gave a thought-provoking lecture on the Mahabharata beyond time and theology!\n\nThe event was hosted by the Centre for Human Sciences (CHS), Rishihood University, on July 16, 2025, at the Ashok Goel Library.",
    videoUrl: "https://www.youtube.com/watch?v=5g-wt7VRQC8&t=1s",
    speaker: "Dr. Lakshmi Bandlamudi",
    speakerTitle: "Professor of Psychology, CUNY",
    duration: "55 minutes",
    topics: [
      "Dialogic Consciousness",
      "Dharmic Validity",
      "Epistemological Necessities",
      "Mahabharata beyond time and theology",
    ],
  },
  {
    id: 104,
    title: "Sanskrit: Bridging the Past and Shaping the Future",
    slug: "sanskrit-bridging-past-shaping-future",
    name: "Prof. Oscar Pujol",
    image: oscarPujol,
    date: "August 31, 2023",
    description:
      "The Centre for Human Sciences at Rishihood University was honoured to host an enlightening guest lecture on World Sanskrit Day 2023 by Prof. Oscar Pujol, the esteemed Director of Instituto Cervantes, New Delhi.\n\nProf. Pujol shared his inspiring journey of learning Sanskrit and highlighted the profound importance of preserving the Sanskara, the essence of our rich cultural heritage. Prof. Pujol stressed the undeniable importance of Sanskrit as a bridge between our past and our future. Let's continue to nurture this language, diving into its profound teachings and contributing to the revival of our civilisation's treasures.",
    videoUrl: "https://www.youtube.com/watch?v=2FDKFat2y8A",
    speaker: "Prof. Oscar Pujol",
    speakerTitle: "Director of Instituto Cervantes, New Delhi",
    duration: "45 minutes",
    topics: [
      "Preserving the Sanskara",
      "Sanskrit as a Civilizational Bridge",
      "Personal Journeys in Sanskrit Learning",
      "Revival of Cultural Heritage",
    ],
  },
  {
    id: 105,
    title: "Vasudhaiva Kutumbakam",
    slug: "vasudhaiva-kutumbakam-yoga",
    name: "Swami Taponidhi ji",
    image: taponidhi,
    date: "June 21, 2023",
    description:
      "International Day of Yoga Keynote Address by Swami Taponidhi ji on Vasudhaiva Kutumbakam.\n\nIn this video, Swami Taponidhi takes us through the realms of Yoga in a direct and pragmatic manner. Swamiji shares the foundational values that constitute a Yoga practice for today's seeker –” ranging from the philosophical and esoteric to the practical and essential.\n\nSwami Taponidhi Saraswati was initiated into Poorna Sannyasa by his Guru Swami Niranjanananda Saraswati, the Spiritual Head and Paramacharya of Bihar School of Yoga, in January 2004.",
    videoUrl: "https://www.youtube.com/watch?v=MNKKtTO7vqU",
    speaker: "Swami Taponidhi ji",
    speakerTitle: "Initiated Poorna Sannyasi, Bihar School of Yoga",
    duration: "60 minutes",
    topics: [
      "Vasudhaiva Kutumbakam and Oneness",
      "Yoga Practice for Today's Seeker",
      "Philosophical & Esoteric Realms of Yoga",
      "Bihar School of Yoga Tradition",
    ],
  },
  {
    id: 106,
    title: "Pustak Lokarpane The Rishi Tradition of Bharat",
    slug: "rishi-tradition-of-bharat",
    name: "Dr Sthaneshwar Timalsina & Dr Sampadananda Mishra",
    image: rishiTradition,
    date: "January 08, 2023",
    description:
      "Centre for Human Sciences, in collaboration with The Mythic Society, organised a Special Lecture Program at The Mythic Society, Bengaluru, on 8 January 2023. Sthaneshwar Timalsina graced the occasion and delivered a lecture on the Tantric Knowledge System. Sampadananda Mishra spoke on the á¹šá¹£i Tradition of BhÄrat. On this occasion, the lokÄrpaá¹‡am of the book The Rishi Tradition of Bharat, published by Subbu Publications, was also held.\n\nThe book is now available at: https://subbupublications.com/product/sm1/",
    videoUrl: "",
    bookLink: "https://subbupublications.com/product/sm1/",
    speaker: "Dr Sthaneshwar Timalsina & Dr Sampadananda Mishra",
    speakerTitle: "Scholars & Authors of Indian Knowledge Systems",
    duration: "90 minutes",
    topics: [
      "Tantric Knowledge System",
      "Rishi Tradition of Bharat",
      "Book Lokarpanam",
      "Subbu Publications",
    ],
  },
  {
    id: 107,
    title: "Japan's Rich Aesthetic Culture",
    slug: "japans-rich-aesthetic-culture",
    name: "Nupur Tewari",
    image: nupurTewari,
    date: "August 29, 2022",
    description:
      "A guest talk on Japan's rich aesthetic culture was organised by the Centre for Human Sciences at Rishihood University on 8th July 2022, in which Nupur Tewari ji, Japan's official representative of Hindi Khabar spoke on the beauty and intricacies of the Japanese lifestyle. She spoke extensively on how Japan's culture has essentially been imported from India a long time ago by the propagation of Buddhism and the need for us to learn from that culture. She emphasised religious and cultural harmony in Japan and the role of respecting others as we would like to be respected in bringing about this cultural and social acceptance. She also talked about the problems Japan is facing currently, particularly the high suicide rates, and the ways they can be countered.",
    videoUrl: "",
    speaker: "Nupur Tewari",
    speakerTitle: "Representative of Hindi Khabar, Japan",
    duration: "45 minutes",
    topics: [
      "Japanese Aesthetic Culture",
      "Buddhism and Indo-Japanese Cultural Links",
      "Social Acceptability and Respect",
      "Contemporary Challenges in Modern Japan",
    ],
  },
  {
    id: 108,
    title: "Sākṣātkāra- Heal Thyself",
    slug: "saksatkara-heal-thyself",
    name: "Nitasha Sharma",
    image: nitashaSharma,
    date: "May 10, 2022",
    description:
      "Sākṣātkāra has been exquisitely curated to bring out the importance of pressing the pause button in favour of knowing ourselves better. It gently introduces some concepts and ideas using the science of psychology and the discipline of yoga. Psychology is the study of the mind, and Yoga provides a roadmap for giving our mind the best possible form. Through this hour-and-a-half-long session, we gain insight into some practical ideas from both these fields. Ideas that can work hand in hand in our quest to raise our awareness of who we truly are.",
    videoUrl: "",
    speaker: "Nitasha Sharma",
    speakerTitle:
      "Certified Lifestyle Specialist, Psychologist, Singer & Yoga Teacher",
    duration: "90 minutes",
    topics: [
      "Self-awareness and Personal Reflection",
      "Psychology and the Study of the Mind",
      "Yoga as a Roadmap for Mental Form",
      "Practical Lifestyle Integration",
    ],
  },
];

export const booktalk = [
  {
    id: 1,
    name: "National Selfhood in Science",
    slug: "national-selfhood-in-science",
    author: "Shri J Nandakumar",
    image: nationalSelfhood,
    date: "March 30, 2026",
    description:
      "The Centre for Human Sciences recently hosted a book talk by Shri J. Nandakumar (National Convenor, Prajna Pravah) on his work National Selfhood in Science: A Saga of Struggles by Indian Scientists to Counter Colonial Apartheid.\n\nThe session explored the integrated Indian view of knowledge through ParÄ VidyÄ and AparÄ VidyÄ, highlighting the harmony between science and dharma, as emphasised by Swami Vivekananda.\n\nShri J. Nandakumar reflected on the historical marginalisation of Indian scientists such as Radhanath Sikdar and Bibha Chowdhuri, while calling for a renewed effort to reclaim India's scientific selfhood.\n\nThe event took place at Mini Auditorium, Rishihood University on 30th March, 2026.",
    videoUrl: "https://www.youtube.com/watch?v=X0JZk-4Cnis",
    speaker: "Shri J Nandakumar",
    speakerTitle: "National Convenor, Prajna Pravah",
    duration: "60 minutes",
    topics: [
      "ParÄ VidyÄ and AparÄ VidyÄ",
      "Harmony between Science and Dharma",
      "Struggles by Indian Scientists",
      "Countering Colonial Apartheid",
      "Reclaiming India's Scientific Selfhood",
    ],
  },
  {
    id: 2,
    name: "Living the Vivekananda Way - Dr. Ananya Awasthi",
    slug: "living-the-vivekananda-way-ananya-awasthi",
    author: "Dr. Ananya Awasthi",
    image: ananyaAwasthi,
    date: "November 19, 2025",
    description:
      "Living the Vivekananda Way by Dr Ananya Awasthi\n\nThe Centre for Human Sciences recently hosted a book talk on Living the Vivekananda Way: Practical Spirituality for Modern India, co-authored by Dr Ananya Awasthi and Dr Nikhil Yadav.\n\nThe discussion was held in honour of Shri Eknath Ranade, eminent RSS leader and founder of Vivekananda Rock Memorial and the Vivekananda Kendra. He was instrumental in bringing Vivekananda's message to modern India.\n\nDr Ananya Awasthi, a Public-health expert and Founder-Director of Anuvaad, spoke about the vision behind Anuvaad Solutions and how their work bridges research, policy, and community awareness in the fields of health and nutrition.\n\nThe event took place at the Ashok Goel Library on 19th November, 2025.",
    videoUrl: "https://www.youtube.com/watch?v=ymsv67PrMdw",
    speaker: "Dr. Ananya Awasthi",
    speakerTitle: "Public-health Expert & Founder-Director, Anuvaad",
    duration: "50 minutes",
    topics: [
      "Living the Vivekananda Way",
      "Practical Spirituality for Modern India",
      "Eknath Ranade and Vivekananda Rock Memorial",
      "Health, Nutrition & Community Policy",
    ],
  },
  {
    id: 3,
    name: "Living the Vivekananda Way - Dr. Nikhil Yadav",
    slug: "living-the-vivekananda-way-nikhil-yadav",
    author: "Dr Nikhil Yadav",
    image: nikhilYadav,
    date: "November 19, 2025",
    description:
      "Living the Vivekananda Way by Dr Nikhil Yadav\n\nThe Centre for Human Sciences recently hosted a book talk on Living the Vivekananda Way: Practical Spirituality for Modern India, co-authored by Dr Ananya Awasthi and Dr Nikhil Yadav.\n\nThe discussion was held in honour of Shri Eknath Ranade, eminent RSS leader and founder of Vivekananda Rock Memorial and the Vivekananda Kendra. He was instrumental in bringing Vivekananda's message to modern India.\n\nDr Nikhil Yadav, author, PhD (JNU), Deputy Head, Vivekananda Kendra (Uttar Prant) and a youth empowerment leader, reflected on the deep spiritual and cultural foundations of Vivekananda's message, especially the role of strength, fearlessness, and national reconstruction.\n\nThe event took place at the Ashok Goel Library on 19th November, 2025.",
    videoUrl: "https://www.youtube.com/watch?v=ymsv67PrMdw",
    speaker: "Dr Nikhil Yadav",
    speakerTitle: "PhD (JNU), Deputy Head, Vivekananda Kendra (Uttar Prant)",
    duration: "50 minutes",
    topics: [
      "Living the Vivekananda Way",
      "Practical Spirituality for Modern India",
      "Eknath Ranade and Vivekananda Rock Memorial",
      "Strength, Fearlessness & National Reconstruction",
    ],
  },
  {
    id: 4,
    name: "A Zigzag Mind",
    slug: "a-zigzag-mind",
    author: "Dr. Sonal Mansingh",
    image: sonalMansingh,
    date: "November 18, 2025",
    description:
      "A Zigzag Mind by Dr Sonal Mansingh (Padma Vibhushan Awardee)\n\nThe Centre for Human Sciences recently hosted a book talk on A Zigzag Mind, authored by Dr Sonal Mansingh (Padma Vibhushan Awardee).\n\nOne of India's foremost cultural icons, Dr Mansingh, spoke about the nature of a student's mind - its distractions, its potential, and the discipline needed to refine it. She encouraged the students to cultivate attentiveness, self-discipline, and purpose.\n\nThe event took place at the Main Auditorium, Rishihood University on 18th November, 2025.",
    videoUrl: "https://www.youtube.com/watch?v=YLn-dqkoArI&t=22s",
    speaker: "Dr. Sonal Mansingh",
    speakerTitle: "Padma Vibhushan Awardee & Foremost Cultural Icon",
    duration: "45 minutes",
    topics: [
      "Nature of a Student's Mind",
      "Cultivating Attentiveness and Purpose",
      "Self-discipline and Self-refinement",
      "Discipline in Arts and Life",
    ],
  },
  {
    id: 5,
    name: "The Myth Busted",
    slug: "the-myth-busted",
    author: "Shefali Kashyap",
    image: shefaliKashyap,
    date: "September 12, 2025",
    description:
      "The Myth Busted by Shefali Kashyap\n\nThe Centre for Human Sciences recently hosted a book talk on The Myth Busted: Women in RSS & Sisterhood in Saffron, authored by social and political activist Shefali Kashyap.\n\nThe author challenged misconceptions about women in the RSS/Rashtra Sevika Samiti, traced their roles in the freedom struggles and social service, and highlighted how the Sevika Samiti builds women's leadership on civilizational values.\n\nThe event took place at the Ashok Goel Library on 12th September, 2025.",
    videoUrl: "https://www.youtube.com/watch?v=_q6Y-_9jHiI",
    speaker: "Shefali Kashyap",
    speakerTitle: "Social and Political Activist & Author",
    duration: "40 minutes",
    topics: [
      "Women in RSS & Sisterhood in Saffron",
      "Rashtra Sevika Samiti History",
      "Women in Freedom Struggle & Social Service",
      "Leadership on Civilizational Values",
    ],
  },
  {
    id: 6,
    name: "Land of Pathshalas",
    slug: "land-of-pathshalas",
    author: "Dr. Ankur Kakkar",
    image: ankurKakkar,
    date: "August 06, 2025",
    description:
      "Land of Pathshalas: A Story of Indigenous Indian Education by Dr Ankur Kakkar\n\nDr Ankur Kakkar, PhD (Heidelberg University) & Associate Professor at Indus University, Ahmedabad, delivered a keynote on his book Land of Pathshalas. He re-examined precolonial Indian education systems, blending history, data, and indigenous perspectives.\n\nHe showed how pathshalas were not just formal schools but community learning spaces, that colonial narratives mischaracterised Indian education, and that archival data reveals inclusive practices across castes, regions, genders, and even women's training in arts and professions.\n\nThe event was hosted by the Centre for Human Sciences (CHS) at Rishihood University on August 6, 2025, at the Ashok Goel Library.",
    videoUrl: "https://www.youtube.com/watch?v=jxvzqZVXGHs",
    speaker: "Dr. Ankur Kakkar",
    speakerTitle:
      "PhD (Heidelberg University) & Associate Professor, Indus University",
    duration: "50 minutes",
    topics: [
      "Indigenous Indian Education",
      "Precolonial Pathshalas & Learning Spaces",
      "Deconstructing Colonial Narratives",
      "Archival Education Data and Inclusivity",
    ],
  },
  {
    id: 7,
    name: "SHE The King: Rise of Lokmata Ahilyabai Holkar",
    slug: "she-the-king-ahilyabai-holkar",
    author: "Dr. Aditi Narayani",
    image: sheTheKing,
    date: "June 10, 2026",
    description:
      "SHE The King - The Rise of Lokmata Ahilyabai Holkar by Dr Aditi Narayani\n\nAs we mark the 300th birth anniversary of one of India's most visionary rulers, the Centre for Human Sciences hosted a thought-provoking book talk by Dr. Aditi Narayani on ð’ð¡ðž - ð“ð¡ðž ðŠð¢ð§ð : ð‘ð¢ð¬ðž ð¨ðŸ ð‹ð¨ð¤ð¦ðšð­ðš ð€ð¡ð¢ð¥ð²ðšð›ðšð¢ ð‡ð¨ð¥ð¤ðšð«.\n\nThrough her powerful narrative, Dr Narayani, a renowned sociologist, public intellectual, and commentator, illuminates the extraordinary life and legacy of Ahilyabai Holkar: the philosopher queen, the reformer, and the matriarch of justice.\n\nFrom personal tragedies to a historic reign, Rani Ahilyabai defied norms, upheld dharma, championed inclusive governance, empowered the marginalised, and transformed Malwa into a beacon of peace, prosperity, and spirituality.\n\nThe talk captures her enduring contributions: judicial reforms, economic revival, temple restoration, and the famed Maheshwari saris, and how her legacy continues to inspire leadership with compassion.",
    videoUrl: "https://www.youtube.com/watch?v=rgToOmQuA1A&t=2s",
    speaker: "Dr. Aditi Narayani",
    speakerTitle: "Renowned Sociologist, Public Intellectual & Author",
    duration: "55 minutes",
    topics: [
      "Ahilyabai Holkar: The Philosopher Queen",
      "Inclusive Governance & Empowerment",
      "Dharmic Reign & Temple Restorations",
      "Malwa's Economic Revival & Maheshwari Saris",
    ],
  },
  {
    id: 8,
    name: "Integral Humanism: Jacques Maritain & Deendayal Upadhyaya",
    slug: "integral-humanism-sonu-trivedi",
    author: "Dr. Sonu Trivedi",
    image: sonuTrivedi,
    date: "June 02, 2025",
    description:
      "Integral Humanism: Perspectives of Deendayal Upadhyay and Jacques Maritain by Dr Sonu Trivedi\n\nDr Sonu Trivedi (Associate Professor, Zakir Hussain Delhi College) spoke on her edited book titled Integral Humanism: Perspectives of Deendayal Upadhyay and Jacques Maritain. The articles in the book offer a comparative analysis of Jacques Maritain's and Deendayal Upadhyaya's visions of Integral Humanism, showing how both thinkers, despite their differing traditions, converge on an Integral Humanism rooted in human dignity and natural law. She highlights their shared rejection of Western ideological models and emphasises the cultural foundations of their philosophies.\n\nThe book was unveiled at the Ashok Goel Library, Rishihood University, on 2nd June, 2025.",
    videoUrl: "https://www.youtube.com/watch?v=qSfOEeR4xwA",
    speaker: "Dr. Sonu Trivedi",
    speakerTitle: "Associate Professor, Zakir Hussain Delhi College",
    duration: "45 minutes",
    topics: [
      "Jacques Maritain and Deendayal Upadhyaya",
      "Comparative Visions of Integral Humanism",
      "Human Dignity and Natural Law",
      "Rejection of Western Ideological Models",
    ],
  },
  {
    id: 9,
    name: "Integral Humanism: Perspectives of Deendayal ji & Jacques Maritain",
    slug: "integral-humanism-come-carpentier",
    author: "CÃ´me Carpentier de Gourdon",
    image: comeCarpentier,
    date: "June 02, 2025",
    description:
      "Integral Humanism: Perspectives of Deendayal ji & Jacques Maritain - CÃ´me Carpentier de Gourdon\n\nCÃ´me Carpentier de Gourdon (Distinguished fellow, India Foundation), panellist at the book talk, traces the evolution of humanism from its Western rationalist roots to Deendayal Upadhyaya's spiritually grounded Ekaatm Manav Darshan, highlighting dharma as India's guiding principle. He urges a shift in discourse toward emerging ideas like transhumanism, positioning it as a vital challenge for contemporary thought.\n\nThe book was unveiled at the Ashok Goel Library, Rishihood University, on 2nd June, 2025.",
    videoUrl: "https://www.youtube.com/watch?v=qSfOEeR4xwA",
    speaker: "CÃ´me Carpentier de Gourdon",
    speakerTitle: "Distinguished Fellow, India Foundation & Panellist",
    duration: "45 minutes",
    topics: [
      "Evolution of Humanism from Western Rationalism",
      "Ekaatm Manav Darshan & Spiritually Grounded Humanism",
      "Dharma as India's Guiding Principle",
      "Transhumanism and Contemporary Thought Challenges",
    ],
  },
  {
    id: 10,
    name: "Broken Promises: Caste, Crime, and Politics in Bihar",
    slug: "broken-promises-bihar",
    author: "Mrityunjay Sharma",
    image: brokenPromises,
    date: "February 20, 2025",
    description:
      "Broken Promises: Caste, Crime, and Politics in Bihar by Mrityunjay Sharma\n\nIn this insightful discussion, author Mrityunjay Sharma talks about his book Broken Promises: Caste, Crime and Politics in Bihar. He shares real stories and sharp insights on how caste and politics are deeply connected in Bihar–”and how these issues still affect lives today.\n\nThis session was organised by the Rishihood Foundation Program in collaboration with the Centre for Human Sciences and the Ashok Goel Library at Rishihood University. It's a must-watch for anyone interested in understanding the real challenges behind India's political and social systems.",
    videoUrl: "https://www.youtube.com/watch?v=bmE5YdRmkZs",
    speaker: "Mrityunjay Sharma",
    speakerTitle: "Author & Political Analyst",
    duration: "50 minutes",
    topics: [
      "Broken Promises: Caste, Crime & Politics in Bihar",
      "Deep Connections of Caste and Politics",
      "Rishihood Foundation Program Collaboration",
      "Political and Social Challenges in Bihar",
    ],
  },
  {
    id: 11,
    name: "Aryaa - An Anthology of Vedic Women",
    slug: "aryaa-vedic-women",
    author: "Shivakumar GV",
    image: aryaaVedicWomen,
    date: "August 18, 2024",
    description:
      "Aryaa - An Anthology of Vedic Women by Shivakumar GV\n\nWhat goes into the conceptualisation of such content? What does it take to write historical stories accurately? How can art, history and writing play a more important role in shaping our collective future? –” if you have similar questions in your mind, do watch this video with the curator of the new anthology and collection of stories on Vedic women, Aryaa.",
    videoUrl: "https://www.youtube.com/watch?v=85u9ASM4tys",
    speaker: "Shivakumar GV",
    speakerTitle: "Curator & Author, Aryaa Anthology",
    duration: "60 minutes",
    topics: [
      "Conceptualisation of Vedic Content",
      "Writing Historical Stories Accurately",
      "Art, History, and Civilizational Future",
      "Aryaa: Anthology of Vedic Women",
    ],
  },
];

// Offerings for the Offerings page
export const offerings = [
  {
    id: 1,
    title: "IKS Course Design",
    slug: "iks-course-design",
    description:
      "Comprehensive design and development of Indian Knowledge Systems (IKS) based courses that integrate traditional wisdom with modern pedagogical approaches.",
    image: O3,
    category: "Course Development",
    features: [
      "Curriculum design based on classical Indian texts",
      "Integration of traditional and modern teaching methods",
      "Multimedia content development",
      "Assessment frameworks aligned with IKS principles",
    ],
    samples: [
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=400&q=80",
      "https://images.unsplash.com/photo-1470115636492-6d2b56f9146d?auto=format&fit=crop&w=400&q=80",
      "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=400&q=80",
    ],
    contactEmail: "iks-courses@rishihood.edu.in",
  },
  {
    id: 2,
    title: "IKS Content Development",
    slug: "iks-content-development",
    description:
      "Creation of high-quality educational content rooted in Indian Knowledge Systems, including textbooks, digital materials, and multimedia resources.",
    image: O2,
    category: "Content Creation",
    features: [
      "Textbook development with IKS perspective",
      "Digital learning materials and e-books",
      "Video lectures and multimedia content",
      "Interactive learning modules",
    ],
    samples: [
      "https://images.unsplash.com/photo-1470115636492-6d2b56f9146d?auto=format&fit=crop&w=400&q=80",
      "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=400&q=80",
      "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?auto=format&fit=crop&w=400&q=80",
    ],
    contactEmail: "content-dev@rishihood.edu.in",
  },
  {
    id: 3,
    title: "IKS Based Faculty Development Program (FDP)",
    slug: "iks-faculty-development-program",
    description:
      "Comprehensive faculty development programs designed to enhance teaching capabilities in Indian Knowledge Systems and traditional wisdom.",
    image: O1,
    category: "Training Programs",
    features: [
      "Intensive workshops on IKS methodologies",
      "Pedagogical training for traditional knowledge",
      "Research methodology in IKS",
      "Certification programs for educators",
    ],
    samples: [
      "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=400&q=80",
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=400&q=80",
      "https://images.unsplash.com/photo-1470115636492-6d2b56f9146d?auto=format&fit=crop&w=400&q=80",
    ],
    contactEmail: "fdp@rishihood.edu.in",
  },
  {
    id: 4,
    title: "IKS Wall Design",
    slug: "iks-wall-design",
    description:
      "Creative design and implementation of educational wall displays that showcase Indian Knowledge Systems in institutional spaces.",
    image: O6,
    category: "Visual Design",
    features: [
      "Interactive wall displays",
      "Traditional art integration",
      "Multilingual content presentation",
      "Cultural heritage visualization",
    ],
    samples: [
      "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?auto=format&fit=crop&w=400&q=80",
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=400&q=80",
      "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=400&q=80",
    ],
    contactEmail: "design@rishihood.edu.in",
  },
  {
    id: 5,
    title: "IKS Educational Posters",
    slug: "iks-educational-posters",
    description:
      "Design and production of educational posters that effectively communicate complex IKS concepts through visual storytelling.",
    image: O4,
    category: "Visual Design",
    features: [
      "High-quality poster design",
      "Bilingual content (English & Sanskrit/Hindi)",
      "Scientific accuracy in visual representation",
      "Print-ready formats",
    ],
    samples: [
      "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=400&q=80",
      "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?auto=format&fit=crop&w=400&q=80",
      "https://images.unsplash.com/photo-1470115636492-6d2b56f9146d?auto=format&fit=crop&w=400&q=80",
    ],
    contactEmail: "posters@rishihood.edu.in",
  },
  {
    id: 6,
    title: "IKS Research Consultancy",
    slug: "iks-research-consultancy",
    description:
      "Expert consultancy services for research projects involving Indian Knowledge Systems, traditional wisdom, and interdisciplinary studies.",
    image: O5,
    category: "Research Services",
    features: [
      "Research methodology guidance",
      "Literature review and analysis",
      "Data interpretation and validation",
      "Publication support and review",
    ],
    samples: [
      "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?auto=format&fit=crop&w=400&q=80",
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=400&q=80",
      "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=400&q=80",
    ],
    contactEmail: "research@rishihood.edu.in",
  },
];

export const lectureseriesDetails: Record<string, any> = {
  "indian-council-of-philosophical-research": {
    title:
      "ICPR - Sri Aurobindo's Political and Cultural Philosophy: Nationalism and Swaraj",
    description:
      "The Centre for Human Sciences, Rishihood University, inaugurated an Indian Council of Philosophical Research (ICPR)-sponsored series of lectures on 'Sri Aurobindo's Political and Cultural Philosophy: Nationalism and Swaraj' at the Bharatiya Vidya Bhavan, New Delhi, to celebrate the 150th birth anniversary of Sri Aurobindo. It was a grand event that also marked 'Azadi ka Amrit Mahotsav' in India's 75th year of Independence.",
    inauguralVideo: "https://www.youtube.com/watch?v=eRpjWOgzM5E",
    inauguralDescription:
      "The occasion was graced by Minister of State for Culture and External Affairs Meenakshi Lekhi as the Chief Guest; Dr. Sachidananda Mishra, member-secretary of the ICPR was the special guest; Dr. Makarand Paranjape, professor at JNU and former director, IIAS, was the chief speaker and Dr. Sampadananda Mishra, director, Centre for Human Sciences at Rishihood University, was the convener. The message of Dr Ashok Pradhan, director, Bharatiya Vidya Bhavan, New Delhi, was read out by Professor Shashibala, Dean, Centre for Indology, BVB, New Delhi. RK Mishra, Registrar, BVB, New Delhi, also spoke on the occasion.\n\nThe speakers set the context by emphasizing the need for achieving independence of mind and thought as a prerequisite for being truly independent and explained how Sri Aurobindo's philosophy leads us in that direction.\n\nThe first lecture was delivered by Dr Makarand Paranjape, Professor at JNU and former Director, IIAS.",
    chiefSpeaker: {
      name: "Dr. Makarand Paranjape",
      role: "Professor, JNU and Former Director, IIAS",
      quote:
        "Sri Aurobindo's vision of nationalism transcends the conventional understanding. It is rooted in a spiritual understanding of India's destiny and the evolution of human consciousness.",
      videoUrl: "https://www.youtube.com/watch?v=eRpjWOgzM5E",
    },
    lectures: [
      {
        id: 1,
        title: "Sri Aurobindo's Idea of Swaraj: Towards A New India",
        objectives:
          "To understand the essence of Swarajya in Sri Aurobindo's perspective. To understand the value of Swarajya during the freedom struggle. To understand the importance of Swarajya in the New World. To discuss to what extent Swarajya has been achieved.",
        outcomes:
          "Understanding of the concept of Swaraj in personal as well as political spaces. To have mastery over our environment and circumstances. Figuring out a way to attain poorna Swarajya so that New India can prosper.",
        facilitator: "Dr. Makarand Paranjape",
        date: "12th August 2022",
        link: "https://www.youtube.com/watch?v=eRpjWOgzM5E",
      },
      {
        id: 2,
        title:
          "Sri Aurobindo's Thoughts on Education as Foundation for Indian Nationalism",
        objectives:
          "To provide a holistic education, that is integral, immersive, and interdisciplinary on the lines of Sri Aurobindo's three principles of education. Inculcating self-awareness based on the idea of knowing one's swabhava and swadharma. To cultivate the value of nationalism through education.",
        outcomes:
          "Self-aware nationalists in society walk on the path of Dharma. Providing solutions to the crisis of the modern world. The reservoir of knowledge in Sanskrit is to be applied in every stream of knowledge for holistic development.",
        facilitator: "Dr. Priya M Vaidya",
        date: "19th October 2022",
        link: "https://www.youtube.com/watch?v=ZxN6lnQ9lQ8",
      },
      {
        id: 3,
        title: "Sri Aurobindo's Vision for India and the World",
        objectives:
          "To have an understanding of India's domestic needs, International issues and India's cultural and material exchange with the world. To understand India's identity and importance in the Global context. To understand how to curtail division and preserve unity.",
        outcomes:
          "Inculcation of pride for India among citizens. Increment in India's potential. To have a society where unity is cherished and fanaticism is discouraged. Growth in India's potential leads to the growth of the entire world.",
        facilitator: "Shri Devdip Ganguli",
        date: "30th October 2022",
        link: "https://www.youtube.com/watch?v=-S3tSG-ejyg",
      },
      {
        id: 4,
        title: "Sri Aurobindo's Idea of Nationalism and the Quest for Freedom",
        objectives:
          "To understand what nationalism means in the Indian (Dharmic) context and how it is different from the European enlightenment view. To understand what constitutes Indian nationalism amidst linguistic, religious, and customary differences.",
        outcomes:
          "The realization that Nationalism is not equivalent to mono-culturalism. Inculcation of the spirit of Nationalism based on Sanatana principles in the context of Sri Aurobindo's thoughts.",
        facilitator: "Dr. Ramesh Bijlani",
        date: "20th November 2022",
        link: "https://www.youtube.com/watch?v=XSWZdFIjYh4",
      },
      {
        id: 5,
        title: "Sri Aurobindo - The Prophet of India's Nationalism",
        objectives:
          "To have a proper understanding of Sri Aurobindo's thoughts on Indian nationalism. To understand the contributions of Sri Aurobindo concerning the Indian freedom struggle. To understand the significance of Sri Aurobindo's philosophy in nationalism.",
        outcomes:
          "Understanding of Sri Aurobindo's philosophy of Nationalism. Understanding of how Sri Aurobindo is the prophet of India's Nationalism. Creation of a society with a strong nationalistic fervor based on Sri Aurobindo's philosophy.",
        facilitator: "Mohit Bansal",
        date: "18th December 2022",
        link: "https://www.youtube.com/watch?v=BW5a9BF3iQo",
      },
      {
        id: 6,
        title: "The Idea of Indianness: A Necessity for Nation-Building",
        objectives:
          "To understand the Idea of India in the context of Sri Aurobindo's philosophy. To understand how the dharmic concept of a nation is different from the Western concept. To understand why dharma should be the backbone of Indian nationalism.",
        outcomes:
          "Cultivation of nationalistic sentiment based on the concept of dharma. Understanding that the concept of dharma is enough to unify the whole world as one nation irrespective of race, caste, creed, gender, language, ethnicity, etc.",
        facilitator: "Dr. Aparna Roy",
        date: "26th March 2023",
        link: "https://www.youtube.com/watch?v=a0hkgGkhViE",
      },
      {
        id: 7,
        title:
          "Sri Aurobindo's Social Philosophy: Imperatives for Vasudhaiva Kutumbaka",
        objectives:
          "To examine issues, challenges, and problems of societal life –“ inter-group harmony, religious divide, caste, gender, education, social reform, etc. To discuss the social philosophy of Sri Aurobindo and its influences on a diverse Indian society.",
        outcomes:
          "The understanding that the individual and society are two manifestations or expressions of the same Spirit or the Divine. Inculcation of the spirit of brotherhood amongst all beings.",
        facilitator: "Prof. Michel Danino",
        date: "6th June 2023",
        link: "https://www.youtube.com/watch?v=c9-FoU1LLPM",
      },
      {
        id: 8,
        title:
          "Sri Aurobindo's Political Vedantism: A Guide for 'Ek Bharat, Shrestha Bharat'",
        objectives:
          "To divest politics from its negative connotations. To infuse politics with Vedantic ideas. To reconcile ethical human conduct in political life with the philosophy of Vedantic knowledge as laid down in our Upanishads and Sri Bhagavad Gita.",
        outcomes:
          "Politically aware citizens derive their inspiration from the spirit of Vedanta. The fusion of Dharmic ideals with politics will naturally lead to a reduction in crime, illicit money, dominance of muscle power, and corruption.",
        facilitator: "Prof. Sudhir Kumar",
        date: "12th June 2023",
        link: "https://www.youtube.com/watch?v=x5yqI8g23cE",
      },
      {
        id: 9,
        title:
          "Swachhta in Polity: Sri Aurobindo's Primer for Spiritualism the Politics",
        objectives:
          "To understand the need for fair play in politics in the context of Sri Aurobindo's philosophy. To understand Sri Aurobindo's political philosophy in detail and how it can be used to purify Indian polity.",
        outcomes:
          "A political landscape free of crime and corruption. Individuals in the political landscape who are spiritually motivated and who are for the betterment of the nation and always put the nation before the self.",
        facilitator: "Dr. Lakshmi Bandlamundi",
        date: "24th July 2023",
        link: "https://www.youtube.com/watch?v=TEIwX82oDuY",
      },
      {
        id: 10,
        title:
          "Sri Aurobindo on Indian Culture: The Bedrock of Atmanirbhar Bharat",
        objectives:
          "To understand India's true potential. To understand the need for self-sufficiency. To realize how Indian culture acts as a strong base for a self-sufficient society. To take inspiration from India's past to become Atmanirbhar.",
        outcomes:
          "Realization of the need to be self-sufficient, both as individuals as well as a society and a nation. Inculcation of strong cultural values in Individuals will make a strong society.",
        facilitator: "Shri M.S. Chaitra",
        date: "24th July 2023",
        link: "https://www.youtube.com/watch?v=8mhB9TI3ffg",
      },
    ],
  },
  "ekatma-darshan-series": {
    title: "Ekatma Darshan Series",
    description:
      "The Ekatma Darśana Series was launched by the Centre for Human Sciences at Rishihood University as part of the Integral Humanism Initiative Project. The series aims to foster deeper engagement with the philosophy of Integral Humanism and its relevance to contemporary social, cultural, economic, and national challenges through lectures, discussions, and academic interactions. The series began on 25 September 2023 with a special lecture commemorating the 107th birth anniversary of Deendayal Upadhyaya.",
    lectures: [
      {
        id: 1,
        title: "Ekatma Manav Darsan",
        speaker: "Dr Mahesh Chandra Sharma",
        speakerDesignation:
          "Chairman of the Research & Development Foundation for Integral Humanism",
        description:
          'The lecture, "Ekatma Manav Darsan," presented by Dr Mahesh Chandra Sharma ji, shed light on the core principles of integral humanism, the individual\'s place within society, and the journey toward shared well-being. This lecture was organised by the Centre for Human Sciences in collaboration with the Ashok Goel Library at Rishihood University.',
        link: "https://www.youtube.com/watch?v=eNcYWbAnijo",
      },
      {
        id: 2,
        title: "Integral Humanism - Survival of the Weakest",
        speaker: "Shri Deepak Sharma",
        speakerDesignation:
          "Member of the Central Working Committee, in charge of Delhi; All India Associate Head of Treasury, Swadeshi Jagaran Manch",
        description:
          "This lecture delved into the roadmap to Swawlambi Bharat.",
        link: "https://www.youtube.com/watch?v=ThIy4ftwkrI",
      },
      {
        id: 3,
        title:
          "Interdisciplinary Perspectives on Generative AI and the Technological Singularity",
        speaker: "Shri Pankaj Upadhyay",
        speakerDesignation:
          "Director (India and Middle East) at Bricpoint Capital, UK",
        description:
          "Delving into existential reflections inspired by art, philosophy, quantum physics, and neurology, Shri Upadhyay navigates through the complexities of humanism and its role in the face of global challenges. From questioning the origins of human propensities to examining the ethical considerations of generative AI, the lecture provides a thought-provoking exploration of the intersection of art, science, and technology.",
        link: "https://www.youtube.com/watch?v=e1b7JKVytKE",
      },
    ],
  },
  "avadhanakala-series": {
    title: "Avadhanakala",
    description:
      'This lecture series is a part of the research project titled "Avadhanakala and Consciousness Studies" granted to the Centre for Human Sciences, Rishihood University, by the Indian Knowledge System Division of the Ministry of Education, Government of India.',
    lectures: [
      {
        id: 1,
        title: "An Introduction to Avadhanam",
        speaker: "Prof. Sampadananda Mishra",
        speakerDesignation:
          "Director of Centre for Human Sciences at Rishihood University, Sonipat, Haryana",
        link: "https://www.youtube.com/watch?v=p3nGMG7oAqc",
      },
      {
        id: 2,
        title: "Avadhana in Jain Tradition",
        speaker: "Mrs Surbhi Bhagat",
        speakerDesignation: "Founder of Uttam Garbh Sanskar, Gurugram",
        link: "https://www.youtube.com/watch?v=KGaFmPJXZkM",
      },
      {
        id: 3,
        title: "Nisedhaksari and Dattapadi",
        speaker: "Dr Ramakrishna Pejathaya",
        speakerDesignation:
          "Associate Professor in the Centre for Indian Knowledge Systems at Chanakya University",
        link: "https://www.youtube.com/watch?v=zFOnyAGxYts",
      },
      {
        id: 4,
        title: "Samasyaa - Poorana",
        speaker: "Shri Arjun Bhardwaj",
        speakerDesignation: "Contributing Editor at Prekshaa, Bengaluru",
        link: "https://www.youtube.com/watch?v=NxUCY96KMtM",
      },
      {
        id: 5,
        title: "History of Avadhana from Vedic Period to Medieval Times",
        speaker: "Prof. Radhavallabh Tripathi",
        speakerDesignation: "Renowned poet, playwright, critic and translator",
        link: "https://www.youtube.com/watch?v=ds8mVJ4Tm7Y",
      },
      {
        id: 6,
        title:
          "Exploring Avadhana: A Psychological Perspective on Exceptional Cognitive Abilities",
        speaker: "Dr. S Vaishnavii",
        speakerDesignation:
          "Assistant Professor at the Department of Education, National Sanskrit University, Tirupati",
        link: "https://www.youtube.com/watch?v=-wVCjDarkTI",
      },
      {
        id: 7,
        title: "Objectives and Outcomes of Avadhanam",
        speaker: "Shri Shashi Kiran BN",
        speakerDesignation: "Contributing editor at Prekshaa, Bengaluru",
        link: "https://www.youtube.com/watch?v=iVYIAQrezsk",
      },
      {
        id: 8,
        title: "Gitavadhanam - Tidbits to Ponder",
        speaker: "Gitavadhani Dr Sachidananda Murthy",
        speakerDesignation:
          "Professor at Department of Education, National Sanskrit University, Tirupati",
        link: "https://www.youtube.com/watch?v=e63sfcA3NrA",
      },
      {
        id: 9,
        title: "Avadhana Tradition in Odisha",
        speaker: "Shri Prateek Pattanaik",
        speakerDesignation: "Researcher, Odissi musician, and musicologist",
        link: "https://www.youtube.com/watch?v=hSS7dqxytGI",
      },
      {
        id: 10,
        title: "Avadhana Tala",
        speaker: "Talavadhani Kanchana Sisters",
        speakerDesignation:
          "Kanchana S Shriranjani and Kanchana S. Shruthiranjani. Kanchana sisters are renowned Karnatic Classical Duet Vocalists, Violists, Gurus, Sangeetha Avadhaanis, Music Directors and Composers.",
        link: "https://www.youtube.com/watch?v=wqVvmKc6jsc",
      },
      {
        id: 11,
        title: "The Poetry of Avadhanam",
        speaker: "Satavadhani Dr R. Ganesh",
        speakerDesignation:
          "Renowned Sanskrit scholar and ashu kavi - extempore poet",
        link: "https://www.youtube.com/watch?v=V0ckVkHjLhg",
      },
      {
        id: 12,
        title: "Avadhana in Everyday Life",
        speaker: "Mrs Surbhi Bhagat",
        speakerDesignation: "Founder, Uttam Garbh Sanskar, Gurugram",
        link: "https://www.youtube.com/watch?v=TngYubXjOlg",
      },
    ],
  },
  "vaicariki-series": {
    title: "Vaicārikī",
    description:
      "Vaicariki is an initiative for thoughts, dialogues, and discussions by the Rashtram School of Public Leadership at Rishihood University, Sonipat. It is part of the 150-year birth anniversary celebration of Sri Aurobindo and the 75th anniversary of India's Independence. It is a series of webinars in which eminent thinkers and philosophers from all over the country and the world are invited to speak and discuss the most pressing issues of our times and try to contextualise them with the philosophical framework of Sri Aurobindo and the Sanatana tradition.",
    webinars: [
      {
        id: 1,
        title: "VAICĀRIKĪ 1: Integrality of the New Education Policy",
        link: "https://www.youtube.com/live/Mp95N-cKn00",
        details: {
          keynote:
            "Sh. Manoj Pavitran – Educationist & Product Designer, Auroville",
          moderator:
            "Ms Divyanshi – Executive, Purnam Centre for Integrality, Auroville; Anurag Shukla – Researcher & Doctoral Student, IIM Ahmedabad",
          panelists:
            "Dr K. Parameswaran – Associate Professor of Law, Gujarat National Law University; Prof. Priya M. Vaidya – Associate Professor, Dept of Philosophy, University of Mumbai",
        },
        summary:
          "The keynote address began with an introduction of the Purnam Centre for Integrality. Manoj Pavithran ji, in his address, highlighted that the dominant mode of education across the world dates back to the Industrial Revolution period and was designed to meet specific needs such as mass production, industrialised job markets, etc. He added that this mode of education was further reduced in India during British rule to produce servants,  not leaders, innovators, and thinkers capable of self-government. Pointing out the futility of such an education system in a completely reversed world order, a world heading towards automation, he stressed four key ideas as propounded by Sri Aurobindo, namely, Swadeshi, boycott, swaraj and national education, an education that is rooted in Indian culture. He extensively discussed three processes to address the needs of evolutionary education: the individual™s self-discovery as the foundation of the future of self-education; the nation's soul (a radically new idea); and the evolutionary crisis humanity faces, such as the disconnect from nature and society. And it is because of this that a new education system is required to regenerate and accelerate the evolutionary process with an aim towards seeking harmony with nature™s own impulses.\n\nAfter the keynote address, Ms Divyanshi ji explained how the Purnam Centre at Auroville is dedicated to creating an educative environment where ordinary people can become sadhaks and, through art, music, and poetry, gain a sense of the radiant soul within.\n\nThe panel discussion started with Dr K. Parameswaran, who spoke about the challenges one has to face in a proper academic institution with all the rules and regulations, especially in explaining the teachings of Sri Aurobindo rationally in the educational context. He elaborated on the three principles given by Sri Aurobindo, which are apparent in the New Education Policy, regarding how a teacher should be and how his teaching should be. He emphasised why the learning environment needs to be stimulating, enriching and positive. Enlarging upon the teachings of Sri Aurobindo, he explained how nothing can be taught and why a teacher is not an instructor or a taskmaster but a helper and a guide whose business is to suggest, not to impose. He explained the need for educating each and every personality according to his/her own capabilities introducing creativity thereby having diversity and supported it with Sri Aurobindo's second principle of education, that mind has to be consulted in its gross: The chief aim of education is to help the growing soul to draw out that which is best in it and make it perfect for a noble use. On the issue of interdisciplinary studies, he quoted Sri Aurobindo, who said that the third principle of education is to work from the near to the far, and that when one delves deeper into one's own subject, one is required to explore all the subjects that are the integration points. He highlighted the need to move from the domain of information to that of intuition and inspiration.\n\nDr Priya M Vaidya spoke on the Integrality of the New Education Policy and on how Sri Aurobindo™s thoughts are inherent in it. She spoke about the NEP as laying out the roadmap for India™s future and encouraging the principles of exploration, evolution, and contribution. She emphasised the need to train teachers to be good facilitators and the freedom the new policy gives teachers to teach the way they want.",
      },
      {
        id: 2,
        title: "VAICĀRIKĪ 2: Varna and Jati- An Integral Perspective",
        link: "https://www.youtube.com/live/YIZz5sELYzM",
        details: {
          keynote: "Dr Kundan Singh – Professor: Hindu University of America",
          moderator:
            "Sh. Manan Bindal – Volunteer: Sri Aurobindo Ashram, Delhi Branch",
          panelists:
            "Ashish Dhar – Co-Founder Upword and Pragyata; Neelesh Marik – Director – Expense on demand",
        },
        summary:
          'In the second chapter of Vaicariki, the ideas and institutions of Varna, Jati, and Caste were discussed in light of the works of Sri Aurobindo and the Mother, with the vision of the defence of Indian Culture, as dwelt upon extensively by Sri Aurobindo, and to address contemporary discourse.\n\nIn the keynote address, Dr Kundan Singh pointed out the difficulties in dealing with issues as volatile as varna and jati. He explained how India™s history, culture, and sociology were distorted by various factors, such as invasions and foreign rule. He explained the ideas contained in the Vedanta and enlarged upon the various planes of consciousness, namely, the gyanmaya kosha, the manomaya kosha, anandmaya kosha, pranmaya kosha and explained how these different planes are essentially interconnected. He explained how, during the 1870s, a narrative was constructed and a caste system  was introduced by foreigners to portray our culture as inherently hierarchical and oppressive, ultimately distorting the original meanings of varna and jati. Referring to Sri Aurobindo, he explained that a system is understood very differently when it is put in place, but over time, certain deviations and distortions occur. He referred to the Samkhya philosophy and explained the ideas of Purusa and Prakriti, the manifest and the unmanifest, the three gunas and their qualities, and the idea of ego/ahamkara. Highlighting the principles of the three gunas, he explained how different people have different interests and expertise because of the predominance of one of the three gunas. Tracing the etymology of the word Varna, which comes from the root vri, meaning "to choose," he explained that Varna was not birth-based but rather based on one™s gunas and pravritti.\n\nThe panel discussion began with Shri Manan Bindal, who set the context.\n\nShri Ashish Dhar explained how caste was a social institution in Hindu civilisation, which, being spiritually based, rested on spiritual and moral foundations and subordinated material elements and considerations. He emphasised that caste, therefore, was not only an institution which ought to be immune from the second-hand denunciations so long in fashion but a supreme necessity without which Hindu civilisation could not have developed its distinctive character or worked out its unique mission. He talked about the culture of the shudras and how colonial historians created a fabricated narrative. He emphasised upon the art architectural and artistic accomplishments of the hindu civilization achieved by the sudras and so there is no question about their being educated or even having access to; not just access to but in some cases having a complete command over the knowledge as evident in the inscriptional evidence where the shudras have themselves written about their piece of art or piece of the the sculpture or the temple that they have made and they\'ve given credit to themselves or the chief architecture deck in sanskrit itself. The kind technical expertise required to build and to create such forms of art and architecture would not have been possible without advanced knowledge of material sciences mathematics so these are just logical deductions one has got to make and there is enough scholarship which is already present which talks about these things and unfortunately what has happened is that these forms of scholarship have been systematically kept away from public consciousness because of political agendas.\n\nShri Neelesh Marik explained the need to reclaim intuitive power and the need for the evolution of consciousness. He spoke of the symbolic understanding of the parts of the divine body, the representative of the intention of the spirit to embody these different faculties in the social fabric through individuals, as being the symbolic stage and the origin of the varna system. He presented an extensive discussion of swabhava and swadharma and drew a correlation between swabhava, swadharma, and the concept of Varna. He also cautioned against the solidification of hierarchies leading to discrimination.',
      },
      {
        id: 3,
        title: "VAICĀRIKĪ 3: The Spirit of Indian Nationalism",
        link: "https://www.youtube.com/live/KQorMs5mUpw",
        details: {
          keynote:
            "Dr Anirban Ganguly – Director, Dr Syama Prasad Mookerjee Research Foundation (SPMRF)",
          inaugural:
            "Dr Bharat Gupt – Professor, Indira Gandhi National Centre for Arts (IGNCA)",
          panelists:
            "Shri Devdip Ganguli – Faculty, Sri Aurobindo International Centre of Education; Shri Raghava Krishna",
        },
        summary:
          "For Sri Aurobindo, the nation was not just a superficial construct but also had a subtle body embodying the thoughts, the literature, the philosophy, the mental and emotional activities, the sum of hopes, pleasures, aspirations, fulfilments, the civilisation and culture. His vision of nationalism went beyond the search for a merely political ideal and transformed it into a spiritual goal, a way to recover Indian thought, energy and greatness, not only for India but for the cause of the whole world.\n\nIn the Inaugural address, Dr Bharat Gupt pointed out the challenges our country is facing amidst the religious fanaticism. He explained in detail the idea of nationalism with respect to Sri Aurobindo, noting that it is essentially synonymous with Hindu nationalism and the principles of Sanatan Dharma.\n\nIn the Keynote address, Dr Anirban Ganguly explained that Sri Aurobindo™s idea of nationalism is not limited to a single epoch but is universally applicable across all ages throughout history. He explained how this idea of nationalism is based on the Sanatan siddhant of karma and everyone doing their own work with utmost honesty. He talked about a new India and a new nationalism, and this new nationalism that we are seeing manifest before us today in terms of expansion, inclusion, and a rising consciousness and empowerment, at all levels, political, economic and educational. A churning awareness has come about a rising consciousness that India can collectively rise and can attain the past position of a vishwa guru only when all her parts, all her dimensions, move ahead equally and are empowered comprehensively. He also discussed the idea of freedom and what India can do once it has achieved freedom in every aspect of being.\n\nIn the panel discussion, Shri Raghav Krishna and Shri Devdeep Ganguly discussed the challenges India faces. They discussed the idea of nationalism as a historical force and as an emotional, social, and political reality of our nation, and how it is both a motivating and a unifying force. They extensively discussed the various theories and worldviews surrounding nationalism and contextualised Indian nationalism and its uniqueness within the global scheme with respect to the ideas of great thinkers like Sri Aurobindo and Swami Vivekananda.",
      },
      {
        id: 4,
        title:
          "VAICĀRIKĪ 4: Death, Dying and Beyond- Sri Aurobindo's Perspectives",
        link: "https://www.youtube.com/live/8PI1DT4Jsks",
        details: {
          keynote:
            "Dr Alok Pandey –“ Doctor- Sri Aurobindo Ashram, Pondicherry",
          moderator:
            "Dr Mala Kapadia –“ Professor & Director of Centre for Wellness and Wellbeing, Rashtram",
          panelists:
            "Prof. Joy Sen –“ Professor, IIT Kharagpur; Dr Vladimir Yatsenko –“ Director of Research- Institute of Applied Research in Integral Studies, La Grace Sri Aurobindo Integral Life Centre",
        },
        summary:
          "The Covid-19 pandemic has instilled the fear of death across the globe on an unprecedented level. Yet, death and life beyond dying have always intrigued mere mortals since time immemorial.",
      },
      {
        id: 5,
        title: "VAICĀRIKĪ 5: Aryas, Vedas and Historical Chronology",
        link: "https://www.youtube.com/live/jLumW-s3dyk",
        details: {
          keynote: "Prof. Michel Danino –“ Visiting Professor: IIT Gandhinagar",
          panelists:
            "Chair: Dr Joy Sen –“ Professor: IIT Kharagpur; Shri Megh Kalyanasundaram –“ Director Special Projects, Indica; Ms Manogna Sastry –“ Team Leader- Research: Infinity Foundation; Shri Amritanshu Pandey –“ Independent Researcher and Author",
        },
        summary:
          "Sri Aurobindo commented in detail about the exclusive preoccupation with the naturalistic element of the Rig Vedic hymns by the European scholars. They created a gulf between the early Rigvedic age and the later Upanishadic and other thoughts. Sri Aurobindo remarked, The hypothesis, invented to fill the gap, that these ideas were borrowed by barbarous Aryan invaders from the civilised Dravidians, is a conjecture supported only by other conjectures. It is indeed coming to be doubted whether the whole story of an Aryan invasion through the Punjab is not a myth of the philologists. He revealed the secret of the Vedas as the embodiment of spiritual and psychological knowledge concealed in a veil of concrete and material figures and symbols. His seminal works laid a new foundation for a wide range of studies, including Comparative Religion, Philology, Historiography, Mythology, and Archaeology.",
      },
      {
        id: 6,
        title: "VAICĀRIKĪ 6: The Divine Mother: All is SHE",
        link: "https://www.youtube.com/live/nTCoST1AXRw",
        details: {
          keynote:
            "Dr Ramesh Bijlani –“ Doctor & Trustee: Sri Aurobindo Ashram- Delhi branch",
          panelists:
            "Ms Gitanjali J B –“ Co-Founder & CEO- Himalayan Institute of Alternatives, Ladakh; Shri Mohit Bansal –“ Data Analyst; IIT Delhi Alumni",
        },
        summary:
          "In all that is done in the universe, the Divine through his Shakti is behind all action, Sri Aurobindo describes the all-encompassing and the transcendental Reality as the Divine Mother. The principle behind the workings is feminine in character. In Yoga also, it is the Divine who is the Sadhaka and the Sadhana. The sixth chapter of Vaicariki will focus on the feminine aspect as expounded by Sri Aurobindo and the Mother. This declutters our minds from the needless divisions and dualities due to the politics of our times.",
      },
      {
        id: 7,
        title:
          "VAICĀRIKĪ 7: Inevitable Wars and Illusionary Peace: Sri Aurobindo's Realism",
        link: "https://www.youtube.com/live/BEVLiWavsSw",
        details: {
          moderator:
            "Shri Sreejit Datta –“ Mentor & Assistant Professor at Rashtram | Director of Centre for Civilisational Studies",
          keynote:
            "Shri Aravindan Neelakandan –“ Contributing Editor at Swarajya | Co-author of –˜Breaking India'",
          panelists:
            "Shri Govind –“ President –“ Sri Aurobindo Yoga Foundation of North America; Shri Uday Arya –“ Teacher, SAICE | Co-founder BlueLotus Ventures",
        },
        summary:
          "Over the ages, there have been several attempts by philosophers to theorise the actual causes of the massive devastation, brutality, and cruelty brought about by wars, and the ways in which they can be curbed. Some see hope in the rise of commercialism and material progress in bringing about peace; others find hope in the adoption of a democratic framework of governments.\n\nSri Aurobindo discards such superficial propositions and remarks, only when a man has developed not merely a fellow-feeling with all men, but a dominant sense of unity and commonality, only when he is aware of them not merely as brothers- that is a fragile bond- but as parts of himself, only when he has learned to live not in his separate personal and communal ego-sense, but in a larger universal consciousness can the phenomenon of war, with whatever weapons, pass out of his life without the possibility of return.",
      },
      {
        id: 8,
        title:
          "VAICĀRIKĪ 8: Religion, Conflict and Spirituality- Sri Aurobindo's Thoughts",
        link: "https://www.youtube.com/live/wmyyJ72_LW4",
        details: {
          keynote:
            "Shri Swami Brahmdev ji –“ Founder of Aurovalley Ashram (An International Centre for Inner Ecology and Spiritual Studies), Raiwala, Dehradun.",
          moderator:
            "Dr Lakshmi Saripalli –“ Astrophysicist, retd. Raman Research Institute, Bangalore",
          panelists:
            "Dr Pravir Malik –“ Chief Strategy Officer at Galaxies | Chief Technologist at Deep Order Technologies; Shri Amit Gujral –“ Fashion Designer | Businessman",
        },
        summary:
          "Religious animosity is perhaps the most common form of conflict. Human societies have been fighting among themselves on religious grounds since time immemorial. The landmarks in history, like the killing of pagans by the Roman Christians, the history of the Crusades, the riots between Protestants and Catholics, the idea of Ghazwa-e-hind, the rampant riots during India's partition, and the genocide in Kashmir, are all examples of conflicts predicated upon the idea of religion. It is ironic to note that the word religion, which traces back its root to the Latin word religare, meaning to bind, is the cause of so much bloodshed, suffering and division. It is high time that we move forward from the idea of organised religion towards the realm of spirituality, where mankind may find peace, prosperity and brotherhood. Sri Aurobindo writes, The highest spirituality indeed moves in a free and wide air far above that lower stage of seeking which is governed by religious form and dogma; it does not easily bear their limitations and, even when it admits, it transcends them; it lives in an experience which to the formal religious mind is unintelligible.",
      },
    ],
  },
};

export const internships = [
  {
    id: 1,
    title: "Research Internship Programme",
    slug: "research-internship-programme",
    image: philosophyImage,
    description:
      "The Research Internship Programme at the Centre for Human Sciences (CHS), Rishihood University, offers students, scholars, and independent researchers an opportunity to engage in guided research across diverse domains of Indian Knowledge Systems.",
    detailedContent: {
      about: {
        title: "About the Programme",
        content: [
          "The Research Internship Programme at the Centre for Human Sciences (CHS), Rishihood University, offers students, scholars, and independent researchers an opportunity to engage in guided research across diverse domains of Indian Knowledge Systems, humanities, social sciences, philosophy, culture, and interdisciplinary studies.",
          "The internship may be undertaken either on a research topic proposed by the applicant or as part of an ongoing project at the Centre. Internship durations range from one to six months, depending on the scope of the project and the objectives of the intern.",
          "The programme is designed in accordance with the spirit of the UGC Guidelines for Internships and Research-Based Learning, and may be undertaken for academic credit wherever permitted by the parent institution.",
          "During the internship, participants receive structured exposure to:",
          "• Research methodology and academic writing\n• Literature review and bibliography preparation\n• Philosophical inquiry and critical thinking\n• Indian Knowledge Systems (IKS)\n• Academic presentation and publication practices\n• Interdisciplinary approaches to research",
          "Interns work under the guidance of faculty members, project mentors, and research associates while contributing to meaningful academic and research initiatives.",
        ],
      },
      researchAreas: {
        title: "Research Areas",
        description:
          "The Centre encourages research that bridges classical Indian knowledge traditions with contemporary academic inquiry. The following thematic areas represent some of the domains in which research internships may be undertaken. Applicants may select one of the listed themes, propose a related topic, or develop an independent research proposal aligned with the Centre's areas of interest.",
        areas: [
          {
            title: "Ayurveda",
            description:
              "Research on traditional Indian health sciences, preventive healthcare, wellness, dietetics, longevity studies, and the contemporary relevance of Ayurvedic principles.",
            subtopics: [
              "Gut Health and Mental Well-being",
              "Rasayana Therapy, Longevity, and Healthy Aging",
              "Ayurvedic Perspectives on Sleep Disorders",
              "Panchakarma and Scientific Validation",
              "Pathya-Apathya and Disease Management",
            ],
          },
          {
            title: "Contemporary Indian Thinkers",
            description:
              "Exploration of the philosophical, educational, social, and spiritual contributions of modern Indian thinkers and their relevance to contemporary society.",
            subtopics: [
              "Sri Aurobindo and Integral Yoga",
              "Swami Vivekananda and Global Citizenship",
              "Sri Ramakrishna's Experiential Spirituality",
              "J. Krishnamurti and Critiques of Authority",
              "Ramana Maharshi and Contemporary Well-being",
            ],
          },
          {
            title: "Darśanas and Indic Traditions",
            description:
              "Studies in classical Indian philosophical systems, religious traditions, spirituality, and textual traditions.",
            subtopics: [
              "Concepts of Mokṣa across Traditions",
              "Comparative Study of the Six Darśanas and Cārvāka",
              "Tantra: Philosophy and Practice",
              "Ecological Consciousness in Vedas and Purāṇas",
              "Bhagavad Gītā, Leadership, and Resilience",
            ],
          },
          {
            title: "Governance and Public Administration",
            description:
              "Research on statecraft, governance models, public administration, political thought, and policy frameworks from Indian traditions.",
            subtopics: [
              "Arthashastra and Strategic Governance",
              "Public Administration in Ancient India",
              "Dharma and Ethics of Governance",
              "Civic Administration and Urban Management",
              "War, Diplomacy, and International Relations",
            ],
          },
          {
            title: "Indian Geography",
            description:
              "Exploration of geographical knowledge, environmental understanding, and sacred landscapes in Indian literature and traditions.",
            subtopics: [
              "Celestial Geography and Cosmology",
              "Rivers and Sacred Hydrology",
              "Traditional Soil Classification Systems",
              "Mountains, Deserts, and Forests in Literature",
              "Biodiversity and Ecological Knowledge",
            ],
          },
          {
            title: "Indian Philosophy",
            description:
              "Research on metaphysics, epistemology, ethics, ontology, and contemporary applications of Indian philosophical thought.",
            subtopics: [
              "Upanishadic Metaphysics",
              "Advaita Vedānta in Contemporary Contexts",
              "Pramāṇa Theories and Epistemology",
              "Indian Ethics and Moral Philosophy",
              "Philosophy and Sustainability",
            ],
          },
          {
            title: "Indian Psychology",
            description:
              "Studies on consciousness, personality, cognition, emotions, mental well-being, and self-development from Indian perspectives.",
            subtopics: [
              "Emotional Intelligence in Indian Thought",
              "Meditation and Mindfulness",
              "Personality and Self-Development",
              "Stress and Anxiety Management",
              "Concepts of Happiness and Well-being",
            ],
          },
          {
            title: "Integral Humanism",
            description:
              "Research based on the philosophy of Pt. Deendayal Upadhyaya and its applications in education, governance, economics, and social development.",
            subtopics: [
              "Philosophical Foundations of Integral Humanism",
              "Holistic Education Reform",
              "Public Policy and Governance",
              "Workplace Well-being",
              "Sustainable Community Development",
            ],
          },
          {
            title: "Sanskrit and Computational Linguistics",
            description:
              "Interdisciplinary studies combining Sanskrit knowledge systems with artificial intelligence, linguistics, and computational sciences.",
            subtopics: [
              "Sanskrit NLP and Language Technologies",
              "Pāṇinian Grammar and Computing",
              "Sanskrit-Based Programming Languages",
              "AI-Assisted Vedic Text Analysis",
              "Speech Recognition and Phonetics",
            ],
          },
          {
            title: "Science and Technology in Indian Knowledge Systems",
            description:
              "Research on indigenous scientific traditions and their relevance for contemporary technological and environmental challenges.",
            subtopics: [
              "Environmental Sustainability",
              "Animal Husbandry and Veterinary Science",
              "Agricultural Innovations",
              "Water Management Systems",
              "Engineering and Metallurgical Traditions",
            ],
          },
          {
            title: "Town Planning and Architecture",
            description:
              "Studies on architecture, urban planning, Vāstu traditions, temple design, and spatial philosophy.",
            subtopics: [
              "Temple Architecture and Vāstu Śāstra",
              "Arthashastra and Urban Planning",
              "Vāstu Puruṣa Maṇḍala",
              "Civic and Sacred Architecture",
              "Holistic Models of Ancient Town Planning",
            ],
          },
          {
            title: "Vedic Mathematics and Astronomy",
            description:
              "Research on mathematical, calendrical, astronomical, and computational traditions of India.",
            subtopics: [
              "Computational Techniques in Vedic Mathematics",
              "Contributions of Āryabhaṭa and Bhāskara",
              "Panchāṅga Computation Systems",
              "Jyotiṣa and Astronomical Models",
              "Ancient Astronomical Instruments",
            ],
          },
        ],
      },
      opportunities: {
        title: "Ongoing Opportunities",
        table: [
          {
            programme: "Integral Humanism Initiative",
            duration: "1–6 Months",
            status: "Open",
          },
          {
            programme: "Summer Research Internship 2026",
            duration: "1–2 Months",
            status: "Open",
          },
          {
            programme: "Winter Research Internship 2026–27",
            duration: "1–2 Months",
            status: "Upcoming",
          },
          {
            programme: "Cryptography and Sanskrit: A Study and Documentation",
            duration: "6 Months",
            status: "Closed",
          },
        ],
      },
      responsibilities: {
        title: "Intern Responsibilities",
        description:
          "Research interns are expected to actively contribute to the assigned project through:",
        items: [
          "Literature Survey and Review",
          "Bibliography Preparation",
          "Translation and Annotation",
          "Documentation and Archival Work",
          "Field Work and Data Collection (where applicable)",
          "Data Analysis and Interpretation",
          "Research Report Writing",
          "Academic Presentations and Discussions",
        ],
      },
      outcomes: {
        title: "Expected Outcomes",
        description:
          "Upon successful completion of the internship, participants may receive:",
        items: [
          "Research Report",
          "Publication Support and Mentorship",
          "Conference Presentation Opportunities",
          "Research Portfolio Development",
          "Internship Completion Certificate",
        ],
      },
      application: {
        title: "Apply for Research Internship",
        description:
          "Interested applicants may submit their application through the Research Internship Application Form.",
        link: "https://docs.google.com/forms/d/1ouG1_Q8Y9xcn0MeiT5_NpxBVra3K6t2d1Y15GTD7gq4/edit",
      },
    },
  },
  {
    id: 2,
    title: "Project-Based Internship Programme",
    slug: "project-based-internship-programme",
    image: projectInternshipImage,
    description:
      "The Project-Based Internship Programme at the Centre for Human Sciences (CHS), Rishihood University, provides students and young professionals with an opportunity to contribute directly to ongoing institutional projects.",
    detailedContent: {
      about: {
        title: "About the Programme",
        content: [
          "The Project-Based Internship Programme at the Centre for Human Sciences (CHS), Rishihood University, provides students and young professionals with an opportunity to contribute directly to ongoing institutional projects. Unlike research internships, which are primarily focused on independent academic inquiry, project-based internships emphasize practical engagement, collaborative work, documentation, content development, field implementation, and project execution.",
          "Interns are assigned to specific projects based on their interests, academic background, skills, and project requirements. The nature of work may include research assistance, content creation, translation, event support, data management, outreach activities, educational resource development, and documentation.",
          "The programme is designed to provide hands-on experience while exposing interns to Indian Knowledge Systems (IKS), interdisciplinary learning, and real-world project management. Depending on the project, internships may be offered in online, offline, or hybrid modes.",
        ],
      },
      availableProjects: [
        {
          id: 1,
          title: "1. Integral Humanism Initiative",
          overview:
            "The Integral Humanism Initiative is a long-term research, documentation, and outreach project dedicated to the study and dissemination of the philosophy of Pt. Deendayal Upadhyaya and related streams of Indian thought. The project seeks to explore the relevance of Integral Humanism in education, governance, economics, social development, sustainability, and public policy.",
          natureOfWork: [
            "Literature review and source collection",
            "Documentation and archival work",
            "Content writing and editing",
            "Translation of texts and articles",
            "Bibliography preparation",
            "Development of educational resources",
            "Event and seminar support",
            "Social media and outreach content",
          ],
          preferredSkills: [
            "Academic writing and research aptitude",
            "Interest in Indian philosophy and public policy",
            "Basic knowledge of referencing and citation methods",
            "Hindi and/or Sanskrit reading ability (desirable)",
            "Content development and communication skills",
            "Attention to detail and documentation skills",
          ],
        },
        {
          id: 2,
          title: "2. IKS Awareness Programme for School Children (Paid)",
          overview:
            "The Indian Knowledge Systems (IKS) Awareness Programme aims to introduce school students to India's rich intellectual, scientific, cultural, and philosophical heritage through engaging educational activities, workshops, learning modules, and outreach initiatives.\n\nThis project involves direct interaction with educational institutions and the development of age-appropriate learning resources.",
          natureOfWork: [
            "Educational content development",
            "Workshop and activity design",
            "School outreach and coordination",
            "Presentation preparation",
            "Documentation of programme activities",
            "Development of learning materials and handouts",
            "Event management and execution",
            "Feedback collection and reporting",
          ],
          preferredSkills: [
            "Communication and presentation skills",
            "Interest in education and child development",
            "Creative content creation",
            "Graphic design and multimedia skills (desirable)",
            "Public speaking and facilitation abilities",
            "Organizational and coordination skills",
          ],
          compensation:
            "This is a paid internship/project assignment. Specific remuneration details will be communicated to selected candidates based on project requirements and duration.",
        },
        {
          id: 3,
          title:
            "3. Effect of Sanskrit Chandas in Children with Learning Disabilities",
          overview:
            "This interdisciplinary project examines the role of Sanskrit chandas (metrical patterns) and rhythmic recitation in supporting children with learning disabilities. The project combines perspectives from Indian Knowledge Systems, education, linguistics, psychology, and cognitive sciences.\n\nThe initiative involves research, educational interventions, documentation, and analysis of observations related to learning outcomes.",
          natureOfWork: [
            "Literature survey and review",
            "Data collection and documentation",
            "Observation and reporting",
            "Educational material preparation",
            "Transcription and translation",
            "Assistance in field activities",
            "Data organization and analysis",
            "Report preparation",
          ],
          preferredSkills: [
            "Interest in psychology, education, linguistics, or Sanskrit",
            "Research and documentation skills",
            "Ability to work with data and observations",
            "Patience and sensitivity while working with children",
            "Basic knowledge of Sanskrit (desirable)",
            "Academic writing and reporting skills",
          ],
        },
      ],
      eligibility: {
        title: "General Eligibility",
        description: "Applications are welcome from:",
        items: [
          "Undergraduate students",
          "Postgraduate students",
          "Doctoral scholars",
          "Recent graduates",
          "Independent learners with relevant skills and interests",
        ],
        footer:
          "Selection is based on project requirements, applicant suitability, demonstrated interest, and availability.",
      },
      outcomes: {
        title: "Expected Learning Outcomes",
        description: "Participants may gain experience in:",
        items: [
          "Project management and coordination",
          "Research and documentation",
          "Educational outreach",
          "Content development",
          "Translation and communication",
          "Academic and professional writing",
          "Indian Knowledge Systems and interdisciplinary studies",
        ],
      },
      application: {
        title: "Apply for a Project-Based Internship",
        description:
          "Interested candidates may submit their application through the Project-Based Internship Application Form.",
        link: "https://docs.google.com/forms/d/1ouG1_Q8Y9xcn0MeiT5_NpxBVra3K6t2d1Y15GTD7gq4/edit",
      },
    },
  },
  {
    id: 3,
    title: "Internship Resources",
    slug: "internship-resources",
    image: internshipResourcesImage,
    description:
      "The Internship Programme of the Centre for Human Sciences seeks to provide meaningful opportunities for intellectual growth, research training, and holistic human development.",
    detailedContent: {
      about: {
        title: "About the Programme",
        content: [
          "The Internship Programme of the Centre for Human Sciences seeks to provide meaningful opportunities for intellectual growth, research training, and holistic human development. The programme is designed to cultivate inquiry, scholarship, ethical conduct, and social responsibility while fostering a deeper understanding of human life, society, culture, and knowledge systems.",
        ],
      },
      resources: [
        {
          title: "Internship Manual",
          url: "/assets/Interns/INTERNSHIP MANUAL.pdf",
        },
        { title: "Guidelines", url: "/assets/Interns/Guidelines.pdf" },
        { title: "Forms", url: "/assets/Interns/Forms.pdf" },
      ],
      faqs: [
        {
          question: "1. Who can apply for the internship?",
          answer:
            "Students and learners from diverse academic backgrounds are eligible to apply. Applicants may include:\n• Students who have completed Class 10\n• Students currently pursuing Class 11 or Class 12 (+2)\n• Undergraduate students\n• Postgraduate students\n• Doctoral (Ph.D.) scholars\n• Independent researchers and lifelong learners with a demonstrated interest in research\n\nSelection is based on suitability, motivation, and the availability of positions.",
        },
        {
          question: "2. Is the internship online or offline?",
          answer:
            "The internship is offered in a hybrid mode. Depending on the nature of the project, interns may be required to work either remotely, on campus, or through a combination of both.\n\nSpecific requirements will be communicated at the time of selection.",
        },
        {
          question: "3. What is the duration of the internship?",
          answer:
            "The internship duration may range from one month to six months, depending on the project requirements, intern availability, and mutual agreement between the intern and the Centre.",
        },
        {
          question: "4. Is there any internship fee?",
          answer:
            "Unless specifically announced for a particular programme, there is no application or participation fee for the internship. For offline internships, interns are required to pay for food and accommodation on campus.",
        },
        {
          question: "5. Is the internship paid?",
          answer:
            "The internship is primarily intended as a learning and research opportunity. Any honorarium, stipend, or financial support, if available, will be specified in the internship announcement.",
        },
        {
          question: "6. What is the selection process?",
          answer:
            "The selection process, eligibility criteria, required documents, and evaluation procedures are described in the Internship Manual. Applicants are advised to review the manual carefully before applying.",
        },
        {
          question:
            "7. What documents are required during the application process?",
          answer:
            "Applicants may be required to submit:\n• Internship Application Form\n• Curriculum Vitae (CV) or Résumé\n• Statement of Purpose\n• Recommendation Letter\n• Consent Letter from Parent Institution (Once Selected)\n• Any additional documents specified in the internship announcement",
        },
        {
          question: "8. Will I receive an internship certificate?",
          answer:
            "Yes. An Internship Completion Certificate will be issued upon successful completion of the internship, subject to:\n• Fulfilment of attendance and participation requirements\n• Completion of assigned tasks and deliverables\n• Submission of all reports and required materials\n• Transfer of all internship-related work and associated rights, wherever applicable\n• Compliance with the guidelines and policies of the Centre\n\nThe decision regarding certificate issuance shall rest with the Centre.",
        },
        {
          question: "9. What kind of work will interns be assigned?",
          answer:
            "Our Internship is research internship. Assignments may include, but are not limited to:\n• Research assistance\n• Academic writing and editing\n• Literature reviews\n• Translation and transcription\n• Documentation and archiving\n• Content development\n• Data compilation and analysis\n• Event and project support\n\nTasks vary according to the intern's background, skills, and project requirements.",
        },
        {
          question: "10. Can interns choose their area of work?",
          answer:
            "Applicants may indicate their areas of interest during the application process. While efforts are made to accommodate preferences, final task allocation depends on project requirements and institutional priorities.",
        },
        {
          question:
            "11. What happens if I am unable to complete the internship?",
          answer:
            "Interns should immediately inform their Reporting Guide and the respective authorities. Depending on the circumstances, the internship may be discontinued or rescheduled. Certificates are generally issued only upon successful completion of all requirements.",
        },
        {
          question: "12. Can the internship duration be extended?",
          answer:
            "Yes. Subject to mutual agreement, satisfactory performance, and project requirements, an internship may be extended beyond the initially approved period, up to six months.",
        },
        {
          question: "13. Are interns required to submit periodic reports?",
          answer:
            "Yes. Interns may be required to maintain work logs, submit progress reports through weekly presentations, or provide periodic updates as specified by their Reporting Guide.",
        },
        {
          question: "14. Who will supervise the interns?",
          answer:
            "Each intern will be assigned a mentor who will provide guidance, review submissions, and monitor progress throughout the internship.",
        },
        {
          question:
            "15. Can the work produced during the internship be published elsewhere?",
          answer: "No",
        },
        {
          question: "16. Whom should I contact for queries?",
          answer:
            "For application-related and internship-related queries, please contact:\nEmail: chs@rishihood.edu.in\n\nApplicants and interns are encouraged to communicate through official email channels for all formal correspondence.",
        },
      ],
    },
  },
];
